export class DemoConstants {
  public static keywords = [
    {
      _id: {
        keywordText: 'advocado',
        isMicroMoment: true
      },
      sessionCount: 21,
      keywordText: 'advocado',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'the scoop',
        isMicroMoment: false
      },
      sessionCount: 11,
      keywordText: 'the scoop',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'best tv ads',
        isMicroMoment: true
      },
      sessionCount: 1,
      keywordText: 'best tv ads',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'real time bidding',
        isMicroMoment: true
      },
      sessionCount: 1,
      keywordText: 'real time bidding',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'monitor tv',
        isMicroMoment: false
      },
      sessionCount: 1,
      keywordText: 'monitor tv',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'commercial performance',
        isMicroMoment: true
      },
      sessionCount: 1,
      keywordText: 'commercial performance',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'real time biding',
        isMicroMoment: false
      },
      sessionCount: 8,
      keywordText: 'real time biding',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'avocado',
        isMicroMoment: false
      },
      sessionCount: 4,
      keywordText: 'avocado',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'guacamole',
        isMicroMoment: false
      },
      sessionCount: 7,
      keywordText: 'guacamole',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'tv advertising',
        isMicroMoment: false
      },
      sessionCount: 9,
      keywordText: 'tv advertising',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'tv performance',
        isMicroMoment: false
      },
      sessionCount: 1,
      keywordText: 'tv performance',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'maximize bids',
        isMicroMoment: false
      },
      sessionCount: 8,
      keywordText: 'maximize bids',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'tv ad cost',
        isMicroMoment: true
      },
      sessionCount: 3,
      keywordText: 'tv ad cost',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'advocado saint louis',
        isMicroMoment: false
      },
      sessionCount: 78,
      keywordText: 'advocado saint louis',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'television commercials',
        isMicroMoment: false
      },
      sessionCount: 7,
      keywordText: 'television commercials',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'google ads automation',
        isMicroMoment: false
      },
      sessionCount: 37,
      keywordText: 'google ads automation',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'maximize ad spend',
        isMicroMoment: true
      },
      sessionCount: 2,
      keywordText: 'maximize ad spend',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'advocado core media',
        isMicroMoment: false
      },
      sessionCount: 2,
      keywordText: 'advocado core media',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'advocado media ad spend',
        isMicroMoment: false
      },
      sessionCount: 55,
      keywordText: 'advocado media ad spend',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'advocado bvs',
        isMicroMoment: false
      },
      sessionCount: 1,
      keywordText: 'advocado bvs',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'attribution data',
        isMicroMoment: false
      },
      sessionCount: 9,
      keywordText: 'attribution data',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'data is our core',
        isMicroMoment: false
      },
      sessionCount: 2,
      keywordText: 'data is our core',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'confirm ad spend',
        isMicroMoment: false
      },
      sessionCount: 7,
      keywordText: 'confirm ad spend',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'advertisements advocado',
        isMicroMoment: false
      },
      sessionCount: 8,
      keywordText: 'advertisements advocado',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'transparent data is our core',
        isMicroMoment: false
      },
      sessionCount: 21,
      keywordText: 'transparent data is our core',
      isMicroMoment: false
    }
  ];

  public static mMRecords = [
    {
      _id: {
        origEventId: '99d4d110bbf0669fb6562cc83eb95545',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: 0.818181818181818,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '99d4d110bbf0669fb6562cc83eb95545',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T15:59:55.214Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '988e0bef9d71ad9e656886592d729e35',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.19090909090909092,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: '988e0bef9d71ad9e656886592d729e35',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T15:21:14.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '9a36df2380de225902c04c1f1c6657a8',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 10,
      lift: -0.08138888888888893,
      baselineSessionCount: 5,
      baselineSessionsPerSecond: 0.016666666666666666,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '9a36df2380de225902c04c1f1c6657a8',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T18:11:31.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'bbe965eb416fc593d14a116d01b45859',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 5,
      pvCount: 7,
      lift: 2.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'bbe965eb416fc593d14a116d01b45859',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T14:18:55.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4012b5733bb4f33d16fdb070eb8b762b',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.035009613402470545,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '4012b5733bb4f33d16fdb070eb8b762b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-07T16:47:12.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3ae4e1a8f97e158fe77f11284fa055f6',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 1.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '3ae4e1a8f97e158fe77f11284fa055f6',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-07T17:41:40.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '30fd197bc404a7b45a1b5550e72bbf58',
        affiliate: 'ABC',
        isci: '554694H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554694H',
      affiliate: 'ABC',
      origEventId: '30fd197bc404a7b45a1b5550e72bbf58',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T11:29:44.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '981b65f1043069a64b5aada3474daccf',
        affiliate: 'FOX',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.06884920634920633,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'FOX',
      origEventId: '981b65f1043069a64b5aada3474daccf',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T12:56:14.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '5cbc984bfef674e1a883fd292caec77d',
        affiliate: 'FOX',
        isci: '554686H'
      },
      sessionCount: 4,
      pvCount: 7,
      lift: 0.3252500000927182,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'FOX',
      origEventId: '5cbc984bfef674e1a883fd292caec77d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T20:43:41.683Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4ca44c5d17f2332616d9e3838642dbec',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.6666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '4ca44c5d17f2332616d9e3838642dbec',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T12:12:37.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6ec7dabf928644ab6d1fb1606a6d2cb1',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.19090909090909092,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: '6ec7dabf928644ab6d1fb1606a6d2cb1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T15:21:29.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f52097e372c1b373185bfef27bdd4498',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.2561471861471861,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: 'f52097e372c1b373185bfef27bdd4498',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T15:49:20.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f55d2d5a70c6459a3524492069025ed4',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 5,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'f55d2d5a70c6459a3524492069025ed4',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T19:45:49.623Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '37c7b7367daa92649d1139092536a53a',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 4,
      pvCount: 12,
      lift: 0.06844797178130509,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: '37c7b7367daa92649d1139092536a53a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:11:16.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6a294f1a000cda4fe2837be322eddf4e',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: -0.017228835978835986,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: '6a294f1a000cda4fe2837be322eddf4e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T19:15:53.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6dccd4cae0ac0b46d10f6819fea653c6',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 5,
      pvCount: 6,
      lift: 3.166666666666666,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: '6dccd4cae0ac0b46d10f6819fea653c6',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T20:11:08.730Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1dcc12ee65030f0b2914f2b9fec4f062',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: -0.12132558578987149,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '1dcc12ee65030f0b2914f2b9fec4f062',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T14:17:51.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '5d028712a09376876d4ed2e5fe79b9ed',
        affiliate: 'MNTV',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.21064814814814817,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'MNTV',
      origEventId: '5d028712a09376876d4ed2e5fe79b9ed',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T13:18:13.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7081c68d94bafeae1aa90fdde980b80f',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.6666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '7081c68d94bafeae1aa90fdde980b80f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T15:13:28.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '744032ee7df3d08794939f7d5949d3cb',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 18,
      lift: 0.02167328042328042,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: '744032ee7df3d08794939f7d5949d3cb',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T18:17:00.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7871597467df4cad6a54bc77138fcd6e',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 3,
      pvCount: 6,
      lift: 0.00833333333333328,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: '7871597467df4cad6a54bc77138fcd6e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T16:41:32.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '72079a5317f90c4bcf4f2384da0cc775',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 9,
      lift: 0.24583333333333326,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '72079a5317f90c4bcf4f2384da0cc775',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T16:45:04.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '75104b0fb38e62af9b883ead0d32aa96',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 4,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '75104b0fb38e62af9b883ead0d32aa96',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T17:48:17.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c1d89543728444c92a111c520ff52b56',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 4,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: 'c1d89543728444c92a111c520ff52b56',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T11:59:46.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'fa38cc9c413700130895c0c4aa09ae4a',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 3,
      pvCount: 9,
      lift: 0.5757575757575757,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: 'fa38cc9c413700130895c0c4aa09ae4a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T18:58:17.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '191f4ab224c3d431b5dd1808893b27f1',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '191f4ab224c3d431b5dd1808893b27f1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T16:21:07.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '183296d275aeffe0a7c485c549e4df5b',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '183296d275aeffe0a7c485c549e4df5b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T14:30:02.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a16e8b2e567dd31ed291481d22cd2b31',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.05535714285714282,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'a16e8b2e567dd31ed291481d22cd2b31',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T13:19:54.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '28c30cbfddf3d861d1a6161869b50801',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.175,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: '28c30cbfddf3d861d1a6161869b50801',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T18:15:16.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a6dc953b16a56d280ab988a14f52135e',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.2777777777777778,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: 'a6dc953b16a56d280ab988a14f52135e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-14T16:29:31.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1f9f8a8b31193619884df180634b2311',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: 0.14285714285714285,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '1f9f8a8b31193619884df180634b2311',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T12:23:45.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '93b02e6d7e8c0149bb0d1226d83ccbf3',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 7,
      lift: 0.3807407407407407,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: '93b02e6d7e8c0149bb0d1226d83ccbf3',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T14:37:31.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'fc959ce7677305b1403aec29ae183ef9',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 4,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'fc959ce7677305b1403aec29ae183ef9',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T14:24:56.950Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1593ce472b24ea3a24fb8798557d38ef',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.27272727272727265,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: '1593ce472b24ea3a24fb8798557d38ef',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T19:44:33.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '65d4dea52bf8ac69edc2c29c3ece611d',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: '65d4dea52bf8ac69edc2c29c3ece611d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T15:15:41.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b7a7fb5eeff7f07ef025f373a7f5182c',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'b7a7fb5eeff7f07ef025f373a7f5182c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T13:25:25.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '68e6076b052b15ad24d08fc1012cb180',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 0.09014660493827159,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: '68e6076b052b15ad24d08fc1012cb180',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T13:56:29.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd83550107636fe57e59d6e28c50d513f',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.27272727272727265,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: 'd83550107636fe57e59d6e28c50d513f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T19:44:33.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7bbaded8bf933a8e426c6d09cacd7251',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.19090909090909092,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: '7bbaded8bf933a8e426c6d09cacd7251',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T15:21:07.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b67aa5e4edae49d121a7c67fa19e63bf',
        affiliate: 'CW',
        isci: '558906H'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 1.7502439394141687,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CW',
      origEventId: 'b67aa5e4edae49d121a7c67fa19e63bf',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T16:26:21.601Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e9f142317df3e4ee60794e5ab88ad763',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 0.05925925925925925,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: 'e9f142317df3e4ee60794e5ab88ad763',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T15:24:31.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7d475275f2bb23f7b56ee44213b22cda',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 4,
      lift: 1.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '7d475275f2bb23f7b56ee44213b22cda',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T14:17:03.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '63dc048d6f440331fc7571db36b80026',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 6,
      pvCount: 16,
      lift: -0.16666666666666674,
      baselineSessionCount: 6,
      baselineSessionsPerSecond: 0.02,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: '63dc048d6f440331fc7571db36b80026',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T17:44:13.670Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '624173cd20a4e18c1c2a422bd8329139',
        affiliate: 'IND (ERBK)',
        isci: '554692H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554692H',
      affiliate: 'IND (ERBK)',
      origEventId: '624173cd20a4e18c1c2a422bd8329139',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T09:18:21.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '212408fec17cae93817ef9b2887a3dee',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: '212408fec17cae93817ef9b2887a3dee',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T11:59:19.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8ebd1a65e61ae590867d80e66b4d1b84',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.14404761904761906,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '8ebd1a65e61ae590867d80e66b4d1b84',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T14:45:38.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '237aee6a15f13e831a9ffcf769dc9b98',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.10284580498866212,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '237aee6a15f13e831a9ffcf769dc9b98',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T15:45:22.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '179fabc899ef23b7bcb2d3dffac4447e',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 5,
      pvCount: 7,
      lift: 3.545454545454545,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: '179fabc899ef23b7bcb2d3dffac4447e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T23:57:18.713Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1d3d344d5f67813146527c0fff30d7c7',
        affiliate: 'FOX',
        isci: '554686H'
      },
      sessionCount: 3,
      pvCount: 5,
      lift: 0.2499999999999998,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'FOX',
      origEventId: '1d3d344d5f67813146527c0fff30d7c7',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T20:14:15.859Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f596478043e99975a6de5b28e40513a3',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.1111111111111111,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: 'f596478043e99975a6de5b28e40513a3',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-14T16:29:11.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3b2d63146af313f8547475fd2613e9a3',
        affiliate: 'ABC',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'ABC',
      origEventId: '3b2d63146af313f8547475fd2613e9a3',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T21:36:54.529Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c94183fd7d4bbf0d4838dd6a4f8a86de',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'c94183fd7d4bbf0d4838dd6a4f8a86de',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T11:28:10.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e3a3756a7ea909e7082b3c547baa10c5',
        affiliate: 'CBS',
        isci: '558904H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558904H',
      affiliate: 'CBS',
      origEventId: 'e3a3756a7ea909e7082b3c547baa10c5',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T16:20:28.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: 'bc13097c46ac04815bc1ae763a874a0f',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: 'bc13097c46ac04815bc1ae763a874a0f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T12:14:00.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '989f9539e72af67407224a68fe4c66fa',
        affiliate: 'ABC',
        isci: '554686H'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 3,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'ABC',
      origEventId: '989f9539e72af67407224a68fe4c66fa',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T21:31:22.223Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6453d8df58dd393968dff83c799f6a85',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 5,
      pvCount: 8,
      lift: 0.5597594997594997,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '6453d8df58dd393968dff83c799f6a85',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T13:59:52.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7bdc7d26a60d6e4ca03af0f319faa901',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 0.05972222222222222,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: '7bdc7d26a60d6e4ca03af0f319faa901',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T15:24:11.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd4a3fbf0cb90ab520ce987098676f705',
        affiliate: 'ABC',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'ABC',
      origEventId: 'd4a3fbf0cb90ab520ce987098676f705',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T11:39:25.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '04f1680c2b76de74ee870b1fce2edd3a',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 5,
      pvCount: 11,
      lift: 0.2648148148148148,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: '04f1680c2b76de74ee870b1fce2edd3a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T14:16:39.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '769b0bdddbdff4fc5b15b1073c5d7e31',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 10,
      lift: -0.08138888888888893,
      baselineSessionCount: 5,
      baselineSessionsPerSecond: 0.016666666666666666,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '769b0bdddbdff4fc5b15b1073c5d7e31',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T18:11:31.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'dc0c8a102bbf3c2cffe7ba908d56fe33',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 7,
      pvCount: 16,
      lift: 0.2906349206349206,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'dc0c8a102bbf3c2cffe7ba908d56fe33',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T17:19:12.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '88f7d728f439a9433b3953c7bd394cee',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 0.6912136363260674,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '88f7d728f439a9433b3953c7bd394cee',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T13:57:39.099Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '687cd9767300be7e799caea2181a3ac4',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 8,
      lift: 2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '687cd9767300be7e799caea2181a3ac4',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T16:13:35.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b241e342c9a90d6fb42ae72ab4135fd5',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 8,
      lift: 1.4166666666666665,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'b241e342c9a90d6fb42ae72ab4135fd5',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T17:49:06.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '774efe86bbba2780117b35b10bf5b670',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 1.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: '774efe86bbba2780117b35b10bf5b670',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T12:44:42.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2c789c95219209e41317870fc410ec9d',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: -0.07293650793650794,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '2c789c95219209e41317870fc410ec9d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T17:46:34.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e9856f3eadcb218118ed23e94a65dfbc',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: -0.15122354497354495,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'e9856f3eadcb218118ed23e94a65dfbc',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T14:17:07.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b0e5deaa1b2c4cd9fcc12cfd27f9dae5',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 10,
      pvCount: 20,
      lift: 0.31046296296296294,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: 'b0e5deaa1b2c4cd9fcc12cfd27f9dae5',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T15:37:02.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'fa50c77ff140929c951182f8ca52a256',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 7,
      lift: 0.10215891912320482,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'fa50c77ff140929c951182f8ca52a256',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:46:09.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8d93f942583a9698a1f02ce2c716f28d',
        affiliate: 'MNTV',
        isci: '554686H'
      },
      sessionCount: 7,
      pvCount: 11,
      lift: 1.1166666666666665,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'MNTV',
      origEventId: '8d93f942583a9698a1f02ce2c716f28d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T19:18:54.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f5ee13191686f34aa7b9a42944e62045',
        affiliate: 'IND (ERBK)',
        isci: '558908H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558908H',
      affiliate: 'IND (ERBK)',
      origEventId: 'f5ee13191686f34aa7b9a42944e62045',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T14:46:21.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '0d51b2ea25d96eea2570bfcfd39c2ccc',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 5,
      pvCount: 13,
      lift: 0.6363636363636362,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '0d51b2ea25d96eea2570bfcfd39c2ccc',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T16:24:58.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '83988e7ec2a186ca4a0f0da8d590baac',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 7,
      lift: 0.06726190476190474,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '83988e7ec2a186ca4a0f0da8d590baac',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T18:45:29.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '46821178de896abf44a1a4f8e20d77ca',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 7,
      pvCount: 7,
      lift: 0.06060606060606052,
      baselineSessionCount: 6,
      baselineSessionsPerSecond: 0.02,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '46821178de896abf44a1a4f8e20d77ca',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T21:20:53.522Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '5b778eacbd6d23cc33ef6c6c4e2a4745',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 5,
      pvCount: 9,
      lift: 0.0599206349206349,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '5b778eacbd6d23cc33ef6c6c4e2a4745',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T17:46:58.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'af6b247b48d0b5354c832ab87ea5116d',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 4,
      pvCount: 19,
      lift: 0.03819444444444444,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: 'af6b247b48d0b5354c832ab87ea5116d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T18:16:43.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'fe87be33f95b638153d86fff49b1f55a',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'fe87be33f95b638153d86fff49b1f55a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T11:27:29.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '21047b79fe097da82505e1ff7fe98283',
        affiliate: 'FOX',
        isci: '554686H'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 0.15740740740740733,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'FOX',
      origEventId: '21047b79fe097da82505e1ff7fe98283',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T12:58:42.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '5c1f992165acf93d510b688893e0934b',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 1.811111111111111,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: '5c1f992165acf93d510b688893e0934b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T14:33:37.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ee03bf64f8b313cee27abbb85eb7aff3',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 7,
      pvCount: 10,
      lift: 1.0541666666666665,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: 'ee03bf64f8b313cee27abbb85eb7aff3',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T14:46:56.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b4a3e87185d8409905618ae633d008a0',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 5,
      pvCount: 8,
      lift: 0.07927469135802467,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: 'b4a3e87185d8409905618ae633d008a0',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T19:37:26.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '38fe40bfaa16206c7d889fbb46cae3ed',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 5,
      pvCount: 10,
      lift: -0.0013888888888889208,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: '38fe40bfaa16206c7d889fbb46cae3ed',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T14:44:46.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8fff9155b961005a05d17a772e992661',
        affiliate: 'FOX',
        isci: '554686H'
      },
      sessionCount: 4,
      pvCount: 4,
      lift: 2.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'FOX',
      origEventId: '8fff9155b961005a05d17a772e992661',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T15:43:36.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '5b4a5e639b25624a433295722a6affc2',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 5,
      pvCount: 8,
      lift: 0.07927469135802467,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: '5b4a5e639b25624a433295722a6affc2',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T19:37:26.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a822d4ee037d5e84a600a181b5d7f30a',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.034490740740740745,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: 'a822d4ee037d5e84a600a181b5d7f30a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T10:29:39.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a6dc61ceca0d3514d6bfd014ad981435',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: 'a6dc61ceca0d3514d6bfd014ad981435',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T13:55:25.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '390ff4e703ab0792644d094cd3d8f4eb',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: 0.6666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: '390ff4e703ab0792644d094cd3d8f4eb',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T11:53:59.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '950ac5c90743c8d9917cb2e4a8a82702',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 7,
      pvCount: 12,
      lift: 0.3002777777777777,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: '950ac5c90743c8d9917cb2e4a8a82702',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T19:16:32.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd01f6ec56af6a3ab10cc99f7c7cfea0b',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 0.06342592592592591,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: 'd01f6ec56af6a3ab10cc99f7c7cfea0b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T15:49:11.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'cd1642d74d6c26f9db21878eac9e2ab0',
        affiliate: 'FOX',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.09837962962962961,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'FOX',
      origEventId: 'cd1642d74d6c26f9db21878eac9e2ab0',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T12:37:00.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd4be3580766902ec800e63b39c0e10ef',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.030303030303030325,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: 'd4be3580766902ec800e63b39c0e10ef',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T14:58:02.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0e71faa1f6a2c36648ac7ba02d37887b',
        affiliate: 'FOX',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'FOX',
      origEventId: '0e71faa1f6a2c36648ac7ba02d37887b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T12:32:35.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ea32e8fedab62515048eb433c4765b69',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'ea32e8fedab62515048eb433c4765b69',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T13:41:57.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd3455dfd6b09e841084af120ccee8b63',
        affiliate: 'FOX',
        isci: '558902H'
      },
      sessionCount: 7,
      pvCount: 14,
      lift: 0.9444444444444443,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'FOX',
      origEventId: 'd3455dfd6b09e841084af120ccee8b63',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T17:56:18.926Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'bd66cb03fb80c5ceb082603e6bece5b7',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: 0.6666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: 'bd66cb03fb80c5ceb082603e6bece5b7',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T11:53:59.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '693b262a6dd0cf40ad5709e91ecdd2ce',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 5,
      pvCount: 8,
      lift: 0.031746031746031717,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '693b262a6dd0cf40ad5709e91ecdd2ce',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:47:15.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ceced9b94fd87d4ad49e4c9245028f50',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.1111111111111111,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: 'ceced9b94fd87d4ad49e4c9245028f50',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-14T16:29:07.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2939910748ddc48ab7425ecab7280c11',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: -0.04853174603174605,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '2939910748ddc48ab7425ecab7280c11',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T17:45:53.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c1d7bfb793612bce998b124dfe416075',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 5,
      lift: 3,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: 'c1d7bfb793612bce998b124dfe416075',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-07T00:31:25.560Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0de94f28c2d6519f0cbd5a2103cadb43',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: '0de94f28c2d6519f0cbd5a2103cadb43',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T16:46:10.265Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'fde4c1b303cc3419ad0604a7bfbaa5ad',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 0.3025,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'fde4c1b303cc3419ad0604a7bfbaa5ad',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T16:46:26.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'fdf1ecfdc4574ff43bf1edb5ca746ca7',
        affiliate: 'FOX',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.09560185185185183,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'FOX',
      origEventId: 'fdf1ecfdc4574ff43bf1edb5ca746ca7',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T12:36:56.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '46418efca6d8619a8d632d428f73cec2',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 6,
      lift: -0.1,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: '46418efca6d8619a8d632d428f73cec2',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T14:33:08.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a8ab9ab6b361540ff9d05b8ab644d903',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 8,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: 'a8ab9ab6b361540ff9d05b8ab644d903',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T17:54:43.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4c0679aa4007a77f4638f870e364b17c',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 6,
      lift: -0.07083333333333335,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: '4c0679aa4007a77f4638f870e364b17c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T14:33:41.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6ae511476d4512130eac0a74448f9fe1',
        affiliate: 'FOX',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 0.00441798941798941,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'FOX',
      origEventId: '6ae511476d4512130eac0a74448f9fe1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T14:26:42.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8e68c1d078b979ca0f4e77b86e8eabfe',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 5,
      pvCount: 9,
      lift: 0.6563492063492062,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '8e68c1d078b979ca0f4e77b86e8eabfe',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T17:46:02.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '033617e5527f0fadab32396980dfb070',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '033617e5527f0fadab32396980dfb070',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T10:47:33.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '40f031744e16ad274f62f4e357194f41',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '40f031744e16ad274f62f4e357194f41',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T14:45:46.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '865e74435c0a9c1852d4c30f3529db83',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 4,
      pvCount: 10,
      lift: 0.46696428571428555,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: '865e74435c0a9c1852d4c30f3529db83',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T15:39:00.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '555ab3a9990010dfb892d4d92f1851c5',
        affiliate: 'ABC',
        isci: '554686H'
      },
      sessionCount: 7,
      pvCount: 14,
      lift: 0.4222222222222221,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'ABC',
      origEventId: '555ab3a9990010dfb892d4d92f1851c5',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T16:38:03.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c509255d6d7068c44b84e4707b50b193',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 5,
      pvCount: 6,
      lift: -0.05853174603174606,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'c509255d6d7068c44b84e4707b50b193',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T14:26:07.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b60314c74c5c3202eaf429644f4e36f4',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 3,
      pvCount: 8,
      lift: 1.4999999999999996,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: 'b60314c74c5c3202eaf429644f4e36f4',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T21:41:32.374Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '701091514cc7b41f12f96176a7866612',
        affiliate: 'FOX',
        isci: '554686H'
      },
      sessionCount: 6,
      pvCount: 6,
      lift: 0.37833333333333324,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'FOX',
      origEventId: '701091514cc7b41f12f96176a7866612',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T12:46:01.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '30c5f72d113b51d674f918486fc5d964',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 0.8,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '30c5f72d113b51d674f918486fc5d964',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T14:15:19.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1098f9a29f918e9b8466bd5207153a40',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '1098f9a29f918e9b8466bd5207153a40',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T12:17:32.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '30b6de0c74b54cff7401a80a8be37f9c',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 6,
      pvCount: 9,
      lift: 1.4848484848484844,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '30b6de0c74b54cff7401a80a8be37f9c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T13:29:02.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '03b543c22e70d474278a2c351def93cc',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 10,
      pvCount: 12,
      lift: 10,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '03b543c22e70d474278a2c351def93cc',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T18:19:15.443Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e549537153d505b42103e96a36e9f07b',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: 'e549537153d505b42103e96a36e9f07b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T16:44:31.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'bd68731d5df66626cd70d284a0ab5b05',
        affiliate: 'CW',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.6666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CW',
      origEventId: 'bd68731d5df66626cd70d284a0ab5b05',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T18:24:40.521Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '18d33e0c8e7e1552360b8aaf7f7cb7f6',
        affiliate: 'CBS',
        isci: '558906H'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 1.727272727272727,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CBS',
      origEventId: '18d33e0c8e7e1552360b8aaf7f7cb7f6',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T14:59:31.579Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '48eac8a1da6529c166fb9bf2324ca80e',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: -0.4444444444444446,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '48eac8a1da6529c166fb9bf2324ca80e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T16:15:10.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0f0ab88efe6c6612fe6901b98798b5c1',
        affiliate: 'MNTV',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'MNTV',
      origEventId: '0f0ab88efe6c6612fe6901b98798b5c1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-07T13:24:08.384Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '334284274a77e5738a97629361c1b934',
        affiliate: 'CW',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CW',
      origEventId: '334284274a77e5738a97629361c1b934',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T12:30:41.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2429410c310bac3774456302ca17263b',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.14285714285714285,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '2429410c310bac3774456302ca17263b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T11:27:59.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6c900b16267e31c4ef5a08ce248e9d77',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 9,
      lift: 0.323015873015873,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '6c900b16267e31c4ef5a08ce248e9d77',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T14:15:01.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '768348b0d9ddf7c20ea3446d00d50193',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.13333333333333333,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: '768348b0d9ddf7c20ea3446d00d50193',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T12:27:15.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '323fd88f4fbd6faa8c2f2f0bb7c734cd',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 0.1980753968253968,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: '323fd88f4fbd6faa8c2f2f0bb7c734cd',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T15:38:45.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7b38a8de1afee0150b22b05a5a2f905a',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 11,
      lift: 0.5680555555555555,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '7b38a8de1afee0150b22b05a5a2f905a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T16:46:12.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '886839a23f1dbecdc0b49b9480e902cc',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '886839a23f1dbecdc0b49b9480e902cc',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T13:28:46.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '079e842300faecb009ced4f591141369',
        affiliate: 'FOX',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 6,
      lift: 0.2857142857142857,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'FOX',
      origEventId: '079e842300faecb009ced4f591141369',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T12:24:21.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3bd656c3f190493e8afc3a92566b4e01',
        affiliate: 'CBS',
        isci: '554686H'
      },
      sessionCount: 5,
      pvCount: 8,
      lift: 0.09860339506172837,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'CBS',
      origEventId: '3bd656c3f190493e8afc3a92566b4e01',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T19:36:26.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'cdb4dc12b04f8b07f67aff7214f820fb',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: 'cdb4dc12b04f8b07f67aff7214f820fb',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T17:49:14.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '364b1f62a0d485625ac5e6a23b88ac59',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 9,
      pvCount: 18,
      lift: 0.6221825396825396,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '364b1f62a0d485625ac5e6a23b88ac59',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T17:18:29.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '08f527046120901ef985478ba2846774',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 5,
      pvCount: 10,
      lift: 0.1216269841269841,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '08f527046120901ef985478ba2846774',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T17:17:57.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4b62b12eff5392ec1ef4dff5eea87454',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 5,
      pvCount: 5,
      lift: 3.545454545454545,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '4b62b12eff5392ec1ef4dff5eea87454',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T15:24:53.975Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ec3e10553ecfd2b6830baae3caa11bbb',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 4,
      pvCount: 12,
      lift: 0.10937059082892416,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: 'ec3e10553ecfd2b6830baae3caa11bbb',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:43:17.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0a5b16e808dd0d7f88ff513db764d311',
        affiliate: 'MNTV',
        isci: '558908H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558908H',
      affiliate: 'MNTV',
      origEventId: '0a5b16e808dd0d7f88ff513db764d311',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T18:26:35.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '7799b02548a724834e15d24a18b9ed51',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 6,
      pvCount: 16,
      lift: 0.2650396825396825,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '7799b02548a724834e15d24a18b9ed51',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T17:19:55.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '086b1bff0cd83a679cbd2bb7d622294a',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 7,
      pvCount: 8,
      lift: 0.26686507936507936,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '086b1bff0cd83a679cbd2bb7d622294a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T14:12:53.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd07968b0e6b86634700577b9deb906cc',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'd07968b0e6b86634700577b9deb906cc',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T14:47:13.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '541163bc72e18135aa1d487b8eaacd8f',
        affiliate: 'FOX',
        isci: '554686H'
      },
      sessionCount: 4,
      pvCount: 4,
      lift: 2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'FOX',
      origEventId: '541163bc72e18135aa1d487b8eaacd8f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T15:44:11.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd6b5beec566093137a0f9a70aa74dfbf',
        affiliate: 'IND (ERBK)',
        isci: '558908H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558908H',
      affiliate: 'IND (ERBK)',
      origEventId: 'd6b5beec566093137a0f9a70aa74dfbf',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T15:15:02.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '0e30ff6c7462806497f13a05ae64b31f',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 5,
      pvCount: 8,
      lift: 0.12706349206349205,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '0e30ff6c7462806497f13a05ae64b31f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T19:41:49.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a92784fe4c7c63e041355efacc2c358d',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 9,
      lift: 0.2837301587301587,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'a92784fe4c7c63e041355efacc2c358d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T14:15:23.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'cffa28c7043cad529d2bf2a56583a5e2',
        affiliate: 'ABC',
        isci: '554686H'
      },
      sessionCount: 3,
      pvCount: 9,
      lift: 1.509259259259259,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'ABC',
      origEventId: 'cffa28c7043cad529d2bf2a56583a5e2',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:17:38.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '37467c5e993668189aa0f5bb075af7fa',
        affiliate: 'MNTV',
        isci: '554686H'
      },
      sessionCount: 2,
      pvCount: 9,
      lift: -0.4444444444444446,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'MNTV',
      origEventId: '37467c5e993668189aa0f5bb075af7fa',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T22:53:42.021Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '44fadcb6e2e106a0331a3461ec401104',
        affiliate: 'CBS',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'CBS',
      origEventId: '44fadcb6e2e106a0331a3461ec401104',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-14T00:35:56.343Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8526de4a35804ee8adb073df2cf75a5b',
        affiliate: 'NBC',
        isci: '558908H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558908H',
      affiliate: 'NBC',
      origEventId: '8526de4a35804ee8adb073df2cf75a5b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T14:23:27.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: 'bf1ef5136812f65621e726f3e3e4bebd',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: 0.7,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'bf1ef5136812f65621e726f3e3e4bebd',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T16:30:12.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd9694529b8fd97695021f3dead64f195',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: 'd9694529b8fd97695021f3dead64f195',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T17:00:10.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'fe47b95524331e7378fbaf8a56d65b42',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 5,
      pvCount: 7,
      lift: 0.8410714285714284,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'fe47b95524331e7378fbaf8a56d65b42',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T17:17:44.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '16aa42b6e0e830e88092e88b245d5163',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 5,
      lift: 0.17599206349206348,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '16aa42b6e0e830e88092e88b245d5163',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T17:16:15.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3171045f7fe3e4e207af84dee4e4beca',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 7,
      lift: 0.03234126984126982,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '3171045f7fe3e4e207af84dee4e4beca',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T18:45:51.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '277781800022ec49e1e74d7dd82b9113',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 4,
      pvCount: 7,
      lift: 4,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '277781800022ec49e1e74d7dd82b9113',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T17:29:21.455Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '35aa19b6f08b8f7e3e3d61643fd6e990',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 4,
      pvCount: 5,
      lift: 0.8650793650793651,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '35aa19b6f08b8f7e3e3d61643fd6e990',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T15:46:47.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '813ca4b5994ab6263d5507298979ba0a',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 6,
      pvCount: 10,
      lift: 1.6495370370370368,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: '813ca4b5994ab6263d5507298979ba0a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T15:18:06.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3a7c6994d5e360772004604376b1aa14',
        affiliate: 'IND (ERBK)',
        isci: '558908H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.09090909090909098,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558908H',
      affiliate: 'IND (ERBK)',
      origEventId: '3a7c6994d5e360772004604376b1aa14',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T15:16:50.441Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: 'da4abaae0c9775d46f46f7b695ad4e41',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 10,
      pvCount: 20,
      lift: 0.31046296296296294,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: 'da4abaae0c9775d46f46f7b695ad4e41',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T15:37:02.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd9ea1629bfa42210a74ae0c349d88332',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.09090909090909098,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: 'd9ea1629bfa42210a74ae0c349d88332',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T16:59:31.299Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a56dc17b322027e0c2c804fb1cc5a5be',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 7,
      pvCount: 8,
      lift: 0.05436507936507933,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'a56dc17b322027e0c2c804fb1cc5a5be',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T14:27:32.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6fc1fdf339c5a4cdb7d89097ca34edf8',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '6fc1fdf339c5a4cdb7d89097ca34edf8',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T22:15:14.139Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6bb342ab8a0fc48b380c92a1842f81f2',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: 0.14285714285714285,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '6bb342ab8a0fc48b380c92a1842f81f2',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T12:23:51.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e9dfdc8c7d98c3f249bb6e7a0829fccf',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 7,
      lift: 0.6666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: 'e9dfdc8c7d98c3f249bb6e7a0829fccf',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T09:38:43.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0781ba4f272090ca299f68ac112ac580',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '0781ba4f272090ca299f68ac112ac580',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T11:49:53.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2dc61a66c2b4d699836e37f5a139bd27',
        affiliate: 'FOX',
        isci: '554686H'
      },
      sessionCount: 4,
      pvCount: 5,
      lift: 2.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'FOX',
      origEventId: '2dc61a66c2b4d699836e37f5a139bd27',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T17:46:07.496Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '17f5b47c4a1acf47f5d1623cf3a7bb9c',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 7,
      pvCount: 17,
      lift: 0.5783730158730158,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '17f5b47c4a1acf47f5d1623cf3a7bb9c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T17:20:18.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd3b8d62306f880a6596b9dd27be4f792',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 4,
      pvCount: 10,
      lift: 0.27222222222222214,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: 'd3b8d62306f880a6596b9dd27be4f792',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T15:46:51.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1861d95c223b6e954493ae38750e8bfc',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: 0.26666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: '1861d95c223b6e954493ae38750e8bfc',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T19:32:01.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a89571db951448740608d246c073d585',
        affiliate: 'ABC',
        isci: '554686H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 1.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'ABC',
      origEventId: 'a89571db951448740608d246c073d585',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T11:39:55.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'bca5a48c0f901218ed4c99086a2fa34d',
        affiliate: 'ABC',
        isci: '554694H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554694H',
      affiliate: 'ABC',
      origEventId: 'bca5a48c0f901218ed4c99086a2fa34d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T11:28:49.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: 'ce153e648273b231b2b0e4bb8216ac87',
        affiliate: 'FOX',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 0.0019179894179894086,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'FOX',
      origEventId: 'ce153e648273b231b2b0e4bb8216ac87',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T14:27:00.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2e3ee1d42fee355627177a72c051706c',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 4,
      pvCount: 12,
      lift: 0.06571649029982361,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: '2e3ee1d42fee355627177a72c051706c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:11:08.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2dbe31a936f53f896445068af50cb43f',
        affiliate: 'ABC',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.2830541667011049,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'ABC',
      origEventId: '2dbe31a936f53f896445068af50cb43f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T13:59:32.898Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '5a15b29769fcfd229b1b404e662a8a01',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '5a15b29769fcfd229b1b404e662a8a01',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T16:57:46.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '610386777d1e0bf1cf0d250f0ec60938',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 4,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '610386777d1e0bf1cf0d250f0ec60938',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T19:12:58.360Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '00d27358d9231e99a70959054ec1e8da',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '00d27358d9231e99a70959054ec1e8da',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T09:25:07.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8af890c588d520236bc63057b344805f',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.6666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '8af890c588d520236bc63057b344805f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T18:24:14.810Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c1b528b5bdae00979c646452e20e42b7',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 0.11264991181657846,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: 'c1b528b5bdae00979c646452e20e42b7',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T13:56:57.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '873bb5fe14e0ed66c7096b647524268c',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 0.1057716049382716,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: '873bb5fe14e0ed66c7096b647524268c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T13:56:44.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'de9cb40cf25ede8ee8bcf69c881328ce',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 4,
      pvCount: 8,
      lift: 0.6666666666666664,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: 'de9cb40cf25ede8ee8bcf69c881328ce',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T18:27:01.629Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '9601c93450e1a0d3187f604b78bd97ec',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: '9601c93450e1a0d3187f604b78bd97ec',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T16:52:38.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd7d9ef0b41c9ea465d543ab4db8a6c33',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 0.8,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'd7d9ef0b41c9ea465d543ab4db8a6c33',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T14:16:26.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2630c6d61478bd663388175af4e8c431',
        affiliate: 'ABC',
        isci: '554686H'
      },
      sessionCount: 3,
      pvCount: 9,
      lift: -0.375,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'ABC',
      origEventId: '2630c6d61478bd663388175af4e8c431',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T20:44:55.235Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ef55bdf162cdcf2cc622bb31d7256084',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 10,
      lift: -0.235515873015873,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'ef55bdf162cdcf2cc622bb31d7256084',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T18:44:58.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3fdb008c002c7979c7ddaec25e884331',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.6666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: '3fdb008c002c7979c7ddaec25e884331',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T14:32:55.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '49ced2241deac108ab83dda039dd3267',
        affiliate: 'CW',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CW',
      origEventId: '49ced2241deac108ab83dda039dd3267',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T15:38:24.233Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '735cbaefbfeaa9dc9dc186c2fa0e13f2',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 5,
      pvCount: 8,
      lift: 0.8513888888888886,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: '735cbaefbfeaa9dc9dc186c2fa0e13f2',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T15:17:47.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '924d87932df1fe5027bb677659f6b40f',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 1.1428571428571426,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '924d87932df1fe5027bb677659f6b40f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T14:22:38.771Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '31138719b1ba50519fe191224c7083ef',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 7,
      lift: -0.309072618825095,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '31138719b1ba50519fe191224c7083ef',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T20:42:35.209Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1e544e7b23f457568b21b2df16e0ccad',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 7,
      pvCount: 14,
      lift: 0.6612119047414687,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '1e544e7b23f457568b21b2df16e0ccad',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T15:42:08.243Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '9e9f41dd33de25ad28adda9758b9c904',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 5,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '9e9f41dd33de25ad28adda9758b9c904',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T13:42:51.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '42ad149e3b86ae95d4382cf766c3b4dd',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 6,
      pvCount: 9,
      lift: 1.4848484848484844,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '42ad149e3b86ae95d4382cf766c3b4dd',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T13:29:02.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a08f4e688358699e189d2eed8df49055',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 7,
      lift: 0.3807407407407407,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: 'a08f4e688358699e189d2eed8df49055',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T14:37:31.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '70f6e2a7293d6c3634de248eaf2aee27',
        affiliate: 'FOX',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.09560185185185183,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'FOX',
      origEventId: '70f6e2a7293d6c3634de248eaf2aee27',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T12:36:56.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f0b55df3d5c7d4ec032526782715e4e0',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: -0.07013007054673723,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: 'f0b55df3d5c7d4ec032526782715e4e0',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T19:15:45.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ab0008ce0f61831930ece39f5ec34b9b',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 7,
      pvCount: 14,
      lift: 0.37218253968253967,
      baselineSessionCount: 5,
      baselineSessionsPerSecond: 0.016666666666666666,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'ab0008ce0f61831930ece39f5ec34b9b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T18:10:45.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '49e182599e696a01050aef48566ffc90',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.42857142857142844,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '49e182599e696a01050aef48566ffc90',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T19:14:41.958Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3f9aa205a6a05740e4aff71ca556a5fe',
        affiliate: 'IND (ERBK)',
        isci: '558908H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558908H',
      affiliate: 'IND (ERBK)',
      origEventId: '3f9aa205a6a05740e4aff71ca556a5fe',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-14T18:20:03.221Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: 'ce787390de338644fbb1a90102acb0ec',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'ce787390de338644fbb1a90102acb0ec',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T13:41:13.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a66db3eccb6d68798b60624e977c4c6a',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: 0.42857142857142844,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'a66db3eccb6d68798b60624e977c4c6a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T18:47:08.189Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ef2fa822b7fa149d4f438ec22dce5939',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.3666666666666667,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'ef2fa822b7fa149d4f438ec22dce5939',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T11:28:46.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2b24577ca7e75b64c43056373e875dd8',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: '2b24577ca7e75b64c43056373e875dd8',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T08:46:39.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '964e27ba28633b61c34257b866df7712',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '964e27ba28633b61c34257b866df7712',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T16:20:45.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '17986813c433f39f1e786ba657b032f0',
        affiliate: 'CW',
        isci: '554686H'
      },
      sessionCount: 6,
      pvCount: 16,
      lift: 0.7254763887988195,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'CW',
      origEventId: '17986813c433f39f1e786ba657b032f0',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T16:53:52.712Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '94d9f4354b0706f6d9c45707431a7ad2',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '94d9f4354b0706f6d9c45707431a7ad2',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T16:24:21.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3055e9e37f039a75f723f1bab571cd3b',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '3055e9e37f039a75f723f1bab571cd3b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T11:49:53.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'dc695506db261baa0f2d368d6c9caf85',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.3666666666666667,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'dc695506db261baa0f2d368d6c9caf85',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T11:27:17.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '5df30a0744ce2f8e7c9cd7b6d6d5580b',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 4,
      pvCount: 13,
      lift: 0.050419973544973545,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '5df30a0744ce2f8e7c9cd7b6d6d5580b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:42:43.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1b6c4a335e3e15fd37707856f91569a1',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: '1b6c4a335e3e15fd37707856f91569a1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T08:44:48.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0a416face5316087e299fe98756b2026',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 5,
      pvCount: 8,
      lift: 0.11527006172839502,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: '0a416face5316087e299fe98756b2026',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T19:36:42.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2c0f844e8cfb8fd748f1c26ace763c72',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 7,
      pvCount: 10,
      lift: 0.2527777777777777,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '2c0f844e8cfb8fd748f1c26ace763c72',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T14:14:44.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '190b9f1bdf8caf83677a854bf31f647a',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 0.06180555555555554,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: '190b9f1bdf8caf83677a854bf31f647a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T15:24:20.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '378f2330d7812be209094b43fae30518',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.09090909090909091,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: '378f2330d7812be209094b43fae30518',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T09:57:20.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '82a685c49d1e0cb2aa49dba56ff7663b',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 0.11264991181657846,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: '82a685c49d1e0cb2aa49dba56ff7663b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T13:57:12.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3ab4a1613877a4c7501d31068bce2a33',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 0.06180555555555554,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: '3ab4a1613877a4c7501d31068bce2a33',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T15:24:20.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a9a71288f3d441fe5d397ad59288df46',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 0.5167592592592591,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: 'a9a71288f3d441fe5d397ad59288df46',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T19:14:15.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'cf47cb05725f78ce12d29c8a6a62381c',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: 'cf47cb05725f78ce12d29c8a6a62381c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T12:17:32.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '381673fd1259e3489ed54c8a9d47e332',
        affiliate: 'MNTV',
        isci: '554686H'
      },
      sessionCount: 4,
      pvCount: 15,
      lift: 0.9009259259259258,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'MNTV',
      origEventId: '381673fd1259e3489ed54c8a9d47e332',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T17:54:10.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4adee81ae1809b86209bca955393d8ba',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 18,
      lift: 0.021673280423280417,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: '4adee81ae1809b86209bca955393d8ba',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T18:17:00.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '178a172851f940b4a9f556b1c6f0b562',
        affiliate: 'FOX',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 6,
      lift: 0.2857142857142857,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'FOX',
      origEventId: '178a172851f940b4a9f556b1c6f0b562',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T12:23:59.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '05b5fe2602d7b98e58f6cd22c9829659',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 7,
      lift: 1.6618892857006615,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '05b5fe2602d7b98e58f6cd22c9829659',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T16:27:22.647Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ddfe3e8052f71e7b2360417d67442601',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 0.0626190476190476,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'ddfe3e8052f71e7b2360417d67442601',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T15:44:04.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7a712e1ae1daf46dafefe2ac477dc609',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 3,
      pvCount: 5,
      lift: -0.13333333333333333,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: '7a712e1ae1daf46dafefe2ac477dc609',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T19:46:11.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f113fc681da491a97af1b62701b29e0e',
        affiliate: 'ABC',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 4,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'ABC',
      origEventId: 'f113fc681da491a97af1b62701b29e0e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T14:25:37.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '69d3dd9a7b104398d857f091f4a2b809',
        affiliate: 'ABC',
        isci: '554686H'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 0.2499999999999998,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'ABC',
      origEventId: '69d3dd9a7b104398d857f091f4a2b809',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T21:37:29.770Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd2ed6a3ba399aaebe9ac965edd527850',
        affiliate: 'CW',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'CW',
      origEventId: 'd2ed6a3ba399aaebe9ac965edd527850',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T12:32:21.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6087681dc99d473cd651328e4ef5a5cc',
        affiliate: 'ABC',
        isci: '554686H'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 0.48379629629629617,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'ABC',
      origEventId: '6087681dc99d473cd651328e4ef5a5cc',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T15:54:42.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '52d911225eb953dee4c09d112dfb202c',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.08717592592592595,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '52d911225eb953dee4c09d112dfb202c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T17:44:39.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '06ba2686469a0e804b7387a1f684cdea',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.027073105465962605,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '06ba2686469a0e804b7387a1f684cdea',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-07T16:46:48.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '30997ec16d3f55feb78ed45b6787bcec',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '30997ec16d3f55feb78ed45b6787bcec',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T17:00:10.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0f326d8929b1eca11ec812c45e60fddf',
        affiliate: 'IND (ERBK)',
        isci: '558908H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558908H',
      affiliate: 'IND (ERBK)',
      origEventId: '0f326d8929b1eca11ec812c45e60fddf',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T15:18:17.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '3717a6236187208eb1ff3b5b4581bf81',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '3717a6236187208eb1ff3b5b4581bf81',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T12:14:00.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '08e594bd57f2f531145d5e74d7b6bd74',
        affiliate: 'IND (ERBK)',
        isci: '558908H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558908H',
      affiliate: 'IND (ERBK)',
      origEventId: '08e594bd57f2f531145d5e74d7b6bd74',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T15:18:17.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '26445921f2a326a733b72ccd38aee725',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 4,
      pvCount: 10,
      lift: 0.47251984126984115,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: '26445921f2a326a733b72ccd38aee725',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T15:38:54.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '69ed86dd03fb2422c9cbab97b972e43f',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 5,
      pvCount: 10,
      lift: -0.0013888888888889208,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: '69ed86dd03fb2422c9cbab97b972e43f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T14:44:46.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6ba80b6eec7bac6068e36d2cf3fd0a41',
        affiliate: 'CW',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CW',
      origEventId: '6ba80b6eec7bac6068e36d2cf3fd0a41',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T12:50:16.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '260e5620e43e04345e03735c60e00292',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.04490740740740741,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: '260e5620e43e04345e03735c60e00292',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T10:30:01.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8ecd53ea9df10e20ac685c123c23a4c7',
        affiliate: 'CW',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CW',
      origEventId: '8ecd53ea9df10e20ac685c123c23a4c7',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T11:48:23.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '9e0496bbc4aa289c301fc6de9d64f98c',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 7,
      pvCount: 8,
      lift: 0.9444444444444443,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: '9e0496bbc4aa289c301fc6de9d64f98c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T17:27:22.154Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'dd88c5d8fcc1b2b0576d64be9fb041fd',
        affiliate: 'FOX',
        isci: '554686H'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 0.20601851851851843,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'FOX',
      origEventId: 'dd88c5d8fcc1b2b0576d64be9fb041fd',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T12:59:17.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd3edb611623df26a5104e4057a6ccb6a',
        affiliate: 'FOX',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: -0.0036375661375661473,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'FOX',
      origEventId: 'd3edb611623df26a5104e4057a6ccb6a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T14:27:16.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7848190d7d913d860a16116f196854e4',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 6,
      lift: 0.42857142857142855,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '7848190d7d913d860a16116f196854e4',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T12:37:26.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1265eb31616b9c303c19de493845574a',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '1265eb31616b9c303c19de493845574a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T14:30:02.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2e1367dda9b0c40b66db5e19a0855a70',
        affiliate: 'MNTV',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.25925925925925924,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'MNTV',
      origEventId: '2e1367dda9b0c40b66db5e19a0855a70',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T13:17:38.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '65f8ca5b8d2b7f6172a19af51a044760',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 5,
      pvCount: 13,
      lift: -0.16666666666666682,
      baselineSessionCount: 5,
      baselineSessionsPerSecond: 0.016666666666666666,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: '65f8ca5b8d2b7f6172a19af51a044760',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T20:24:12.093Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2fdc105270b29ae55913f6ff22e1e5f4',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: -0.09464836860670194,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: '2fdc105270b29ae55913f6ff22e1e5f4',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T14:18:22.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a481e0db272c26f44e48ff777534668f',
        affiliate: 'IND (ERBK)',
        isci: '558908H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558908H',
      affiliate: 'IND (ERBK)',
      origEventId: 'a481e0db272c26f44e48ff777534668f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T15:15:25.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: 'c375d4eeaff07ac00604ccff677b2164',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 7,
      pvCount: 9,
      lift: 3.9999999999999996,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'c375d4eeaff07ac00604ccff677b2164',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T14:44:14.549Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7bc96e0a3d2fce9e39f3bb0a36d89ad6',
        affiliate: 'CW',
        isci: '554686H'
      },
      sessionCount: 4,
      pvCount: 12,
      lift: 4,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'CW',
      origEventId: '7bc96e0a3d2fce9e39f3bb0a36d89ad6',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T17:32:21.711Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd4336c5932d024eae42363056231bab0',
        affiliate: 'ABC',
        isci: '554686H'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 1.4999999999999996,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'ABC',
      origEventId: 'd4336c5932d024eae42363056231bab0',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T20:17:44.133Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6b77ccf81e37d162ff0b78612599f9c2',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.19090909090909092,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: '6b77ccf81e37d162ff0b78612599f9c2',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T15:21:29.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd691fd652bd1d42f6929a1bbecdae524',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'd691fd652bd1d42f6929a1bbecdae524',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-07T17:43:31.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1326cd7af1756d9d4cda092263e084f6',
        affiliate: 'IND (ERBK)',
        isci: '558908H'
      },
      sessionCount: 1,
      pvCount: 4,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558908H',
      affiliate: 'IND (ERBK)',
      origEventId: '1326cd7af1756d9d4cda092263e084f6',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T19:15:15.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '928eb883ddb130a7b9290314dcbdd197',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.09090909090909091,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: '928eb883ddb130a7b9290314dcbdd197',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T09:57:38.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'dd7f5a5a1d543db3a59cd5674997b8a5',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.14982993197278913,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'dd7f5a5a1d543db3a59cd5674997b8a5',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T15:43:56.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '20eda1fd92d41c788f4571a63b503bf3',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 6,
      pvCount: 9,
      lift: 1.4848484848484844,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '20eda1fd92d41c788f4571a63b503bf3',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T13:29:02.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'eaa36f8600afe098a8b7ff1068ecf8d1',
        affiliate: 'ABC',
        isci: '554686H'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 0.8666666666666667,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'ABC',
      origEventId: 'eaa36f8600afe098a8b7ff1068ecf8d1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T11:23:32.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ab36de015ebede208258cc35a0ca9c07',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 7,
      pvCount: 8,
      lift: 0.5136904761904761,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'ab36de015ebede208258cc35a0ca9c07',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T15:16:50.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0999138a8baa46835c8a80e78a8e6d74',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '0999138a8baa46835c8a80e78a8e6d74',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T12:18:07.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'fd861e1d36016c610be19d906332167e',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 7,
      pvCount: 8,
      lift: 0.019444444444444424,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'fd861e1d36016c610be19d906332167e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T14:27:54.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd30978954bc76e36fe453d972f5ff407',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 0.05972222222222222,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: 'd30978954bc76e36fe453d972f5ff407',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T15:24:11.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '18525e8cb587b62897b5ee2c7d52cbbd',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.36828703703703697,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: '18525e8cb587b62897b5ee2c7d52cbbd',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T14:37:05.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '97c7de84c2ed9577cfad8b58a976030c',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: 0.26666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: '97c7de84c2ed9577cfad8b58a976030c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T19:31:38.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8bfdc11055c71dda41bf3d7cb8047129',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 0.7027777777777776,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: '8bfdc11055c71dda41bf3d7cb8047129',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T19:13:39.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e475dfefbbb9936fbcb0ba5bae8675fc',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.05595238095238089,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'e475dfefbbb9936fbcb0ba5bae8675fc',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T14:43:48.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'da05509dc67ed39101d95082667bdbea',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: -0.5000000000000001,
      baselineSessionCount: 5,
      baselineSessionsPerSecond: 0.016666666666666666,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: 'da05509dc67ed39101d95082667bdbea',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T14:28:31.629Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3208bd3fa4bed78d9ac62b9037d06867',
        affiliate: 'MNTV',
        isci: '554686H'
      },
      sessionCount: 6,
      pvCount: 10,
      lift: 0.6999999999999998,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'MNTV',
      origEventId: '3208bd3fa4bed78d9ac62b9037d06867',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T19:18:18.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '69f200b0e3f8557d6b24e74442f468dc',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: -0.12083333333333342,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '69f200b0e3f8557d6b24e74442f468dc',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T15:42:34.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '5a5f7f1688e9b0a4ab9792f3d007fe29',
        affiliate: 'IND (ERBK)',
        isci: '554692H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554692H',
      affiliate: 'IND (ERBK)',
      origEventId: '5a5f7f1688e9b0a4ab9792f3d007fe29',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T19:43:56.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '19fef73b100744a03b312d97b9df6c2e',
        affiliate: 'CBS',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.09090909090909091,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CBS',
      origEventId: '19fef73b100744a03b312d97b9df6c2e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T09:59:45.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7f892df7a4ff77cd49cbe1ad3ff2f541',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 9,
      lift: 3,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '7f892df7a4ff77cd49cbe1ad3ff2f541',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T13:45:42.285Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7651dd23ac3ae49c28f6a89d9321a36d',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 5,
      lift: 1.8571428571428568,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '7651dd23ac3ae49c28f6a89d9321a36d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T22:17:02.939Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '86bc1962bad562b92da9d02e83ac585c',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 1.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '86bc1962bad562b92da9d02e83ac585c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T15:13:51.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '196ea9d75a57af0e54985d000c5d4757',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.7041666666666665,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: '196ea9d75a57af0e54985d000c5d4757',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T11:27:43.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4aca669a31fc5a45904d8c3a3535673b',
        affiliate: 'CW',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 12,
      lift: 0.6706393939076049,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CW',
      origEventId: '4aca669a31fc5a45904d8c3a3535673b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T16:30:21.405Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '42e89a0b90002244a2c994c59aa0a445',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 12,
      lift: 0.017213044891616333,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '42e89a0b90002244a2c994c59aa0a445',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T15:16:20.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '5a0785b82a5913133fc26c7ac3faf19b',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 4,
      pvCount: 12,
      lift: 0.06803130511463842,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: '5a0785b82a5913133fc26c7ac3faf19b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:11:13.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2960f8d26d24cc0abd43cd80f8b5b5c3',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 7,
      pvCount: 8,
      lift: 0.05436507936507933,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '2960f8d26d24cc0abd43cd80f8b5b5c3',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T14:26:50.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b60bfd5afd89c6ffa3234d8c95c236e8',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: 2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: 'b60bfd5afd89c6ffa3234d8c95c236e8',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T17:14:02.374Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ceda78968ebdf9d0ad0b827baea85347',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: 'ceda78968ebdf9d0ad0b827baea85347',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-14T17:25:13.533Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'cd801fabd110c87742b243ef9314ce8d',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 7,
      lift: 0.3407407407407407,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: 'cd801fabd110c87742b243ef9314ce8d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T14:37:13.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e6a7a5849bea23ba434324e68f9ce303',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: -0.11481481481481481,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: 'e6a7a5849bea23ba434324e68f9ce303',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T19:46:24.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a0701b1cbf15d24b26bfa776399c85b3',
        affiliate: 'CBS',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 8,
      lift: -0.04444444444444446,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CBS',
      origEventId: 'a0701b1cbf15d24b26bfa776399c85b3',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T19:49:32.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '07cd1d7692e9b02723b02a61d9260aa6',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.14285714285714285,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '07cd1d7692e9b02723b02a61d9260aa6',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T11:27:59.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1a91d21ee5d69108b1ca42a935064eaa',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 5,
      pvCount: 5,
      lift: 2.5714285714285707,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '1a91d21ee5d69108b1ca42a935064eaa',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T19:13:37.285Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4f03e45f9b6aef22291f7588447c6115',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: '4f03e45f9b6aef22291f7588447c6115',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T17:49:14.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '471269011ce8b13b70b82a0efb5e8bc2',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 15,
      lift: 0.4845238095238094,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '471269011ce8b13b70b82a0efb5e8bc2',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T16:45:26.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'fbaafcffe7d7033633f8e018562c0a5a',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 0.1980753968253968,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: 'fbaafcffe7d7033633f8e018562c0a5a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T15:38:45.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4a735646b2ba7890d435932c3846377f',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 14,
      lift: 0.5833333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '4a735646b2ba7890d435932c3846377f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T16:46:10.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a4b6b7dc72a9d4f8037992ea87daeb45',
        affiliate: 'CW',
        isci: '554686H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'CW',
      origEventId: 'a4b6b7dc72a9d4f8037992ea87daeb45',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T16:53:04.133Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f07492eb57c4e3d0859b167e5c43e04c',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 5,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: 'f07492eb57c4e3d0859b167e5c43e04c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T13:42:51.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '45734000d7aee0148578213c1c9ce2f2',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 7,
      lift: 0.11285714285714282,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '45734000d7aee0148578213c1c9ce2f2',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T18:12:37.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7f967e3e689c045afe9f2277abaead3d',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 4,
      pvCount: 5,
      lift: 0.05555555555555548,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '7f967e3e689c045afe9f2277abaead3d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T19:44:00.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1cf79f67a2dd26b5632fbe53e56f95a5',
        affiliate: 'IND (ERBK)',
        isci: '558908H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558908H',
      affiliate: 'IND (ERBK)',
      origEventId: '1cf79f67a2dd26b5632fbe53e56f95a5',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T13:14:54.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '9401ee80fa28b46dd40a56d8c77ef6f1',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '9401ee80fa28b46dd40a56d8c77ef6f1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T11:31:33.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6a1afa05a866dff5a198b06d46d21d1c',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 9,
      lift: 0.32380952380952377,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '6a1afa05a866dff5a198b06d46d21d1c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T14:13:33.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd8f706ede675083ec2416f68c6fdad19',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'd8f706ede675083ec2416f68c6fdad19',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T10:44:14.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '68028d57c41ae0b33ee26e9fe5d73208',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 3,
      pvCount: 9,
      lift: 1.801781817999753,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '68028d57c41ae0b33ee26e9fe5d73208',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T15:12:04.757Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'df7f2c60a4d572e67a8baf7a45f5705a',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: -0.11481481481481481,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: 'df7f2c60a4d572e67a8baf7a45f5705a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T19:46:24.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3030972aaffdaf64a7d1ae773c69b960',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: 2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '3030972aaffdaf64a7d1ae773c69b960',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T22:16:11.487Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1209badfadd538bea1effbcfc2aa6fe2',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: '1209badfadd538bea1effbcfc2aa6fe2',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T16:53:09.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '96993d7024d716e5b1c366f59906a3d7',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 13,
      lift: 0.04093915343915343,
      baselineSessionCount: 5,
      baselineSessionsPerSecond: 0.016666666666666666,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '96993d7024d716e5b1c366f59906a3d7',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T14:16:24.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3b77b35e0d67b9acc479449bada25ffc',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: 0.09879629629629626,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: '3b77b35e0d67b9acc479449bada25ffc',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T14:37:48.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1a9e2572faa44d13d881ab2edc0ec64c',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.42857142857142844,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '1a9e2572faa44d13d881ab2edc0ec64c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T20:12:00.235Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '55e24892f00d6d91611d1ce1fa3939da',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.7,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '55e24892f00d6d91611d1ce1fa3939da',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T13:25:55.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '583a53308e4342dcd13fdd211df40973',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 1.1152777777777776,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: '583a53308e4342dcd13fdd211df40973',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T18:12:08.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b9387e0c084f856bc434600a703a434a',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 7,
      lift: 0.013888888888888873,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: 'b9387e0c084f856bc434600a703a434a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T19:57:54.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e1050eca9d9de928fe6aef1ccefaac5c',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 7,
      pvCount: 7,
      lift: 5.363636363636363,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: 'e1050eca9d9de928fe6aef1ccefaac5c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T18:28:51.499Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0e829d738b02b43e859a649f94a2228b',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 5,
      pvCount: 17,
      lift: 1.583333333333333,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '0e829d738b02b43e859a649f94a2228b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T18:15:22.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '621fe96e2c0716f8da9051a4e70d4abc',
        affiliate: 'FOX',
        isci: '558902H'
      },
      sessionCount: 5,
      pvCount: 10,
      lift: 0.09544027778837415,
      baselineSessionCount: 5,
      baselineSessionsPerSecond: 0.016666666666666666,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'FOX',
      origEventId: '621fe96e2c0716f8da9051a4e70d4abc',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T19:26:47.006Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '587472b79598cb9670447018798dc293',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '587472b79598cb9670447018798dc293',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T12:17:32.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '44331075667d363eaf78d6b2ab91c547',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: '44331075667d363eaf78d6b2ab91c547',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T17:49:14.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '9cb92d56dbd0cb510abf5d3e1391af57',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: -0.07707451499118166,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: '9cb92d56dbd0cb510abf5d3e1391af57',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T19:15:30.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'bd793a01c572db31b612d8df8d6715a0',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: 0.26666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: 'bd793a01c572db31b612d8df8d6715a0',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T19:32:01.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '12fe81de4897de9c2e5e6af9af7bc33d',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: -0.058796296296296305,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '12fe81de4897de9c2e5e6af9af7bc33d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T19:58:09.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '33d5cee73bf0c8f87bcb6d698ff7a591',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 3,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '33d5cee73bf0c8f87bcb6d698ff7a591',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T19:43:54.308Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1bed01bbeef8f0baa70698e9e5af98ec',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.14285714285714285,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '1bed01bbeef8f0baa70698e9e5af98ec',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T11:27:32.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b6bcc0b114aca46800b5ba90d96295b3',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 4,
      lift: 0.1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: 'b6bcc0b114aca46800b5ba90d96295b3',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T19:31:21.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'df337161d6ab2423dae6928d341e59b5',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 0.30250000000000005,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'df337161d6ab2423dae6928d341e59b5',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T16:46:26.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'af72a1fabe59641937bceb7039fce553',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 5,
      lift: 1.1428571428571426,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'af72a1fabe59641937bceb7039fce553',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T00:40:06.360Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3374af4c01da369a910cb71836e25655',
        affiliate: 'ABC',
        isci: '554686H'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 1.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'ABC',
      origEventId: '3374af4c01da369a910cb71836e25655',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T16:31:56.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a866f97acfeb4781e5b072e040f770da',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.030303030303030325,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: 'a866f97acfeb4781e5b072e040f770da',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T14:58:02.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6761fe3e4f795bad995f5762e727fa40',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 9,
      lift: 2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '6761fe3e4f795bad995f5762e727fa40',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T19:58:07.894Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c7a670eccd9f76f8cf8c0cd51ffa14ff',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.09447451358165644,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'c7a670eccd9f76f8cf8c0cd51ffa14ff',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-07T16:45:21.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0620e7d34d943068327b313a570085db',
        affiliate: 'IND (ERBK)',
        isci: '558908H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558908H',
      affiliate: 'IND (ERBK)',
      origEventId: '0620e7d34d943068327b313a570085db',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T13:14:21.236Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '1d31c38598e2788748c31088efd332d0',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 5,
      pvCount: 8,
      lift: 3.166666666666666,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: '1d31c38598e2788748c31088efd332d0',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T16:27:17.694Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3c21acde927d7d33d756cfeaf21c6be0',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.037896825396825366,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '3c21acde927d7d33d756cfeaf21c6be0',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T13:20:38.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c01e4222b38739ee3df25022426def03',
        affiliate: 'FOX',
        isci: '554686H'
      },
      sessionCount: 5,
      pvCount: 10,
      lift: 5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'FOX',
      origEventId: 'c01e4222b38739ee3df25022426def03',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T17:32:05.516Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e3dd4c5c7e4a8994f262a33d11b95046',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 5,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: 'e3dd4c5c7e4a8994f262a33d11b95046',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T13:44:20.304Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '84b9907dbae56b2866006fb9eb9e25a7',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 11,
      lift: 0.6029761904761903,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '84b9907dbae56b2866006fb9eb9e25a7',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T16:45:50.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '924e4ab68d083c1ce9fa3d6eb56028f4',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.6666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '924e4ab68d083c1ce9fa3d6eb56028f4',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T12:12:41.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6ac9186c9ea6aeedd6a4675f8690f139',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '6ac9186c9ea6aeedd6a4675f8690f139',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T15:11:59.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b5d81b4ebaf7180716ce49752bd8b3b7',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 5,
      lift: 0.6944444444444444,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: 'b5d81b4ebaf7180716ce49752bd8b3b7',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T16:59:24.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6bacfbc8b03219a86cc5b5ad8a692b05',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '6bacfbc8b03219a86cc5b5ad8a692b05',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T12:25:28.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b2c89cae02055fea789d59d86b0dc56c',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 4,
      pvCount: 8,
      lift: 0.17152777777777772,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: 'b2c89cae02055fea789d59d86b0dc56c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T19:57:21.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a11828a71f924274cca531ba5b762c16',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.2777777777777778,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: 'a11828a71f924274cca531ba5b762c16',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-14T16:29:31.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3090f211b1a9af9c68514472cd905f87',
        affiliate: 'ABC',
        isci: '554686H'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 0.07777777777777777,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'ABC',
      origEventId: '3090f211b1a9af9c68514472cd905f87',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T15:00:17.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b85912581740ce3e709c78b634510e6b',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 4,
      pvCount: 12,
      lift: 0.05450617283950615,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: 'b85912581740ce3e709c78b634510e6b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:11:43.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c21f1f7f011b704da06081c9a8fc4c18',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: 'c21f1f7f011b704da06081c9a8fc4c18',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T10:13:53.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'fd84ec4eff81f6609b1b894dc61a6339',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: 'fd84ec4eff81f6609b1b894dc61a6339',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T12:14:00.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '826a6a70e07200737cc6574f3d00640f',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 4,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '826a6a70e07200737cc6574f3d00640f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T15:59:55.529Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '26496e4f8d92ef67888a35d253da9bcd',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.03935185185185185,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: '26496e4f8d92ef67888a35d253da9bcd',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T14:36:41.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '5d8fd80d8c876e3db1a119da885f2018',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 6,
      pvCount: 13,
      lift: 0.16111111111111107,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: '5d8fd80d8c876e3db1a119da885f2018',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T14:44:13.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '52cdd02a21cc1403ffed4421ea2509e0',
        affiliate: 'IND (ERBK)',
        isci: '558904H'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558904H',
      affiliate: 'IND (ERBK)',
      origEventId: '52cdd02a21cc1403ffed4421ea2509e0',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T14:46:14.018Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '2910357582e33e09c293ecdcf1e28789',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: 0.10296296296296292,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: '2910357582e33e09c293ecdcf1e28789',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T14:37:42.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e78b3e87984ab206628d09c2b230d872',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 6,
      lift: 0.42857142857142855,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: 'e78b3e87984ab206628d09c2b230d872',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T12:37:26.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2728a12c8832a154ddf12796fcfc9c8e',
        affiliate: 'ABC',
        isci: '554686H'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 0.48379629629629617,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'ABC',
      origEventId: '2728a12c8832a154ddf12796fcfc9c8e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T15:54:42.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8007fba96706e78c014777c894337079',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 8,
      pvCount: 10,
      lift: 0.9779761904761903,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '8007fba96706e78c014777c894337079',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T15:15:20.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd1a615aaa57b3a31861ac1dbb5fd8279',
        affiliate: 'ABC',
        isci: '554686H'
      },
      sessionCount: 7,
      pvCount: 14,
      lift: 0.4222222222222221,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'ABC',
      origEventId: 'd1a615aaa57b3a31861ac1dbb5fd8279',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T16:37:27.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c5fc13cb2c6b513b2ecab64bd237ee8d',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 4,
      pvCount: 5,
      lift: 1.5361111111111108,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: 'c5fc13cb2c6b513b2ecab64bd237ee8d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T19:13:05.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '9cbb3a30edbfff05dabd47e736fa9c02',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.2857142857142858,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '9cbb3a30edbfff05dabd47e736fa9c02',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T22:44:16.694Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f5497bb10119a34e6085da6dda450638',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: 'f5497bb10119a34e6085da6dda450638',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T08:17:42.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0a410f37359624dc2584ad969130de53',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 4,
      pvCount: 5,
      lift: 2.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '0a410f37359624dc2584ad969130de53',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T17:45:21.669Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f6e5305c13d8d7463d57dfed5acfe9ce',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: -0.07707451499118165,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: 'f6e5305c13d8d7463d57dfed5acfe9ce',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T19:15:30.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '658673bb0f5ee8c8f81452d9aee62d56',
        affiliate: 'MNTV',
        isci: '558908H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558908H',
      affiliate: 'MNTV',
      origEventId: '658673bb0f5ee8c8f81452d9aee62d56',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T17:28:48.061Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '633981a30a2ec334e2f461b5877e2fbc',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 12,
      lift: 0.05987177505034647,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '633981a30a2ec334e2f461b5877e2fbc',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T15:17:03.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '33448e6376909f1387311647325d0317',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: '33448e6376909f1387311647325d0317',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T13:22:47.212Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6231db0d4bb9e4e5f073e1702632bf78',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.09090909090909091,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: '6231db0d4bb9e4e5f073e1702632bf78',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T09:57:31.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7b1fc59793d8fa465609ed3a598ae9a1',
        affiliate: 'FOX',
        isci: '554686H'
      },
      sessionCount: 3,
      pvCount: 8,
      lift: 0.006944444444444373,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'FOX',
      origEventId: '7b1fc59793d8fa465609ed3a598ae9a1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T15:14:10.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e58327bae45268ba99e9d97687766d20',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 17,
      lift: 1.5833333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'e58327bae45268ba99e9d97687766d20',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T16:46:32.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f3742b278fce1a55a293700918bb8057',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 4,
      lift: 0.1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: 'f3742b278fce1a55a293700918bb8057',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T19:31:21.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '38c5490a8abf40912cab0a60555f0dc4',
        affiliate: 'IND (ERBK)',
        isci: '554692H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554692H',
      affiliate: 'IND (ERBK)',
      origEventId: '38c5490a8abf40912cab0a60555f0dc4',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T19:42:39.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: 'f90a060ebc54844df1c1b5bc136e20ca',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: -0.16666666666666682,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: 'f90a060ebc54844df1c1b5bc136e20ca',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T13:20:55.990Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b0cf1a3b050c3724da917f6076e81faa',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 5,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: 'b0cf1a3b050c3724da917f6076e81faa',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T13:43:20.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '879d17f0bb2e4ef29baa1c5025ed9552',
        affiliate: 'CBS',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 8,
      lift: 0.818181818181818,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CBS',
      origEventId: '879d17f0bb2e4ef29baa1c5025ed9552',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T14:23:15.105Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6092581c30c8a4487fc674bb7d847f6e',
        affiliate: 'MNTV',
        isci: '554686H'
      },
      sessionCount: 4,
      pvCount: 15,
      lift: 0.9009259259259258,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'MNTV',
      origEventId: '6092581c30c8a4487fc674bb7d847f6e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T17:54:10.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'dda15ab4bfad545a9456a76f05e5ebc1',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 6,
      pvCount: 7,
      lift: 0.33511904761904754,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'dda15ab4bfad545a9456a76f05e5ebc1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T15:16:05.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '9736edecd8db8ab33cafd98a07adbf3d',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '9736edecd8db8ab33cafd98a07adbf3d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T10:45:42.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'bdc8955157efaf301980ed83a88b3169',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: 'bdc8955157efaf301980ed83a88b3169',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T17:57:16.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '965c72d42c9a51d91317e797af683f43',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.034490740740740745,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: '965c72d42c9a51d91317e797af683f43',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T10:29:39.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7bcd352ff3cae075621bad8abfe825c9',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 8,
      pvCount: 13,
      lift: 0.41694444444444434,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: '7bcd352ff3cae075621bad8abfe825c9',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T19:16:50.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ed2ed06fe15de331f65fbb7f518bee7c',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 8,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: 'ed2ed06fe15de331f65fbb7f518bee7c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T17:55:22.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '887d56f1b589d21118f1e72fdf6b6280',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '887d56f1b589d21118f1e72fdf6b6280',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T10:48:31.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3551360b4a8aed8a89471ee151c060c2',
        affiliate: 'CBS',
        isci: '554686H'
      },
      sessionCount: 4,
      pvCount: 5,
      lift: -0.13333333333333333,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'CBS',
      origEventId: '3551360b4a8aed8a89471ee151c060c2',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T18:48:08.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e811f34da07928e931d53aea46b4641b',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 0.8,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'e811f34da07928e931d53aea46b4641b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T14:16:05.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '83ccb231b541419d3ecde26970a48a99',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.09090909090909091,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: '83ccb231b541419d3ecde26970a48a99',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T09:56:58.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '529a162f081fa3af136051686ac88b05',
        affiliate: 'FOX',
        isci: '554686H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'FOX',
      origEventId: '529a162f081fa3af136051686ac88b05',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T17:58:48.915Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e1987bda71a4ca83cadae6f3b4b1f051',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 7,
      pvCount: 8,
      lift: 0.33511904761904754,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'e1987bda71a4ca83cadae6f3b4b1f051',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T14:13:36.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd6061a5b05a41967dea2def6dc420bcf',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 9,
      lift: 0.3238095238095238,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'd6061a5b05a41967dea2def6dc420bcf',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T14:13:33.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3cc83515811d933f8467967b4612c678',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 7,
      pvCount: 10,
      lift: 0.711706349206349,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '3cc83515811d933f8467967b4612c678',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T18:44:00.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7d0682f4e0ec63b7ce9a48b0e140c0a5',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: -0.09464836860670194,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: '7d0682f4e0ec63b7ce9a48b0e140c0a5',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T14:18:22.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1aaa9a0c1f7bf862b8ade3de4d393bf0',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 0.36507936507936506,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '1aaa9a0c1f7bf862b8ade3de4d393bf0',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T15:46:20.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b565fd7ec1483c654072d838593c086f',
        affiliate: 'MNTV',
        isci: '554686H'
      },
      sessionCount: 4,
      pvCount: 5,
      lift: 0.11111111111111097,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'MNTV',
      origEventId: 'b565fd7ec1483c654072d838593c086f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T14:47:45.105Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '36e3e0bd0232286d85e56d026f1e8811',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 8,
      lift: 2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: '36e3e0bd0232286d85e56d026f1e8811',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T16:59:19.630Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c13e4cc573ae011f86efa1a859cc3908',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: -0.003240740740740738,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: 'c13e4cc573ae011f86efa1a859cc3908',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T16:14:37.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3c52fc540b59eacc4d91a8ed64f3005a',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 0.7041666666666665,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: '3c52fc540b59eacc4d91a8ed64f3005a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T16:11:09.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b0c2ed9865346621b5a1e616ad4b4172',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: 'b0c2ed9865346621b5a1e616ad4b4172',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T11:49:53.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4687eb8eb4bb8f55a3f9598fc79fb00a',
        affiliate: 'FOX',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: -0.5000000000000001,
      baselineSessionCount: 5,
      baselineSessionsPerSecond: 0.016666666666666666,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'FOX',
      origEventId: '4687eb8eb4bb8f55a3f9598fc79fb00a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T15:24:19.148Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '791f52fe23a439918526376bcd6625ac',
        affiliate: 'FOX',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 0.004417989417989399,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'FOX',
      origEventId: '791f52fe23a439918526376bcd6625ac',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T14:26:42.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7930da060bbce9da91545c27f413e988',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 4,
      pvCount: 12,
      lift: 0.05450617283950615,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: '7930da060bbce9da91545c27f413e988',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:11:43.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6c2c333ad00fd9335277bde401294ada',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.04490740740740741,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: '6c2c333ad00fd9335277bde401294ada',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T10:30:01.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8b1afa19ef300fae8d5751fa64f7975f',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 4,
      pvCount: 19,
      lift: 0.0431547619047619,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: '8b1afa19ef300fae8d5751fa64f7975f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T18:16:48.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e0750e37d3bbd2aeaa9a3d45ea2625f8',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 9,
      lift: 0.20277777777777772,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: 'e0750e37d3bbd2aeaa9a3d45ea2625f8',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T16:55:42.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7b296489c525b112f90d539997645654',
        affiliate: 'MNTV',
        isci: '558908H'
      },
      sessionCount: 1,
      pvCount: 8,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558908H',
      affiliate: 'MNTV',
      origEventId: '7b296489c525b112f90d539997645654',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T17:21:19.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '726e202da5a50f3b192e17081e3b0c58',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 5,
      pvCount: 8,
      lift: 0.5597594997594997,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '726e202da5a50f3b192e17081e3b0c58',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T13:59:52.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b5eaeda150d670d265a2d3c9081ef04e',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 1.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'b5eaeda150d670d265a2d3c9081ef04e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T16:49:05.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'dfa090dd7d928860af713fe2274abb06',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: -0.09687059082892414,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: 'dfa090dd7d928860af713fe2274abb06',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T14:18:46.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4b00091cd0774b050b9721a255bfd736',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 6,
      pvCount: 6,
      lift: 1.727272727272727,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '4b00091cd0774b050b9721a255bfd736',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T17:30:01.524Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '5431567a9a7f2f723ed3f1f63acb33b3',
        affiliate: 'ABC',
        isci: '554686H'
      },
      sessionCount: 4,
      pvCount: 5,
      lift: -0.5238095238095238,
      baselineSessionCount: 7,
      baselineSessionsPerSecond: 0.023333333333333334,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'ABC',
      origEventId: '5431567a9a7f2f723ed3f1f63acb33b3',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T16:39:30.331Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f490a51b609534f6b46f46c9b14ce473',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: 'f490a51b609534f6b46f46c9b14ce473',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T16:49:56.270Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'beeab1cf33f3ab92b9eecf3eb5c508b4',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 8,
      pvCount: 13,
      lift: 1.8571428571428568,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'beeab1cf33f3ab92b9eecf3eb5c508b4',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T19:16:28.400Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f2be5326d1feb983bfd31664c5a76e3a',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 10,
      pvCount: 20,
      lift: 0.26157407407407407,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: 'f2be5326d1feb983bfd31664c5a76e3a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T15:36:40.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6947916527e36aa00f35914ee6544efd',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 0.1869642857142857,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: '6947916527e36aa00f35914ee6544efd',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T15:38:33.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd2a38d7c86b7d23d6eb987b6ef1bd193',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.19090909090909092,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: 'd2a38d7c86b7d23d6eb987b6ef1bd193',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T15:20:54.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'cc02c6d9f3c373bb4a6a610a282101f1',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 13,
      lift: -0.18115079365079365,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'cc02c6d9f3c373bb4a6a610a282101f1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T18:43:07.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1e91b2e4c6862c2151790d1001c0b858',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 5,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '1e91b2e4c6862c2151790d1001c0b858',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T13:43:20.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c9a892983b4810f35cf392cd1744332f',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 4,
      pvCount: 5,
      lift: 0.8650793650793651,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: 'c9a892983b4810f35cf392cd1744332f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T15:46:35.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f459324ef6a32fbce476abae61f2d291',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 7,
      pvCount: 10,
      lift: 1.0541666666666665,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: 'f459324ef6a32fbce476abae61f2d291',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T14:46:56.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c7e5e993aadf3e4f67d4c6300cd616a1',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 1.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: 'c7e5e993aadf3e4f67d4c6300cd616a1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T16:11:42.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6d8502b1bc9b2b10b5b9cfb0c4127057',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 5,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '6d8502b1bc9b2b10b5b9cfb0c4127057',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T13:42:51.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '553228767d450b9b4c293d4955d26f15',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '553228767d450b9b4c293d4955d26f15',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T11:29:08.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '94f076695e7a3b7d73ad684d0df7ad72',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 5,
      pvCount: 5,
      lift: 0.6863095238095238,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '94f076695e7a3b7d73ad684d0df7ad72',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T14:45:11.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7aa5281c05296c0b6246c7c40b57769c',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 7,
      pvCount: 15,
      lift: 0.6666666666666666,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '7aa5281c05296c0b6246c7c40b57769c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T16:27:33.029Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '98d3f8618954352c0300d6442cfde48e',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 4,
      pvCount: 7,
      lift: 0.5310185185185183,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: '98d3f8618954352c0300d6442cfde48e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T15:17:24.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0a4417fae318a57f16cbf893cd21bf35',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '0a4417fae318a57f16cbf893cd21bf35',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T16:57:50.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c31217d41edd935e4c340a81f7c98da7',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 6,
      pvCount: 9,
      lift: -0.07490476199558813,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'c31217d41edd935e4c340a81f7c98da7',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T20:15:36.832Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '886f52e082769bfcf64cc9bc65fb94c0',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 4,
      pvCount: 7,
      lift: 0.28194444444444444,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: '886f52e082769bfcf64cc9bc65fb94c0',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T18:58:47.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '10678b7bb8972d8d3d64ba236f9bb0c6',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 10,
      lift: -0.04761904761904766,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '10678b7bb8972d8d3d64ba236f9bb0c6',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T15:45:48.464Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ef2eff5ece78e75f540a451cb58f2e66',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: 'ef2eff5ece78e75f540a451cb58f2e66',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T10:13:53.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b1c176dd3c580b55551fdfdd9e6ebe89',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.030303030303030325,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: 'b1c176dd3c580b55551fdfdd9e6ebe89',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T10:59:54.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '526db979332df3a28286159047e4a510',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 0.05972222222222222,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: '526db979332df3a28286159047e4a510',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T15:24:11.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2f710792c6a490f96bf42f3ce01c5d19',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 3,
      pvCount: 8,
      lift: -0.45454545454545464,
      baselineSessionCount: 5,
      baselineSessionsPerSecond: 0.016666666666666666,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '2f710792c6a490f96bf42f3ce01c5d19',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T15:13:56.244Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '36f9b76c22ad2b916ea29e0abc899095',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 6,
      pvCount: 19,
      lift: 0.7117063492063491,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '36f9b76c22ad2b916ea29e0abc899095',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T17:15:08.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '37914e132fa5b50d2d458ed0a79782ce',
        affiliate: 'IND (ERBK)',
        isci: '554692H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554692H',
      affiliate: 'IND (ERBK)',
      origEventId: '37914e132fa5b50d2d458ed0a79782ce',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T19:44:35.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: 'bba27dd79f92ac1c382e1787f6105d78',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 0.6428571428571428,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: 'bba27dd79f92ac1c382e1787f6105d78',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T12:23:59.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd1eada723807cfadbbacf21fea2d8f1f',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 4,
      lift: -0.02293650793650793,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'd1eada723807cfadbbacf21fea2d8f1f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T19:41:34.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '56a25bbccf31fdac6728a5b73a5dd876',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: '56a25bbccf31fdac6728a5b73a5dd876',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T09:40:12.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ebda2633d13de13e127daeae410b5c31',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 1.1428571428571426,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'ebda2633d13de13e127daeae410b5c31',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T21:48:26.121Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3f69a1578439502396e2e5a7fe3cbc2c',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 10,
      lift: -0.20059523809523808,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '3f69a1578439502396e2e5a7fe3cbc2c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T18:44:36.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '88c73742d8b11db49f57887c520d7490',
        affiliate: 'MNTV',
        isci: '554686H'
      },
      sessionCount: 2,
      pvCount: 10,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'MNTV',
      origEventId: '88c73742d8b11db49f57887c520d7490',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T19:47:14.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4e43b9de7e284c0e28c70b17aa36a70a',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.09090909090909091,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: '4e43b9de7e284c0e28c70b17aa36a70a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T09:57:09.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8641791586549dc414ef5b888c2dba6e',
        affiliate: 'CW',
        isci: '558906H'
      },
      sessionCount: 6,
      pvCount: 7,
      lift: 0.4381529581529582,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CW',
      origEventId: '8641791586549dc414ef5b888c2dba6e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T14:25:30.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '04ed64356fbc6979de18051c23f30b27',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: 0.26666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: '04ed64356fbc6979de18051c23f30b27',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T19:31:34.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1d2b2ea16ff692380d3c25bc0d01d829',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 10,
      pvCount: 14,
      lift: 0.6285714285714284,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '1d2b2ea16ff692380d3c25bc0d01d829',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T14:16:34.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '377c44db952277368c4325b76b7e9e16',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 7,
      pvCount: 10,
      lift: 0.2527777777777777,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '377c44db952277368c4325b76b7e9e16',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T14:14:44.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b9b4bae069b89b3c87ce98a947105d91',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 4,
      pvCount: 8,
      lift: 0.1444444444444444,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: 'b9b4bae069b89b3c87ce98a947105d91',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T15:47:33.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b26854327ba0f140e841cbd30ad2b2d4',
        affiliate: 'ABC',
        isci: '554686H'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 1.2685185185185182,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'ABC',
      origEventId: 'b26854327ba0f140e841cbd30ad2b2d4',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T15:54:07.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'bb31378cc0d65f3d4f2a712a69734696',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 8,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: 'bb31378cc0d65f3d4f2a712a69734696',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T17:54:55.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '40859ea04d0c39f903be2a57c3b6177d',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 5,
      pvCount: 13,
      lift: 0.03735956503813652,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '40859ea04d0c39f903be2a57c3b6177d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T15:15:35.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '57ce0ffc5f64df22b8778e153d1046db',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 9,
      lift: 0.4839285714285714,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '57ce0ffc5f64df22b8778e153d1046db',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T13:45:52.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '94d02d4cd85208f766fbe638696306cd',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 5,
      pvCount: 8,
      lift: 0.8513888888888886,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: '94d02d4cd85208f766fbe638696306cd',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T15:17:47.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '30c1f03eca62b0e0ed6e98800ac1da39',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.6666666666666664,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '30c1f03eca62b0e0ed6e98800ac1da39',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T16:15:40.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3aae7e5d5f3c1eadc7342275601b24b0',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: '3aae7e5d5f3c1eadc7342275601b24b0',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T14:40:29.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4d470f281d89cf513734536a3fb41a73',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: 0.14285714285714285,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '4d470f281d89cf513734536a3fb41a73',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T12:23:45.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3c538f44fa5786b4a7ba6e49b91921ae',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 10,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: '3c538f44fa5786b4a7ba6e49b91921ae',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T23:46:56.488Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c727a9248ba0b72a66897114ed1c7531',
        affiliate: 'FOX',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 6,
      lift: 0.2857142857142857,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'FOX',
      origEventId: 'c727a9248ba0b72a66897114ed1c7531',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T12:23:59.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6b2d17c855e7ee18dfa09116976cda7e',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.574074074074074,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: '6b2d17c855e7ee18dfa09116976cda7e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T11:53:01.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '82623ccd30739af9001612d7a2253e14',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 7,
      pvCount: 16,
      lift: 0.2906349206349206,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '82623ccd30739af9001612d7a2253e14',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T17:19:12.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7199e80130b10d78c5e217bf95928034',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: '7199e80130b10d78c5e217bf95928034',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T15:16:15.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1d678ac30e91fae2b2197709fae8080b',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 0.36507936507936506,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '1d678ac30e91fae2b2197709fae8080b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T15:46:20.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ac024f4798dc6fc811adc6f2d053b2be',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: 'ac024f4798dc6fc811adc6f2d053b2be',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T14:40:29.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '022aa0d38c8996a4aab60c7383c0f2de',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '022aa0d38c8996a4aab60c7383c0f2de',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T11:31:33.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd5069e2381238576aed4902f3618b2c7',
        affiliate: 'IND (ERBK)',
        isci: '554692H'
      },
      sessionCount: 1,
      pvCount: 4,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554692H',
      affiliate: 'IND (ERBK)',
      origEventId: 'd5069e2381238576aed4902f3618b2c7',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T13:16:09.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: 'd4d0d145f074e8ec7a0ea6e5ed995b87',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.532142857142857,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'd4d0d145f074e8ec7a0ea6e5ed995b87',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T17:47:38.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b83ba3288bcd3d50790fe078a66ec1f0',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 5,
      pvCount: 13,
      lift: 0.6363636363636362,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: 'b83ba3288bcd3d50790fe078a66ec1f0',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T16:24:58.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '14ffd6e7b5638f3b1c5b304636066ded',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 0.08944444444444441,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: '14ffd6e7b5638f3b1c5b304636066ded',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T19:13:34.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8c3b11b217ff42fe936f93b215b41174',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 5,
      lift: 4,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '8c3b11b217ff42fe936f93b215b41174',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T21:45:51.878Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3818dd07e20963d219af44ed7aa8a376',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.25614718614718607,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '3818dd07e20963d219af44ed7aa8a376',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T15:49:20.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3e1af92dae1203822ff76cf0735f5ad5',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 4,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '3e1af92dae1203822ff76cf0735f5ad5',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T11:59:25.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '17b03adb8de174e32835a0f6f933037b',
        affiliate: 'MNTV',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.21064814814814817,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'MNTV',
      origEventId: '17b03adb8de174e32835a0f6f933037b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T13:18:13.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '9ff6588c14491fa15d81ecbe5c62ea49',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: -0.058796296296296305,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '9ff6588c14491fa15d81ecbe5c62ea49',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T19:58:09.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3c10d3cd74f3734af179c787a26bfcd9',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.3818181818181818,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '3c10d3cd74f3734af179c787a26bfcd9',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T10:24:50.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4bd7614bae9a8bffd8efa44423edf620',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 6,
      pvCount: 19,
      lift: 0.781547619047619,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '4bd7614bae9a8bffd8efa44423edf620',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T17:15:52.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '37618e1eba1780afb13583058b6259aa',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '37618e1eba1780afb13583058b6259aa',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T08:47:45.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1d064ac8f5fe602ab1405842baa5c54c',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 4,
      pvCount: 7,
      lift: 1.3181818181818181,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '1d064ac8f5fe602ab1405842baa5c54c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T13:53:01.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '585e02b00fbfc068d0f44dfabcd12212',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.049768518518518524,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: '585e02b00fbfc068d0f44dfabcd12212',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T14:36:26.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '17ccc0793205418e3109ed4a68f6ee26',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 7,
      lift: 0.03263888888888886,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '17ccc0793205418e3109ed4a68f6ee26',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T19:57:27.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '00009d0214dfb2225d726554b0aa64b7',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: '00009d0214dfb2225d726554b0aa64b7',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T08:46:39.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f60513cde0e4a0b5dbf8ea46519217cc',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 0.12678571428571428,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'f60513cde0e4a0b5dbf8ea46519217cc',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T13:45:07.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '86fa295cf7e6a4c3511b22a4f787ab63',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 0.08944444444444441,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: '86fa295cf7e6a4c3511b22a4f787ab63',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T19:13:34.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'fa8480428f226a72ceb437d29d1d4eee',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: 'fa8480428f226a72ceb437d29d1d4eee',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T13:28:46.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '00c8e687573231a065f7c30388b8dd0d',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 1.6666666666666665,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '00c8e687573231a065f7c30388b8dd0d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T18:23:39.643Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '92c8f362de650fae702c4051c894a77a',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 5,
      pvCount: 5,
      lift: 0.25363636363636366,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '92c8f362de650fae702c4051c894a77a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T12:45:16.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e6ce52b5afdbee172cd3c4032564c859',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: 'e6ce52b5afdbee172cd3c4032564c859',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T10:47:51.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '772cf0dfd96605e4e92a74190f63d89f',
        affiliate: 'ABC',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.1666666666666668,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'ABC',
      origEventId: '772cf0dfd96605e4e92a74190f63d89f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T19:59:48.727Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '5119e68c1bc108d0e9b4f69cbe52b490',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.818181818181818,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '5119e68c1bc108d0e9b4f69cbe52b490',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T18:53:04.765Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f5fe6e7bed51dfcf892f77f5578920e5',
        affiliate: 'MNTV',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'MNTV',
      origEventId: 'f5fe6e7bed51dfcf892f77f5578920e5',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T00:47:20.864Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2c104f69136a68febc3c430083cd9886',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '2c104f69136a68febc3c430083cd9886',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T09:25:48.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '30f657f2340e09cd39b6f6c8fae58bd7',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 5,
      pvCount: 8,
      lift: 0.5495322270322269,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '30f657f2340e09cd39b6f6c8fae58bd7',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T14:00:01.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2ed4f1181270c378c5c95ef76aae9cc3',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 5,
      pvCount: 6,
      lift: 0.7857142857142856,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '2ed4f1181270c378c5c95ef76aae9cc3',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T20:45:24.677Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ebd0fad8ac97a8cf1b72dedfd950f630',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 5,
      lift: -0.4285714285714287,
      baselineSessionCount: 5,
      baselineSessionsPerSecond: 0.016666666666666666,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'ebd0fad8ac97a8cf1b72dedfd950f630',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T20:15:21.196Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '9fb55bbd75ac3782c9e1c5abea99ee16',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: -0.0833333333333334,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '9fb55bbd75ac3782c9e1c5abea99ee16',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T18:59:04.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2b41b67c0d3ee36359acc266450445b4',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.6666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: '2b41b67c0d3ee36359acc266450445b4',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T14:32:55.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2f1d0ebfd6f64ea61a89203da7d275c0',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 5,
      pvCount: 6,
      lift: 0.4944444444444443,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: '2f1d0ebfd6f64ea61a89203da7d275c0',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T18:46:50.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '80832e7e514f7a029b2f9581400b5af6',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: '80832e7e514f7a029b2f9581400b5af6',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T16:15:14.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'af2c8d70f00c65c343ce2ee25f42e027',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 0.02453703703703701,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: 'af2c8d70f00c65c343ce2ee25f42e027',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T14:16:12.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a3e71e91d7b6ee3d0c61edd39ecd7ca4',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: -0.07013007054673723,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: 'a3e71e91d7b6ee3d0c61edd39ecd7ca4',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T19:15:45.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7987832022c9281931523a734de496cb',
        affiliate: 'CW',
        isci: '558906H'
      },
      sessionCount: 6,
      pvCount: 7,
      lift: 0.4294949494949495,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CW',
      origEventId: '7987832022c9281931523a734de496cb',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T14:25:22.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'fd28ef8823eda7a590edae5bc14cd82d',
        affiliate: 'FOX',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.06560846560846562,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'FOX',
      origEventId: 'fd28ef8823eda7a590edae5bc14cd82d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T12:56:28.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0785ab16779407f70a2d41ee8ebd64dd',
        affiliate: 'FOX',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 6,
      lift: 0.2857142857142857,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'FOX',
      origEventId: '0785ab16779407f70a2d41ee8ebd64dd',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T12:24:06.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd6e471e2c7f04d7f6c5ad4a860a46bed',
        affiliate: 'ABC',
        isci: '554686H'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 0.8666666666666667,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'ABC',
      origEventId: 'd6e471e2c7f04d7f6c5ad4a860a46bed',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T11:24:04.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '805727c128bd73ca8a1e2e79a28dc577',
        affiliate: 'CW',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CW',
      origEventId: '805727c128bd73ca8a1e2e79a28dc577',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T19:25:25.723Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e62952cc739795a61d49880936ea8dbf',
        affiliate: 'IND (ERBK)',
        isci: '554692H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554692H',
      affiliate: 'IND (ERBK)',
      origEventId: 'e62952cc739795a61d49880936ea8dbf',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T09:17:40.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '0fda80ffca5f595da63803b10bbe0868',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '0fda80ffca5f595da63803b10bbe0868',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T12:17:32.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0f86bf2e1ff541caf60401d2f624e396',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.36828703703703697,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: '0f86bf2e1ff541caf60401d2f624e396',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T14:37:05.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'dae2be21c27c3e3940970c6e50955d85',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 9,
      lift: 0.20277777777777772,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: 'dae2be21c27c3e3940970c6e50955d85',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T16:55:42.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a0fb7b7d4c1fb0c9b6d7cced9aa41898',
        affiliate: 'MNTV',
        isci: '554686H'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: -0.15848055548138096,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'MNTV',
      origEventId: 'a0fb7b7d4c1fb0c9b6d7cced9aa41898',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T14:38:31.348Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '72546be9a3a96e95b40e25e8bd1a75c5',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '72546be9a3a96e95b40e25e8bd1a75c5',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T11:25:31.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '626c8f7c2fe60e673f8de6e3be12cabe',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: 0.26666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: '626c8f7c2fe60e673f8de6e3be12cabe',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T19:31:34.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ffa76d804dde1e260bbbfde03fbc77f4',
        affiliate: 'FOX',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.06560846560846562,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'FOX',
      origEventId: 'ffa76d804dde1e260bbbfde03fbc77f4',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T12:56:28.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f2991c8edd9bff81a0b74e6b19651701',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 4,
      lift: 0.1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: 'f2991c8edd9bff81a0b74e6b19651701',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T19:31:25.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '555ae3849190dd684b6d9be7b1cb1f62',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '555ae3849190dd684b6d9be7b1cb1f62',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T14:25:10.388Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a5e99302a312ddc3d343960eea2c6ace',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 4,
      pvCount: 17,
      lift: 0.32525000009271826,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: 'a5e99302a312ddc3d343960eea2c6ace',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T20:48:47.503Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a55ad292a789d1d386eb76583d586dd3',
        affiliate: 'ABC',
        isci: '554692H'
      },
      sessionCount: 1,
      pvCount: 5,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554692H',
      affiliate: 'ABC',
      origEventId: 'a55ad292a789d1d386eb76583d586dd3',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T15:43:30.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: 'da26600225f6f97bd9ad8eb1aeb549d3',
        affiliate: 'CW',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: -0.09090909090909098,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CW',
      origEventId: 'da26600225f6f97bd9ad8eb1aeb549d3',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T17:30:44.625Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1798b1ae66b3b791a4ca3b136f819e9d',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 9,
      pvCount: 19,
      lift: 1.0535185185185183,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: '1798b1ae66b3b791a4ca3b136f819e9d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T15:37:32.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'cd9d2bd219797908afcbc357dddeac4a',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'cd9d2bd219797908afcbc357dddeac4a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-07T17:43:06.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'cbcb085814334e7052ec0b9c1cf5c9d2',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 1.4,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'cbcb085814334e7052ec0b9c1cf5c9d2',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T16:47:32.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4956ced83a57b04a4068487022dde85a',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '4956ced83a57b04a4068487022dde85a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T12:14:00.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6d94431e8cb1f331c7bb50530f712902',
        affiliate: 'CBS',
        isci: '554686H'
      },
      sessionCount: 2,
      pvCount: 15,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'CBS',
      origEventId: '6d94431e8cb1f331c7bb50530f712902',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T19:32:53.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '59ca93df3acf310dc1e970205e38d853',
        affiliate: 'FOX',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: -0.0036375661375661473,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'FOX',
      origEventId: '59ca93df3acf310dc1e970205e38d853',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T14:27:16.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd8c1b359e4283ac9804bdf7444dc29aa',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 3,
      pvCount: 9,
      lift: 0.5757575757575757,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: 'd8c1b359e4283ac9804bdf7444dc29aa',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T18:58:17.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '425afd7e0e18de4f4dd73b4f4e78a582',
        affiliate: 'ABC',
        isci: '554686H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.2222222222222222,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'ABC',
      origEventId: '425afd7e0e18de4f4dd73b4f4e78a582',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T15:44:51.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1d54e4b8cbf4f8a8f1a9e19b3946af68',
        affiliate: 'ABC',
        isci: '554686H'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 1.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'ABC',
      origEventId: '1d54e4b8cbf4f8a8f1a9e19b3946af68',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T16:31:22.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '24c4aa7da5a28428f7486c7c68910c5b',
        affiliate: 'ABC',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 4,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'ABC',
      origEventId: '24c4aa7da5a28428f7486c7c68910c5b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T14:25:01.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c236ac6332cc49ee665923a8b569a38c',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 5,
      pvCount: 6,
      lift: 2.5714285714285707,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'c236ac6332cc49ee665923a8b569a38c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T22:45:14.095Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6c4bbdeef5de65b7ef9311ab2ec3301c',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '6c4bbdeef5de65b7ef9311ab2ec3301c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T13:42:42.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '80ceff607e217535b1cb47b97222277d',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 5,
      pvCount: 8,
      lift: 2.5714285714285707,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '80ceff607e217535b1cb47b97222277d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T21:45:09.217Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0bd459f07514c2927ea4545a28ffe931',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 4,
      pvCount: 12,
      lift: 0.10937059082892417,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '0bd459f07514c2927ea4545a28ffe931',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:43:17.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7b76b48994f19b1dc536c21a21fcc993',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 3,
      pvCount: 6,
      lift: 0.36363636363636354,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '7b76b48994f19b1dc536c21a21fcc993',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T16:58:54.247Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd0a3913380bb982ae3151d1aa7d53bb3',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'd0a3913380bb982ae3151d1aa7d53bb3',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T08:47:03.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'fd57e454746feecf427a4254c506b162',
        affiliate: 'FOX',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.06884920634920635,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'FOX',
      origEventId: 'fd57e454746feecf427a4254c506b162',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T12:56:14.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '39bae6c6d79827acacbddabfa8bcd656',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 0.01180555555555556,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: '39bae6c6d79827acacbddabfa8bcd656',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T15:24:56.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0d09ab6e53ab12211c990646f2254c20',
        affiliate: 'CBS',
        isci: '558906H'
      },
      sessionCount: 3,
      pvCount: 6,
      lift: 3,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CBS',
      origEventId: '0d09ab6e53ab12211c990646f2254c20',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T14:59:47.518Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3c0c3b142672c172fb3a0f215054f804',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 5,
      pvCount: 10,
      lift: 1.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: '3c0c3b142672c172fb3a0f215054f804',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T18:57:14.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8188d8787f82f8feda24c7b24a830143',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.574074074074074,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: '8188d8787f82f8feda24c7b24a830143',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T11:53:01.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0c115f321d21daeba8d6795526d84088',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: '0c115f321d21daeba8d6795526d84088',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T23:58:16.932Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ef02648108df8ac5eea332741bf5eaa6',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 0.22571428571428573,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'ef02648108df8ac5eea332741bf5eaa6',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T16:45:43.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0166b91c275b872f3abac43b2aafc0b5',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 7,
      lift: 0.013888888888888873,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '0166b91c275b872f3abac43b2aafc0b5',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T19:57:54.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8ed7eabc2638127953460dc68b272e3f',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: '8ed7eabc2638127953460dc68b272e3f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T17:14:49.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a28ad40380530303470cb9bd400e0ed9',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 8,
      pvCount: 10,
      lift: 0.6557539682539683,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'a28ad40380530303470cb9bd400e0ed9',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T14:14:44.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '08abf56074f03961f5c320b185dad4b5',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: 0.2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '08abf56074f03961f5c320b185dad4b5',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T16:31:39.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'edce5b4337bb1515e7e68af4508d7490',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 7,
      pvCount: 12,
      lift: 5.363636363636363,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: 'edce5b4337bb1515e7e68af4508d7490',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T18:59:51.500Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8c8d0575c3bdf282615dcbe7daec6cc0',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 6,
      lift: 0.42857142857142855,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '8c8d0575c3bdf282615dcbe7daec6cc0',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T12:37:52.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6e7477ca88febf5dd9484cea67b58bc0',
        affiliate: 'MNTV',
        isci: '554686H'
      },
      sessionCount: 4,
      pvCount: 13,
      lift: 2.333333333333333,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'MNTV',
      origEventId: '6e7477ca88febf5dd9484cea67b58bc0',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T18:17:44.370Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '65ec3d625aefdb3c5614588279019253',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 5,
      pvCount: 8,
      lift: 0.11527006172839502,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: '65ec3d625aefdb3c5614588279019253',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T19:36:46.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '17b92f23d26a7fe33a5bd219abd0099e',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.14285714285714285,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '17b92f23d26a7fe33a5bd219abd0099e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T11:27:44.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'feea50d6caec2f5ff47d0cf0f09e8a20',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 5,
      pvCount: 10,
      lift: 1.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: 'feea50d6caec2f5ff47d0cf0f09e8a20',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T18:57:14.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '714277d1d07dbd7c9096c77207bc1f5c',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 0.42857142857142844,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '714277d1d07dbd7c9096c77207bc1f5c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T21:44:47.921Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3d07d864f133df9baf45bbd680da8e3c',
        affiliate: 'MNTV',
        isci: '554686H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: -0.1666666666666668,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'MNTV',
      origEventId: '3d07d864f133df9baf45bbd680da8e3c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T18:38:09.584Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6460c6c7ca7fb78f0de525ddeccbd44a',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '6460c6c7ca7fb78f0de525ddeccbd44a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T09:26:32.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '105c094a52717f3a0c2fdafb7c9b098e',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.7,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '105c094a52717f3a0c2fdafb7c9b098e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T13:25:55.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b184d2101dbd50fa94b43511d2d29b17',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: 'b184d2101dbd50fa94b43511d2d29b17',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T11:58:49.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd654abd40647279f682aba713627b41e',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 3,
      pvCount: 12,
      lift: 0.36363636363636354,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: 'd654abd40647279f682aba713627b41e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T19:30:05.884Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3022d6fc3d1e99df2167fcffa56c7a94',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 0.11264991181657846,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: '3022d6fc3d1e99df2167fcffa56c7a94',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T13:56:57.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '095c5e25d7cf70447abd66838be0ad85',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 0.7,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '095c5e25d7cf70447abd66838be0ad85',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T14:46:14.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '5dcfb0fa46d11b1eaa3e53f5f3c9b700',
        affiliate: 'FOX',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 6,
      lift: 0.2857142857142857,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'FOX',
      origEventId: '5dcfb0fa46d11b1eaa3e53f5f3c9b700',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T12:23:43.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1c31e808f1de4f4b18a012c2d2a86793',
        affiliate: 'CBS',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.09090909090909091,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CBS',
      origEventId: '1c31e808f1de4f4b18a012c2d2a86793',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T09:59:45.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'af8c665253f8d7118158ba70a3d42019',
        affiliate: 'CW',
        isci: '558906H'
      },
      sessionCount: 6,
      pvCount: 7,
      lift: 0.4294949494949495,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CW',
      origEventId: 'af8c665253f8d7118158ba70a3d42019',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T14:25:22.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '06cee7980074669d4b868aa0b9f0e82b',
        affiliate: 'MNTV',
        isci: '558908H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558908H',
      affiliate: 'MNTV',
      origEventId: '06cee7980074669d4b868aa0b9f0e82b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-07T16:10:57.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: 'dfdd2fa9bfbad0d2cc08b69bbaeab77e',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 4,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: 'dfdd2fa9bfbad0d2cc08b69bbaeab77e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T11:59:25.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f518c91b09709c5bb2a28a331911088f',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: 'f518c91b09709c5bb2a28a331911088f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T08:44:15.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'bc51e7c3df0591a1e8a34172aef873c7',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: -0.13333333333333333,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: 'bc51e7c3df0591a1e8a34172aef873c7',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T19:46:47.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '73066608f7e12b369180c6ddc4402544',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 9,
      lift: 0.44900793650793647,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '73066608f7e12b369180c6ddc4402544',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T13:46:14.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '9bd2cbd01ef0ca8a7bafb2009c72618e',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.09090909090909091,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: '9bd2cbd01ef0ca8a7bafb2009c72618e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T09:56:58.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1242b3850ba9ad5d3c8561179a616d8d',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.5833333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '1242b3850ba9ad5d3c8561179a616d8d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T10:23:26.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0ddb07b2e4c2d945611a4d4874ef6439',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '0ddb07b2e4c2d945611a4d4874ef6439',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T16:24:21.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'add791144b7dd3524ef451cfaf971036',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: -0.5833333333333334,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: 'add791144b7dd3524ef451cfaf971036',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T19:44:17.153Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f1cc5b843fc60017fefe183fa7af532d',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.034490740740740745,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: 'f1cc5b843fc60017fefe183fa7af532d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T10:29:39.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1ef6557a15166d3b230f33cfcbd8888d',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: -0.037268518518518534,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '1ef6557a15166d3b230f33cfcbd8888d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T19:57:38.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1904d3a0784a63737ee7f1099f413263',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 7,
      pvCount: 10,
      lift: 0.7272727272727272,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: '1904d3a0784a63737ee7f1099f413263',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T18:42:03.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1416314a2b037631156135aa87fa1637',
        affiliate: 'IND (ERBK)',
        isci: '554692H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554692H',
      affiliate: 'IND (ERBK)',
      origEventId: '1416314a2b037631156135aa87fa1637',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T19:42:18.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '4d7585283579acbf352a344ebd8f2294',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 0.36507936507936506,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '4d7585283579acbf352a344ebd8f2294',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T15:46:20.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '274164c40af20948e7357f4a778fedb0',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: '274164c40af20948e7357f4a778fedb0',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T11:59:14.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b80b17d096cf90a30d53eaa01ce70812',
        affiliate: 'IND (ERBK)',
        isci: '558908H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558908H',
      affiliate: 'IND (ERBK)',
      origEventId: 'b80b17d096cf90a30d53eaa01ce70812',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T17:45:49.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: 'b66d82927883d95d70c90e2b3400a8f1',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 6,
      lift: 0.42857142857142855,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: 'b66d82927883d95d70c90e2b3400a8f1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T12:37:41.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '025758bde6b4b830356ba8afa527eec2',
        affiliate: 'ABC',
        isci: '554686H'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 0.6666666666666664,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'ABC',
      origEventId: '025758bde6b4b830356ba8afa527eec2',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T14:59:32.735Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7ce1be8b327e1f284743e9af549e9428',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 4,
      pvCount: 12,
      lift: 0.06409611992945323,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: '7ce1be8b327e1f284743e9af549e9428',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:11:31.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ba41e0e46cad5d11602542679989e4d4',
        affiliate: 'ABC',
        isci: '554686H'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 0.36507936507936506,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'ABC',
      origEventId: 'ba41e0e46cad5d11602542679989e4d4',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T15:45:22.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '687e335ff2dd01f35b18db95b0a4b17a',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 10,
      pvCount: 14,
      lift: 0.6678571428571427,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '687e335ff2dd01f35b18db95b0a4b17a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T14:16:12.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b83319266ed8f42aeccd41cddfd6b130',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: 0.7,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'b83319266ed8f42aeccd41cddfd6b130',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T16:30:12.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6558d1be7cb735cc1f3797aab4dc05ca',
        affiliate: 'ABC',
        isci: '554686H'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 0.6666666666666664,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'ABC',
      origEventId: '6558d1be7cb735cc1f3797aab4dc05ca',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T20:54:07.759Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '590747136b050b613ce8ad2cd50566f8',
        affiliate: 'IND (ERBK)',
        isci: '558908H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558908H',
      affiliate: 'IND (ERBK)',
      origEventId: '590747136b050b613ce8ad2cd50566f8',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T17:16:27.854Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '49b5e244aec255e28651578dcfba9f3e',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '49b5e244aec255e28651578dcfba9f3e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T13:28:46.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e7d8a4b0cf0e344381a86487a81ea64a',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: 'e7d8a4b0cf0e344381a86487a81ea64a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T09:39:29.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'fdd4c0dcc319d275ccdb535b2a125f2e',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: -0.021428571428571446,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'fdd4c0dcc319d275ccdb535b2a125f2e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T17:45:39.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '14e1e8f9ab78c66ed06edbb1fd014b6e',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 4,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '14e1e8f9ab78c66ed06edbb1fd014b6e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T17:48:17.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c174d9860f9022b39b3191e0c9776e72',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.19090909090909092,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: 'c174d9860f9022b39b3191e0c9776e72',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T15:20:54.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f8cfc2af0e623880d38a879b4511b0e0',
        affiliate: 'CBS',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 5,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'CBS',
      origEventId: 'f8cfc2af0e623880d38a879b4511b0e0',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T00:32:54.525Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '559982c8c8aa887906455f9e8b032686',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 4,
      lift: 1.8571428571428568,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '559982c8c8aa887906455f9e8b032686',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T22:47:44.513Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e24164cf33be0bf3c0e6182d3d9b6049',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.2777777777777778,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: 'e24164cf33be0bf3c0e6182d3d9b6049',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-14T16:29:23.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f6e4cdb37a0db4961db8914571c7f0b5',
        affiliate: 'FOX',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.0796296296296296,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'FOX',
      origEventId: 'f6e4cdb37a0db4961db8914571c7f0b5',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T12:37:39.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd42b42de64150c9fca5e985af4ac89db',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 3,
      pvCount: 8,
      lift: 0.2499999999999998,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: 'd42b42de64150c9fca5e985af4ac89db',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T15:24:16.354Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'efc6700b757d40f71b097a8f7070c1af',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.20939393939393933,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: 'efc6700b757d40f71b097a8f7070c1af',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T15:49:38.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ff864314e0dcf9eb6d78b745b1734afc',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 6,
      pvCount: 16,
      lift: 0.3053571428571428,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'ff864314e0dcf9eb6d78b745b1734afc',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T16:46:37.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2a47f1a37477fcbf1a6d8cd5c5199c43',
        affiliate: 'CW',
        isci: '554686H'
      },
      sessionCount: 3,
      pvCount: 8,
      lift: 1.4999999999999996,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'CW',
      origEventId: '2a47f1a37477fcbf1a6d8cd5c5199c43',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T16:53:13.110Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '75e51f3690adc0221b537ed29ad10c31',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 6,
      pvCount: 9,
      lift: 4.4775166666868955,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '75e51f3690adc0221b537ed29ad10c31',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T16:31:36.440Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '73d130ba1d42fe33c28d04cf3e96be2f',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: '73d130ba1d42fe33c28d04cf3e96be2f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-07T10:50:11.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f6569da8bcddd66855c73c982e26ec9f',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: -0.04074074074074076,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: 'f6569da8bcddd66855c73c982e26ec9f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T19:16:08.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '274f579f241b95ea0cbddc4a5f2d8e11',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 5,
      pvCount: 8,
      lift: 0.11527006172839502,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: '274f579f241b95ea0cbddc4a5f2d8e11',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T19:36:42.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a3fe4c3bce78a372668d655d06778e29',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 5,
      lift: 4,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'a3fe4c3bce78a372668d655d06778e29',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T14:18:18.225Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f41ae5dbf535743b38d2149dc9d9563e',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.13333333333333333,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: 'f41ae5dbf535743b38d2149dc9d9563e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T12:27:51.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '40a6fe471758839c5794389d5c585ffb',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: 0.14285714285714285,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '40a6fe471758839c5794389d5c585ffb',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T12:23:35.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd62599bb64b9fccbf78d305afec354f9',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.03829365079365076,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'd62599bb64b9fccbf78d305afec354f9',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T13:19:11.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '057caf83a19e4f628ec9e376e864ec6c',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.04545454545454549,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '057caf83a19e4f628ec9e376e864ec6c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T12:29:59.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1874948c1492eeb3594bb9f816690251',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: -0.0833333333333334,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '1874948c1492eeb3594bb9f816690251',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T18:59:04.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c349a5606ea5a226494e2017bacee53c',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 10,
      lift: 3,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'c349a5606ea5a226494e2017bacee53c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T22:18:32.873Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0042a294c8f664d4a7a67b672264191c',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 5,
      pvCount: 10,
      lift: 0.156547619047619,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '0042a294c8f664d4a7a67b672264191c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T17:17:35.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '428f8068938772a7fd19ec6cae9937be',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 8,
      pvCount: 13,
      lift: 0.386111111111111,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: '428f8068938772a7fd19ec6cae9937be',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T19:17:08.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e76b9450819bdd661aba5cc920f2a334',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: 'e76b9450819bdd661aba5cc920f2a334',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T11:27:10.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '19289605f693908eff6bf863ba15ddf8',
        affiliate: 'CBS',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 8,
      lift: -0.04444444444444446,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CBS',
      origEventId: '19289605f693908eff6bf863ba15ddf8',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T19:49:32.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '304761cc8bdda82b77943fcc04de4e05',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 5,
      pvCount: 5,
      lift: 0.25363636363636366,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '304761cc8bdda82b77943fcc04de4e05',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T12:45:16.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '10c2310b80852dc49f1a840adde52e9f',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 4,
      pvCount: 4,
      lift: 2.6363636363636362,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '10c2310b80852dc49f1a840adde52e9f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T18:29:06.130Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '354990b71e1a052583b8a74c5e24dd51',
        affiliate: 'IND (ERBK)',
        isci: '558908H'
      },
      sessionCount: 1,
      pvCount: 6,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558908H',
      affiliate: 'IND (ERBK)',
      origEventId: '354990b71e1a052583b8a74c5e24dd51',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T15:13:47.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '2906d51416b7ecc77f49b0566adeadd5',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '2906d51416b7ecc77f49b0566adeadd5',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T21:24:22.528Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '97815d6ed0e75a11e968fb9b061d6205',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 5,
      pvCount: 14,
      lift: 0.09536961054818198,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '97815d6ed0e75a11e968fb9b061d6205',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T15:17:27.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1f6916e5d442970871e79c4236b1af4a',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 5,
      pvCount: 5,
      lift: 0.7228174603174603,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '1f6916e5d442970871e79c4236b1af4a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T14:44:48.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '00645f225a847772278500537a8aad42',
        affiliate: 'CBS',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 8,
      lift: -0.04444444444444446,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CBS',
      origEventId: '00645f225a847772278500537a8aad42',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T19:49:32.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '09e868f05010295fd0a78796cc79ba50',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: 0.14285714285714285,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '09e868f05010295fd0a78796cc79ba50',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T12:23:35.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c2065549e921a0d372a3b8a7a5919c98',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: -0.2857142857142858,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'c2065549e921a0d372a3b8a7a5919c98',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T23:10:46.436Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '00a4e8edd7ed18eaa6a99bc9251b4629',
        affiliate: 'FOX',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 6,
      lift: 0.2857142857142857,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'FOX',
      origEventId: '00a4e8edd7ed18eaa6a99bc9251b4629',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T12:23:59.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '28bb6d5720d1127bdf69b13ef2427886',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: 0.26666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: '28bb6d5720d1127bdf69b13ef2427886',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T19:31:48.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8eb818caac77a5d2616b01520a129a5a',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.5833333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '8eb818caac77a5d2616b01520a129a5a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T10:23:03.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd2d8c2351ef88b36f2933f0efa510acb',
        affiliate: 'IND (ERBK)',
        isci: '558908H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558908H',
      affiliate: 'IND (ERBK)',
      origEventId: 'd2d8c2351ef88b36f2933f0efa510acb',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T13:14:32.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: 'a8fc4ca81926edc5d66603641b8c7576',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 1.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'a8fc4ca81926edc5d66603641b8c7576',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T16:48:20.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'acda91564787e23d63a948a3d458492c',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'acda91564787e23d63a948a3d458492c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T09:25:07.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '09cb02ca519103f0573a01e673a0d2d7',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 6,
      lift: 0.42857142857142855,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '09cb02ca519103f0573a01e673a0d2d7',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T12:37:52.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e01ec54f875e93226b4ddad141275b7a',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.7027777777777777,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: 'e01ec54f875e93226b4ddad141275b7a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T13:27:30.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4c7dcc0bbe2c4c28bdd59afb0849a617',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.27272727272727265,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: '4c7dcc0bbe2c4c28bdd59afb0849a617',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T19:44:33.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'be96d9fa346e5c90d0d0d7934d9e916c',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.09090909090909091,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: 'be96d9fa346e5c90d0d0d7934d9e916c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T09:57:38.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '864d7a93646155e1b9f72ad228676d99',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.2777777777777778,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: '864d7a93646155e1b9f72ad228676d99',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-14T16:29:46.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '5c4c32b64c9141286cc3551e55b4e689',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '5c4c32b64c9141286cc3551e55b4e689',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T17:00:10.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4cf58cfd593cbec1103b74b411f9c671',
        affiliate: 'IND (ERBK)',
        isci: '554692H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554692H',
      affiliate: 'IND (ERBK)',
      origEventId: '4cf58cfd593cbec1103b74b411f9c671',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T19:42:59.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '23ad054c86eb26bd3827700fc1afed50',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '23ad054c86eb26bd3827700fc1afed50',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T19:58:07.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a0fbe86b9a7a17cc00cdad5d0390d6e3',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: 'a0fbe86b9a7a17cc00cdad5d0390d6e3',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T23:58:19.763Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'aee4a175a5d21a84a36a61f487652128',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 7,
      lift: 3,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: 'aee4a175a5d21a84a36a61f487652128',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T13:59:44.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b781f6d0d33cffe72f936dde02c141a0',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 5,
      lift: 1.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'b781f6d0d33cffe72f936dde02c141a0',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T14:18:33.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1260ae54eeb231442f801da08fd831b7',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.19090909090909092,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: '1260ae54eeb231442f801da08fd831b7',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T15:20:54.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8e537207c76bdddcc65eaca61bee4d90',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '8e537207c76bdddcc65eaca61bee4d90',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T16:58:02.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '97502303e006c4bfe832376af1f18434',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 6,
      lift: 0.42857142857142855,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '97502303e006c4bfe832376af1f18434',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T12:37:26.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c8822e09ef17ecf311961450b353f716',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 4,
      pvCount: 9,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: 'c8822e09ef17ecf311961450b353f716',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T18:57:26.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd7aee7b32f384e5ca661193069dd0fea',
        affiliate: 'CBS',
        isci: '554686H'
      },
      sessionCount: 9,
      pvCount: 40,
      lift: 6.499999999999999,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'CBS',
      origEventId: 'd7aee7b32f384e5ca661193069dd0fea',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T23:48:09.010Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '17c9caa8a42f42c8a9f4c8bf9d9148d9',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.12738095238095234,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '17c9caa8a42f42c8a9f4c8bf9d9148d9',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T14:45:17.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3d27777b49a5bf39ab14679643884098',
        affiliate: 'IND (ERBK)',
        isci: '558908H'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558908H',
      affiliate: 'IND (ERBK)',
      origEventId: '3d27777b49a5bf39ab14679643884098',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-07T02:46:57.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '998dba5d38750ed4ddcfcaf1c6c6f949',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.10284580498866211,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '998dba5d38750ed4ddcfcaf1c6c6f949',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T15:45:45.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd2d47d609862b560eb908fba6c19b0d6',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.0037397721326292606,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'd2d47d609862b560eb908fba6c19b0d6',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-07T16:46:06.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '831e625dd1c927a627ca6d9d2f3eada3',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.6666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '831e625dd1c927a627ca6d9d2f3eada3',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T12:12:37.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1f467346d4311a1c031cd6cb61c99e19',
        affiliate: 'ABC',
        isci: '554686H'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 0.11236388882001234,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'ABC',
      origEventId: '1f467346d4311a1c031cd6cb61c99e19',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T14:59:31.716Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e5078439da7def7eecb966aad2f1a242',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.030303030303030325,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: 'e5078439da7def7eecb966aad2f1a242',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T10:59:54.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c095cb920160f6a923fbf8d83756c6f1',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: 'c095cb920160f6a923fbf8d83756c6f1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T17:14:49.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f2e9984ae3253601aa354ce3e34d930e',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 7,
      lift: 0.5331349206349205,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'f2e9984ae3253601aa354ce3e34d930e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T13:44:23.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '518f07ceb6139615bebb32c51cd65b88',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 5,
      pvCount: 8,
      lift: 0.11364969135802468,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: '518f07ceb6139615bebb32c51cd65b88',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T19:36:53.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '5d6618c88438cd3757d9c6ea5739797d',
        affiliate: 'MNTV',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'MNTV',
      origEventId: '5d6618c88438cd3757d9c6ea5739797d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T09:38:25.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd9eb11954b29b418aad1083abbb48f15',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 1.4,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'd9eb11954b29b418aad1083abbb48f15',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T16:47:08.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3f9678b79285336039b21351a995a57a',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 6,
      pvCount: 12,
      lift: 0.33511904761904754,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '3f9678b79285336039b21351a995a57a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T17:16:50.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ffebdf4b36cb2d0c65b2a7d5a58b98b7',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 5,
      pvCount: 15,
      lift: 0.6275793650793651,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'ffebdf4b36cb2d0c65b2a7d5a58b98b7',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T16:46:59.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '9b42fa92a1e871ee01116cf7bcd53651',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.14285714285714285,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '9b42fa92a1e871ee01116cf7bcd53651',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T11:27:44.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '9de686774b5aa5ec6e90036e756cdb82',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '9de686774b5aa5ec6e90036e756cdb82',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T16:24:21.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '5222b944042a8c0830859900d153421c',
        affiliate: 'CBS',
        isci: '554686H'
      },
      sessionCount: 2,
      pvCount: 15,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'CBS',
      origEventId: '5222b944042a8c0830859900d153421c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T19:33:29.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '44c80ea484286a686cb3894e42302ec1',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 0.8333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '44c80ea484286a686cb3894e42302ec1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T17:57:03.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '38b834fc49f53eb9582aec863281212a',
        affiliate: 'MNTV',
        isci: '558908H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558908H',
      affiliate: 'MNTV',
      origEventId: '38b834fc49f53eb9582aec863281212a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T17:29:46.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '13710b7c2a0961da37f8019dee49a92b',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 6,
      pvCount: 13,
      lift: 0.3003968253968254,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '13710b7c2a0961da37f8019dee49a92b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T17:18:53.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8bc1ea7ba4c1d67eb46b5106023339d1',
        affiliate: 'FOX',
        isci: '554686H'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 0.20601851851851843,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'FOX',
      origEventId: '8bc1ea7ba4c1d67eb46b5106023339d1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T12:59:17.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f0ad23563260358263af31aee33469db',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 4,
      pvCount: 4,
      lift: 2.333333333333333,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: 'f0ad23563260358263af31aee33469db',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T00:46:18.097Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1e93627abde9bbf5132a7a30919f5273',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 6,
      pvCount: 9,
      lift: 0.6576388888888887,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '1e93627abde9bbf5132a7a30919f5273',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T14:46:22.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8533386cc598dad75d9b5c22c434c698',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.818181818181818,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: '8533386cc598dad75d9b5c22c434c698',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T23:42:07.312Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'bc8564f8ee7c2431fbe3130ffa153e48',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.19090909090909092,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: 'bc8564f8ee7c2431fbe3130ffa153e48',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T15:20:59.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'fc06be3c3a3181878660f03d5b48fa64',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: -0.02615740740740742,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: 'fc06be3c3a3181878660f03d5b48fa64',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T19:16:02.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7c6f12340eb1c5dd3490a2ec90cad3df',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 3,
      pvCount: 5,
      lift: 3,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '7c6f12340eb1c5dd3490a2ec90cad3df',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T17:58:59.517Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '98dfd5efbdeba04f1c69d7066b5d45eb',
        affiliate: 'MNTV',
        isci: '558908H'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558908H',
      affiliate: 'MNTV',
      origEventId: '98dfd5efbdeba04f1c69d7066b5d45eb',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T17:44:29.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '0fac13333e0ca5faa318be4e39ecda49',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 5,
      pvCount: 5,
      lift: 1.75,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '0fac13333e0ca5faa318be4e39ecda49',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T14:43:20.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '563064f6d17593cbe8d508db8c41eba5',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '563064f6d17593cbe8d508db8c41eba5',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T21:25:00.780Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd66077f832f95f54328dac654a69561e',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: 'd66077f832f95f54328dac654a69561e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T18:12:45.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '331fb0634df611d9b6f57aae2d768f8b',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 0.1869642857142857,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: '331fb0634df611d9b6f57aae2d768f8b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T15:38:33.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1d21ab7a4491a6567d3e3c70fa40264b',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: '1d21ab7a4491a6567d3e3c70fa40264b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T08:46:39.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ef8aea96ec687b7397a4d52ef4372317',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: 'ef8aea96ec687b7397a4d52ef4372317',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T11:59:14.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '350a0f95a897e33c1583ab392d391341',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: '350a0f95a897e33c1583ab392d391341',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T16:53:09.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '19a0486b61b987a16b4f4d0a6de791c9',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.6666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: '19a0486b61b987a16b4f4d0a6de791c9',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T08:23:47.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'fa6f362aeef845fb751966e5dc23ef18',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: -0.4174476192111062,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'fa6f362aeef845fb751966e5dc23ef18',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:21:40.979Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b82ab0edb5ff920e95853d561601b5ab',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 3,
      pvCount: 9,
      lift: 0.5757575757575757,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: 'b82ab0edb5ff920e95853d561601b5ab',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T18:58:17.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c187c2cb3073c504be8945f804917304',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 4,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'c187c2cb3073c504be8945f804917304',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T23:44:07.148Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '83fefddb3173a88ddfbc65af7383752d',
        affiliate: 'CW',
        isci: '554686H'
      },
      sessionCount: 5,
      pvCount: 10,
      lift: -0.16666666666666682,
      baselineSessionCount: 5,
      baselineSessionsPerSecond: 0.016666666666666666,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'CW',
      origEventId: '83fefddb3173a88ddfbc65af7383752d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T14:45:51.479Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ad02bf0e5cc4edb0d931ee5799e83348',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 0.038214285714285715,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'ad02bf0e5cc4edb0d931ee5799e83348',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T15:43:20.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ac8390600ae6344285d84b6e26a29c93',
        affiliate: 'CBS',
        isci: '558904H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558904H',
      affiliate: 'CBS',
      origEventId: 'ac8390600ae6344285d84b6e26a29c93',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T16:20:28.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '3226f656c989eaaff5392d330d558696',
        affiliate: 'ABC',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'ABC',
      origEventId: '3226f656c989eaaff5392d330d558696',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T19:25:08.967Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a58727a3ceba19fec699d4ec7184c457',
        affiliate: 'FOX',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: -0.0036375661375661473,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'FOX',
      origEventId: 'a58727a3ceba19fec699d4ec7184c457',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T14:27:16.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3c44c9f433f987191c8f47e24d908b33',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '3c44c9f433f987191c8f47e24d908b33',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T10:47:11.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6cdb05cf0814939cf9ae9d7ce51026c8',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: -0.08246031746031747,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '6cdb05cf0814939cf9ae9d7ce51026c8',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T19:41:17.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '24b96752e4a1cf54e65ab5b056c96b72',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 6,
      pvCount: 9,
      lift: 0.6576388888888887,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '24b96752e4a1cf54e65ab5b056c96b72',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T14:46:27.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7dff891c736e0df72248dfe3465ee2d4',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 10,
      pvCount: 20,
      lift: 0.31046296296296294,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: '7dff891c736e0df72248dfe3465ee2d4',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T15:37:02.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'cf215c22fc2c204be8a908a26eda9663',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 9,
      lift: 0.33124999999999993,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: 'cf215c22fc2c204be8a908a26eda9663',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T15:39:07.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a659e79910b53aee05f7c67d96ec6258',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: 'a659e79910b53aee05f7c67d96ec6258',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T23:12:15.323Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7cfcab2ce50fe4f24031a33c9a83e57a',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 4,
      pvCount: 20,
      lift: 0.06102513227513227,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: '7cfcab2ce50fe4f24031a33c9a83e57a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T18:17:15.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '9a1252da99d4d1c49ccd4d330f0a81b8',
        affiliate: 'FOX',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.06884920634920633,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'FOX',
      origEventId: '9a1252da99d4d1c49ccd4d330f0a81b8',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T12:56:14.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4a73b193eaded6078567e6c34d227300',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 9,
      lift: 0.3408730158730158,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '4a73b193eaded6078567e6c34d227300',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T14:14:16.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '552e2fd88d3b31f5282ebd8fba717298',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 4,
      pvCount: 12,
      lift: 0.06733686067019397,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: '552e2fd88d3b31f5282ebd8fba717298',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:11:24.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e3823a59c0e3f5e02aa4affd8cee453c',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: -0.017228835978835986,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: 'e3823a59c0e3f5e02aa4affd8cee453c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T19:15:53.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e1ecc99a8ca9cccd6f02d834afead63c',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 6,
      lift: 3,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'e1ecc99a8ca9cccd6f02d834afead63c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T21:30:15.329Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8def5d9b00b9f45ee9d51ad1d30005f6',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 7,
      pvCount: 8,
      lift: 0.4803571428571427,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '8def5d9b00b9f45ee9d51ad1d30005f6',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T15:17:11.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1ff313b8f2ddbc273324a6db75754036',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: '1ff313b8f2ddbc273324a6db75754036',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T17:14:49.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a87f6291f3dc0e7433213e5ef401b8a8',
        affiliate: 'FOX',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: 2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'FOX',
      origEventId: 'a87f6291f3dc0e7433213e5ef401b8a8',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T17:23:52.109Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8da2d859151a068f0abded5befc15f30',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: -0.037268518518518534,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '8da2d859151a068f0abded5befc15f30',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T19:57:38.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c2e9ea4055a2a40917833e5fe4a9e15d',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: 'c2e9ea4055a2a40917833e5fe4a9e15d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T11:59:29.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7aea473084dda87a850d5133fee61856',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: '7aea473084dda87a850d5133fee61856',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T11:13:32.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '95d2de2831745d3196764f620f84805f',
        affiliate: 'MNTV',
        isci: '558908H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.09090909090909098,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558908H',
      affiliate: 'MNTV',
      origEventId: '95d2de2831745d3196764f620f84805f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T19:58:55.255Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '673d7bc1dfbe0e8c133bd2e8adff6e26',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: '673d7bc1dfbe0e8c133bd2e8adff6e26',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T11:13:13.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c9e305b3dba3d452d282fd189f321f86',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.3818181818181818,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: 'c9e305b3dba3d452d282fd189f321f86',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T10:25:08.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '857d8a79ce36f88c9418b147ea745587',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '857d8a79ce36f88c9418b147ea745587',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T13:55:07.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a195d2dab9a129204e696fee613eb0ce',
        affiliate: 'CBS',
        isci: '554686H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'CBS',
      origEventId: 'a195d2dab9a129204e696fee613eb0ce',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T00:32:32.600Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'dba6c922a482fe1a5d6a319570f514fa',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.03829365079365077,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'dba6c922a482fe1a5d6a319570f514fa',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T13:19:11.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '93727616a62b3a5dab175ff9b9b928a7',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '93727616a62b3a5dab175ff9b9b928a7',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T17:57:16.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '99fbd1e64358b73dc3fdf8d94081d073',
        affiliate: 'IND (ERBK)',
        isci: '558908H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558908H',
      affiliate: 'IND (ERBK)',
      origEventId: '99fbd1e64358b73dc3fdf8d94081d073',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T15:15:02.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '05afac9a6804917b93ac2aa4e31d2048',
        affiliate: 'FOX',
        isci: '554686H'
      },
      sessionCount: 5,
      pvCount: 12,
      lift: 1.5374999999999996,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'FOX',
      origEventId: '05afac9a6804917b93ac2aa4e31d2048',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T15:06:31.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f517a75e7d411155c3e24811645ba5c5',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'f517a75e7d411155c3e24811645ba5c5',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T14:47:35.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '05650f296cfcdb12956f75e083382d44',
        affiliate: 'CW',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CW',
      origEventId: '05650f296cfcdb12956f75e083382d44',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T11:26:17.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '351445b0a32062b35073867ac51d7271',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 7,
      lift: 0.42857142857142844,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '351445b0a32062b35073867ac51d7271',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T19:17:09.327Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a4755a598ef8638fcd4c77b62b2025a5',
        affiliate: 'CW',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CW',
      origEventId: 'a4755a598ef8638fcd4c77b62b2025a5',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T12:30:41.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '39c6113f4db865fe2068929c985bad5a',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: '39c6113f4db865fe2068929c985bad5a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T16:44:53.914Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '629a99b5d329b4293391043cd68f4ea5',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '629a99b5d329b4293391043cd68f4ea5',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T17:57:30.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f99df835090d8c0c54f103d25f3909ca',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 0.5167592592592591,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: 'f99df835090d8c0c54f103d25f3909ca',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T19:14:15.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c03d3200cf9b77085acd22d39ad8a926',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: -0.044212962962962975,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: 'c03d3200cf9b77085acd22d39ad8a926',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T19:57:28.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a790c77d15f8f99025b6e9a26a7c9770',
        affiliate: 'CBS',
        isci: '554686H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: -0.13164351851851852,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'CBS',
      origEventId: 'a790c77d15f8f99025b6e9a26a7c9770',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T19:35:49.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd8904f6b3ccf4cffa645cd86ddefcefd',
        affiliate: 'CW',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CW',
      origEventId: 'd8904f6b3ccf4cffa645cd86ddefcefd',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T16:48:24.850Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '96bd1f37f0647f777199c4806b5607ba',
        affiliate: 'IND (ERBK)',
        isci: '558908H'
      },
      sessionCount: 1,
      pvCount: 5,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558908H',
      affiliate: 'IND (ERBK)',
      origEventId: '96bd1f37f0647f777199c4806b5607ba',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T23:44:28.028Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '43f9eae7a048a44d0bad0baf2c3d538e',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.034490740740740745,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: '43f9eae7a048a44d0bad0baf2c3d538e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T10:29:46.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e348b4d7fc9dbd32f78ceeda8ed59546',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 6,
      pvCount: 9,
      lift: 0.42440476190476184,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'e348b4d7fc9dbd32f78ceeda8ed59546',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T18:44:44.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '419ce6f5ade59a5bd4e56488add33697',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 0.36363636363636354,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '419ce6f5ade59a5bd4e56488add33697',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T22:00:11.887Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7db7617ce4fe33ed747183fbc7a5d9b8',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 6,
      pvCount: 13,
      lift: 0.3353174603174602,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '7db7617ce4fe33ed747183fbc7a5d9b8',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T17:18:31.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '32e0af1575ada9bd8402acdab7ad5348',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: '32e0af1575ada9bd8402acdab7ad5348',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-15T00:48:38.384Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '61939b04e9acc7793bbb9a5ff0b726df',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '61939b04e9acc7793bbb9a5ff0b726df',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-07T14:49:49.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '73a5f4c8edd39bb61992ae840b449e3b',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.6666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '73a5f4c8edd39bb61992ae840b449e3b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T15:12:44.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'de43fa1b790fb4c668feca61a00d8773',
        affiliate: 'IND (ERBK)',
        isci: '558908H'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558908H',
      affiliate: 'IND (ERBK)',
      origEventId: 'de43fa1b790fb4c668feca61a00d8773',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T19:41:27.345Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: 'a0891af16a7cef48b305494aac68db3b',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 0.7833333333333332,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'a0891af16a7cef48b305494aac68db3b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T14:47:41.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f0ccfed626e5187b296fae343d3887b8',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 0.8,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'f0ccfed626e5187b296fae343d3887b8',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T14:14:36.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'fb084f493b7b12639c3c99e169efeee0',
        affiliate: 'CW',
        isci: '554686H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.6666666666666664,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'CW',
      origEventId: 'fb084f493b7b12639c3c99e169efeee0',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:55:19.966Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8684dec1637b93e7aa75db05c1cfd146',
        affiliate: 'FOX',
        isci: '558902H'
      },
      sessionCount: 5,
      pvCount: 12,
      lift: 3.166666666666666,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'FOX',
      origEventId: '8684dec1637b93e7aa75db05c1cfd146',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T20:44:05.099Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '83402f4a2f526a4d4f77cb1bf3a4a482',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '83402f4a2f526a4d4f77cb1bf3a4a482',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T23:43:08.910Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '954f8969e55fe6ee1f4cb8935d0fb1fd',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '954f8969e55fe6ee1f4cb8935d0fb1fd',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T10:47:51.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'dc6283db9e0c432dc00ca56c0f42c296',
        affiliate: 'ABC',
        isci: '554686H'
      },
      sessionCount: 5,
      pvCount: 6,
      lift: 0.38888888888888873,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'ABC',
      origEventId: 'dc6283db9e0c432dc00ca56c0f42c296',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T13:58:43.250Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a82a420c6be683ae2abcb25279bbe5a1',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 5,
      pvCount: 8,
      lift: 0.11364969135802468,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: 'a82a420c6be683ae2abcb25279bbe5a1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T19:36:53.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ee16c5fe7204f06fa42b1acd1308d30a',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 7,
      lift: -0.00984126984126985,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'ee16c5fe7204f06fa42b1acd1308d30a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T19:40:49.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a99373b887b40887efd55e0292368938',
        affiliate: 'FOX',
        isci: '554686H'
      },
      sessionCount: 5,
      pvCount: 12,
      lift: 1.5374999999999996,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'FOX',
      origEventId: 'a99373b887b40887efd55e0292368938',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T15:07:04.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a9f345f850e97d79cdf90fc9e5eaaddb',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: 'a9f345f850e97d79cdf90fc9e5eaaddb',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T12:14:12.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '88524468cc9bd6d8b3f2d9629d88a72c',
        affiliate: 'MNTV',
        isci: '558908H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558908H',
      affiliate: 'MNTV',
      origEventId: '88524468cc9bd6d8b3f2d9629d88a72c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T22:11:35.083Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: 'afe9535a0079b03ffbd12db3ddb79e18',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.03935185185185185,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: 'afe9535a0079b03ffbd12db3ddb79e18',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T14:36:52.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7184ea932be5049022cc464b3630d610',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 0.1980753968253968,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: '7184ea932be5049022cc464b3630d610',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T15:38:45.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f5ecfd6a9cd05695f65ab0b8dd5551f7',
        affiliate: 'CW',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CW',
      origEventId: 'f5ecfd6a9cd05695f65ab0b8dd5551f7',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T11:48:29.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0977d9b8405209284f15ec33309241e7',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 5,
      lift: 0.75,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '0977d9b8405209284f15ec33309241e7',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T16:50:11.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '672ab4a2f14e8c12cdc340d250cf26dc',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 2.6363636363636362,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '672ab4a2f14e8c12cdc340d250cf26dc',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T15:45:24.195Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '91a4454c97fb3dee5ec4c2e5b14d93bb',
        affiliate: 'IND (ERBK)',
        isci: '554692H'
      },
      sessionCount: 1,
      pvCount: 4,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554692H',
      affiliate: 'IND (ERBK)',
      origEventId: '91a4454c97fb3dee5ec4c2e5b14d93bb',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T13:15:32.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '6ae87bb67730109ebde9c035e72d9504',
        affiliate: 'ABC',
        isci: '554686H'
      },
      sessionCount: 4,
      pvCount: 7,
      lift: 4,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'ABC',
      origEventId: '6ae87bb67730109ebde9c035e72d9504',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T13:59:02.275Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f447e88647f788c85144a0d06573effa',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 0.8333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: 'f447e88647f788c85144a0d06573effa',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T17:57:03.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3d242845f423c0a4cdef96dc2af5a134',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: -0.3466809525376275,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '3d242845f423c0a4cdef96dc2af5a134',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T14:45:05.811Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '89fb66b60c77e7e0719702d5f9f39268',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '89fb66b60c77e7e0719702d5f9f39268',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T14:46:30.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4fd2dad0813755e0d7f58e58bdb5e3b6',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: 0.19206349206349202,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '4fd2dad0813755e0d7f58e58bdb5e3b6',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T19:40:05.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd1d71ce81c1025599b478bf5ad40bb56',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 5,
      lift: 0.75,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'd1d71ce81c1025599b478bf5ad40bb56',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T16:49:50.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '952c85a77e9fb11f000c35a70ebd0cc5',
        affiliate: 'FOX',
        isci: '558902H'
      },
      sessionCount: 4,
      pvCount: 12,
      lift: 4,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'FOX',
      origEventId: '952c85a77e9fb11f000c35a70ebd0cc5',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T17:37:00.826Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '748e8e347e979f42360223fb55d99101',
        affiliate: 'IND (ERBK)',
        isci: '558908H'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558908H',
      affiliate: 'IND (ERBK)',
      origEventId: '748e8e347e979f42360223fb55d99101',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-07T02:46:57.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: 'c32caa51cc8a9fc119e517d170ce97c1',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 7,
      pvCount: 12,
      lift: 0.425,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: 'c32caa51cc8a9fc119e517d170ce97c1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T18:58:31.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f671e4f8d4e5bef3566c5b43f7a9d74d',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 7,
      pvCount: 7,
      lift: 1.4371031746031746,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'f671e4f8d4e5bef3566c5b43f7a9d74d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T14:44:05.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '41e68b97a69d1f0de8539d5f66830ae3',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: '41e68b97a69d1f0de8539d5f66830ae3',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T16:56:24.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'adad39dbb67a107653eb13863074217b',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: 'adad39dbb67a107653eb13863074217b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T09:39:29.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ce48758847f2e83c49d64acf4651ab94',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 4,
      pvCount: 20,
      lift: 0.06102513227513227,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: 'ce48758847f2e83c49d64acf4651ab94',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T18:17:15.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'aabbf4765978cab9be9932b5938ca697',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 0.025119047619047617,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'aabbf4765978cab9be9932b5938ca697',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T15:44:25.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f08169725823eee30ef9cbdbf6fddf01',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.5333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'f08169725823eee30ef9cbdbf6fddf01',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T14:48:03.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3a002232306dd8146a9c8eb542325e7c',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 4,
      pvCount: 7,
      lift: 0.28194444444444444,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: '3a002232306dd8146a9c8eb542325e7c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T18:58:10.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '94df22ddd566ae9e702a03e7b01aeed4',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 5,
      pvCount: 8,
      lift: 0.5199025974025974,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '94df22ddd566ae9e702a03e7b01aeed4',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T14:00:12.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1756197408bf5827261d38f545dfa526',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '1756197408bf5827261d38f545dfa526',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T13:43:04.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '22c71959824bbbe2a2038bce68ab2a83',
        affiliate: 'CBS',
        isci: '558906H'
      },
      sessionCount: 5,
      pvCount: 9,
      lift: 1.2727272727272725,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CBS',
      origEventId: '22c71959824bbbe2a2038bce68ab2a83',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T15:59:51.330Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '9f68c945a615899a272338e5391d8953',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '9f68c945a615899a272338e5391d8953',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T12:43:33.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b9ca361ab0132db9302fe30ba37d5584',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: -0.4444444444444446,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: 'b9ca361ab0132db9302fe30ba37d5584',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T21:44:01.751Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b4be8111d554736845c928603261a868',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 0.06261904761904763,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'b4be8111d554736845c928603261a868',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T15:44:04.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'bbede927466cbbc3d04399f16c9f86f0',
        affiliate: 'FOX',
        isci: '558902H'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 0.11111111111111097,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'FOX',
      origEventId: 'bbede927466cbbc3d04399f16c9f86f0',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T15:22:45.769Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '34beae08c57f7acc0710127e867e3dd1',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 8,
      pvCount: 23,
      lift: 0.9765873015873014,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '34beae08c57f7acc0710127e867e3dd1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T17:17:01.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '53576b81cd47bce21c5f2c3e63d5089c',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: '53576b81cd47bce21c5f2c3e63d5089c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T13:26:56.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b70cfffecdecff85c330328735cff426',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: -0.044212962962962975,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: 'b70cfffecdecff85c330328735cff426',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T19:57:28.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'bca30fe8aec528034b8260159d25be73',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: -0.09090909090909098,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: 'bca30fe8aec528034b8260159d25be73',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T15:26:49.907Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '80aa7bfb012788f2cab4444e9e698ebe',
        affiliate: 'FOX',
        isci: '558902H'
      },
      sessionCount: 4,
      pvCount: 16,
      lift: 2.333333333333333,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'FOX',
      origEventId: '80aa7bfb012788f2cab4444e9e698ebe',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T17:14:35.302Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e9e54b1ba0e726e45059df779fd3b3f1',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.14285714285714285,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: 'e9e54b1ba0e726e45059df779fd3b3f1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T11:27:32.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1d7480f1169be491d0dab8a51799a4b5',
        affiliate: 'IND (ERBK)',
        isci: '554692H'
      },
      sessionCount: 1,
      pvCount: 4,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554692H',
      affiliate: 'IND (ERBK)',
      origEventId: '1d7480f1169be491d0dab8a51799a4b5',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T13:14:19.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: 'c6ff03e05872dfd2dfda673034cc13e9',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 0.6428571428571428,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: 'c6ff03e05872dfd2dfda673034cc13e9',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T12:23:59.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'dd3abb09745a69e63e57793a8a408b23',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 6,
      pvCount: 12,
      lift: 0.2652777777777777,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'dd3abb09745a69e63e57793a8a408b23',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T17:16:06.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4f076b4c3893dfaaab08a892eb3b2ab4',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 8,
      pvCount: 13,
      lift: 0.41694444444444434,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: '4f076b4c3893dfaaab08a892eb3b2ab4',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T19:16:50.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ce00bdac01b98d95854712fd8a2bc265',
        affiliate: 'FOX',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 6,
      lift: 0.2857142857142857,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'FOX',
      origEventId: 'ce00bdac01b98d95854712fd8a2bc265',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T12:24:21.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a0a2253e54218ea95d4fb06e05e47ca7',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 4,
      pvCount: 19,
      lift: 0.04315476190476189,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: 'a0a2253e54218ea95d4fb06e05e47ca7',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T18:16:48.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f0a3d1a6ce236b281c2cb25fe1816cf1',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: 'f0a3d1a6ce236b281c2cb25fe1816cf1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T12:25:28.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6f14a8489f86b48ab233e5fcf21c26bb',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 10,
      lift: 4,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '6f14a8489f86b48ab233e5fcf21c26bb',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T19:43:21.491Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b4473986d28c39c337de01769e7d19d3',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 5,
      lift: 1.425396825396825,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'b4473986d28c39c337de01769e7d19d3',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T13:21:01.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '13ae83f52f26798e015e9129541c1569',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: -0.1666666666666668,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: '13ae83f52f26798e015e9129541c1569',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T14:58:10.939Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '40b26deb440d12bd599249977d59d23a',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: '40b26deb440d12bd599249977d59d23a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T23:15:08.736Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ef351415a46e94cd49c7b2573bc54d86',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: -0.09444444444444448,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'ef351415a46e94cd49c7b2573bc54d86',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T17:44:10.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd1feaab04b487283ce31b4e837a17c1b',
        affiliate: 'FOX',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.0796296296296296,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'FOX',
      origEventId: 'd1feaab04b487283ce31b4e837a17c1b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T12:37:39.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c5442d3f120cb00d45f4d8d7b7e64b22',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 7,
      pvCount: 7,
      lift: 0.2876111110051472,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: 'c5442d3f120cb00d45f4d8d7b7e64b22',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T20:20:54.752Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c51fe1028b1bc00eeba50f80096d0059',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: 'c51fe1028b1bc00eeba50f80096d0059',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-07T20:58:05.757Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '66a1cc2d6c5d20393490ff3691392ffb',
        affiliate: 'NBC',
        isci: '558908H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558908H',
      affiliate: 'NBC',
      origEventId: '66a1cc2d6c5d20393490ff3691392ffb',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T14:23:27.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: 'a6a8e869b3db37113ca2d62029076ed7',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 5,
      pvCount: 14,
      lift: 0.5926587301587302,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'a6a8e869b3db37113ca2d62029076ed7',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T16:45:08.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'dbb0a50147d85fe5d4d22b9db2141bb6',
        affiliate: 'CW',
        isci: '558906H'
      },
      sessionCount: 6,
      pvCount: 11,
      lift: -0.03030303030303033,
      baselineSessionCount: 6,
      baselineSessionsPerSecond: 0.02,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CW',
      origEventId: 'dbb0a50147d85fe5d4d22b9db2141bb6',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T14:52:44.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '05dad5c6dd45c6ae2220b1110ad55320',
        affiliate: 'IND (ERBK)',
        isci: '554692H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554692H',
      affiliate: 'IND (ERBK)',
      origEventId: '05dad5c6dd45c6ae2220b1110ad55320',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T19:41:04.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '7232688f3d06537447ddb84ee4abaa47',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 8,
      lift: 0.42857142857142844,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '7232688f3d06537447ddb84ee4abaa47',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T19:26:10.140Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2b2a79161b1124272dedf8ff92c29491',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 5,
      pvCount: 21,
      lift: 0.31449735449735444,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: '2b2a79161b1124272dedf8ff92c29491',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T18:17:25.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6a18b0d569182fa5cd238715e3348ba9',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: -0.09687059082892414,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: '6a18b0d569182fa5cd238715e3348ba9',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T14:18:46.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b91fe89f621be4b6d2bcf670f7c8085d',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: 'b91fe89f621be4b6d2bcf670f7c8085d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-07T15:50:17.421Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a9623c07a8b0414f8acf0756b9c8b4b6',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'a9623c07a8b0414f8acf0756b9c8b4b6',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T08:46:17.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2c5330161d9b7e87872b50a30d3bb727',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 4,
      pvCount: 4,
      lift: 2.6363636363636362,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: '2c5330161d9b7e87872b50a30d3bb727',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T13:46:43.579Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd8cd6b336410f0f18e90170dc28a45ea',
        affiliate: 'MNTV',
        isci: '558908H'
      },
      sessionCount: 1,
      pvCount: 5,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558908H',
      affiliate: 'MNTV',
      origEventId: 'd8cd6b336410f0f18e90170dc28a45ea',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T15:59:24.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: 'ddc5b73709f51e17c0ae51bb1e29831c',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: -0.30430277784665427,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: 'ddc5b73709f51e17c0ae51bb1e29831c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T14:56:52.618Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '93ff3214ca7dd4eed8d0ea683bfa6fde',
        affiliate: 'CBS',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: -0.09604393966270218,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CBS',
      origEventId: '93ff3214ca7dd4eed8d0ea683bfa6fde',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T14:43:44.599Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'feb0d160473946e1369f47108ab28b76',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: 'feb0d160473946e1369f47108ab28b76',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-07T10:50:47.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3cd727df8d54da2bd1c548573225d503',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 9,
      pvCount: 18,
      lift: 0.6221825396825396,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '3cd727df8d54da2bd1c548573225d503',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T17:18:29.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd05074e16fb38b887db29163167baa93',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 0.05972222222222222,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: 'd05074e16fb38b887db29163167baa93',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T15:24:11.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e8faceb01c03afada183a24aac5e2e45',
        affiliate: 'CW',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CW',
      origEventId: 'e8faceb01c03afada183a24aac5e2e45',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T11:30:22.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e4161d7430889d851c7b05119b4949c5',
        affiliate: 'MNTV',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 9,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'MNTV',
      origEventId: 'e4161d7430889d851c7b05119b4949c5',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T00:18:24.452Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1728ac48c055304506b0e76cc80a2b1f',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 7,
      pvCount: 10,
      lift: 0.7272727272727272,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: '1728ac48c055304506b0e76cc80a2b1f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T18:42:03.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b54cf0c95bcd28a0162d74437def893d',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 5,
      pvCount: 5,
      lift: 0.25363636363636366,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: 'b54cf0c95bcd28a0162d74437def893d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T12:45:16.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1c8fe6ca30fb983838c9659a4d6766dc',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: -0.11481481481481481,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '1c8fe6ca30fb983838c9659a4d6766dc',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T19:46:24.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '51e47417eeb628d958fd40339ac6ac9d',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '51e47417eeb628d958fd40339ac6ac9d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T12:49:17.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'bcb6055cc1f0b3adf4f15fa63d2303b6',
        affiliate: 'CBS',
        isci: '558904H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558904H',
      affiliate: 'CBS',
      origEventId: 'bcb6055cc1f0b3adf4f15fa63d2303b6',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T16:20:38.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '3b2aee975d3ea52c0894f0d9445142ed',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: -0.09090909090909098,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '3b2aee975d3ea52c0894f0d9445142ed',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T16:25:33.849Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '10aed9cf5042f8d123f9d463fd69078a',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '10aed9cf5042f8d123f9d463fd69078a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T08:48:09.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'bb2d6a5baa7fe34c69ce3510477b1e95',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 4,
      pvCount: 7,
      lift: 1.3181818181818181,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: 'bb2d6a5baa7fe34c69ce3510477b1e95',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T13:53:01.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '56d4e0377df3654232952a2ebc62d50e',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 7,
      pvCount: 19,
      lift: 0.27272727272727265,
      baselineSessionCount: 5,
      baselineSessionsPerSecond: 0.016666666666666666,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: '56d4e0377df3654232952a2ebc62d50e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T15:43:10.619Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2bb7ff4e964d01ff9b81485cd75ecfa7',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.18475056689342403,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '2bb7ff4e964d01ff9b81485cd75ecfa7',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T15:44:40.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'eb470afdcebf805c108fbf00959f889a',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 6,
      pvCount: 19,
      lift: 0.746626984126984,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'eb470afdcebf805c108fbf00959f889a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T17:16:59.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3fe16394b26c764f8702613028c2e7a6',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '3fe16394b26c764f8702613028c2e7a6',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T14:30:02.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '582087d9333776a7851e169e816b824b',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.030303030303030325,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '582087d9333776a7851e169e816b824b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T10:59:54.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a5c5fc60d89d7579cb4d5149ad6ef0af',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: -0.021428571428571446,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'a5c5fc60d89d7579cb4d5149ad6ef0af',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T17:44:56.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2bbeafe54a8252ff6074c4e235a87e20',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '2bbeafe54a8252ff6074c4e235a87e20',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T14:44:25.454Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1e9c89208e8b5f8a72581f83dd6defa4',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.6666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: '1e9c89208e8b5f8a72581f83dd6defa4',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T08:23:47.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7984b07c58459c1a113cf3b1d0fba301',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '7984b07c58459c1a113cf3b1d0fba301',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T13:55:07.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0d515d34efbde87988b69675ea1993f8',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 5,
      pvCount: 10,
      lift: 1.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: '0d515d34efbde87988b69675ea1993f8',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T18:57:14.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd9a50d4ce320fa9da58b5e223a7deda6',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 5,
      lift: 3,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'd9a50d4ce320fa9da58b5e223a7deda6',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T18:41:14.746Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd864c0e31547b135d445f0644201cd32',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: -0.28571428571428575,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'd864c0e31547b135d445f0644201cd32',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T18:44:29.245Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '44b49c6277f841b21023be280a3cad2c',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: -0.003240740740740738,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: '44b49c6277f841b21023be280a3cad2c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T16:14:37.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '547280525ad8d05f94f024ad29fcd4a3',
        affiliate: 'CBS',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.09090909090909091,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CBS',
      origEventId: '547280525ad8d05f94f024ad29fcd4a3',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T09:59:45.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'aecb59c7130b7a7f36e6717fca8f0a39',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 0.5042929292929292,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: 'aecb59c7130b7a7f36e6717fca8f0a39',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T18:15:03.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4517dfd0f570b7f0967db291fd24625a',
        affiliate: 'MNTV',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'MNTV',
      origEventId: '4517dfd0f570b7f0967db291fd24625a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T09:39:00.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e51d24349c1bd3c1771ca60d31d4a20d',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'e51d24349c1bd3c1771ca60d31d4a20d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T13:46:23.554Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e7690de3237a0338c94e12ab3742beec',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: 'e7690de3237a0338c94e12ab3742beec',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T12:44:08.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8e9932924ffbfa966af321d7fef942b9',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.1111111111111111,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: '8e9932924ffbfa966af321d7fef942b9',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-14T16:29:07.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '23c3008a9d355e200f8fc3360d916886',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: 0.6666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: '23c3008a9d355e200f8fc3360d916886',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T11:54:40.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6965db9a12ac3ebab9b07fb4450e4bb9',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 8,
      pvCount: 13,
      lift: 0.41277777777777763,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: '6965db9a12ac3ebab9b07fb4450e4bb9',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T19:16:56.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '625edd6c4652f6916e3f59a2da45f29d',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 4,
      pvCount: 5,
      lift: 0.05555555555555548,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '625edd6c4652f6916e3f59a2da45f29d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T19:44:00.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e7348399f45ae8756dee0482f07e38fe',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 9,
      pvCount: 12,
      lift: 0.5075396825396824,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'e7348399f45ae8756dee0482f07e38fe',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T14:15:26.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd037c2a87488b4e3cc63dec02932d73b',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.5833333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'd037c2a87488b4e3cc63dec02932d73b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T10:22:18.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4d68285076737df726fa017f8d6d5496',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 3,
      pvCount: 12,
      lift: 3,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '4d68285076737df726fa017f8d6d5496',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T21:13:36.466Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '681a43f99dc033da1a8dc739f62cfd00',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 6,
      pvCount: 9,
      lift: 0.6576388888888887,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '681a43f99dc033da1a8dc739f62cfd00',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T14:46:22.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4cd2078e1ad8f053f642d003c46ba119',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.030303030303030325,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '4cd2078e1ad8f053f642d003c46ba119',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T14:58:02.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a3239b2f70d9106b15e5fd5520a57548',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 0.36507936507936506,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: 'a3239b2f70d9106b15e5fd5520a57548',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T15:46:20.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c76133c62fffdb3f2c60f3a4f1b661f9',
        affiliate: 'IND (ERBK)',
        isci: '558908H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558908H',
      affiliate: 'IND (ERBK)',
      origEventId: 'c76133c62fffdb3f2c60f3a4f1b661f9',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T19:16:23.137Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '8ed8e66d64301ef20e7141e70cc52144',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 6,
      pvCount: 9,
      lift: 0.6576388888888887,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '8ed8e66d64301ef20e7141e70cc52144',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T14:46:22.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7d59eb671ea032fb8e3151ab3b16c3e7',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '7d59eb671ea032fb8e3151ab3b16c3e7',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T14:45:46.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'cc1824840d153ec50721be4e97db50a2',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.19090909090909092,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: 'cc1824840d153ec50721be4e97db50a2',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T15:21:02.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2da6bc57636d7d9288f1828fce1b6901',
        affiliate: 'CW',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 7,
      lift: 0.818181818181818,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CW',
      origEventId: '2da6bc57636d7d9288f1828fce1b6901',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T17:50:17.677Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4fe015ab6813ae7f65e921dea39f0cb5',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 0.8,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '4fe015ab6813ae7f65e921dea39f0cb5',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T14:16:26.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2599118a39317dea0724c1a8b97d67a1',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.3666666666666667,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '2599118a39317dea0724c1a8b97d67a1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T11:28:02.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3a74edce7bdbd7e9d5da5f6d0541e4fb',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.2777777777777778,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: '3a74edce7bdbd7e9d5da5f6d0541e4fb',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-14T16:29:46.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0a5a3674d899e23692686b42a0316f1f',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 4,
      pvCount: 19,
      lift: 0.038194444444444434,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: '0a5a3674d899e23692686b42a0316f1f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T18:16:43.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '476e688598c7a77b342e0ba69d538a34',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: 0.2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '476e688598c7a77b342e0ba69d538a34',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T16:30:54.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0606301f944f2e771f0c76489ada2d36',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 7,
      pvCount: 12,
      lift: 0.3002777777777777,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: '0606301f944f2e771f0c76489ada2d36',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T19:16:32.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8c6683ff647dd5c94297dbe1108c1451',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 5,
      pvCount: 17,
      lift: 1.583333333333333,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '8c6683ff647dd5c94297dbe1108c1451',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T18:15:22.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '600173a7286f80293d44c9c8bcc6c5e7',
        affiliate: 'ABC',
        isci: '554686H'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 0.11263888888888886,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'ABC',
      origEventId: '600173a7286f80293d44c9c8bcc6c5e7',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T15:44:55.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'fd3eaa1c7c393321659f117f3ebf0dc2',
        affiliate: 'FOX',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'FOX',
      origEventId: 'fd3eaa1c7c393321659f117f3ebf0dc2',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T12:31:59.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '25561231f06d8eb33ef5b9ced4eb3fac',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 7,
      lift: 0.9166666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '25561231f06d8eb33ef5b9ced4eb3fac',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T17:48:23.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8336d869781a099b4e748bbc134e24ba',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 0.02453703703703701,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: '8336d869781a099b4e748bbc134e24ba',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T14:16:12.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '9a7f1b231ca2eaa578700bf15aee748f',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 4,
      lift: 0.1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: '9a7f1b231ca2eaa578700bf15aee748f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T19:31:21.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3dd1789f46e84531b280829bdae3056c',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 4,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '3dd1789f46e84531b280829bdae3056c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T16:29:00.990Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6601c0ea543a10b00e6d88dc4e9e75be',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 4,
      pvCount: 5,
      lift: 0.42037037037037034,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: '6601c0ea543a10b00e6d88dc4e9e75be',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T15:49:54.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '002364e85407e2ce746d861d55397bac',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 3,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '002364e85407e2ce746d861d55397bac',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-07T21:45:26.646Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0a06fa63832f76b76c692b1d7849d58e',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: -0.1666666666666668,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: '0a06fa63832f76b76c692b1d7849d58e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T21:11:15.260Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '602b084fec9a7c085e456f6da1e864d5',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 5,
      pvCount: 12,
      lift: 1.2727272727272725,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '602b084fec9a7c085e456f6da1e864d5',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T18:55:10.462Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c5d20343f7a0415047298495eea818c4',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: -0.2857142857142858,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'c5d20343f7a0415047298495eea818c4',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T15:22:22.242Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e5213b32a3fd01ebb3970a0810761662',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: -0.5454545454545455,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: 'e5213b32a3fd01ebb3970a0810761662',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T15:15:33.150Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b25b95227a223ccb2045bfadeb0c52e2',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 13,
      lift: -0.11130952380952379,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'b25b95227a223ccb2045bfadeb0c52e2',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T18:43:51.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '9d54183b140efe1f5f2af4a551ebb4fa',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.2857142857142858,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '9d54183b140efe1f5f2af4a551ebb4fa',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T19:14:48.798Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'bf6e9b0e318b4084d24c6e64172bea59',
        affiliate: 'ABC',
        isci: '554686H'
      },
      sessionCount: 2,
      pvCount: 10,
      lift: 0.014415278037389135,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'ABC',
      origEventId: 'bf6e9b0e318b4084d24c6e64172bea59',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T20:44:54.830Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f1be01eab8957237eb6aad876cd60585',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 1.1428571428571426,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'f1be01eab8957237eb6aad876cd60585',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T19:46:17.827Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'dd74bc9b7c0c462023ff7e08d04fcf66',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 5,
      pvCount: 8,
      lift: 0.08382936507936506,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'dd74bc9b7c0c462023ff7e08d04fcf66',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:46:50.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ce57871af1ee80ab3cf737e7dcd0ad5a',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 6,
      lift: 0.42857142857142855,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: 'ce57871af1ee80ab3cf737e7dcd0ad5a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T12:37:26.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'bcfa9cbfaa0aa5c87531f3eb90c58b0e',
        affiliate: 'ABC',
        isci: '554686H'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 0.07777777777777777,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'ABC',
      origEventId: 'bcfa9cbfaa0aa5c87531f3eb90c58b0e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T14:59:43.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '9a08598bd84d4861e5dd75e7899618d9',
        affiliate: 'CBS',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CBS',
      origEventId: '9a08598bd84d4861e5dd75e7899618d9',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T00:45:47.489Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2e23041cc60baf130282d638039d5a51',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 0.05925925925925925,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: '2e23041cc60baf130282d638039d5a51',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T15:24:31.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '067b6f9ea23908b9de272085397bba01',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 0.5042929292929292,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: '067b6f9ea23908b9de272085397bba01',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T18:15:03.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '60c4b367580f8ab8c41ec2a22acf0bfc',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 5,
      pvCount: 6,
      lift: 0.4944444444444443,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: '60c4b367580f8ab8c41ec2a22acf0bfc',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T18:47:24.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4b0f1530ee4a4c9a0e802fadbcbd8b07',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 4,
      pvCount: 8,
      lift: 0.17152777777777772,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '4b0f1530ee4a4c9a0e802fadbcbd8b07',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T19:57:21.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4d1dc28b6d2e1741906d022831b327d8',
        affiliate: 'CW',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'CW',
      origEventId: '4d1dc28b6d2e1741906d022831b327d8',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T12:32:55.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'df821d62384ca199de40c347aadf538e',
        affiliate: 'CW',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CW',
      origEventId: 'df821d62384ca199de40c347aadf538e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T11:30:22.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '47ae366ecdd7f3a928e4d8ecc55df350',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.2585696971777714,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '47ae366ecdd7f3a928e4d8ecc55df350',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:19:20.323Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f0e6049e63ea5df6741fcd0c757b0b8a',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 4,
      pvCount: 7,
      lift: 1.5277777777777777,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: 'f0e6049e63ea5df6741fcd0c757b0b8a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T17:00:04.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'fc8f4635187adadaecde9415b9b8b836',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'fc8f4635187adadaecde9415b9b8b836',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T10:46:26.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '323af28450d4ab104a07825c7ad9ed3b',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.5833333333333334,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: '323af28450d4ab104a07825c7ad9ed3b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T20:15:46.367Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6baeafd7d9583f62cfbf008f926ad4c8',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 7,
      pvCount: 8,
      lift: 0.33511904761904754,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '6baeafd7d9583f62cfbf008f926ad4c8',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T14:14:21.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '5279e86b9153334b34be4755e08edd7d',
        affiliate: 'CW',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CW',
      origEventId: '5279e86b9153334b34be4755e08edd7d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T11:30:31.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '912a58116469350cbf468ae5aef8b122',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: 0.09879629629629626,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: '912a58116469350cbf468ae5aef8b122',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T14:37:48.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ff01b4a1c0a004c51b10a97eabaa4149',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: -0.04853174603174603,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'ff01b4a1c0a004c51b10a97eabaa4149',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T17:45:08.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f332a46400b221f735811ab69749c426',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 0.04884259259259259,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: 'f332a46400b221f735811ab69749c426',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T15:24:41.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '890c4df9268da09f747bb186234501a4',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: -0.2694444444444445,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: '890c4df9268da09f747bb186234501a4',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T16:42:06.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1688acd40e33acfb43d065f91271f6ef',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.1498299319727891,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '1688acd40e33acfb43d065f91271f6ef',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T15:43:56.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd6645b04c7ebe1e7b0c57aac7123776c',
        affiliate: 'CW',
        isci: '558906H'
      },
      sessionCount: 3,
      pvCount: 9,
      lift: 3,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CW',
      origEventId: 'd6645b04c7ebe1e7b0c57aac7123776c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T19:52:48.200Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4619c149f2c6fbf5032a4232c84bcbea',
        affiliate: 'CBS',
        isci: '558906H'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 1.727272727272727,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CBS',
      origEventId: '4619c149f2c6fbf5032a4232c84bcbea',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T00:49:34.379Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '620a1727dfa3de2f0d854cd36ab61aa2',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 4,
      pvCount: 10,
      lift: 0.27222222222222214,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: '620a1727dfa3de2f0d854cd36ab61aa2',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T15:46:51.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f56f3812c971d9d819b789af055dd09a',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.42857142857142844,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'f56f3812c971d9d819b789af055dd09a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T22:16:21.163Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7dc0c42f0d150b1fecce9a68ffcb243e',
        affiliate: 'NBC',
        isci: '558908H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558908H',
      affiliate: 'NBC',
      origEventId: '7dc0c42f0d150b1fecce9a68ffcb243e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T14:59:33.309Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '98e54dc77d1791d5d30be27f7ee7b97d',
        affiliate: 'CW',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CW',
      origEventId: '98e54dc77d1791d5d30be27f7ee7b97d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T12:50:16.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '605135ead99f6a2b787a81cf41ddc096',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '605135ead99f6a2b787a81cf41ddc096',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T16:57:46.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ca34cc6e7f72345e02c7d642f2e24069',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 0.7,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'ca34cc6e7f72345e02c7d642f2e24069',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T14:46:14.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f2049029e98420fb95c566eef4d31fed',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'f2049029e98420fb95c566eef4d31fed',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T11:29:18.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '110650e30a845d214a88027b2d6ba284',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '110650e30a845d214a88027b2d6ba284',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T10:13:53.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '219b37d88a69f98a30d7b4982a33089b',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 6,
      pvCount: 16,
      lift: 0.3053571428571428,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '219b37d88a69f98a30d7b4982a33089b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T16:45:52.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c575de537ad049d66422b772936a60da',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.47299545461481274,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: 'c575de537ad049d66422b772936a60da',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T14:39:02.422Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '748a6b9dd107e0e41e261f0f3ded6df1',
        affiliate: 'CBS',
        isci: '554686H'
      },
      sessionCount: 4,
      pvCount: 5,
      lift: -0.13333333333333333,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'CBS',
      origEventId: '748a6b9dd107e0e41e261f0f3ded6df1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T18:48:44.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f891af102d5d1ede720e61cfcb5cd24c',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: 'f891af102d5d1ede720e61cfcb5cd24c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T11:25:31.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '00417f0b18e7e5aceec522649aeee3d7',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: '00417f0b18e7e5aceec522649aeee3d7',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T16:58:53.744Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '5160fa9e815b0c0cf0415af7d5e63d1e',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 7,
      pvCount: 10,
      lift: 0.7272727272727272,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: '5160fa9e815b0c0cf0415af7d5e63d1e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T18:42:03.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f88482fea1b8a54976ffcd983f00bf57',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 8,
      pvCount: 12,
      lift: 8,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'f88482fea1b8a54976ffcd983f00bf57',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T18:31:06.729Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7250368989c5d2dc41cc0dc7ccf5e5c8',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 6,
      lift: 0.8908730158730158,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '7250368989c5d2dc41cc0dc7ccf5e5c8',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T16:44:42.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7ddaa8157c98cc1959fd7fa92a138a2f',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '7ddaa8157c98cc1959fd7fa92a138a2f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T17:57:21.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '5aa8183f6fed312e9ad294e09a78d71c',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: '5aa8183f6fed312e9ad294e09a78d71c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T11:58:49.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '58033864e0904fc96932efca3046285b',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 6,
      lift: -0.07083333333333335,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: '58033864e0904fc96932efca3046285b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T14:33:41.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '37d0b8a1e0bb01d3873273125501823a',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 4,
      pvCount: 13,
      lift: 0.05041997354497354,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '37d0b8a1e0bb01d3873273125501823a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:42:43.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8a713791238ec670cb2f222dda5f60ae',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '8a713791238ec670cb2f222dda5f60ae',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T12:25:28.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6537d432d23d3a1146181f40ee3a56a3',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.0037397721326292706,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '6537d432d23d3a1146181f40ee3a56a3',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-07T16:46:06.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'bafd9ff9535ba67db17f09ef558c5cc3',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 8,
      lift: 1.4166666666666665,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'bafd9ff9535ba67db17f09ef558c5cc3',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T17:49:30.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7f5c59ba1f79adf87b7e85bae65eb412',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 3,
      pvCount: 6,
      lift: 1.4999999999999996,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: '7f5c59ba1f79adf87b7e85bae65eb412',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T13:17:46.718Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '983ea058552971625d55a9dbaf1dbab3',
        affiliate: 'FOX',
        isci: '554686H'
      },
      sessionCount: 4,
      pvCount: 13,
      lift: 0.7013888888888887,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'FOX',
      origEventId: '983ea058552971625d55a9dbaf1dbab3',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T15:14:45.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '494e258e276edeb86de28cdcf2f24bfe',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 6,
      pvCount: 19,
      lift: 0.781547619047619,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '494e258e276edeb86de28cdcf2f24bfe',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T17:16:37.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '442f30bc25e21f4ed08b6cef429f65d0',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: '442f30bc25e21f4ed08b6cef429f65d0',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T23:58:01.728Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd620471489ee5beb92ceab70a98dc32e',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.6666666666666664,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: 'd620471489ee5beb92ceab70a98dc32e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T13:47:50.992Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f2e5721d43facb67941a44170f677430',
        affiliate: 'ABC',
        isci: '554686H'
      },
      sessionCount: 3,
      pvCount: 5,
      lift: 0.23053749998410533,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'ABC',
      origEventId: 'f2e5721d43facb67941a44170f677430',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T16:23:38.634Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4d10cac7980fb6fa6b25fdaeb6c779ff',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.14285714285714285,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '4d10cac7980fb6fa6b25fdaeb6c779ff',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T11:27:32.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ad00f95add6626da59f128beb2943bee',
        affiliate: 'CW',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CW',
      origEventId: 'ad00f95add6626da59f128beb2943bee',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T11:26:28.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b72a1aee45edd2ec71e3759fc8bb156e',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: -0.07707451499118166,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: 'b72a1aee45edd2ec71e3759fc8bb156e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T19:15:30.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0d9c7e0562a083453b978313e7c18034',
        affiliate: 'CW',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CW',
      origEventId: '0d9c7e0562a083453b978313e7c18034',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T12:30:51.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '21be8de9b72307759aa8c29a4c5c1f3c',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 3,
      pvCount: 5,
      lift: 2.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: '21be8de9b72307759aa8c29a4c5c1f3c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T15:48:43.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'fa67d1c6e13f01ddc84661759b9f75f1',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: 'fa67d1c6e13f01ddc84661759b9f75f1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T17:49:27.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1e9495b12dec8a7e311a7a21e71dac7c',
        affiliate: 'MNTV',
        isci: '554686H'
      },
      sessionCount: 2,
      pvCount: 10,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'MNTV',
      origEventId: '1e9495b12dec8a7e311a7a21e71dac7c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T19:47:50.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '181f9e7c5cc905d66120356592a158ec',
        affiliate: 'CW',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CW',
      origEventId: '181f9e7c5cc905d66120356592a158ec',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T11:26:17.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '15fc6ce8f301b0e286af0ed2c4809399',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 4,
      pvCount: 13,
      lift: 0.818181818181818,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '15fc6ce8f301b0e286af0ed2c4809399',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T13:29:15.900Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2343eb93aa42de7f34550f02992b90b5',
        affiliate: 'MNTV',
        isci: '558908H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558908H',
      affiliate: 'MNTV',
      origEventId: '2343eb93aa42de7f34550f02992b90b5',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T22:55:03.501Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '4e011fb923c993e3190f19780da26e00',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 0.7833333333333332,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '4e011fb923c993e3190f19780da26e00',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T14:46:56.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '04be38e235cb44ee448c254055dcc1a1',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.2777777777777778,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: '04be38e235cb44ee448c254055dcc1a1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-14T16:29:23.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8ea5591f83c798fa626cc715995bb4f1',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: '8ea5591f83c798fa626cc715995bb4f1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T16:43:56.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '09b1281a5b2fd9bd1fb6a9f18071675e',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: '09b1281a5b2fd9bd1fb6a9f18071675e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T11:58:49.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1e8b8ffb7ff85287350edcd246d08850',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 0.09037037037037034,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: '1e8b8ffb7ff85287350edcd246d08850',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T19:13:36.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '17e7ebf34ec76467e882abc3451925cb',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.6666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: '17e7ebf34ec76467e882abc3451925cb',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T08:23:47.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a19cfdcb778c5e0b4ca64c091c6bfe3e',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'a19cfdcb778c5e0b4ca64c091c6bfe3e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T10:21:35.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '64a333ec29ac31f91533d579bc5af0ad',
        affiliate: 'MNTV',
        isci: '554686H'
      },
      sessionCount: 4,
      pvCount: 8,
      lift: 1.2703703703703701,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'MNTV',
      origEventId: '64a333ec29ac31f91533d579bc5af0ad',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T17:53:36.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0a2e49456027d5015c440fcc5b43d57c',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 0.06342592592592591,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: '0a2e49456027d5015c440fcc5b43d57c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T15:49:11.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '998e2353dc529ad4ff56e9a3bfba88d8',
        affiliate: 'ABC',
        isci: '554686H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.2222222222222222,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'ABC',
      origEventId: '998e2353dc529ad4ff56e9a3bfba88d8',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T15:44:51.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b8199596afeafad47ebf854dcce96dd9',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 5,
      pvCount: 9,
      lift: 0.7857142857142856,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'b8199596afeafad47ebf854dcce96dd9',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T21:44:26.756Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '21cb0a552540c21cc70f2a72a14a5bb2',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: -0.09687059082892414,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: '21cb0a552540c21cc70f2a72a14a5bb2',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T14:18:46.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a08850245866a8ef7bf0ca27b0331e34',
        affiliate: 'CW',
        isci: '558906H'
      },
      sessionCount: 6,
      pvCount: 11,
      lift: -0.03030303030303033,
      baselineSessionCount: 6,
      baselineSessionsPerSecond: 0.02,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CW',
      origEventId: 'a08850245866a8ef7bf0ca27b0331e34',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T14:52:44.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e4b5cb26fea9a59820c4670a1fa198d6',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: 'e4b5cb26fea9a59820c4670a1fa198d6',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T11:12:50.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '74cb02371c7c93ec6634e513dfc1eb09',
        affiliate: 'ABC',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'ABC',
      origEventId: '74cb02371c7c93ec6634e513dfc1eb09',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T11:12:50.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0d78a07ac8209d66ea619db58d29b30b',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 7,
      lift: 0.6666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '0d78a07ac8209d66ea619db58d29b30b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T09:38:43.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e4291455d20f267591db620720aab507',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: 'e4291455d20f267591db620720aab507',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T10:49:53.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b018f32857dc8ee1856c0dd191055230',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.04545454545454549,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: 'b018f32857dc8ee1856c0dd191055230',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T12:29:59.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0e31bc5667551085199d26083c70134c',
        affiliate: 'CW',
        isci: '554686H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: -0.45080833335717524,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'CW',
      origEventId: '0e31bc5667551085199d26083c70134c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T15:47:32.825Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '51815ca5e809c5cd1c7e9b581c7cb134',
        affiliate: 'MNTV',
        isci: '558902H'
      },
      sessionCount: 9,
      pvCount: 19,
      lift: 1.0535185185185183,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'MNTV',
      origEventId: '51815ca5e809c5cd1c7e9b581c7cb134',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T15:37:32.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'bea7e047c7805fa8c29e1c2dc1f84f0c',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 5,
      pvCount: 8,
      lift: 0.11527006172839502,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: 'bea7e047c7805fa8c29e1c2dc1f84f0c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T19:36:42.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '5f540c9a6486496bf00c3855fad6f9e1',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 13,
      lift: 0.06088907785336357,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '5f540c9a6486496bf00c3855fad6f9e1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:45:23.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4b0f6c8c73bad57b5a4af9479b5a0ce8',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 6,
      pvCount: 15,
      lift: 0.3353174603174602,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '4b0f6c8c73bad57b5a4af9479b5a0ce8',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T17:17:47.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '5d89f74286bb1c76f8dd6e9727552c4b',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 4,
      lift: -0.022936507936507918,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '5d89f74286bb1c76f8dd6e9727552c4b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T19:41:34.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '59442cdeee9bc0610efd767b207d6db3',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.049768518518518524,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: '59442cdeee9bc0610efd767b207d6db3',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T14:36:26.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1b2f3b72ebb33006005266d8d0cf118a',
        affiliate: 'IND (ERBK)',
        isci: '554692H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554692H',
      affiliate: 'IND (ERBK)',
      origEventId: '1b2f3b72ebb33006005266d8d0cf118a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T19:41:04.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: 'e064aa2b7a40b13e25c747bd41655bf1',
        affiliate: 'IND (KNLC)',
        isci: '554686H'
      },
      sessionCount: 7,
      pvCount: 12,
      lift: 0.425,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'IND (KNLC)',
      origEventId: 'e064aa2b7a40b13e25c747bd41655bf1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T18:57:57.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1e8f36e238059a769b3a4a678df90940',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '1e8f36e238059a769b3a4a678df90940',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T10:48:06.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '9749ae4a75eed3a3d80c5aeddcbc5202',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '9749ae4a75eed3a3d80c5aeddcbc5202',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T11:28:54.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8310cda93987e956742c4d4ea0b440b9',
        affiliate: 'IND (ERBK)',
        isci: '558908H'
      },
      sessionCount: 1,
      pvCount: 5,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558908H',
      affiliate: 'IND (ERBK)',
      origEventId: '8310cda93987e956742c4d4ea0b440b9',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T23:12:21.462Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '2b9b8696a4d5f77b50e38e70cff31d5f',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 1.727272727272727,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '2b9b8696a4d5f77b50e38e70cff31d5f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T17:25:33.537Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '98b82f5291dcfcad35406a0f2e78d4f5',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '98b82f5291dcfcad35406a0f2e78d4f5',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T12:18:07.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '39185bef2a5fa10f2f966a472b79a68d',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: 0.2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '39185bef2a5fa10f2f966a472b79a68d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T16:32:01.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b6fad0fc5d858864a340834338705dc6',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 0.3126452380702609,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'b6fad0fc5d858864a340834338705dc6',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T16:26:44.027Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ce9f510a110f25ffdcd0bfd299f58eea',
        affiliate: 'IND (KNLC)',
        isci: '558906H'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 0.5042929292929292,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'IND (KNLC)',
      origEventId: 'ce9f510a110f25ffdcd0bfd299f58eea',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T18:15:03.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'fda2a7e39678ab95195fe0c16ec86d5f',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: -0.2857142857142858,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: 'fda2a7e39678ab95195fe0c16ec86d5f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T16:45:24.642Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c4389f2a22ba42425a33eadf0a0b2095',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 3,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: 'c4389f2a22ba42425a33eadf0a0b2095',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T17:12:43.287Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0080e1e147272345e07a144866fd167a',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 0.09014660493827159,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: '0080e1e147272345e07a144866fd167a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T13:56:29.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c40cfc06f017e3f73cddf1cd04eeb51c',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 4,
      pvCount: 8,
      lift: 0.17152777777777772,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: 'c40cfc06f017e3f73cddf1cd04eeb51c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T19:57:21.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '50a65b0af829c2a7b8eea5e727109bba',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: '50a65b0af829c2a7b8eea5e727109bba',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T11:31:33.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3492a7b5bd27375ef757a64f35626191',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 0.4839285714285713,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '3492a7b5bd27375ef757a64f35626191',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T17:16:59.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ea15d91dd7c5ec98f0afb89cf925e1c5',
        affiliate: 'NBC',
        isci: '558906H'
      },
      sessionCount: 2,
      pvCount: 7,
      lift: 0.6666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'NBC',
      origEventId: 'ea15d91dd7c5ec98f0afb89cf925e1c5',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-01T09:38:43.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd9da94c6db1256c29b0b6a4ac020695c',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.19090909090909092,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: 'd9da94c6db1256c29b0b6a4ac020695c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T15:20:54.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7d1d8a5787320ec40437c767f8db326f',
        affiliate: 'IND (NTVI)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 6,
      lift: -0.0841666666666667,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (NTVI)',
      origEventId: '7d1d8a5787320ec40437c767f8db326f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T18:12:14.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '333e052146ce44f69339b4d7e743d26e',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '333e052146ce44f69339b4d7e743d26e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T16:58:29.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '9f0c0a070732713fa13c4531a3896c0b',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 4,
      pvCount: 13,
      lift: 0.05041997354497354,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '9f0c0a070732713fa13c4531a3896c0b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:42:43.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '69a98fa63421574c1c02029110f025cd',
        affiliate: 'FOX',
        isci: '554686H'
      },
      sessionCount: 5,
      pvCount: 5,
      lift: 0.19916666666666666,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'FOX',
      origEventId: '69a98fa63421574c1c02029110f025cd',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T12:46:37.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e711a6098a3210dd752062ac6550dd5a',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 5,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: 'e711a6098a3210dd752062ac6550dd5a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T13:42:51.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '9e8bbefef7d03e7e9e48a14c9c05f781',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 8,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '9e8bbefef7d03e7e9e48a14c9c05f781',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T17:54:43.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2ff770610463759463027e427a66c60f',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: -0.1562462207105064,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '2ff770610463759463027e427a66c60f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-02T14:18:13.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '31a154e29fce361ad0cd70d6aace3436',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 4,
      pvCount: 12,
      lift: 0.06571649029982361,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: '31a154e29fce361ad0cd70d6aace3436',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:11:08.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '15518b47489342fa143a8b5926eed503',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 5,
      pvCount: 8,
      lift: 0.2490190474759964,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '15518b47489342fa143a8b5926eed503',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T15:16:45.581Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '272099b1bb061cccaca7fac2df365d86',
        affiliate: 'CBS',
        isci: '558902H'
      },
      sessionCount: 4,
      pvCount: 12,
      lift: 0.0657164902998236,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CBS',
      origEventId: '272099b1bb061cccaca7fac2df365d86',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:11:08.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '389044d10fe5e1ad2a9eccbe8c892c48',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '389044d10fe5e1ad2a9eccbe8c892c48',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-07T17:42:24.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4cf66a8777bccacb44d2406c2d21f67b',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.12738095238095234,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '4cf66a8777bccacb44d2406c2d21f67b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-04-30T14:44:33.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0bd1df6885918081ed7344dbc41fa502',
        affiliate: 'IND (KNLC)',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.08717592592592592,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'IND (KNLC)',
      origEventId: '0bd1df6885918081ed7344dbc41fa502',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-04T17:44:39.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '326431c3e7be548c58ac874d35bc84a4',
        affiliate: 'CW',
        isci: '558906H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CW',
      origEventId: '326431c3e7be548c58ac874d35bc84a4',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T11:48:23.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '993e7e838bb1fcd8e58e406ea2b7bdd7',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 3,
      pvCount: 9,
      lift: 0.18075396825396822,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '993e7e838bb1fcd8e58e406ea2b7bdd7',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T16:44:23.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '10db9a8b26aafc4efbfd404a25044719',
        affiliate: 'MNTV',
        isci: '554686H'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '554686H',
      affiliate: 'MNTV',
      origEventId: '10db9a8b26aafc4efbfd404a25044719',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T09:39:00.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '096c723fc8fda576c38c0be63d8f6d0a',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 5,
      pvCount: 7,
      lift: 0.8061507936507935,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: '096c723fc8fda576c38c0be63d8f6d0a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T17:18:06.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e3e775bd79e6ae7a4e898bdfa7671654',
        affiliate: 'FOX',
        isci: '558902H'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.09837962962962961,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'FOX',
      origEventId: 'e3e775bd79e6ae7a4e898bdfa7671654',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T12:37:12.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a48c4e185f33b972b44ff7e7156336e0',
        affiliate: 'CW',
        isci: '558906H'
      },
      sessionCount: 6,
      pvCount: 11,
      lift: -0.03030303030303033,
      baselineSessionCount: 6,
      baselineSessionsPerSecond: 0.02,
      eventLength: 30,
      isci: '558906H',
      affiliate: 'CW',
      origEventId: 'a48c4e185f33b972b44ff7e7156336e0',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-03T14:52:44.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '19283139d187f75c96c10da34ecc72c1',
        affiliate: 'CW',
        isci: '558902H'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.09090909090909091,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: '558902H',
      affiliate: 'CW',
      origEventId: '19283139d187f75c96c10da34ecc72c1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-05T09:56:58.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd48a0fd6a417144554d973544bd9d1f9',
        affiliate: 'IND (KNLC)',
        isci: '554684H'
      },
      sessionCount: 4,
      pvCount: 4,
      lift: 1.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: '554684H',
      affiliate: 'IND (KNLC)',
      origEventId: 'd48a0fd6a417144554d973544bd9d1f9',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T14:17:49.000Z',
      dmaName: 'St. Louis MO, United States'
    }
  ];

  public static GG35W6 = [
    {
      _id: {
        keywordText: 'advocado core media',
        isMicroMoment: false
      },
      sessionCount: 25,
      keywordText: 'advocado core media',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'avocado',
        isMicroMoment: false
      },
      sessionCount: 60,
      keywordText: 'avocado',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'google ads automation',
        isMicroMoment: false
      },
      sessionCount: 8,
      keywordText: 'google ads automation',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'advocado',
        isMicroMoment: true
      },
      sessionCount: 62,
      keywordText: 'advocado',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'advertisements advocado',
        isMicroMoment: false
      },
      sessionCount: 59,
      keywordText: 'advertisements advocado',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'advocado saint louis',
        isMicroMoment: false
      },
      sessionCount: 60,
      keywordText: 'advocado saint louis',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'data is our core',
        isMicroMoment: false
      },
      sessionCount: 58,
      keywordText: 'data is our core',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'the scoop',
        isMicroMoment: false
      },
      sessionCount: 13,
      keywordText: 'the scoop',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'tv performance',
        isMicroMoment: false
      },
      sessionCount: 94,
      keywordText: 'tv performance',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'television commercials',
        isMicroMoment: false
      },
      sessionCount: 35,
      keywordText: 'television commercials',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'best tv ads',
        isMicroMoment: true
      },
      sessionCount: 22,
      keywordText: 'best tv ads',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'tv advertising',
        isMicroMoment: false
      },
      sessionCount: 18,
      keywordText: 'tv advertising',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'tv ad cost',
        isMicroMoment: true
      },
      sessionCount: 27,
      keywordText: 'tv ad cost',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'advocado bvs',
        isMicroMoment: false
      },
      sessionCount: 76,
      keywordText: 'advocado bvs',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'guacamole',
        isMicroMoment: false
      },
      sessionCount: 89,
      keywordText: 'guacamole',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'real time biding',
        isMicroMoment: false
      },
      sessionCount: 45,
      keywordText: 'real time biding',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'transparent data is our core',
        isMicroMoment: false
      },
      sessionCount: 48,
      keywordText: 'transparent data is our core',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'commercial performance',
        isMicroMoment: true
      },
      sessionCount: 63,
      keywordText: 'commercial performance',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'real time bidding',
        isMicroMoment: true
      },
      sessionCount: 16,
      keywordText: 'real time bidding',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'advocado media ad spend',
        isMicroMoment: false
      },
      sessionCount: 91,
      keywordText: 'advocado media ad spend',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'confirm ad spend',
        isMicroMoment: false
      },
      sessionCount: 80,
      keywordText: 'confirm ad spend',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'monitor tv',
        isMicroMoment: false
      },
      sessionCount: 5,
      keywordText: 'monitor tv',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'maximize ad spend',
        isMicroMoment: true
      },
      sessionCount: 77,
      keywordText: 'maximize ad spend',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'attribution data',
        isMicroMoment: false
      },
      sessionCount: 92,
      keywordText: 'attribution data',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'maximize bids',
        isMicroMoment: false
      },
      sessionCount: 81,
      keywordText: 'maximize bids',
      isMicroMoment: false
    }
  ];

  public static GG35W1 = [
    {
      _id: {
        keywordText: 'attribution data',
        isMicroMoment: false
      },
      sessionCount: 12,
      keywordText: 'attribution data',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'tv ad cost',
        isMicroMoment: true
      },
      sessionCount: 68,
      keywordText: 'tv ad cost',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'google ads automation',
        isMicroMoment: false
      },
      sessionCount: 1,
      keywordText: 'google ads automation',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'best tv ads',
        isMicroMoment: true
      },
      sessionCount: 10,
      keywordText: 'best tv ads',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'avocado',
        isMicroMoment: false
      },
      sessionCount: 39,
      keywordText: 'avocado',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'advocado bvs',
        isMicroMoment: false
      },
      sessionCount: 57,
      keywordText: 'advocado bvs',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'the scoop',
        isMicroMoment: false
      },
      sessionCount: 50,
      keywordText: 'the scoop',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'data is our core',
        isMicroMoment: false
      },
      sessionCount: 77,
      keywordText: 'data is our core',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'maximize ad spend',
        isMicroMoment: true
      },
      sessionCount: 38,
      keywordText: 'maximize ad spend',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'commercial performance',
        isMicroMoment: true
      },
      sessionCount: 2,
      keywordText: 'commercial performance',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'monitor tv',
        isMicroMoment: false
      },
      sessionCount: 16,
      keywordText: 'monitor tv',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'advocado saint louis',
        isMicroMoment: false
      },
      sessionCount: 8,
      keywordText: 'advocado saint louis',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'transparent data is our core',
        isMicroMoment: false
      },
      sessionCount: 88,
      keywordText: 'transparent data is our core',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'tv advertising',
        isMicroMoment: false
      },
      sessionCount: 44,
      keywordText: 'tv advertising',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'television commercials',
        isMicroMoment: false
      },
      sessionCount: 3,
      keywordText: 'television commercials',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'advocado',
        isMicroMoment: true
      },
      sessionCount: 96,
      keywordText: 'advocado',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'advocado core media',
        isMicroMoment: false
      },
      sessionCount: 97,
      keywordText: 'advocado core media',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'guacamole',
        isMicroMoment: false
      },
      sessionCount: 62,
      keywordText: 'guacamole',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'maximize bids',
        isMicroMoment: false
      },
      sessionCount: 75,
      keywordText: 'maximize bids',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'real time biding',
        isMicroMoment: false
      },
      sessionCount: 72,
      keywordText: 'real time biding',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'advocado media ad spend',
        isMicroMoment: false
      },
      sessionCount: 78,
      keywordText: 'advocado media ad spend',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'confirm ad spend',
        isMicroMoment: false
      },
      sessionCount: 97,
      keywordText: 'confirm ad spend',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'advertisements advocado',
        isMicroMoment: false
      },
      sessionCount: 58,
      keywordText: 'advertisements advocado',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'tv performance',
        isMicroMoment: false
      },
      sessionCount: 52,
      keywordText: 'tv performance',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'real time bidding',
        isMicroMoment: true
      },
      sessionCount: 86,
      keywordText: 'real time bidding',
      isMicroMoment: true
    }
  ];

  public static GF35W1 = [
    {
      _id: {
        keywordText: 'tv advertising',
        isMicroMoment: false
      },
      sessionCount: 52,
      keywordText: 'tv advertising',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'google ads automation',
        isMicroMoment: false
      },
      sessionCount: 52,
      keywordText: 'google ads automation',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'advertisements advocado',
        isMicroMoment: false
      },
      sessionCount: 12,
      keywordText: 'advertisements advocado',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'maximize bids',
        isMicroMoment: false
      },
      sessionCount: 93,
      keywordText: 'maximize bids',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'real time biding',
        isMicroMoment: false
      },
      sessionCount: 8,
      keywordText: 'real time biding',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'confirm ad spend',
        isMicroMoment: false
      },
      sessionCount: 20,
      keywordText: 'confirm ad spend',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'data is our core',
        isMicroMoment: false
      },
      sessionCount: 39,
      keywordText: 'data is our core',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'advocado core media',
        isMicroMoment: false
      },
      sessionCount: 66,
      keywordText: 'advocado core media',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'advocado',
        isMicroMoment: true
      },
      sessionCount: 65,
      keywordText: 'advocado',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'the scoop',
        isMicroMoment: false
      },
      sessionCount: 51,
      keywordText: 'the scoop',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'real time bidding',
        isMicroMoment: true
      },
      sessionCount: 51,
      keywordText: 'real time bidding',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'monitor tv',
        isMicroMoment: false
      },
      sessionCount: 13,
      keywordText: 'monitor tv',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'avocado',
        isMicroMoment: false
      },
      sessionCount: 32,
      keywordText: 'avocado',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'guacamole',
        isMicroMoment: false
      },
      sessionCount: 52,
      keywordText: 'guacamole',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'tv ad cost',
        isMicroMoment: true
      },
      sessionCount: 68,
      keywordText: 'tv ad cost',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'television commercials',
        isMicroMoment: false
      },
      sessionCount: 4,
      keywordText: 'television commercials',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'tv performance',
        isMicroMoment: false
      },
      sessionCount: 2,
      keywordText: 'tv performance',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'commercial performance',
        isMicroMoment: true
      },
      sessionCount: 62,
      keywordText: 'commercial performance',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'best tv ads',
        isMicroMoment: true
      },
      sessionCount: 99,
      keywordText: 'best tv ads',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'advocado saint louis',
        isMicroMoment: false
      },
      sessionCount: 44,
      keywordText: 'advocado saint louis',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'attribution data',
        isMicroMoment: false
      },
      sessionCount: 15,
      keywordText: 'attribution data',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'maximize ad spend',
        isMicroMoment: true
      },
      sessionCount: 64,
      keywordText: 'maximize ad spend',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'transparent data is our core',
        isMicroMoment: false
      },
      sessionCount: 11,
      keywordText: 'transparent data is our core',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'advocado bvs',
        isMicroMoment: false
      },
      sessionCount: 91,
      keywordText: 'advocado bvs',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'advocado media ad spend',
        isMicroMoment: false
      },
      sessionCount: 44,
      keywordText: 'advocado media ad spend',
      isMicroMoment: false
    }
  ];

  public static GF31W1 = [
    {
      _id: {
        keywordText: 'real time biding',
        isMicroMoment: false
      },
      sessionCount: 45,
      keywordText: 'real time biding',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'tv performance',
        isMicroMoment: false
      },
      sessionCount: 100,
      keywordText: 'tv performance',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'transparent data is our core',
        isMicroMoment: false
      },
      sessionCount: 59,
      keywordText: 'transparent data is our core',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'advertisements advocado',
        isMicroMoment: false
      },
      sessionCount: 6,
      keywordText: 'advertisements advocado',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'advocado core media',
        isMicroMoment: false
      },
      sessionCount: 24,
      keywordText: 'advocado core media',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'confirm ad spend',
        isMicroMoment: false
      },
      sessionCount: 53,
      keywordText: 'confirm ad spend',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'the scoop',
        isMicroMoment: false
      },
      sessionCount: 81,
      keywordText: 'the scoop',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'google ads automation',
        isMicroMoment: false
      },
      sessionCount: 31,
      keywordText: 'google ads automation',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'monitor tv',
        isMicroMoment: false
      },
      sessionCount: 51,
      keywordText: 'monitor tv',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'commercial performance',
        isMicroMoment: true
      },
      sessionCount: 96,
      keywordText: 'commercial performance',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'best tv ads',
        isMicroMoment: true
      },
      sessionCount: 70,
      keywordText: 'best tv ads',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'data is our core',
        isMicroMoment: false
      },
      sessionCount: 55,
      keywordText: 'data is our core',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'real time bidding',
        isMicroMoment: true
      },
      sessionCount: 91,
      keywordText: 'real time bidding',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'maximize bids',
        isMicroMoment: false
      },
      sessionCount: 11,
      keywordText: 'maximize bids',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'guacamole',
        isMicroMoment: false
      },
      sessionCount: 75,
      keywordText: 'guacamole',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'avocado',
        isMicroMoment: false
      },
      sessionCount: 93,
      keywordText: 'avocado',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'advocado media ad spend',
        isMicroMoment: false
      },
      sessionCount: 42,
      keywordText: 'advocado media ad spend',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'maximize ad spend',
        isMicroMoment: true
      },
      sessionCount: 7,
      keywordText: 'maximize ad spend',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'advocado',
        isMicroMoment: true
      },
      sessionCount: 100,
      keywordText: 'advocado',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'advocado bvs',
        isMicroMoment: false
      },
      sessionCount: 37,
      keywordText: 'advocado bvs',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'tv advertising',
        isMicroMoment: false
      },
      sessionCount: 79,
      keywordText: 'tv advertising',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'attribution data',
        isMicroMoment: false
      },
      sessionCount: 57,
      keywordText: 'attribution data',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'tv ad cost',
        isMicroMoment: true
      },
      sessionCount: 0,
      keywordText: 'tv ad cost',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'advocado saint louis',
        isMicroMoment: false
      },
      sessionCount: 29,
      keywordText: 'advocado saint louis',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'television commercials',
        isMicroMoment: false
      },
      sessionCount: 80,
      keywordText: 'television commercials',
      isMicroMoment: false
    }
  ];

  public static GE31W1 = [
    {
      _id: {
        keywordText: 'the scoop',
        isMicroMoment: false
      },
      sessionCount: 0,
      keywordText: 'the scoop',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'tv advertising',
        isMicroMoment: false
      },
      sessionCount: 94,
      keywordText: 'tv advertising',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'maximize bids',
        isMicroMoment: false
      },
      sessionCount: 28,
      keywordText: 'maximize bids',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'monitor tv',
        isMicroMoment: false
      },
      sessionCount: 80,
      keywordText: 'monitor tv',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'real time biding',
        isMicroMoment: false
      },
      sessionCount: 96,
      keywordText: 'real time biding',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'avocado',
        isMicroMoment: false
      },
      sessionCount: 61,
      keywordText: 'avocado',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'tv ad cost',
        isMicroMoment: true
      },
      sessionCount: 70,
      keywordText: 'tv ad cost',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'confirm ad spend',
        isMicroMoment: false
      },
      sessionCount: 76,
      keywordText: 'confirm ad spend',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'best tv ads',
        isMicroMoment: true
      },
      sessionCount: 33,
      keywordText: 'best tv ads',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'advocado',
        isMicroMoment: true
      },
      sessionCount: 40,
      keywordText: 'advocado',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'google ads automation',
        isMicroMoment: false
      },
      sessionCount: 70,
      keywordText: 'google ads automation',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'advertisements advocado',
        isMicroMoment: false
      },
      sessionCount: 7,
      keywordText: 'advertisements advocado',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'advocado core media',
        isMicroMoment: false
      },
      sessionCount: 52,
      keywordText: 'advocado core media',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'real time bidding',
        isMicroMoment: true
      },
      sessionCount: 0,
      keywordText: 'real time bidding',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'advocado media ad spend',
        isMicroMoment: false
      },
      sessionCount: 41,
      keywordText: 'advocado media ad spend',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'attribution data',
        isMicroMoment: false
      },
      sessionCount: 67,
      keywordText: 'attribution data',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'tv performance',
        isMicroMoment: false
      },
      sessionCount: 26,
      keywordText: 'tv performance',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'television commercials',
        isMicroMoment: false
      },
      sessionCount: 12,
      keywordText: 'television commercials',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'advocado bvs',
        isMicroMoment: false
      },
      sessionCount: 77,
      keywordText: 'advocado bvs',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'transparent data is our core',
        isMicroMoment: false
      },
      sessionCount: 50,
      keywordText: 'transparent data is our core',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'data is our core',
        isMicroMoment: false
      },
      sessionCount: 37,
      keywordText: 'data is our core',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'maximize ad spend',
        isMicroMoment: true
      },
      sessionCount: 80,
      keywordText: 'maximize ad spend',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'commercial performance',
        isMicroMoment: true
      },
      sessionCount: 89,
      keywordText: 'commercial performance',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'guacamole',
        isMicroMoment: false
      },
      sessionCount: 45,
      keywordText: 'guacamole',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'advocado saint louis',
        isMicroMoment: false
      },
      sessionCount: 9,
      keywordText: 'advocado saint louis',
      isMicroMoment: false
    }
  ];

  public static GE31W2 = [
    {
      _id: {
        keywordText: 'best tv ads',
        isMicroMoment: true
      },
      sessionCount: 88,
      keywordText: 'best tv ads',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'advocado saint louis',
        isMicroMoment: false
      },
      sessionCount: 99,
      keywordText: 'advocado saint louis',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'advocado media ad spend',
        isMicroMoment: false
      },
      sessionCount: 100,
      keywordText: 'advocado media ad spend',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'attribution data',
        isMicroMoment: false
      },
      sessionCount: 32,
      keywordText: 'attribution data',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'google ads automation',
        isMicroMoment: false
      },
      sessionCount: 6,
      keywordText: 'google ads automation',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'commercial performance',
        isMicroMoment: true
      },
      sessionCount: 8,
      keywordText: 'commercial performance',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'maximize ad spend',
        isMicroMoment: true
      },
      sessionCount: 90,
      keywordText: 'maximize ad spend',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'transparent data is our core',
        isMicroMoment: false
      },
      sessionCount: 95,
      keywordText: 'transparent data is our core',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'confirm ad spend',
        isMicroMoment: false
      },
      sessionCount: 77,
      keywordText: 'confirm ad spend',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'guacamole',
        isMicroMoment: false
      },
      sessionCount: 73,
      keywordText: 'guacamole',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'the scoop',
        isMicroMoment: false
      },
      sessionCount: 75,
      keywordText: 'the scoop',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'advocado bvs',
        isMicroMoment: false
      },
      sessionCount: 62,
      keywordText: 'advocado bvs',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'advertisements advocado',
        isMicroMoment: false
      },
      sessionCount: 12,
      keywordText: 'advertisements advocado',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'data is our core',
        isMicroMoment: false
      },
      sessionCount: 64,
      keywordText: 'data is our core',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'advocado',
        isMicroMoment: true
      },
      sessionCount: 8,
      keywordText: 'advocado',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'maximize bids',
        isMicroMoment: false
      },
      sessionCount: 90,
      keywordText: 'maximize bids',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'tv ad cost',
        isMicroMoment: true
      },
      sessionCount: 30,
      keywordText: 'tv ad cost',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'monitor tv',
        isMicroMoment: false
      },
      sessionCount: 40,
      keywordText: 'monitor tv',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'real time biding',
        isMicroMoment: false
      },
      sessionCount: 87,
      keywordText: 'real time biding',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'advocado core media',
        isMicroMoment: false
      },
      sessionCount: 70,
      keywordText: 'advocado core media',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'avocado',
        isMicroMoment: false
      },
      sessionCount: 79,
      keywordText: 'avocado',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'tv performance',
        isMicroMoment: false
      },
      sessionCount: 54,
      keywordText: 'tv performance',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'real time bidding',
        isMicroMoment: true
      },
      sessionCount: 39,
      keywordText: 'real time bidding',
      isMicroMoment: true
    },
    {
      _id: {
        keywordText: 'tv advertising',
        isMicroMoment: false
      },
      sessionCount: 78,
      keywordText: 'tv advertising',
      isMicroMoment: false
    },
    {
      _id: {
        keywordText: 'television commercials',
        isMicroMoment: false
      },
      sessionCount: 6,
      keywordText: 'television commercials',
      isMicroMoment: false
    }
  ];

  public static mMTimeLine = [
    {
      _id: {
        origEventId: '057caf83a19e4f628ec9e376e864ec6c',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.04545454545454549,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '057caf83a19e4f628ec9e376e864ec6c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T12:29:59.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '30c1f03eca62b0e0ed6e98800ac1da39',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.6666666666666664,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '30c1f03eca62b0e0ed6e98800ac1da39',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T16:15:40.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a822d4ee037d5e84a600a181b5d7f30a',
        affiliate: 'CW',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.034490740740740745,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CW',
      origEventId: 'a822d4ee037d5e84a600a181b5d7f30a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T10:29:39.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd62599bb64b9fccbf78d305afec354f9',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.03829365079365076,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'd62599bb64b9fccbf78d305afec354f9',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T13:19:11.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '5b4a5e639b25624a433295722a6affc2',
        affiliate: 'CW',
        isci: 'GE31W1'
      },
      sessionCount: 5,
      pvCount: 8,
      lift: 0.07927469135802467,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CW',
      origEventId: '5b4a5e639b25624a433295722a6affc2',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T19:37:26.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8fff9155b961005a05d17a772e992661',
        affiliate: 'FOX',
        isci: 'GF35W1'
      },
      sessionCount: 4,
      pvCount: 4,
      lift: 2.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'FOX',
      origEventId: '8fff9155b961005a05d17a772e992661',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T15:43:36.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c349a5606ea5a226494e2017bacee53c',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 3,
      pvCount: 10,
      lift: 3,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'c349a5606ea5a226494e2017bacee53c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T22:18:32.873Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1874948c1492eeb3594bb9f816690251',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: -0.0833333333333334,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '1874948c1492eeb3594bb9f816690251',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T18:59:04.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ff864314e0dcf9eb6d78b745b1734afc',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 6,
      pvCount: 16,
      lift: 0.3053571428571428,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: 'ff864314e0dcf9eb6d78b745b1734afc',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T16:46:37.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'fe87be33f95b638153d86fff49b1f55a',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'fe87be33f95b638153d86fff49b1f55a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T11:27:29.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '21047b79fe097da82505e1ff7fe98283',
        affiliate: 'FOX',
        isci: 'GF35W1'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 0.15740740740740733,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'FOX',
      origEventId: '21047b79fe097da82505e1ff7fe98283',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T12:58:42.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '83988e7ec2a186ca4a0f0da8d590baac',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 4,
      pvCount: 7,
      lift: 0.06726190476190474,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: '83988e7ec2a186ca4a0f0da8d590baac',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T18:45:29.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e24164cf33be0bf3c0e6182d3d9b6049',
        affiliate: 'MNTV',
        isci: 'GE31W1'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.2777777777777778,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'MNTV',
      origEventId: 'e24164cf33be0bf3c0e6182d3d9b6049',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-14T16:29:23.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a3fe4c3bce78a372668d655d06778e29',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 4,
      pvCount: 5,
      lift: 4,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'a3fe4c3bce78a372668d655d06778e29',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T14:18:18.225Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f41ae5dbf535743b38d2149dc9d9563e',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.13333333333333333,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'f41ae5dbf535743b38d2149dc9d9563e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T12:27:51.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '274f579f241b95ea0cbddc4a5f2d8e11',
        affiliate: 'CW',
        isci: 'GE31W1'
      },
      sessionCount: 5,
      pvCount: 8,
      lift: 0.11527006172839502,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CW',
      origEventId: '274f579f241b95ea0cbddc4a5f2d8e11',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T19:36:42.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b4a3e87185d8409905618ae633d008a0',
        affiliate: 'CW',
        isci: 'GE31W1'
      },
      sessionCount: 5,
      pvCount: 8,
      lift: 0.07927469135802467,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CW',
      origEventId: 'b4a3e87185d8409905618ae633d008a0',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T19:37:26.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '73d130ba1d42fe33c28d04cf3e96be2f',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: '73d130ba1d42fe33c28d04cf3e96be2f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-07T10:50:11.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f6569da8bcddd66855c73c982e26ec9f',
        affiliate: 'MNTV',
        isci: 'GE31W1'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: -0.04074074074074076,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'MNTV',
      origEventId: 'f6569da8bcddd66855c73c982e26ec9f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T19:16:08.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2a47f1a37477fcbf1a6d8cd5c5199c43',
        affiliate: 'CW',
        isci: 'GF35W1'
      },
      sessionCount: 3,
      pvCount: 8,
      lift: 1.4999999999999996,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'CW',
      origEventId: '2a47f1a37477fcbf1a6d8cd5c5199c43',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T16:53:13.110Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '5c1f992165acf93d510b688893e0934b',
        affiliate: 'ABC',
        isci: 'GE31W1'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 1.811111111111111,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'ABC',
      origEventId: '5c1f992165acf93d510b688893e0934b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T14:33:37.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '46418efca6d8619a8d632d428f73cec2',
        affiliate: 'ABC',
        isci: 'GE31W1'
      },
      sessionCount: 3,
      pvCount: 6,
      lift: -0.1,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'ABC',
      origEventId: '46418efca6d8619a8d632d428f73cec2',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T14:33:08.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c2065549e921a0d372a3b8a7a5919c98',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: -0.2857142857142858,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: 'c2065549e921a0d372a3b8a7a5919c98',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T23:10:46.436Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8e68c1d078b979ca0f4e77b86e8eabfe',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 5,
      pvCount: 9,
      lift: 0.6563492063492062,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: '8e68c1d078b979ca0f4e77b86e8eabfe',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T17:46:02.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6ae511476d4512130eac0a74448f9fe1',
        affiliate: 'FOX',
        isci: 'GE31W1'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 0.00441798941798941,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'FOX',
      origEventId: '6ae511476d4512130eac0a74448f9fe1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T14:26:42.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '28bb6d5720d1127bdf69b13ef2427886',
        affiliate: 'CBS',
        isci: 'GE31W1'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: 0.26666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CBS',
      origEventId: '28bb6d5720d1127bdf69b13ef2427886',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T19:31:48.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8eb818caac77a5d2616b01520a129a5a',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.5833333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '8eb818caac77a5d2616b01520a129a5a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T10:23:03.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4c0679aa4007a77f4638f870e364b17c',
        affiliate: 'ABC',
        isci: 'GE31W1'
      },
      sessionCount: 3,
      pvCount: 6,
      lift: -0.07083333333333335,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'ABC',
      origEventId: '4c0679aa4007a77f4638f870e364b17c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T14:33:41.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ea32e8fedab62515048eb433c4765b69',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: 'ea32e8fedab62515048eb433c4765b69',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T13:41:57.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '304761cc8bdda82b77943fcc04de4e05',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 5,
      pvCount: 5,
      lift: 0.25363636363636366,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '304761cc8bdda82b77943fcc04de4e05',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T12:45:16.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2906d51416b7ecc77f49b0566adeadd5',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '2906d51416b7ecc77f49b0566adeadd5',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T21:24:22.528Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c1d7bfb793612bce998b124dfe416075',
        affiliate: 'CBS',
        isci: 'GE31W1'
      },
      sessionCount: 3,
      pvCount: 5,
      lift: 3,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CBS',
      origEventId: 'c1d7bfb793612bce998b124dfe416075',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-07T00:31:25.560Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1f6916e5d442970871e79c4236b1af4a',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 5,
      pvCount: 5,
      lift: 0.7228174603174603,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: '1f6916e5d442970871e79c4236b1af4a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T14:44:48.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '693b262a6dd0cf40ad5709e91ecdd2ce',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 5,
      pvCount: 8,
      lift: 0.031746031746031717,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: '693b262a6dd0cf40ad5709e91ecdd2ce',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:47:15.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ceced9b94fd87d4ad49e4c9245028f50',
        affiliate: 'MNTV',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.1111111111111111,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'MNTV',
      origEventId: 'ceced9b94fd87d4ad49e4c9245028f50',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-14T16:29:07.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '18d33e0c8e7e1552360b8aaf7f7cb7f6',
        affiliate: 'CBS',
        isci: 'GE31W2'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 1.727272727272727,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'CBS',
      origEventId: '18d33e0c8e7e1552360b8aaf7f7cb7f6',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T14:59:31.579Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '97502303e006c4bfe832376af1f18434',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 3,
      pvCount: 6,
      lift: 0.42857142857142855,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '97502303e006c4bfe832376af1f18434',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T12:37:26.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'bd68731d5df66626cd70d284a0ab5b05',
        affiliate: 'CW',
        isci: 'GE31W2'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.6666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'CW',
      origEventId: 'bd68731d5df66626cd70d284a0ab5b05',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T18:24:40.521Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b781f6d0d33cffe72f936dde02c141a0',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 4,
      pvCount: 5,
      lift: 1.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'b781f6d0d33cffe72f936dde02c141a0',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T14:18:33.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '03b543c22e70d474278a2c351def93cc',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 10,
      pvCount: 12,
      lift: 10,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '03b543c22e70d474278a2c351def93cc',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T18:19:15.443Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0f0ab88efe6c6612fe6901b98798b5c1',
        affiliate: 'MNTV',
        isci: 'GF35W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'MNTV',
      origEventId: '0f0ab88efe6c6612fe6901b98798b5c1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-07T13:24:08.384Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '30c5f72d113b51d674f918486fc5d964',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 0.8,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '30c5f72d113b51d674f918486fc5d964',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T14:15:19.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '864d7a93646155e1b9f72ad228676d99',
        affiliate: 'MNTV',
        isci: 'GE31W1'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.2777777777777778,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'MNTV',
      origEventId: '864d7a93646155e1b9f72ad228676d99',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-14T16:29:46.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e01ec54f875e93226b4ddad141275b7a',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.7027777777777777,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'e01ec54f875e93226b4ddad141275b7a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T13:27:30.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '701091514cc7b41f12f96176a7866612',
        affiliate: 'FOX',
        isci: 'GF35W1'
      },
      sessionCount: 6,
      pvCount: 6,
      lift: 0.37833333333333324,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'FOX',
      origEventId: '701091514cc7b41f12f96176a7866612',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T12:46:01.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4c7dcc0bbe2c4c28bdd59afb0849a617',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W2'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.27272727272727265,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'IND (KNLC)',
      origEventId: '4c7dcc0bbe2c4c28bdd59afb0849a617',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T19:44:33.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '09cb02ca519103f0573a01e673a0d2d7',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 3,
      pvCount: 6,
      lift: 0.42857142857142855,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '09cb02ca519103f0573a01e673a0d2d7',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T12:37:52.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '40f031744e16ad274f62f4e357194f41',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '40f031744e16ad274f62f4e357194f41',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T14:45:46.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a8fc4ca81926edc5d66603641b8c7576',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 1.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'a8fc4ca81926edc5d66603641b8c7576',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T16:48:20.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '555ab3a9990010dfb892d4d92f1851c5',
        affiliate: 'ABC',
        isci: 'GF35W1'
      },
      sessionCount: 7,
      pvCount: 14,
      lift: 0.4222222222222221,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'ABC',
      origEventId: '555ab3a9990010dfb892d4d92f1851c5',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T16:38:03.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '23ad054c86eb26bd3827700fc1afed50',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '23ad054c86eb26bd3827700fc1afed50',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T19:58:07.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a0fbe86b9a7a17cc00cdad5d0390d6e3',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W2'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'IND (KNLC)',
      origEventId: 'a0fbe86b9a7a17cc00cdad5d0390d6e3',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T23:58:19.763Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1098f9a29f918e9b8466bd5207153a40',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '1098f9a29f918e9b8466bd5207153a40',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T12:17:32.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4b62b12eff5392ec1ef4dff5eea87454',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 5,
      pvCount: 5,
      lift: 3.545454545454545,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '4b62b12eff5392ec1ef4dff5eea87454',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T15:24:53.975Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f2e9984ae3253601aa354ce3e34d930e',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 2,
      pvCount: 7,
      lift: 0.5331349206349205,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: 'f2e9984ae3253601aa354ce3e34d930e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T13:44:23.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '364b1f62a0d485625ac5e6a23b88ac59',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 9,
      pvCount: 18,
      lift: 0.6221825396825396,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '364b1f62a0d485625ac5e6a23b88ac59',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T17:18:29.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'cdb4dc12b04f8b07f67aff7214f820fb',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W2'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'IND (KNLC)',
      origEventId: 'cdb4dc12b04f8b07f67aff7214f820fb',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T17:49:14.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '886839a23f1dbecdc0b49b9480e902cc',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '886839a23f1dbecdc0b49b9480e902cc',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T13:28:46.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1f467346d4311a1c031cd6cb61c99e19',
        affiliate: 'ABC',
        isci: 'GF35W1'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 0.11236388882001234,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'ABC',
      origEventId: '1f467346d4311a1c031cd6cb61c99e19',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T14:59:31.716Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '541163bc72e18135aa1d487b8eaacd8f',
        affiliate: 'FOX',
        isci: 'GF35W1'
      },
      sessionCount: 4,
      pvCount: 4,
      lift: 2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'FOX',
      origEventId: '541163bc72e18135aa1d487b8eaacd8f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T15:44:11.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3bd656c3f190493e8afc3a92566b4e01',
        affiliate: 'CBS',
        isci: 'GF35W1'
      },
      sessionCount: 5,
      pvCount: 8,
      lift: 0.09860339506172837,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'CBS',
      origEventId: '3bd656c3f190493e8afc3a92566b4e01',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T19:36:26.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '518f07ceb6139615bebb32c51cd65b88',
        affiliate: 'CW',
        isci: 'GE31W1'
      },
      sessionCount: 5,
      pvCount: 8,
      lift: 0.11364969135802468,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CW',
      origEventId: '518f07ceb6139615bebb32c51cd65b88',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T19:36:53.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd07968b0e6b86634700577b9deb906cc',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'd07968b0e6b86634700577b9deb906cc',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T14:47:13.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '5d6618c88438cd3757d9c6ea5739797d',
        affiliate: 'MNTV',
        isci: 'GF35W1'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'MNTV',
      origEventId: '5d6618c88438cd3757d9c6ea5739797d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T09:38:25.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7799b02548a724834e15d24a18b9ed51',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 6,
      pvCount: 16,
      lift: 0.2650396825396825,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '7799b02548a724834e15d24a18b9ed51',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T17:19:55.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '086b1bff0cd83a679cbd2bb7d622294a',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 7,
      pvCount: 8,
      lift: 0.26686507936507936,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '086b1bff0cd83a679cbd2bb7d622294a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T14:12:53.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ec3e10553ecfd2b6830baae3caa11bbb',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 4,
      pvCount: 12,
      lift: 0.10937059082892416,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'ec3e10553ecfd2b6830baae3caa11bbb',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:43:17.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '768348b0d9ddf7c20ea3446d00d50193',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.13333333333333333,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: '768348b0d9ddf7c20ea3446d00d50193',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T12:27:15.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2429410c310bac3774456302ca17263b',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.14285714285714285,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '2429410c310bac3774456302ca17263b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T11:27:59.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3d27777b49a5bf39ab14679643884098',
        affiliate: 'IND (ERBK)',
        isci: 'GG35W1'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GG35W1',
      affiliate: 'IND (ERBK)',
      origEventId: '3d27777b49a5bf39ab14679643884098',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-07T02:46:57.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '7b38a8de1afee0150b22b05a5a2f905a',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 4,
      pvCount: 11,
      lift: 0.5680555555555555,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '7b38a8de1afee0150b22b05a5a2f905a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T16:46:12.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd2d47d609862b560eb908fba6c19b0d6',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.0037397721326292606,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'd2d47d609862b560eb908fba6c19b0d6',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-07T16:46:06.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '831e625dd1c927a627ca6d9d2f3eada3',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.6666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '831e625dd1c927a627ca6d9d2f3eada3',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T12:12:37.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6a294f1a000cda4fe2837be322eddf4e',
        affiliate: 'MNTV',
        isci: 'GE31W1'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: -0.017228835978835986,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'MNTV',
      origEventId: '6a294f1a000cda4fe2837be322eddf4e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T19:15:53.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f55d2d5a70c6459a3524492069025ed4',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 1,
      pvCount: 5,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'f55d2d5a70c6459a3524492069025ed4',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T19:45:49.623Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '37c7b7367daa92649d1139092536a53a',
        affiliate: 'CBS',
        isci: 'GE31W1'
      },
      sessionCount: 4,
      pvCount: 12,
      lift: 0.06844797178130509,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CBS',
      origEventId: '37c7b7367daa92649d1139092536a53a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:11:16.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd0a3913380bb982ae3151d1aa7d53bb3',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: 'd0a3913380bb982ae3151d1aa7d53bb3',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T08:47:03.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '39bae6c6d79827acacbddabfa8bcd656',
        affiliate: 'CBS',
        isci: 'GE31W1'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 0.01180555555555556,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CBS',
      origEventId: '39bae6c6d79827acacbddabfa8bcd656',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T15:24:56.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a28ad40380530303470cb9bd400e0ed9',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 8,
      pvCount: 10,
      lift: 0.6557539682539683,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'a28ad40380530303470cb9bd400e0ed9',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T14:14:44.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '5cbc984bfef674e1a883fd292caec77d',
        affiliate: 'FOX',
        isci: 'GF35W1'
      },
      sessionCount: 4,
      pvCount: 7,
      lift: 0.3252500000927182,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'FOX',
      origEventId: '5cbc984bfef674e1a883fd292caec77d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T20:43:41.683Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4ca44c5d17f2332616d9e3838642dbec',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.6666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '4ca44c5d17f2332616d9e3838642dbec',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T12:12:37.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '72079a5317f90c4bcf4f2384da0cc775',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 3,
      pvCount: 9,
      lift: 0.24583333333333326,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '72079a5317f90c4bcf4f2384da0cc775',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T16:45:04.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0166b91c275b872f3abac43b2aafc0b5',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 3,
      pvCount: 7,
      lift: 0.013888888888888873,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '0166b91c275b872f3abac43b2aafc0b5',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T19:57:54.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '5d028712a09376876d4ed2e5fe79b9ed',
        affiliate: 'MNTV',
        isci: 'GF35W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.21064814814814817,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'MNTV',
      origEventId: '5d028712a09376876d4ed2e5fe79b9ed',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T13:18:13.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0c115f321d21daeba8d6795526d84088',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: '0c115f321d21daeba8d6795526d84088',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T23:58:16.932Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6dccd4cae0ac0b46d10f6819fea653c6',
        affiliate: 'CBS',
        isci: 'GE31W1'
      },
      sessionCount: 5,
      pvCount: 6,
      lift: 3.166666666666666,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CBS',
      origEventId: '6dccd4cae0ac0b46d10f6819fea653c6',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T20:11:08.730Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '65ec3d625aefdb3c5614588279019253',
        affiliate: 'CW',
        isci: 'GE31W1'
      },
      sessionCount: 5,
      pvCount: 8,
      lift: 0.11527006172839502,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CW',
      origEventId: '65ec3d625aefdb3c5614588279019253',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T19:36:46.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'bbe965eb416fc593d14a116d01b45859',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 5,
      pvCount: 7,
      lift: 2.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'bbe965eb416fc593d14a116d01b45859',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T14:18:55.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1d54e4b8cbf4f8a8f1a9e19b3946af68',
        affiliate: 'ABC',
        isci: 'GF35W1'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 1.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'ABC',
      origEventId: '1d54e4b8cbf4f8a8f1a9e19b3946af68',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T16:31:22.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '425afd7e0e18de4f4dd73b4f4e78a582',
        affiliate: 'ABC',
        isci: 'GF35W1'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.2222222222222222,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'ABC',
      origEventId: '425afd7e0e18de4f4dd73b4f4e78a582',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T15:44:51.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '9a36df2380de225902c04c1f1c6657a8',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 4,
      pvCount: 10,
      lift: -0.08138888888888893,
      baselineSessionCount: 5,
      baselineSessionsPerSecond: 0.016666666666666666,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: '9a36df2380de225902c04c1f1c6657a8',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T18:11:31.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd8c1b359e4283ac9804bdf7444dc29aa',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W2'
      },
      sessionCount: 3,
      pvCount: 9,
      lift: 0.5757575757575757,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'IND (KNLC)',
      origEventId: 'd8c1b359e4283ac9804bdf7444dc29aa',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T18:58:17.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0bd459f07514c2927ea4545a28ffe931',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 4,
      pvCount: 12,
      lift: 0.10937059082892417,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '0bd459f07514c2927ea4545a28ffe931',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:43:17.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7b76b48994f19b1dc536c21a21fcc993',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 3,
      pvCount: 6,
      lift: 0.36363636363636354,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '7b76b48994f19b1dc536c21a21fcc993',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T16:58:54.247Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '30fd197bc404a7b45a1b5550e72bbf58',
        affiliate: 'ABC',
        isci: 'GG35W6'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GG35W6',
      affiliate: 'ABC',
      origEventId: '30fd197bc404a7b45a1b5550e72bbf58',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T11:29:44.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '80ceff607e217535b1cb47b97222277d',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 5,
      pvCount: 8,
      lift: 2.5714285714285707,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: '80ceff607e217535b1cb47b97222277d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T21:45:09.217Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4012b5733bb4f33d16fdb070eb8b762b',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.035009613402470545,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '4012b5733bb4f33d16fdb070eb8b762b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-07T16:47:12.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3ae4e1a8f97e158fe77f11284fa055f6',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 1.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '3ae4e1a8f97e158fe77f11284fa055f6',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-07T17:41:40.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '24c4aa7da5a28428f7486c7c68910c5b',
        affiliate: 'ABC',
        isci: 'GF35W1'
      },
      sessionCount: 1,
      pvCount: 4,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'ABC',
      origEventId: '24c4aa7da5a28428f7486c7c68910c5b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T14:25:01.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '06cee7980074669d4b868aa0b9f0e82b',
        affiliate: 'MNTV',
        isci: 'GG35W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GG35W1',
      affiliate: 'MNTV',
      origEventId: '06cee7980074669d4b868aa0b9f0e82b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-07T16:10:57.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '65d4dea52bf8ac69edc2c29c3ece611d',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: '65d4dea52bf8ac69edc2c29c3ece611d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T15:15:41.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b7a7fb5eeff7f07ef025f373a7f5182c',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'b7a7fb5eeff7f07ef025f373a7f5182c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T13:25:25.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'fc959ce7677305b1403aec29ae183ef9',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 1,
      pvCount: 4,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'fc959ce7677305b1403aec29ae183ef9',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T14:24:56.950Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '93b02e6d7e8c0149bb0d1226d83ccbf3',
        affiliate: 'CW',
        isci: 'GE31W1'
      },
      sessionCount: 3,
      pvCount: 7,
      lift: 0.3807407407407407,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CW',
      origEventId: '93b02e6d7e8c0149bb0d1226d83ccbf3',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T14:37:31.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3022d6fc3d1e99df2167fcffa56c7a94',
        affiliate: 'CW',
        isci: 'GE31W1'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 0.11264991181657846,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CW',
      origEventId: '3022d6fc3d1e99df2167fcffa56c7a94',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T13:56:57.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'af8c665253f8d7118158ba70a3d42019',
        affiliate: 'CW',
        isci: 'GE31W2'
      },
      sessionCount: 6,
      pvCount: 7,
      lift: 0.4294949494949495,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'CW',
      origEventId: 'af8c665253f8d7118158ba70a3d42019',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T14:25:22.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e9f142317df3e4ee60794e5ab88ad763',
        affiliate: 'CBS',
        isci: 'GE31W1'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 0.05925925925925925,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CBS',
      origEventId: 'e9f142317df3e4ee60794e5ab88ad763',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T15:24:31.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1242b3850ba9ad5d3c8561179a616d8d',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.5833333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '1242b3850ba9ad5d3c8561179a616d8d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T10:23:26.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '73066608f7e12b369180c6ddc4402544',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 3,
      pvCount: 9,
      lift: 0.44900793650793647,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: '73066608f7e12b369180c6ddc4402544',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T13:46:14.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6c4bbdeef5de65b7ef9311ab2ec3301c',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: '6c4bbdeef5de65b7ef9311ab2ec3301c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T13:42:42.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f518c91b09709c5bb2a28a331911088f',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'f518c91b09709c5bb2a28a331911088f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T08:44:15.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1593ce472b24ea3a24fb8798557d38ef',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W2'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.27272727272727265,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'IND (KNLC)',
      origEventId: '1593ce472b24ea3a24fb8798557d38ef',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T19:44:33.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '68e6076b052b15ad24d08fc1012cb180',
        affiliate: 'CW',
        isci: 'GE31W1'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 0.09014660493827159,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CW',
      origEventId: '68e6076b052b15ad24d08fc1012cb180',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T13:56:29.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd83550107636fe57e59d6e28c50d513f',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W2'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.27272727272727265,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'IND (KNLC)',
      origEventId: 'd83550107636fe57e59d6e28c50d513f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T19:44:33.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '17b92f23d26a7fe33a5bd219abd0099e',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.14285714285714285,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '17b92f23d26a7fe33a5bd219abd0099e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T11:27:44.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6e7477ca88febf5dd9484cea67b58bc0',
        affiliate: 'MNTV',
        isci: 'GF35W1'
      },
      sessionCount: 4,
      pvCount: 13,
      lift: 2.333333333333333,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'MNTV',
      origEventId: '6e7477ca88febf5dd9484cea67b58bc0',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T18:17:44.370Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'fa38cc9c413700130895c0c4aa09ae4a',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W2'
      },
      sessionCount: 3,
      pvCount: 9,
      lift: 0.5757575757575757,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'IND (KNLC)',
      origEventId: 'fa38cc9c413700130895c0c4aa09ae4a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T18:58:17.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '75104b0fb38e62af9b883ead0d32aa96',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 4,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '75104b0fb38e62af9b883ead0d32aa96',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T17:48:17.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'edce5b4337bb1515e7e68af4508d7490',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 7,
      pvCount: 12,
      lift: 5.363636363636363,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: 'edce5b4337bb1515e7e68af4508d7490',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T18:59:51.500Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8c8d0575c3bdf282615dcbe7daec6cc0',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 3,
      pvCount: 6,
      lift: 0.42857142857142855,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '8c8d0575c3bdf282615dcbe7daec6cc0',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T12:37:52.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '28c30cbfddf3d861d1a6161869b50801',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W2'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.175,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'IND (KNLC)',
      origEventId: '28c30cbfddf3d861d1a6161869b50801',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T18:15:16.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a6dc953b16a56d280ab988a14f52135e',
        affiliate: 'MNTV',
        isci: 'GE31W1'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.2777777777777778,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'MNTV',
      origEventId: 'a6dc953b16a56d280ab988a14f52135e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-14T16:29:31.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a16e8b2e567dd31ed291481d22cd2b31',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.05535714285714282,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'a16e8b2e567dd31ed291481d22cd2b31',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T13:19:54.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '105c094a52717f3a0c2fdafb7c9b098e',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.7,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '105c094a52717f3a0c2fdafb7c9b098e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T13:25:55.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '714277d1d07dbd7c9096c77207bc1f5c',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 0.42857142857142844,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '714277d1d07dbd7c9096c77207bc1f5c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T21:44:47.921Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3d07d864f133df9baf45bbd680da8e3c',
        affiliate: 'MNTV',
        isci: 'GF35W1'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: -0.1666666666666668,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'MNTV',
      origEventId: '3d07d864f133df9baf45bbd680da8e3c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T18:38:09.584Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b66d82927883d95d70c90e2b3400a8f1',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 3,
      pvCount: 6,
      lift: 0.42857142857142855,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'b66d82927883d95d70c90e2b3400a8f1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T12:37:41.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b80b17d096cf90a30d53eaa01ce70812',
        affiliate: 'IND (ERBK)',
        isci: 'GG35W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GG35W1',
      affiliate: 'IND (ERBK)',
      origEventId: 'b80b17d096cf90a30d53eaa01ce70812',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T17:45:49.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: 'f596478043e99975a6de5b28e40513a3',
        affiliate: 'MNTV',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.1111111111111111,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'MNTV',
      origEventId: 'f596478043e99975a6de5b28e40513a3',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-14T16:29:11.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3b2d63146af313f8547475fd2613e9a3',
        affiliate: 'ABC',
        isci: 'GF35W1'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'ABC',
      origEventId: '3b2d63146af313f8547475fd2613e9a3',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T21:36:54.529Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4d7585283579acbf352a344ebd8f2294',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 0.36507936507936506,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '4d7585283579acbf352a344ebd8f2294',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T15:46:20.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '274164c40af20948e7357f4a778fedb0',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W2'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'IND (KNLC)',
      origEventId: '274164c40af20948e7357f4a778fedb0',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T11:59:14.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'bc13097c46ac04815bc1ae763a874a0f',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: 'bc13097c46ac04815bc1ae763a874a0f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T12:14:00.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '989f9539e72af67407224a68fe4c66fa',
        affiliate: 'ABC',
        isci: 'GF35W1'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 3,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'ABC',
      origEventId: '989f9539e72af67407224a68fe4c66fa',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T21:31:22.223Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ba41e0e46cad5d11602542679989e4d4',
        affiliate: 'ABC',
        isci: 'GF35W1'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 0.36507936507936506,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'ABC',
      origEventId: 'ba41e0e46cad5d11602542679989e4d4',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T15:45:22.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '687e335ff2dd01f35b18db95b0a4b17a',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 10,
      pvCount: 14,
      lift: 0.6678571428571427,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '687e335ff2dd01f35b18db95b0a4b17a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T14:16:12.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7ce1be8b327e1f284743e9af549e9428',
        affiliate: 'CBS',
        isci: 'GE31W1'
      },
      sessionCount: 4,
      pvCount: 12,
      lift: 0.06409611992945323,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CBS',
      origEventId: '7ce1be8b327e1f284743e9af549e9428',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:11:31.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c94183fd7d4bbf0d4838dd6a4f8a86de',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'c94183fd7d4bbf0d4838dd6a4f8a86de',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T11:28:10.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '025758bde6b4b830356ba8afa527eec2',
        affiliate: 'ABC',
        isci: 'GF35W1'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 0.6666666666666664,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'ABC',
      origEventId: '025758bde6b4b830356ba8afa527eec2',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T14:59:32.735Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '63dc048d6f440331fc7571db36b80026',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 6,
      pvCount: 16,
      lift: -0.16666666666666674,
      baselineSessionCount: 6,
      baselineSessionsPerSecond: 0.02,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: '63dc048d6f440331fc7571db36b80026',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T17:44:13.670Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7d475275f2bb23f7b56ee44213b22cda',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 4,
      pvCount: 4,
      lift: 1.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '7d475275f2bb23f7b56ee44213b22cda',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T14:17:03.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1904d3a0784a63737ee7f1099f413263',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W2'
      },
      sessionCount: 7,
      pvCount: 10,
      lift: 0.7272727272727272,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'IND (KNLC)',
      origEventId: '1904d3a0784a63737ee7f1099f413263',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T18:42:03.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0ddb07b2e4c2d945611a4d4874ef6439',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '0ddb07b2e4c2d945611a4d4874ef6439',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T16:24:21.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f1cc5b843fc60017fefe183fa7af532d',
        affiliate: 'CW',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.034490740740740745,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CW',
      origEventId: 'f1cc5b843fc60017fefe183fa7af532d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T10:29:39.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '212408fec17cae93817ef9b2887a3dee',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W2'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'IND (KNLC)',
      origEventId: '212408fec17cae93817ef9b2887a3dee',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T11:59:19.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '14e1e8f9ab78c66ed06edbb1fd014b6e',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 4,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '14e1e8f9ab78c66ed06edbb1fd014b6e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T17:48:17.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8d93f942583a9698a1f02ce2c716f28d',
        affiliate: 'MNTV',
        isci: 'GF35W1'
      },
      sessionCount: 7,
      pvCount: 11,
      lift: 1.1166666666666665,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'MNTV',
      origEventId: '8d93f942583a9698a1f02ce2c716f28d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T19:18:54.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '774efe86bbba2780117b35b10bf5b670',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 1.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: '774efe86bbba2780117b35b10bf5b670',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T12:44:42.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '687cd9767300be7e799caea2181a3ac4',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 2,
      pvCount: 8,
      lift: 2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '687cd9767300be7e799caea2181a3ac4',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T16:13:35.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'fdd4c0dcc319d275ccdb535b2a125f2e',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: -0.021428571428571446,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: 'fdd4c0dcc319d275ccdb535b2a125f2e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T17:45:39.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '49b5e244aec255e28651578dcfba9f3e',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '49b5e244aec255e28651578dcfba9f3e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T13:28:46.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f5ee13191686f34aa7b9a42944e62045',
        affiliate: 'IND (ERBK)',
        isci: 'GG35W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GG35W1',
      affiliate: 'IND (ERBK)',
      origEventId: 'f5ee13191686f34aa7b9a42944e62045',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T14:46:21.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '0d51b2ea25d96eea2570bfcfd39c2ccc',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 5,
      pvCount: 13,
      lift: 0.6363636363636362,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '0d51b2ea25d96eea2570bfcfd39c2ccc',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T16:24:58.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f8cfc2af0e623880d38a879b4511b0e0',
        affiliate: 'CBS',
        isci: 'GF35W1'
      },
      sessionCount: 1,
      pvCount: 5,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'CBS',
      origEventId: 'f8cfc2af0e623880d38a879b4511b0e0',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T00:32:54.525Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b0e5deaa1b2c4cd9fcc12cfd27f9dae5',
        affiliate: 'MNTV',
        isci: 'GE31W1'
      },
      sessionCount: 10,
      pvCount: 20,
      lift: 0.31046296296296294,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'MNTV',
      origEventId: 'b0e5deaa1b2c4cd9fcc12cfd27f9dae5',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T15:37:02.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'fa50c77ff140929c951182f8ca52a256',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 4,
      pvCount: 7,
      lift: 0.10215891912320482,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: 'fa50c77ff140929c951182f8ca52a256',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:46:09.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '769b0bdddbdff4fc5b15b1073c5d7e31',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 4,
      pvCount: 10,
      lift: -0.08138888888888893,
      baselineSessionCount: 5,
      baselineSessionsPerSecond: 0.016666666666666666,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: '769b0bdddbdff4fc5b15b1073c5d7e31',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T18:11:31.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '04f1680c2b76de74ee870b1fce2edd3a',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 5,
      pvCount: 11,
      lift: 0.2648148148148148,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: '04f1680c2b76de74ee870b1fce2edd3a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T14:16:39.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7bdc7d26a60d6e4ca03af0f319faa901',
        affiliate: 'CBS',
        isci: 'GE31W1'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 0.05972222222222222,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CBS',
      origEventId: '7bdc7d26a60d6e4ca03af0f319faa901',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T15:24:11.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6558d1be7cb735cc1f3797aab4dc05ca',
        affiliate: 'ABC',
        isci: 'GF35W1'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 0.6666666666666664,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'ABC',
      origEventId: '6558d1be7cb735cc1f3797aab4dc05ca',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T20:54:07.759Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6453d8df58dd393968dff83c799f6a85',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 5,
      pvCount: 8,
      lift: 0.5597594997594997,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '6453d8df58dd393968dff83c799f6a85',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T13:59:52.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'dc0c8a102bbf3c2cffe7ba908d56fe33',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 7,
      pvCount: 16,
      lift: 0.2906349206349206,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'dc0c8a102bbf3c2cffe7ba908d56fe33',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T17:19:12.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '88f7d728f439a9433b3953c7bd394cee',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 0.6912136363260674,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '88f7d728f439a9433b3953c7bd394cee',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T13:57:39.099Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '39c6113f4db865fe2068929c985bad5a',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: '39c6113f4db865fe2068929c985bad5a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T16:44:53.914Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '5df30a0744ce2f8e7c9cd7b6d6d5580b',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 4,
      pvCount: 13,
      lift: 0.050419973544973545,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '5df30a0744ce2f8e7c9cd7b6d6d5580b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:42:43.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '94d9f4354b0706f6d9c45707431a7ad2',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '94d9f4354b0706f6d9c45707431a7ad2',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T16:24:21.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3055e9e37f039a75f723f1bab571cd3b',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '3055e9e37f039a75f723f1bab571cd3b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T11:49:53.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'dc695506db261baa0f2d368d6c9caf85',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.3666666666666667,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'dc695506db261baa0f2d368d6c9caf85',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T11:27:17.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2c0f844e8cfb8fd748f1c26ace763c72',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 7,
      pvCount: 10,
      lift: 0.2527777777777777,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '2c0f844e8cfb8fd748f1c26ace763c72',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T14:14:44.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '190b9f1bdf8caf83677a854bf31f647a',
        affiliate: 'CBS',
        isci: 'GE31W1'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 0.06180555555555554,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CBS',
      origEventId: '190b9f1bdf8caf83677a854bf31f647a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T15:24:20.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0a416face5316087e299fe98756b2026',
        affiliate: 'CW',
        isci: 'GE31W1'
      },
      sessionCount: 5,
      pvCount: 8,
      lift: 0.11527006172839502,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CW',
      origEventId: '0a416face5316087e299fe98756b2026',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T19:36:42.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1b6c4a335e3e15fd37707856f91569a1',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: '1b6c4a335e3e15fd37707856f91569a1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T08:44:48.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ab0008ce0f61831930ece39f5ec34b9b',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 7,
      pvCount: 14,
      lift: 0.37218253968253967,
      baselineSessionCount: 5,
      baselineSessionsPerSecond: 0.016666666666666666,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: 'ab0008ce0f61831930ece39f5ec34b9b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T18:10:45.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f517a75e7d411155c3e24811645ba5c5',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'f517a75e7d411155c3e24811645ba5c5',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T14:47:35.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '05afac9a6804917b93ac2aa4e31d2048',
        affiliate: 'FOX',
        isci: 'GF35W1'
      },
      sessionCount: 5,
      pvCount: 12,
      lift: 1.5374999999999996,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'FOX',
      origEventId: '05afac9a6804917b93ac2aa4e31d2048',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T15:06:31.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a08f4e688358699e189d2eed8df49055',
        affiliate: 'CW',
        isci: 'GE31W1'
      },
      sessionCount: 3,
      pvCount: 7,
      lift: 0.3807407407407407,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CW',
      origEventId: 'a08f4e688358699e189d2eed8df49055',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T14:37:31.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '99fbd1e64358b73dc3fdf8d94081d073',
        affiliate: 'IND (ERBK)',
        isci: 'GG35W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GG35W1',
      affiliate: 'IND (ERBK)',
      origEventId: '99fbd1e64358b73dc3fdf8d94081d073',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T15:15:02.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: 'ef2fa822b7fa149d4f438ec22dce5939',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.3666666666666667,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'ef2fa822b7fa149d4f438ec22dce5939',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T11:28:46.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f0b55df3d5c7d4ec032526782715e4e0',
        affiliate: 'MNTV',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: -0.07013007054673723,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'MNTV',
      origEventId: 'f0b55df3d5c7d4ec032526782715e4e0',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T19:15:45.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ce787390de338644fbb1a90102acb0ec',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: 'ce787390de338644fbb1a90102acb0ec',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T13:41:13.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a66db3eccb6d68798b60624e977c4c6a',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: 0.42857142857142844,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'a66db3eccb6d68798b60624e977c4c6a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T18:47:08.189Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '351445b0a32062b35073867ac51d7271',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 2,
      pvCount: 7,
      lift: 0.42857142857142844,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '351445b0a32062b35073867ac51d7271',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T19:17:09.327Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '49e182599e696a01050aef48566ffc90',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.42857142857142844,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '49e182599e696a01050aef48566ffc90',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T19:14:41.958Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3f9aa205a6a05740e4aff71ca556a5fe',
        affiliate: 'IND (ERBK)',
        isci: 'GG35W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GG35W1',
      affiliate: 'IND (ERBK)',
      origEventId: '3f9aa205a6a05740e4aff71ca556a5fe',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-14T18:20:03.221Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '6087681dc99d473cd651328e4ef5a5cc',
        affiliate: 'ABC',
        isci: 'GF35W1'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 0.48379629629629617,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'ABC',
      origEventId: '6087681dc99d473cd651328e4ef5a5cc',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T15:54:42.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '06ba2686469a0e804b7387a1f684cdea',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.027073105465962605,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '06ba2686469a0e804b7387a1f684cdea',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-07T16:46:48.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '69d3dd9a7b104398d857f091f4a2b809',
        affiliate: 'ABC',
        isci: 'GF35W1'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 0.2499999999999998,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'ABC',
      origEventId: '69d3dd9a7b104398d857f091f4a2b809',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T21:37:29.770Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd2ed6a3ba399aaebe9ac965edd527850',
        affiliate: 'CW',
        isci: 'GF35W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'CW',
      origEventId: 'd2ed6a3ba399aaebe9ac965edd527850',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T12:32:21.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'de43fa1b790fb4c668feca61a00d8773',
        affiliate: 'IND (ERBK)',
        isci: 'GG35W1'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GG35W1',
      affiliate: 'IND (ERBK)',
      origEventId: 'de43fa1b790fb4c668feca61a00d8773',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T19:41:27.345Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '6ba80b6eec7bac6068e36d2cf3fd0a41',
        affiliate: 'CW',
        isci: 'GE31W2'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'CW',
      origEventId: '6ba80b6eec7bac6068e36d2cf3fd0a41',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T12:50:16.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8684dec1637b93e7aa75db05c1cfd146',
        affiliate: 'FOX',
        isci: 'GE31W1'
      },
      sessionCount: 5,
      pvCount: 12,
      lift: 3.166666666666666,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'FOX',
      origEventId: '8684dec1637b93e7aa75db05c1cfd146',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T20:44:05.099Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '260e5620e43e04345e03735c60e00292',
        affiliate: 'CW',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.04490740740740741,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CW',
      origEventId: '260e5620e43e04345e03735c60e00292',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T10:30:01.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '32e0af1575ada9bd8402acdab7ad5348',
        affiliate: 'CBS',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CBS',
      origEventId: '32e0af1575ada9bd8402acdab7ad5348',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-15T00:48:38.384Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '61939b04e9acc7793bbb9a5ff0b726df',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '61939b04e9acc7793bbb9a5ff0b726df',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-07T14:49:49.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '96bd1f37f0647f777199c4806b5607ba',
        affiliate: 'IND (ERBK)',
        isci: 'GG35W1'
      },
      sessionCount: 1,
      pvCount: 5,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GG35W1',
      affiliate: 'IND (ERBK)',
      origEventId: '96bd1f37f0647f777199c4806b5607ba',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T23:44:28.028Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '43f9eae7a048a44d0bad0baf2c3d538e',
        affiliate: 'CW',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.034490740740740745,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CW',
      origEventId: '43f9eae7a048a44d0bad0baf2c3d538e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T10:29:46.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd8904f6b3ccf4cffa645cd86ddefcefd',
        affiliate: 'CW',
        isci: 'GE31W2'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'CW',
      origEventId: 'd8904f6b3ccf4cffa645cd86ddefcefd',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T16:48:24.850Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3ab4a1613877a4c7501d31068bce2a33',
        affiliate: 'CBS',
        isci: 'GE31W1'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 0.06180555555555554,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CBS',
      origEventId: '3ab4a1613877a4c7501d31068bce2a33',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T15:24:20.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a790c77d15f8f99025b6e9a26a7c9770',
        affiliate: 'CBS',
        isci: 'GF35W1'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: -0.13164351851851852,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'CBS',
      origEventId: 'a790c77d15f8f99025b6e9a26a7c9770',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T19:35:49.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '82a685c49d1e0cb2aa49dba56ff7663b',
        affiliate: 'CW',
        isci: 'GE31W1'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 0.11264991181657846,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CW',
      origEventId: '82a685c49d1e0cb2aa49dba56ff7663b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T13:57:12.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3717a6236187208eb1ff3b5b4581bf81',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '3717a6236187208eb1ff3b5b4581bf81',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T12:14:00.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f113fc681da491a97af1b62701b29e0e',
        affiliate: 'ABC',
        isci: 'GF35W1'
      },
      sessionCount: 1,
      pvCount: 4,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'ABC',
      origEventId: 'f113fc681da491a97af1b62701b29e0e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T14:25:37.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'cf47cb05725f78ce12d29c8a6a62381c',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'cf47cb05725f78ce12d29c8a6a62381c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T12:17:32.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e348b4d7fc9dbd32f78ceeda8ed59546',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 6,
      pvCount: 9,
      lift: 0.42440476190476184,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: 'e348b4d7fc9dbd32f78ceeda8ed59546',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T18:44:44.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '05b5fe2602d7b98e58f6cd22c9829659',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 4,
      pvCount: 7,
      lift: 1.6618892857006615,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '05b5fe2602d7b98e58f6cd22c9829659',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T16:27:22.647Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6ae87bb67730109ebde9c035e72d9504',
        affiliate: 'ABC',
        isci: 'GF35W1'
      },
      sessionCount: 4,
      pvCount: 7,
      lift: 4,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'ABC',
      origEventId: '6ae87bb67730109ebde9c035e72d9504',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T13:59:02.275Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd691fd652bd1d42f6929a1bbecdae524',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'd691fd652bd1d42f6929a1bbecdae524',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-07T17:43:31.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f5ecfd6a9cd05695f65ab0b8dd5551f7',
        affiliate: 'CW',
        isci: 'GE31W2'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'CW',
      origEventId: 'f5ecfd6a9cd05695f65ab0b8dd5551f7',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T11:48:29.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0977d9b8405209284f15ec33309241e7',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 3,
      pvCount: 5,
      lift: 0.75,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '0977d9b8405209284f15ec33309241e7',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T16:50:11.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '89fb66b60c77e7e0719702d5f9f39268',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '89fb66b60c77e7e0719702d5f9f39268',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T14:46:30.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ab36de015ebede208258cc35a0ca9c07',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 7,
      pvCount: 8,
      lift: 0.5136904761904761,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: 'ab36de015ebede208258cc35a0ca9c07',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T15:16:50.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd1d71ce81c1025599b478bf5ad40bb56',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 3,
      pvCount: 5,
      lift: 0.75,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'd1d71ce81c1025599b478bf5ad40bb56',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T16:49:50.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'eaa36f8600afe098a8b7ff1068ecf8d1',
        affiliate: 'ABC',
        isci: 'GF35W1'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 0.8666666666666667,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'ABC',
      origEventId: 'eaa36f8600afe098a8b7ff1068ecf8d1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T11:23:32.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0999138a8baa46835c8a80e78a8e6d74',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '0999138a8baa46835c8a80e78a8e6d74',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T12:18:07.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '65f8ca5b8d2b7f6172a19af51a044760',
        affiliate: 'CBS',
        isci: 'GE31W1'
      },
      sessionCount: 5,
      pvCount: 13,
      lift: -0.16666666666666682,
      baselineSessionCount: 5,
      baselineSessionsPerSecond: 0.016666666666666666,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CBS',
      origEventId: '65f8ca5b8d2b7f6172a19af51a044760',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T20:24:12.093Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2e1367dda9b0c40b66db5e19a0855a70',
        affiliate: 'MNTV',
        isci: 'GF35W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.25925925925925924,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'MNTV',
      origEventId: '2e1367dda9b0c40b66db5e19a0855a70',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T13:17:38.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd3edb611623df26a5104e4057a6ccb6a',
        affiliate: 'FOX',
        isci: 'GE31W1'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: -0.0036375661375661473,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'FOX',
      origEventId: 'd3edb611623df26a5104e4057a6ccb6a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T14:27:16.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'dc6283db9e0c432dc00ca56c0f42c296',
        affiliate: 'ABC',
        isci: 'GF35W1'
      },
      sessionCount: 5,
      pvCount: 6,
      lift: 0.38888888888888873,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'ABC',
      origEventId: 'dc6283db9e0c432dc00ca56c0f42c296',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T13:58:43.250Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '9e0496bbc4aa289c301fc6de9d64f98c',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 7,
      pvCount: 8,
      lift: 0.9444444444444443,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: '9e0496bbc4aa289c301fc6de9d64f98c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T17:27:22.154Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '83402f4a2f526a4d4f77cb1bf3a4a482',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: '83402f4a2f526a4d4f77cb1bf3a4a482',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T23:43:08.910Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f0ccfed626e5187b296fae343d3887b8',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 0.8,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'f0ccfed626e5187b296fae343d3887b8',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T14:14:36.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8ecd53ea9df10e20ac685c123c23a4c7',
        affiliate: 'CW',
        isci: 'GE31W2'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'CW',
      origEventId: '8ecd53ea9df10e20ac685c123c23a4c7',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T11:48:23.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'fb084f493b7b12639c3c99e169efeee0',
        affiliate: 'CW',
        isci: 'GF35W1'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.6666666666666664,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'CW',
      origEventId: 'fb084f493b7b12639c3c99e169efeee0',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:55:19.966Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd4336c5932d024eae42363056231bab0',
        affiliate: 'ABC',
        isci: 'GF35W1'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 1.4999999999999996,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'ABC',
      origEventId: 'd4336c5932d024eae42363056231bab0',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T20:17:44.133Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7bc96e0a3d2fce9e39f3bb0a36d89ad6',
        affiliate: 'CW',
        isci: 'GF35W1'
      },
      sessionCount: 4,
      pvCount: 12,
      lift: 4,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'CW',
      origEventId: '7bc96e0a3d2fce9e39f3bb0a36d89ad6',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T17:32:21.711Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7848190d7d913d860a16116f196854e4',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 3,
      pvCount: 6,
      lift: 0.42857142857142855,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '7848190d7d913d860a16116f196854e4',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T12:37:26.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'dd88c5d8fcc1b2b0576d64be9fb041fd',
        affiliate: 'FOX',
        isci: 'GF35W1'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 0.20601851851851843,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'FOX',
      origEventId: 'dd88c5d8fcc1b2b0576d64be9fb041fd',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T12:59:17.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '88524468cc9bd6d8b3f2d9629d88a72c',
        affiliate: 'MNTV',
        isci: 'GG35W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GG35W1',
      affiliate: 'MNTV',
      origEventId: '88524468cc9bd6d8b3f2d9629d88a72c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T22:11:35.083Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: 'a481e0db272c26f44e48ff777534668f',
        affiliate: 'IND (ERBK)',
        isci: 'GG35W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GG35W1',
      affiliate: 'IND (ERBK)',
      origEventId: 'a481e0db272c26f44e48ff777534668f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T15:15:25.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: 'a99373b887b40887efd55e0292368938',
        affiliate: 'FOX',
        isci: 'GF35W1'
      },
      sessionCount: 5,
      pvCount: 12,
      lift: 1.5374999999999996,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'FOX',
      origEventId: 'a99373b887b40887efd55e0292368938',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T15:07:04.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '22c71959824bbbe2a2038bce68ab2a83',
        affiliate: 'CBS',
        isci: 'GE31W2'
      },
      sessionCount: 5,
      pvCount: 9,
      lift: 1.2727272727272725,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'CBS',
      origEventId: '22c71959824bbbe2a2038bce68ab2a83',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T15:59:51.330Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a9f345f850e97d79cdf90fc9e5eaaddb',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: 'a9f345f850e97d79cdf90fc9e5eaaddb',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T12:14:12.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3208bd3fa4bed78d9ac62b9037d06867',
        affiliate: 'MNTV',
        isci: 'GF35W1'
      },
      sessionCount: 6,
      pvCount: 10,
      lift: 0.6999999999999998,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'MNTV',
      origEventId: '3208bd3fa4bed78d9ac62b9037d06867',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T19:18:18.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1756197408bf5827261d38f545dfa526',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: '1756197408bf5827261d38f545dfa526',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T13:43:04.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a82a420c6be683ae2abcb25279bbe5a1',
        affiliate: 'CW',
        isci: 'GE31W1'
      },
      sessionCount: 5,
      pvCount: 8,
      lift: 0.11364969135802468,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CW',
      origEventId: 'a82a420c6be683ae2abcb25279bbe5a1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T19:36:53.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '94df22ddd566ae9e702a03e7b01aeed4',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 5,
      pvCount: 8,
      lift: 0.5199025974025974,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '94df22ddd566ae9e702a03e7b01aeed4',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T14:00:12.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3a002232306dd8146a9c8eb542325e7c',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 4,
      pvCount: 7,
      lift: 0.28194444444444444,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: '3a002232306dd8146a9c8eb542325e7c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T18:58:10.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '53576b81cd47bce21c5f2c3e63d5089c',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: '53576b81cd47bce21c5f2c3e63d5089c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T13:26:56.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7f892df7a4ff77cd49cbe1ad3ff2f541',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 3,
      pvCount: 9,
      lift: 3,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: '7f892df7a4ff77cd49cbe1ad3ff2f541',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T13:45:42.285Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'bbede927466cbbc3d04399f16c9f86f0',
        affiliate: 'FOX',
        isci: 'GE31W1'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 0.11111111111111097,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'FOX',
      origEventId: 'bbede927466cbbc3d04399f16c9f86f0',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T15:22:45.769Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '97c7de84c2ed9577cfad8b58a976030c',
        affiliate: 'CBS',
        isci: 'GE31W1'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: 0.26666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CBS',
      origEventId: '97c7de84c2ed9577cfad8b58a976030c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T19:31:38.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8bfdc11055c71dda41bf3d7cb8047129',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 0.7027777777777776,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: '8bfdc11055c71dda41bf3d7cb8047129',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T19:13:39.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '41e68b97a69d1f0de8539d5f66830ae3',
        affiliate: 'ABC',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'ABC',
      origEventId: '41e68b97a69d1f0de8539d5f66830ae3',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T16:56:24.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd30978954bc76e36fe453d972f5ff407',
        affiliate: 'CBS',
        isci: 'GE31W1'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 0.05972222222222222,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CBS',
      origEventId: 'd30978954bc76e36fe453d972f5ff407',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T15:24:11.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '748e8e347e979f42360223fb55d99101',
        affiliate: 'IND (ERBK)',
        isci: 'GG35W1'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GG35W1',
      affiliate: 'IND (ERBK)',
      origEventId: '748e8e347e979f42360223fb55d99101',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-07T02:46:57.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: 'c32caa51cc8a9fc119e517d170ce97c1',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 7,
      pvCount: 12,
      lift: 0.425,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'c32caa51cc8a9fc119e517d170ce97c1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T18:58:31.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f671e4f8d4e5bef3566c5b43f7a9d74d',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 7,
      pvCount: 7,
      lift: 1.4371031746031746,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: 'f671e4f8d4e5bef3566c5b43f7a9d74d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T14:44:05.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'da05509dc67ed39101d95082667bdbea',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: -0.5000000000000001,
      baselineSessionCount: 5,
      baselineSessionsPerSecond: 0.016666666666666666,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'da05509dc67ed39101d95082667bdbea',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T14:28:31.629Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '16aa42b6e0e830e88092e88b245d5163',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 3,
      pvCount: 5,
      lift: 0.17599206349206348,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '16aa42b6e0e830e88092e88b245d5163',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T17:16:15.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8bc1ea7ba4c1d67eb46b5106023339d1',
        affiliate: 'FOX',
        isci: 'GF35W1'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 0.20601851851851843,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'FOX',
      origEventId: '8bc1ea7ba4c1d67eb46b5106023339d1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T12:59:17.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'fe47b95524331e7378fbaf8a56d65b42',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 5,
      pvCount: 7,
      lift: 0.8410714285714284,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'fe47b95524331e7378fbaf8a56d65b42',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T17:17:44.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8526de4a35804ee8adb073df2cf75a5b',
        affiliate: 'NBC',
        isci: 'GG35W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GG35W1',
      affiliate: 'NBC',
      origEventId: '8526de4a35804ee8adb073df2cf75a5b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T14:23:27.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '38b834fc49f53eb9582aec863281212a',
        affiliate: 'MNTV',
        isci: 'GG35W1'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GG35W1',
      affiliate: 'MNTV',
      origEventId: '38b834fc49f53eb9582aec863281212a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T17:29:46.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '35aa19b6f08b8f7e3e3d61643fd6e990',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 4,
      pvCount: 5,
      lift: 0.8650793650793651,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '35aa19b6f08b8f7e3e3d61643fd6e990',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T15:46:47.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8533386cc598dad75d9b5c22c434c698',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W2'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.818181818181818,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'IND (KNLC)',
      origEventId: '8533386cc598dad75d9b5c22c434c698',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T23:42:07.312Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '277781800022ec49e1e74d7dd82b9113',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 4,
      pvCount: 7,
      lift: 4,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '277781800022ec49e1e74d7dd82b9113',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T17:29:21.455Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3171045f7fe3e4e207af84dee4e4beca',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 4,
      pvCount: 7,
      lift: 0.03234126984126982,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: '3171045f7fe3e4e207af84dee4e4beca',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T18:45:51.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '9b42fa92a1e871ee01116cf7bcd53651',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.14285714285714285,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '9b42fa92a1e871ee01116cf7bcd53651',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T11:27:44.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd6b5beec566093137a0f9a70aa74dfbf',
        affiliate: 'IND (ERBK)',
        isci: 'GG35W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GG35W1',
      affiliate: 'IND (ERBK)',
      origEventId: 'd6b5beec566093137a0f9a70aa74dfbf',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T15:15:02.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: 'ffebdf4b36cb2d0c65b2a7d5a58b98b7',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 5,
      pvCount: 15,
      lift: 0.6275793650793651,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: 'ffebdf4b36cb2d0c65b2a7d5a58b98b7',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T16:46:59.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '44fadcb6e2e106a0331a3461ec401104',
        affiliate: 'CBS',
        isci: 'GF35W1'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'CBS',
      origEventId: '44fadcb6e2e106a0331a3461ec401104',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-14T00:35:56.343Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '9de686774b5aa5ec6e90036e756cdb82',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '9de686774b5aa5ec6e90036e756cdb82',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T16:24:21.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '5222b944042a8c0830859900d153421c',
        affiliate: 'CBS',
        isci: 'GF35W1'
      },
      sessionCount: 2,
      pvCount: 15,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'CBS',
      origEventId: '5222b944042a8c0830859900d153421c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T19:33:29.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'cffa28c7043cad529d2bf2a56583a5e2',
        affiliate: 'ABC',
        isci: 'GF35W1'
      },
      sessionCount: 3,
      pvCount: 9,
      lift: 1.509259259259259,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'ABC',
      origEventId: 'cffa28c7043cad529d2bf2a56583a5e2',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:17:38.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0781ba4f272090ca299f68ac112ac580',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '0781ba4f272090ca299f68ac112ac580',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T11:49:53.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1861d95c223b6e954493ae38750e8bfc',
        affiliate: 'CBS',
        isci: 'GE31W1'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: 0.26666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CBS',
      origEventId: '1861d95c223b6e954493ae38750e8bfc',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T19:32:01.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3226f656c989eaaff5392d330d558696',
        affiliate: 'ABC',
        isci: 'GF35W1'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'ABC',
      origEventId: '3226f656c989eaaff5392d330d558696',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T19:25:08.967Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '17f5b47c4a1acf47f5d1623cf3a7bb9c',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 7,
      pvCount: 17,
      lift: 0.5783730158730158,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '17f5b47c4a1acf47f5d1623cf3a7bb9c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T17:20:18.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2dc61a66c2b4d699836e37f5a139bd27',
        affiliate: 'FOX',
        isci: 'GF35W1'
      },
      sessionCount: 4,
      pvCount: 5,
      lift: 2.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'FOX',
      origEventId: '2dc61a66c2b4d699836e37f5a139bd27',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T17:46:07.496Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '813ca4b5994ab6263d5507298979ba0a',
        affiliate: 'ABC',
        isci: 'GE31W1'
      },
      sessionCount: 6,
      pvCount: 10,
      lift: 1.6495370370370368,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'ABC',
      origEventId: '813ca4b5994ab6263d5507298979ba0a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T15:18:06.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'da4abaae0c9775d46f46f7b695ad4e41',
        affiliate: 'MNTV',
        isci: 'GE31W1'
      },
      sessionCount: 10,
      pvCount: 20,
      lift: 0.31046296296296294,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'MNTV',
      origEventId: 'da4abaae0c9775d46f46f7b695ad4e41',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T15:37:02.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6fc1fdf339c5a4cdb7d89097ca34edf8',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '6fc1fdf339c5a4cdb7d89097ca34edf8',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T22:15:14.139Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd66077f832f95f54328dac654a69561e',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'd66077f832f95f54328dac654a69561e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T18:12:45.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '98dfd5efbdeba04f1c69d7066b5d45eb',
        affiliate: 'MNTV',
        isci: 'GG35W1'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GG35W1',
      affiliate: 'MNTV',
      origEventId: '98dfd5efbdeba04f1c69d7066b5d45eb',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T17:44:29.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '0fac13333e0ca5faa318be4e39ecda49',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 5,
      pvCount: 5,
      lift: 1.75,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: '0fac13333e0ca5faa318be4e39ecda49',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T14:43:20.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'fc06be3c3a3181878660f03d5b48fa64',
        affiliate: 'MNTV',
        isci: 'GE31W1'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: -0.02615740740740742,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'MNTV',
      origEventId: 'fc06be3c3a3181878660f03d5b48fa64',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T19:16:02.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '563064f6d17593cbe8d508db8c41eba5',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '563064f6d17593cbe8d508db8c41eba5',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T21:25:00.780Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7c6f12340eb1c5dd3490a2ec90cad3df',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 3,
      pvCount: 5,
      lift: 3,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '7c6f12340eb1c5dd3490a2ec90cad3df',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T17:58:59.517Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c187c2cb3073c504be8945f804917304',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 1,
      pvCount: 4,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: 'c187c2cb3073c504be8945f804917304',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T23:44:07.148Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'fa6f362aeef845fb751966e5dc23ef18',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: -0.4174476192111062,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'fa6f362aeef845fb751966e5dc23ef18',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:21:40.979Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ef8aea96ec687b7397a4d52ef4372317',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W2'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'IND (KNLC)',
      origEventId: 'ef8aea96ec687b7397a4d52ef4372317',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T11:59:14.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '350a0f95a897e33c1583ab392d391341',
        affiliate: 'ABC',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'ABC',
      origEventId: '350a0f95a897e33c1583ab392d391341',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T16:53:09.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b82ab0edb5ff920e95853d561601b5ab',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W2'
      },
      sessionCount: 3,
      pvCount: 9,
      lift: 0.5757575757575757,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'IND (KNLC)',
      origEventId: 'b82ab0edb5ff920e95853d561601b5ab',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T18:58:17.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '19a0486b61b987a16b4f4d0a6de791c9',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W2'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.6666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'IND (KNLC)',
      origEventId: '19a0486b61b987a16b4f4d0a6de791c9',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T08:23:47.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8def5d9b00b9f45ee9d51ad1d30005f6',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 7,
      pvCount: 8,
      lift: 0.4803571428571427,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: '8def5d9b00b9f45ee9d51ad1d30005f6',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T15:17:11.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e3823a59c0e3f5e02aa4affd8cee453c',
        affiliate: 'MNTV',
        isci: 'GE31W1'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: -0.017228835978835986,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'MNTV',
      origEventId: 'e3823a59c0e3f5e02aa4affd8cee453c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T19:15:53.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7aea473084dda87a850d5133fee61856',
        affiliate: 'ABC',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'ABC',
      origEventId: '7aea473084dda87a850d5133fee61856',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T11:13:32.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c1b528b5bdae00979c646452e20e42b7',
        affiliate: 'CW',
        isci: 'GE31W1'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 0.11264991181657846,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CW',
      origEventId: 'c1b528b5bdae00979c646452e20e42b7',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T13:56:57.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8af890c588d520236bc63057b344805f',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.6666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '8af890c588d520236bc63057b344805f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T18:24:14.810Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '610386777d1e0bf1cf0d250f0ec60938',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 4,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '610386777d1e0bf1cf0d250f0ec60938',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T19:12:58.360Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a659e79910b53aee05f7c67d96ec6258',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'a659e79910b53aee05f7c67d96ec6258',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T23:12:15.323Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'bca5a48c0f901218ed4c99086a2fa34d',
        affiliate: 'ABC',
        isci: 'GG35W6'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GG35W6',
      affiliate: 'ABC',
      origEventId: 'bca5a48c0f901218ed4c99086a2fa34d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T11:28:49.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: 'a58727a3ceba19fec699d4ec7184c457',
        affiliate: 'FOX',
        isci: 'GE31W1'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: -0.0036375661375661473,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'FOX',
      origEventId: 'a58727a3ceba19fec699d4ec7184c457',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T14:27:16.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7dff891c736e0df72248dfe3465ee2d4',
        affiliate: 'MNTV',
        isci: 'GE31W1'
      },
      sessionCount: 10,
      pvCount: 20,
      lift: 0.31046296296296294,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'MNTV',
      origEventId: '7dff891c736e0df72248dfe3465ee2d4',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T15:37:02.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '552e2fd88d3b31f5282ebd8fba717298',
        affiliate: 'CBS',
        isci: 'GE31W1'
      },
      sessionCount: 4,
      pvCount: 12,
      lift: 0.06733686067019397,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CBS',
      origEventId: '552e2fd88d3b31f5282ebd8fba717298',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:11:24.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2dbe31a936f53f896445068af50cb43f',
        affiliate: 'ABC',
        isci: 'GF35W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.2830541667011049,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'ABC',
      origEventId: '2dbe31a936f53f896445068af50cb43f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T13:59:32.898Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2e3ee1d42fee355627177a72c051706c',
        affiliate: 'CBS',
        isci: 'GE31W1'
      },
      sessionCount: 4,
      pvCount: 12,
      lift: 0.06571649029982361,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CBS',
      origEventId: '2e3ee1d42fee355627177a72c051706c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:11:08.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ce153e648273b231b2b0e4bb8216ac87',
        affiliate: 'FOX',
        isci: 'GE31W1'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 0.0019179894179894086,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'FOX',
      origEventId: 'ce153e648273b231b2b0e4bb8216ac87',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T14:27:00.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '49ced2241deac108ab83dda039dd3267',
        affiliate: 'CW',
        isci: 'GE31W2'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'CW',
      origEventId: '49ced2241deac108ab83dda039dd3267',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T15:38:24.233Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a195d2dab9a129204e696fee613eb0ce',
        affiliate: 'CBS',
        isci: 'GF35W1'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'CBS',
      origEventId: 'a195d2dab9a129204e696fee613eb0ce',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T00:32:32.600Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3fdb008c002c7979c7ddaec25e884331',
        affiliate: 'ABC',
        isci: 'GE31W1'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.6666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'ABC',
      origEventId: '3fdb008c002c7979c7ddaec25e884331',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T14:32:55.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '9e9f41dd33de25ad28adda9758b9c904',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 5,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '9e9f41dd33de25ad28adda9758b9c904',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T13:42:51.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1e544e7b23f457568b21b2df16e0ccad',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 7,
      pvCount: 14,
      lift: 0.6612119047414687,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '1e544e7b23f457568b21b2df16e0ccad',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T15:42:08.243Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '735cbaefbfeaa9dc9dc186c2fa0e13f2',
        affiliate: 'ABC',
        isci: 'GE31W1'
      },
      sessionCount: 5,
      pvCount: 8,
      lift: 0.8513888888888886,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'ABC',
      origEventId: '735cbaefbfeaa9dc9dc186c2fa0e13f2',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T15:17:47.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'dba6c922a482fe1a5d6a319570f514fa',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.03829365079365077,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'dba6c922a482fe1a5d6a319570f514fa',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T13:19:11.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2630c6d61478bd663388175af4e8c431',
        affiliate: 'ABC',
        isci: 'GF35W1'
      },
      sessionCount: 3,
      pvCount: 9,
      lift: -0.375,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'ABC',
      origEventId: '2630c6d61478bd663388175af4e8c431',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T20:44:55.235Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '924d87932df1fe5027bb677659f6b40f',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 1.1428571428571426,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '924d87932df1fe5027bb677659f6b40f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T14:22:38.771Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '9601c93450e1a0d3187f604b78bd97ec',
        affiliate: 'ABC',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'ABC',
      origEventId: '9601c93450e1a0d3187f604b78bd97ec',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T16:52:38.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd7d9ef0b41c9ea465d543ab4db8a6c33',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 0.8,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'd7d9ef0b41c9ea465d543ab4db8a6c33',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T14:16:26.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '873bb5fe14e0ed66c7096b647524268c',
        affiliate: 'CW',
        isci: 'GE31W1'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 0.1057716049382716,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CW',
      origEventId: '873bb5fe14e0ed66c7096b647524268c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T13:56:44.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'de9cb40cf25ede8ee8bcf69c881328ce',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 4,
      pvCount: 8,
      lift: 0.6666666666666664,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'de9cb40cf25ede8ee8bcf69c881328ce',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T18:27:01.629Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ef55bdf162cdcf2cc622bb31d7256084',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 2,
      pvCount: 10,
      lift: -0.235515873015873,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: 'ef55bdf162cdcf2cc622bb31d7256084',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T18:44:58.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c9e305b3dba3d452d282fd189f321f86',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.3818181818181818,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: 'c9e305b3dba3d452d282fd189f321f86',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T10:25:08.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '673d7bc1dfbe0e8c133bd2e8adff6e26',
        affiliate: 'ABC',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'ABC',
      origEventId: '673d7bc1dfbe0e8c133bd2e8adff6e26',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T11:13:13.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '95d2de2831745d3196764f620f84805f',
        affiliate: 'MNTV',
        isci: 'GG35W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.09090909090909098,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: 'GG35W1',
      affiliate: 'MNTV',
      origEventId: '95d2de2831745d3196764f620f84805f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T19:58:55.255Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '625edd6c4652f6916e3f59a2da45f29d',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 4,
      pvCount: 5,
      lift: 0.05555555555555548,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '625edd6c4652f6916e3f59a2da45f29d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T19:44:00.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2910357582e33e09c293ecdcf1e28789',
        affiliate: 'CW',
        isci: 'GE31W1'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: 0.10296296296296292,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CW',
      origEventId: '2910357582e33e09c293ecdcf1e28789',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T14:37:42.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e78b3e87984ab206628d09c2b230d872',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 3,
      pvCount: 6,
      lift: 0.42857142857142855,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'e78b3e87984ab206628d09c2b230d872',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T12:37:26.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2728a12c8832a154ddf12796fcfc9c8e',
        affiliate: 'ABC',
        isci: 'GF35W1'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 0.48379629629629617,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'ABC',
      origEventId: '2728a12c8832a154ddf12796fcfc9c8e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T15:54:42.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e7348399f45ae8756dee0482f07e38fe',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 9,
      pvCount: 12,
      lift: 0.5075396825396824,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'e7348399f45ae8756dee0482f07e38fe',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T14:15:26.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd037c2a87488b4e3cc63dec02932d73b',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.5833333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'd037c2a87488b4e3cc63dec02932d73b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T10:22:18.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e7690de3237a0338c94e12ab3742beec',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'e7690de3237a0338c94e12ab3742beec',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T12:44:08.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4d68285076737df726fa017f8d6d5496',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 3,
      pvCount: 12,
      lift: 3,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '4d68285076737df726fa017f8d6d5496',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T21:13:36.466Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'fd84ec4eff81f6609b1b894dc61a6339',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: 'fd84ec4eff81f6609b1b894dc61a6339',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T12:14:00.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '826a6a70e07200737cc6574f3d00640f',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 4,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '826a6a70e07200737cc6574f3d00640f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T15:59:55.529Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4517dfd0f570b7f0967db291fd24625a',
        affiliate: 'MNTV',
        isci: 'GF35W1'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'MNTV',
      origEventId: '4517dfd0f570b7f0967db291fd24625a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T09:39:00.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e51d24349c1bd3c1771ca60d31d4a20d',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: 'e51d24349c1bd3c1771ca60d31d4a20d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T13:46:23.554Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'aecb59c7130b7a7f36e6717fca8f0a39',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W2'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 0.5042929292929292,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'IND (KNLC)',
      origEventId: 'aecb59c7130b7a7f36e6717fca8f0a39',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T18:15:03.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b85912581740ce3e709c78b634510e6b',
        affiliate: 'CBS',
        isci: 'GE31W1'
      },
      sessionCount: 4,
      pvCount: 12,
      lift: 0.05450617283950615,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CBS',
      origEventId: 'b85912581740ce3e709c78b634510e6b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:11:43.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8e9932924ffbfa966af321d7fef942b9',
        affiliate: 'MNTV',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.1111111111111111,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'MNTV',
      origEventId: '8e9932924ffbfa966af321d7fef942b9',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-14T16:29:07.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3a74edce7bdbd7e9d5da5f6d0541e4fb',
        affiliate: 'MNTV',
        isci: 'GE31W1'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.2777777777777778,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'MNTV',
      origEventId: '3a74edce7bdbd7e9d5da5f6d0541e4fb',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-14T16:29:46.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '33448e6376909f1387311647325d0317',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: '33448e6376909f1387311647325d0317',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T13:22:47.212Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2599118a39317dea0724c1a8b97d67a1',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.3666666666666667,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '2599118a39317dea0724c1a8b97d67a1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T11:28:02.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b0cf1a3b050c3724da917f6076e81faa',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 5,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'b0cf1a3b050c3724da917f6076e81faa',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T13:43:20.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e58327bae45268ba99e9d97687766d20',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 3,
      pvCount: 17,
      lift: 1.5833333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'e58327bae45268ba99e9d97687766d20',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T16:46:32.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f3742b278fce1a55a293700918bb8057',
        affiliate: 'CBS',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 4,
      lift: 0.1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CBS',
      origEventId: 'f3742b278fce1a55a293700918bb8057',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T19:31:21.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '9cbb3a30edbfff05dabd47e736fa9c02',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.2857142857142858,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: '9cbb3a30edbfff05dabd47e736fa9c02',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T22:44:16.694Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a3239b2f70d9106b15e5fd5520a57548',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 0.36507936507936506,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'a3239b2f70d9106b15e5fd5520a57548',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T15:46:20.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd1a615aaa57b3a31861ac1dbb5fd8279',
        affiliate: 'ABC',
        isci: 'GF35W1'
      },
      sessionCount: 7,
      pvCount: 14,
      lift: 0.4222222222222221,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'ABC',
      origEventId: 'd1a615aaa57b3a31861ac1dbb5fd8279',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T16:37:27.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2da6bc57636d7d9288f1828fce1b6901',
        affiliate: 'CW',
        isci: 'GE31W2'
      },
      sessionCount: 2,
      pvCount: 7,
      lift: 0.818181818181818,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'CW',
      origEventId: '2da6bc57636d7d9288f1828fce1b6901',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T17:50:17.677Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4fe015ab6813ae7f65e921dea39f0cb5',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 0.8,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '4fe015ab6813ae7f65e921dea39f0cb5',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T14:16:26.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8007fba96706e78c014777c894337079',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 8,
      pvCount: 10,
      lift: 0.9779761904761903,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: '8007fba96706e78c014777c894337079',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T15:15:20.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f6e5305c13d8d7463d57dfed5acfe9ce',
        affiliate: 'MNTV',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: -0.07707451499118165,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'MNTV',
      origEventId: 'f6e5305c13d8d7463d57dfed5acfe9ce',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T19:15:30.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0a410f37359624dc2584ad969130de53',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 4,
      pvCount: 5,
      lift: 2.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '0a410f37359624dc2584ad969130de53',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T17:45:21.669Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c5fc13cb2c6b513b2ecab64bd237ee8d',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 4,
      pvCount: 5,
      lift: 1.5361111111111108,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'c5fc13cb2c6b513b2ecab64bd237ee8d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T19:13:05.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '658673bb0f5ee8c8f81452d9aee62d56',
        affiliate: 'MNTV',
        isci: 'GG35W1'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GG35W1',
      affiliate: 'MNTV',
      origEventId: '658673bb0f5ee8c8f81452d9aee62d56',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T17:28:48.061Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: 'f5497bb10119a34e6085da6dda450638',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'f5497bb10119a34e6085da6dda450638',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T08:17:42.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7d59eb671ea032fb8e3151ab3b16c3e7',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '7d59eb671ea032fb8e3151ab3b16c3e7',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T14:45:46.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0a06fa63832f76b76c692b1d7849d58e',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: -0.1666666666666668,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: '0a06fa63832f76b76c692b1d7849d58e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T21:11:15.260Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '965c72d42c9a51d91317e797af683f43',
        affiliate: 'CW',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.034490740740740745,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CW',
      origEventId: '965c72d42c9a51d91317e797af683f43',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T10:29:39.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e1987bda71a4ca83cadae6f3b4b1f051',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 7,
      pvCount: 8,
      lift: 0.33511904761904754,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'e1987bda71a4ca83cadae6f3b4b1f051',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T14:13:36.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '9d54183b140efe1f5f2af4a551ebb4fa',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.2857142857142858,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '9d54183b140efe1f5f2af4a551ebb4fa',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T19:14:48.798Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'dd74bc9b7c0c462023ff7e08d04fcf66',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 5,
      pvCount: 8,
      lift: 0.08382936507936506,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: 'dd74bc9b7c0c462023ff7e08d04fcf66',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:46:50.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b25b95227a223ccb2045bfadeb0c52e2',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 3,
      pvCount: 13,
      lift: -0.11130952380952379,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: 'b25b95227a223ccb2045bfadeb0c52e2',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T18:43:51.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e811f34da07928e931d53aea46b4641b',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 0.8,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'e811f34da07928e931d53aea46b4641b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T14:16:05.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e5213b32a3fd01ebb3970a0810761662',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: -0.5454545454545455,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: 'e5213b32a3fd01ebb3970a0810761662',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T15:15:33.150Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'dda15ab4bfad545a9456a76f05e5ebc1',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 6,
      pvCount: 7,
      lift: 0.33511904761904754,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: 'dda15ab4bfad545a9456a76f05e5ebc1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T15:16:05.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '9a7f1b231ca2eaa578700bf15aee748f',
        affiliate: 'CBS',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 4,
      lift: 0.1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CBS',
      origEventId: '9a7f1b231ca2eaa578700bf15aee748f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T19:31:21.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8336d869781a099b4e748bbc134e24ba',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 0.02453703703703701,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: '8336d869781a099b4e748bbc134e24ba',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T14:16:12.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '529a162f081fa3af136051686ac88b05',
        affiliate: 'FOX',
        isci: 'GF35W1'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'FOX',
      origEventId: '529a162f081fa3af136051686ac88b05',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T17:58:48.915Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3cc83515811d933f8467967b4612c678',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 7,
      pvCount: 10,
      lift: 0.711706349206349,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: '3cc83515811d933f8467967b4612c678',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T18:44:00.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '879d17f0bb2e4ef29baa1c5025ed9552',
        affiliate: 'CBS',
        isci: 'GE31W2'
      },
      sessionCount: 2,
      pvCount: 8,
      lift: 0.818181818181818,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'CBS',
      origEventId: '879d17f0bb2e4ef29baa1c5025ed9552',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T14:23:15.105Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '002364e85407e2ce746d861d55397bac',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 3,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '002364e85407e2ce746d861d55397bac',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-07T21:45:26.646Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4b0f1530ee4a4c9a0e802fadbcbd8b07',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 4,
      pvCount: 8,
      lift: 0.17152777777777772,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '4b0f1530ee4a4c9a0e802fadbcbd8b07',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T19:57:21.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6c2c333ad00fd9335277bde401294ada',
        affiliate: 'CW',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.04490740740740741,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CW',
      origEventId: '6c2c333ad00fd9335277bde401294ada',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T10:30:01.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7930da060bbce9da91545c27f413e988',
        affiliate: 'CBS',
        isci: 'GE31W1'
      },
      sessionCount: 4,
      pvCount: 12,
      lift: 0.05450617283950615,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CBS',
      origEventId: '7930da060bbce9da91545c27f413e988',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:11:43.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '60c4b367580f8ab8c41ec2a22acf0bfc',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 5,
      pvCount: 6,
      lift: 0.4944444444444443,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: '60c4b367580f8ab8c41ec2a22acf0bfc',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T18:47:24.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '791f52fe23a439918526376bcd6625ac',
        affiliate: 'FOX',
        isci: 'GE31W1'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 0.004417989417989399,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'FOX',
      origEventId: '791f52fe23a439918526376bcd6625ac',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T14:26:42.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4d1dc28b6d2e1741906d022831b327d8',
        affiliate: 'CW',
        isci: 'GF35W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'CW',
      origEventId: '4d1dc28b6d2e1741906d022831b327d8',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T12:32:55.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e0750e37d3bbd2aeaa9a3d45ea2625f8',
        affiliate: 'ABC',
        isci: 'GE31W1'
      },
      sessionCount: 3,
      pvCount: 9,
      lift: 0.20277777777777772,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'ABC',
      origEventId: 'e0750e37d3bbd2aeaa9a3d45ea2625f8',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T16:55:42.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c13e4cc573ae011f86efa1a859cc3908',
        affiliate: 'ABC',
        isci: 'GE31W1'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: -0.003240740740740738,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'ABC',
      origEventId: 'c13e4cc573ae011f86efa1a859cc3908',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T16:14:37.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '36e3e0bd0232286d85e56d026f1e8811',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W2'
      },
      sessionCount: 2,
      pvCount: 8,
      lift: 2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'IND (KNLC)',
      origEventId: '36e3e0bd0232286d85e56d026f1e8811',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T16:59:19.630Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1aaa9a0c1f7bf862b8ade3de4d393bf0',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 0.36507936507936506,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '1aaa9a0c1f7bf862b8ade3de4d393bf0',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T15:46:20.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b565fd7ec1483c654072d838593c086f',
        affiliate: 'MNTV',
        isci: 'GF35W1'
      },
      sessionCount: 4,
      pvCount: 5,
      lift: 0.11111111111111097,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'MNTV',
      origEventId: 'b565fd7ec1483c654072d838593c086f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T14:47:45.105Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ce57871af1ee80ab3cf737e7dcd0ad5a',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 3,
      pvCount: 6,
      lift: 0.42857142857142855,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'ce57871af1ee80ab3cf737e7dcd0ad5a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T12:37:26.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '067b6f9ea23908b9de272085397bba01',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W2'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 0.5042929292929292,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'IND (KNLC)',
      origEventId: '067b6f9ea23908b9de272085397bba01',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T18:15:03.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4687eb8eb4bb8f55a3f9598fc79fb00a',
        affiliate: 'FOX',
        isci: 'GE31W1'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: -0.5000000000000001,
      baselineSessionCount: 5,
      baselineSessionsPerSecond: 0.016666666666666666,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'FOX',
      origEventId: '4687eb8eb4bb8f55a3f9598fc79fb00a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T15:24:19.148Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b0c2ed9865346621b5a1e616ad4b4172',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: 'b0c2ed9865346621b5a1e616ad4b4172',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T11:49:53.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2e23041cc60baf130282d638039d5a51',
        affiliate: 'CBS',
        isci: 'GE31W1'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 0.05925925925925925,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CBS',
      origEventId: '2e23041cc60baf130282d638039d5a51',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T15:24:31.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '9a08598bd84d4861e5dd75e7899618d9',
        affiliate: 'CBS',
        isci: 'GE31W2'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'CBS',
      origEventId: '9a08598bd84d4861e5dd75e7899618d9',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T00:45:47.489Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3c52fc540b59eacc4d91a8ed64f3005a',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 0.7041666666666665,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: '3c52fc540b59eacc4d91a8ed64f3005a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T16:11:09.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '13ae83f52f26798e015e9129541c1569',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: -0.1666666666666668,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: '13ae83f52f26798e015e9129541c1569',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T14:58:10.939Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4f03e45f9b6aef22291f7588447c6115',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W2'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'IND (KNLC)',
      origEventId: '4f03e45f9b6aef22291f7588447c6115',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T17:49:14.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '471269011ce8b13b70b82a0efb5e8bc2',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 3,
      pvCount: 15,
      lift: 0.4845238095238094,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '471269011ce8b13b70b82a0efb5e8bc2',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T16:45:26.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b4473986d28c39c337de01769e7d19d3',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 4,
      pvCount: 5,
      lift: 1.425396825396825,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'b4473986d28c39c337de01769e7d19d3',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T13:21:01.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f0a3d1a6ce236b281c2cb25fe1816cf1',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: 'f0a3d1a6ce236b281c2cb25fe1816cf1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T12:25:28.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a4b6b7dc72a9d4f8037992ea87daeb45',
        affiliate: 'CW',
        isci: 'GF35W1'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'CW',
      origEventId: 'a4b6b7dc72a9d4f8037992ea87daeb45',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T16:53:04.133Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ef351415a46e94cd49c7b2573bc54d86',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: -0.09444444444444448,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: 'ef351415a46e94cd49c7b2573bc54d86',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T17:44:10.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4a735646b2ba7890d435932c3846377f',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 2,
      pvCount: 14,
      lift: 0.5833333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '4a735646b2ba7890d435932c3846377f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T16:46:10.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '40b26deb440d12bd599249977d59d23a',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W2'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'IND (KNLC)',
      origEventId: '40b26deb440d12bd599249977d59d23a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T23:15:08.736Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e9e54b1ba0e726e45059df779fd3b3f1',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.14285714285714285,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'e9e54b1ba0e726e45059df779fd3b3f1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T11:27:32.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '5a0785b82a5913133fc26c7ac3faf19b',
        affiliate: 'CBS',
        isci: 'GE31W1'
      },
      sessionCount: 4,
      pvCount: 12,
      lift: 0.06803130511463842,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CBS',
      origEventId: '5a0785b82a5913133fc26c7ac3faf19b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:11:13.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'bca30fe8aec528034b8260159d25be73',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: -0.09090909090909098,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: 'bca30fe8aec528034b8260159d25be73',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T15:26:49.907Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '80aa7bfb012788f2cab4444e9e698ebe',
        affiliate: 'FOX',
        isci: 'GE31W1'
      },
      sessionCount: 4,
      pvCount: 16,
      lift: 2.333333333333333,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'FOX',
      origEventId: '80aa7bfb012788f2cab4444e9e698ebe',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T17:14:35.302Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6f14a8489f86b48ab233e5fcf21c26bb',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 4,
      pvCount: 10,
      lift: 4,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: '6f14a8489f86b48ab233e5fcf21c26bb',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T19:43:21.491Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '07cd1d7692e9b02723b02a61d9260aa6',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.14285714285714285,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '07cd1d7692e9b02723b02a61d9260aa6',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T11:27:59.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ceda78968ebdf9d0ad0b827baea85347',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W2'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'IND (KNLC)',
      origEventId: 'ceda78968ebdf9d0ad0b827baea85347',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-14T17:25:13.533Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'cd801fabd110c87742b243ef9314ce8d',
        affiliate: 'CW',
        isci: 'GE31W1'
      },
      sessionCount: 3,
      pvCount: 7,
      lift: 0.3407407407407407,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CW',
      origEventId: 'cd801fabd110c87742b243ef9314ce8d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T14:37:13.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b60bfd5afd89c6ffa3234d8c95c236e8',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: 2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: 'b60bfd5afd89c6ffa3234d8c95c236e8',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T17:14:02.374Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1209badfadd538bea1effbcfc2aa6fe2',
        affiliate: 'ABC',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'ABC',
      origEventId: '1209badfadd538bea1effbcfc2aa6fe2',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T16:53:09.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b91fe89f621be4b6d2bcf670f7c8085d',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'b91fe89f621be4b6d2bcf670f7c8085d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-07T15:50:17.421Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a9623c07a8b0414f8acf0756b9c8b4b6',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: 'a9623c07a8b0414f8acf0756b9c8b4b6',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T08:46:17.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '68028d57c41ae0b33ee26e9fe5d73208',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 3,
      pvCount: 9,
      lift: 1.801781817999753,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '68028d57c41ae0b33ee26e9fe5d73208',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T15:12:04.757Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3b77b35e0d67b9acc479449bada25ffc',
        affiliate: 'CW',
        isci: 'GE31W1'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: 0.09879629629629626,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CW',
      origEventId: '3b77b35e0d67b9acc479449bada25ffc',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T14:37:48.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c51fe1028b1bc00eeba50f80096d0059',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W2'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'IND (KNLC)',
      origEventId: 'c51fe1028b1bc00eeba50f80096d0059',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-07T20:58:05.757Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '45734000d7aee0148578213c1c9ce2f2',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 4,
      pvCount: 7,
      lift: 0.11285714285714282,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: '45734000d7aee0148578213c1c9ce2f2',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T18:12:37.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7f967e3e689c045afe9f2277abaead3d',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 4,
      pvCount: 5,
      lift: 0.05555555555555548,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '7f967e3e689c045afe9f2277abaead3d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T19:44:00.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f07492eb57c4e3d0859b167e5c43e04c',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 5,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'f07492eb57c4e3d0859b167e5c43e04c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T13:42:51.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd8f706ede675083ec2416f68c6fdad19',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'd8f706ede675083ec2416f68c6fdad19',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T10:44:14.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a6a8e869b3db37113ca2d62029076ed7',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 5,
      pvCount: 14,
      lift: 0.5926587301587302,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: 'a6a8e869b3db37113ca2d62029076ed7',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T16:45:08.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '66a1cc2d6c5d20393490ff3691392ffb',
        affiliate: 'NBC',
        isci: 'GG35W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GG35W1',
      affiliate: 'NBC',
      origEventId: '66a1cc2d6c5d20393490ff3691392ffb',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T14:23:27.000Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: 'eb470afdcebf805c108fbf00959f889a',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 6,
      pvCount: 19,
      lift: 0.746626984126984,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'eb470afdcebf805c108fbf00959f889a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T17:16:59.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'bd793a01c572db31b612d8df8d6715a0',
        affiliate: 'CBS',
        isci: 'GE31W1'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: 0.26666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CBS',
      origEventId: 'bd793a01c572db31b612d8df8d6715a0',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T19:32:01.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '9cb92d56dbd0cb510abf5d3e1391af57',
        affiliate: 'MNTV',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: -0.07707451499118166,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'MNTV',
      origEventId: '9cb92d56dbd0cb510abf5d3e1391af57',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T19:15:30.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '44331075667d363eaf78d6b2ab91c547',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W2'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'IND (KNLC)',
      origEventId: '44331075667d363eaf78d6b2ab91c547',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T17:49:14.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2bbeafe54a8252ff6074c4e235a87e20',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '2bbeafe54a8252ff6074c4e235a87e20',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T14:44:25.454Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1bed01bbeef8f0baa70698e9e5af98ec',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.14285714285714285,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '1bed01bbeef8f0baa70698e9e5af98ec',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T11:27:32.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a5c5fc60d89d7579cb4d5149ad6ef0af',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: -0.021428571428571446,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: 'a5c5fc60d89d7579cb4d5149ad6ef0af',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T17:44:56.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1728ac48c055304506b0e76cc80a2b1f',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W2'
      },
      sessionCount: 7,
      pvCount: 10,
      lift: 0.7272727272727272,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'IND (KNLC)',
      origEventId: '1728ac48c055304506b0e76cc80a2b1f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T18:42:03.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '55e24892f00d6d91611d1ce1fa3939da',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.7,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '55e24892f00d6d91611d1ce1fa3939da',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T13:25:55.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd05074e16fb38b887db29163167baa93',
        affiliate: 'CBS',
        isci: 'GE31W1'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 0.05972222222222222,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CBS',
      origEventId: 'd05074e16fb38b887db29163167baa93',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T15:24:11.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3cd727df8d54da2bd1c548573225d503',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 9,
      pvCount: 18,
      lift: 0.6221825396825396,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '3cd727df8d54da2bd1c548573225d503',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T17:18:29.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '583a53308e4342dcd13fdd211df40973',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 1.1152777777777776,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: '583a53308e4342dcd13fdd211df40973',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T18:12:08.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ddc5b73709f51e17c0ae51bb1e29831c',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: -0.30430277784665427,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'ddc5b73709f51e17c0ae51bb1e29831c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T14:56:52.618Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'feb0d160473946e1369f47108ab28b76',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'feb0d160473946e1369f47108ab28b76',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-07T10:50:47.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '621fe96e2c0716f8da9051a4e70d4abc',
        affiliate: 'FOX',
        isci: 'GE31W1'
      },
      sessionCount: 5,
      pvCount: 10,
      lift: 0.09544027778837415,
      baselineSessionCount: 5,
      baselineSessionsPerSecond: 0.016666666666666666,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'FOX',
      origEventId: '621fe96e2c0716f8da9051a4e70d4abc',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T19:26:47.006Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '587472b79598cb9670447018798dc293',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '587472b79598cb9670447018798dc293',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T12:17:32.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e4161d7430889d851c7b05119b4949c5',
        affiliate: 'MNTV',
        isci: 'GF35W1'
      },
      sessionCount: 1,
      pvCount: 9,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'MNTV',
      origEventId: 'e4161d7430889d851c7b05119b4949c5',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T00:18:24.452Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '10aed9cf5042f8d123f9d463fd69078a',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: '10aed9cf5042f8d123f9d463fd69078a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T08:48:09.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b9387e0c084f856bc434600a703a434a',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 3,
      pvCount: 7,
      lift: 0.013888888888888873,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'b9387e0c084f856bc434600a703a434a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T19:57:54.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e1050eca9d9de928fe6aef1ccefaac5c',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 7,
      pvCount: 7,
      lift: 5.363636363636363,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: 'e1050eca9d9de928fe6aef1ccefaac5c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T18:28:51.499Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b54cf0c95bcd28a0162d74437def893d',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 5,
      pvCount: 5,
      lift: 0.25363636363636366,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: 'b54cf0c95bcd28a0162d74437def893d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T12:45:16.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'bb2d6a5baa7fe34c69ce3510477b1e95',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 4,
      pvCount: 7,
      lift: 1.3181818181818181,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: 'bb2d6a5baa7fe34c69ce3510477b1e95',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T13:53:01.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6bacfbc8b03219a86cc5b5ad8a692b05',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '6bacfbc8b03219a86cc5b5ad8a692b05',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T12:25:28.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b2c89cae02055fea789d59d86b0dc56c',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 4,
      pvCount: 8,
      lift: 0.17152777777777772,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'b2c89cae02055fea789d59d86b0dc56c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T19:57:21.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '924e4ab68d083c1ce9fa3d6eb56028f4',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.6666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '924e4ab68d083c1ce9fa3d6eb56028f4',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T12:12:41.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b5d81b4ebaf7180716ce49752bd8b3b7',
        affiliate: 'ABC',
        isci: 'GE31W1'
      },
      sessionCount: 3,
      pvCount: 5,
      lift: 0.6944444444444444,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'ABC',
      origEventId: 'b5d81b4ebaf7180716ce49752bd8b3b7',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T16:59:24.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '84b9907dbae56b2866006fb9eb9e25a7',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 4,
      pvCount: 11,
      lift: 0.6029761904761903,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '84b9907dbae56b2866006fb9eb9e25a7',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T16:45:50.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd9a50d4ce320fa9da58b5e223a7deda6',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 3,
      pvCount: 5,
      lift: 3,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: 'd9a50d4ce320fa9da58b5e223a7deda6',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T18:41:14.746Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '44b49c6277f841b21023be280a3cad2c',
        affiliate: 'ABC',
        isci: 'GE31W1'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: -0.003240740740740738,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'ABC',
      origEventId: '44b49c6277f841b21023be280a3cad2c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T16:14:37.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd864c0e31547b135d445f0644201cd32',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: -0.28571428571428575,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: 'd864c0e31547b135d445f0644201cd32',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T18:44:29.245Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3c21acde927d7d33d756cfeaf21c6be0',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.037896825396825366,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '3c21acde927d7d33d756cfeaf21c6be0',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T13:20:38.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a11828a71f924274cca531ba5b762c16',
        affiliate: 'MNTV',
        isci: 'GE31W1'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.2777777777777778,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'MNTV',
      origEventId: 'a11828a71f924274cca531ba5b762c16',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-14T16:29:31.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1e9c89208e8b5f8a72581f83dd6defa4',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W2'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.6666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'IND (KNLC)',
      origEventId: '1e9c89208e8b5f8a72581f83dd6defa4',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T08:23:47.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3374af4c01da369a910cb71836e25655',
        affiliate: 'ABC',
        isci: 'GF35W1'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 1.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'ABC',
      origEventId: '3374af4c01da369a910cb71836e25655',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T16:31:56.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b6bcc0b114aca46800b5ba90d96295b3',
        affiliate: 'CBS',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 4,
      lift: 0.1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CBS',
      origEventId: 'b6bcc0b114aca46800b5ba90d96295b3',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T19:31:21.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e3dd4c5c7e4a8994f262a33d11b95046',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 1,
      pvCount: 5,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'e3dd4c5c7e4a8994f262a33d11b95046',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T13:44:20.304Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c7a670eccd9f76f8cf8c0cd51ffa14ff',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.09447451358165644,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'c7a670eccd9f76f8cf8c0cd51ffa14ff',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-07T16:45:21.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '74cb02371c7c93ec6634e513dfc1eb09',
        affiliate: 'ABC',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'ABC',
      origEventId: '74cb02371c7c93ec6634e513dfc1eb09',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T11:12:50.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e4291455d20f267591db620720aab507',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'e4291455d20f267591db620720aab507',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T10:49:53.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b018f32857dc8ee1856c0dd191055230',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.04545454545454549,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: 'b018f32857dc8ee1856c0dd191055230',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T12:29:59.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e4b5cb26fea9a59820c4670a1fa198d6',
        affiliate: 'ABC',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'ABC',
      origEventId: 'e4b5cb26fea9a59820c4670a1fa198d6',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T11:12:50.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'bea7e047c7805fa8c29e1c2dc1f84f0c',
        affiliate: 'CW',
        isci: 'GE31W1'
      },
      sessionCount: 5,
      pvCount: 8,
      lift: 0.11527006172839502,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CW',
      origEventId: 'bea7e047c7805fa8c29e1c2dc1f84f0c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T19:36:42.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b8199596afeafad47ebf854dcce96dd9',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 5,
      pvCount: 9,
      lift: 0.7857142857142856,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'b8199596afeafad47ebf854dcce96dd9',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T21:44:26.756Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '17b03adb8de174e32835a0f6f933037b',
        affiliate: 'MNTV',
        isci: 'GF35W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.21064814814814817,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'MNTV',
      origEventId: '17b03adb8de174e32835a0f6f933037b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T13:18:13.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0e31bc5667551085199d26083c70134c',
        affiliate: 'CW',
        isci: 'GF35W1'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: -0.45080833335717524,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'CW',
      origEventId: '0e31bc5667551085199d26083c70134c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T15:47:32.825Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '51815ca5e809c5cd1c7e9b581c7cb134',
        affiliate: 'MNTV',
        isci: 'GE31W1'
      },
      sessionCount: 9,
      pvCount: 19,
      lift: 1.0535185185185183,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'MNTV',
      origEventId: '51815ca5e809c5cd1c7e9b581c7cb134',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T15:37:32.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '17e7ebf34ec76467e882abc3451925cb',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W2'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.6666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'IND (KNLC)',
      origEventId: '17e7ebf34ec76467e882abc3451925cb',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T08:23:47.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1d678ac30e91fae2b2197709fae8080b',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 0.36507936507936506,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '1d678ac30e91fae2b2197709fae8080b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T15:46:20.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '998e2353dc529ad4ff56e9a3bfba88d8',
        affiliate: 'ABC',
        isci: 'GF35W1'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.2222222222222222,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'ABC',
      origEventId: '998e2353dc529ad4ff56e9a3bfba88d8',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T15:44:51.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b83ba3288bcd3d50790fe078a66ec1f0',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 5,
      pvCount: 13,
      lift: 0.6363636363636362,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: 'b83ba3288bcd3d50790fe078a66ec1f0',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T16:24:58.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a19cfdcb778c5e0b4ca64c091c6bfe3e',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'a19cfdcb778c5e0b4ca64c091c6bfe3e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T10:21:35.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0080e1e147272345e07a144866fd167a',
        affiliate: 'CW',
        isci: 'GE31W1'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 0.09014660493827159,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CW',
      origEventId: '0080e1e147272345e07a144866fd167a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T13:56:29.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ce9f510a110f25ffdcd0bfd299f58eea',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W2'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 0.5042929292929292,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'IND (KNLC)',
      origEventId: 'ce9f510a110f25ffdcd0bfd299f58eea',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T18:15:03.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2b9b8696a4d5f77b50e38e70cff31d5f',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 1.727272727272727,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '2b9b8696a4d5f77b50e38e70cff31d5f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T17:25:33.537Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '92c8f362de650fae702c4051c894a77a',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 5,
      pvCount: 5,
      lift: 0.25363636363636366,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '92c8f362de650fae702c4051c894a77a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T12:45:16.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '98b82f5291dcfcad35406a0f2e78d4f5',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '98b82f5291dcfcad35406a0f2e78d4f5',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T12:18:07.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c4389f2a22ba42425a33eadf0a0b2095',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 3,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: 'c4389f2a22ba42425a33eadf0a0b2095',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T17:12:43.287Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f5fe6e7bed51dfcf892f77f5578920e5',
        affiliate: 'MNTV',
        isci: 'GF35W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'MNTV',
      origEventId: 'f5fe6e7bed51dfcf892f77f5578920e5',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T00:47:20.864Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '5119e68c1bc108d0e9b4f69cbe52b490',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.818181818181818,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '5119e68c1bc108d0e9b4f69cbe52b490',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T18:53:04.765Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '37618e1eba1780afb13583058b6259aa',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: '37618e1eba1780afb13583058b6259aa',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T08:47:45.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1d064ac8f5fe602ab1405842baa5c54c',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 4,
      pvCount: 7,
      lift: 1.3181818181818181,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '1d064ac8f5fe602ab1405842baa5c54c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T13:53:01.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3c10d3cd74f3734af179c787a26bfcd9',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: 0.3818181818181818,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '3c10d3cd74f3734af179c787a26bfcd9',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T10:24:50.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4bd7614bae9a8bffd8efa44423edf620',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 6,
      pvCount: 19,
      lift: 0.781547619047619,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '4bd7614bae9a8bffd8efa44423edf620',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T17:15:52.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '5f540c9a6486496bf00c3855fad6f9e1',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 4,
      pvCount: 13,
      lift: 0.06088907785336357,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: '5f540c9a6486496bf00c3855fad6f9e1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:45:23.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '00c8e687573231a065f7c30388b8dd0d',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 3,
      pvCount: 4,
      lift: 1.6666666666666665,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '00c8e687573231a065f7c30388b8dd0d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T18:23:39.643Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '9749ae4a75eed3a3d80c5aeddcbc5202',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '9749ae4a75eed3a3d80c5aeddcbc5202',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T11:28:54.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'fa8480428f226a72ceb437d29d1d4eee',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: 'fa8480428f226a72ceb437d29d1d4eee',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T13:28:46.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '17ccc0793205418e3109ed4a68f6ee26',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 3,
      pvCount: 7,
      lift: 0.03263888888888886,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '17ccc0793205418e3109ed4a68f6ee26',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T19:57:27.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f60513cde0e4a0b5dbf8ea46519217cc',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 0.12678571428571428,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: 'f60513cde0e4a0b5dbf8ea46519217cc',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T13:45:07.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e064aa2b7a40b13e25c747bd41655bf1',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 7,
      pvCount: 12,
      lift: 0.425,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'e064aa2b7a40b13e25c747bd41655bf1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T18:57:57.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7987832022c9281931523a734de496cb',
        affiliate: 'CW',
        isci: 'GE31W2'
      },
      sessionCount: 6,
      pvCount: 7,
      lift: 0.4294949494949495,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'CW',
      origEventId: '7987832022c9281931523a734de496cb',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T14:25:22.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a3e71e91d7b6ee3d0c61edd39ecd7ca4',
        affiliate: 'MNTV',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: -0.07013007054673723,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'MNTV',
      origEventId: 'a3e71e91d7b6ee3d0c61edd39ecd7ca4',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T19:15:45.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '69a98fa63421574c1c02029110f025cd',
        affiliate: 'FOX',
        isci: 'GF35W1'
      },
      sessionCount: 5,
      pvCount: 5,
      lift: 0.19916666666666666,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'FOX',
      origEventId: '69a98fa63421574c1c02029110f025cd',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T12:46:37.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'e711a6098a3210dd752062ac6550dd5a',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 5,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'e711a6098a3210dd752062ac6550dd5a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T13:42:51.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '9f0c0a070732713fa13c4531a3896c0b',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 4,
      pvCount: 13,
      lift: 0.05041997354497354,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '9f0c0a070732713fa13c4531a3896c0b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:42:43.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '0fda80ffca5f595da63803b10bbe0868',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '0fda80ffca5f595da63803b10bbe0868',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T12:17:32.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd6e471e2c7f04d7f6c5ad4a860a46bed',
        affiliate: 'ABC',
        isci: 'GF35W1'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 0.8666666666666667,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'ABC',
      origEventId: 'd6e471e2c7f04d7f6c5ad4a860a46bed',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T11:24:04.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '805727c128bd73ca8a1e2e79a28dc577',
        affiliate: 'CW',
        isci: 'GE31W2'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'CW',
      origEventId: '805727c128bd73ca8a1e2e79a28dc577',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T19:25:25.723Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '30f657f2340e09cd39b6f6c8fae58bd7',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 5,
      pvCount: 8,
      lift: 0.5495322270322269,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '30f657f2340e09cd39b6f6c8fae58bd7',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T14:00:01.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2ed4f1181270c378c5c95ef76aae9cc3',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 5,
      pvCount: 6,
      lift: 0.7857142857142856,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: '2ed4f1181270c378c5c95ef76aae9cc3',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T20:45:24.677Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3492a7b5bd27375ef757a64f35626191',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 0.4839285714285713,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '3492a7b5bd27375ef757a64f35626191',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T17:16:59.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c40cfc06f017e3f73cddf1cd04eeb51c',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 4,
      pvCount: 8,
      lift: 0.17152777777777772,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'c40cfc06f017e3f73cddf1cd04eeb51c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T19:57:21.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '80832e7e514f7a029b2f9581400b5af6',
        affiliate: 'ABC',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'ABC',
      origEventId: '80832e7e514f7a029b2f9581400b5af6',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T16:15:14.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2b41b67c0d3ee36359acc266450445b4',
        affiliate: 'ABC',
        isci: 'GE31W1'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.6666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'ABC',
      origEventId: '2b41b67c0d3ee36359acc266450445b4',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T14:32:55.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2f1d0ebfd6f64ea61a89203da7d275c0',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 5,
      pvCount: 6,
      lift: 0.4944444444444443,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: '2f1d0ebfd6f64ea61a89203da7d275c0',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T18:46:50.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'af2c8d70f00c65c343ce2ee25f42e027',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 0.02453703703703701,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'af2c8d70f00c65c343ce2ee25f42e027',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T14:16:12.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '9fb55bbd75ac3782c9e1c5abea99ee16',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 2,
      pvCount: 3,
      lift: -0.0833333333333334,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '9fb55bbd75ac3782c9e1c5abea99ee16',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T18:59:04.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ebd0fad8ac97a8cf1b72dedfd950f630',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 4,
      pvCount: 5,
      lift: -0.4285714285714287,
      baselineSessionCount: 5,
      baselineSessionsPerSecond: 0.016666666666666666,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: 'ebd0fad8ac97a8cf1b72dedfd950f630',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T20:15:21.196Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '10db9a8b26aafc4efbfd404a25044719',
        affiliate: 'MNTV',
        isci: 'GF35W1'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'MNTV',
      origEventId: '10db9a8b26aafc4efbfd404a25044719',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T09:39:00.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7d1d8a5787320ec40437c767f8db326f',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 3,
      pvCount: 6,
      lift: -0.0841666666666667,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: '7d1d8a5787320ec40437c767f8db326f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T18:12:14.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'cd9d2bd219797908afcbc357dddeac4a',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'cd9d2bd219797908afcbc357dddeac4a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-07T17:43:06.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '993e7e838bb1fcd8e58e406ea2b7bdd7',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 3,
      pvCount: 9,
      lift: 0.18075396825396822,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '993e7e838bb1fcd8e58e406ea2b7bdd7',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T16:44:23.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1798b1ae66b3b791a4ca3b136f819e9d',
        affiliate: 'MNTV',
        isci: 'GE31W1'
      },
      sessionCount: 9,
      pvCount: 19,
      lift: 1.0535185185185183,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'MNTV',
      origEventId: '1798b1ae66b3b791a4ca3b136f819e9d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T15:37:32.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '326431c3e7be548c58ac874d35bc84a4',
        affiliate: 'CW',
        isci: 'GE31W2'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'CW',
      origEventId: '326431c3e7be548c58ac874d35bc84a4',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T11:48:23.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd48a0fd6a417144554d973544bd9d1f9',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 4,
      pvCount: 4,
      lift: 1.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'd48a0fd6a417144554d973544bd9d1f9',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T14:17:49.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '59ca93df3acf310dc1e970205e38d853',
        affiliate: 'FOX',
        isci: 'GE31W1'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: -0.0036375661375661473,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'FOX',
      origEventId: '59ca93df3acf310dc1e970205e38d853',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T14:27:16.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4956ced83a57b04a4068487022dde85a',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '4956ced83a57b04a4068487022dde85a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T12:14:00.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6d94431e8cb1f331c7bb50530f712902',
        affiliate: 'CBS',
        isci: 'GF35W1'
      },
      sessionCount: 2,
      pvCount: 15,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'CBS',
      origEventId: '6d94431e8cb1f331c7bb50530f712902',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T19:32:53.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '096c723fc8fda576c38c0be63d8f6d0a',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 5,
      pvCount: 7,
      lift: 0.8061507936507935,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '096c723fc8fda576c38c0be63d8f6d0a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T17:18:06.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a0fb7b7d4c1fb0c9b6d7cced9aa41898',
        affiliate: 'MNTV',
        isci: 'GF35W1'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: -0.15848055548138096,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'MNTV',
      origEventId: 'a0fb7b7d4c1fb0c9b6d7cced9aa41898',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T14:38:31.348Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '626c8f7c2fe60e673f8de6e3be12cabe',
        affiliate: 'CBS',
        isci: 'GE31W1'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: 0.26666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CBS',
      origEventId: '626c8f7c2fe60e673f8de6e3be12cabe',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T19:31:34.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'dae2be21c27c3e3940970c6e50955d85',
        affiliate: 'ABC',
        isci: 'GE31W1'
      },
      sessionCount: 3,
      pvCount: 9,
      lift: 0.20277777777777772,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'ABC',
      origEventId: 'dae2be21c27c3e3940970c6e50955d85',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T16:55:42.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '272099b1bb061cccaca7fac2df365d86',
        affiliate: 'CBS',
        isci: 'GE31W1'
      },
      sessionCount: 4,
      pvCount: 12,
      lift: 0.0657164902998236,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CBS',
      origEventId: '272099b1bb061cccaca7fac2df365d86',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:11:08.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '31a154e29fce361ad0cd70d6aace3436',
        affiliate: 'CBS',
        isci: 'GE31W1'
      },
      sessionCount: 4,
      pvCount: 12,
      lift: 0.06571649029982361,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CBS',
      origEventId: '31a154e29fce361ad0cd70d6aace3436',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:11:08.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '15518b47489342fa143a8b5926eed503',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 5,
      pvCount: 8,
      lift: 0.2490190474759964,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '15518b47489342fa143a8b5926eed503',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T15:16:45.581Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'a5e99302a312ddc3d343960eea2c6ace',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 4,
      pvCount: 17,
      lift: 0.32525000009271826,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'a5e99302a312ddc3d343960eea2c6ace',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T20:48:47.503Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '389044d10fe5e1ad2a9eccbe8c892c48',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '389044d10fe5e1ad2a9eccbe8c892c48',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-07T17:42:24.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f2991c8edd9bff81a0b74e6b19651701',
        affiliate: 'CBS',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 4,
      lift: 0.1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CBS',
      origEventId: 'f2991c8edd9bff81a0b74e6b19651701',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T19:31:25.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f332a46400b221f735811ab69749c426',
        affiliate: 'CBS',
        isci: 'GE31W1'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 0.04884259259259259,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CBS',
      origEventId: 'f332a46400b221f735811ab69749c426',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T15:24:41.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '912a58116469350cbf468ae5aef8b122',
        affiliate: 'CW',
        isci: 'GE31W1'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: 0.09879629629629626,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CW',
      origEventId: '912a58116469350cbf468ae5aef8b122',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T14:37:48.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f2be5326d1feb983bfd31664c5a76e3a',
        affiliate: 'MNTV',
        isci: 'GE31W1'
      },
      sessionCount: 10,
      pvCount: 20,
      lift: 0.26157407407407407,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'MNTV',
      origEventId: 'f2be5326d1feb983bfd31664c5a76e3a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T15:36:40.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f56f3812c971d9d819b789af055dd09a',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.42857142857142844,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'f56f3812c971d9d819b789af055dd09a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T22:16:21.163Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c9a892983b4810f35cf392cd1744332f',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 4,
      pvCount: 5,
      lift: 0.8650793650793651,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'c9a892983b4810f35cf392cd1744332f',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T15:46:35.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'cc02c6d9f3c373bb4a6a610a282101f1',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 3,
      pvCount: 13,
      lift: -0.18115079365079365,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: 'cc02c6d9f3c373bb4a6a610a282101f1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T18:43:07.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1e91b2e4c6862c2151790d1001c0b858',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 5,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '1e91b2e4c6862c2151790d1001c0b858',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T13:43:20.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '323af28450d4ab104a07825c7ad9ed3b',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.5833333333333334,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: '323af28450d4ab104a07825c7ad9ed3b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T20:15:46.367Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4b00091cd0774b050b9721a255bfd736',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 6,
      pvCount: 6,
      lift: 1.727272727272727,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '4b00091cd0774b050b9721a255bfd736',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T17:30:01.524Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '726e202da5a50f3b192e17081e3b0c58',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 5,
      pvCount: 8,
      lift: 0.5597594997594997,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '726e202da5a50f3b192e17081e3b0c58',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T13:59:52.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b5eaeda150d670d265a2d3c9081ef04e',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 1.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'b5eaeda150d670d265a2d3c9081ef04e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T16:49:05.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f490a51b609534f6b46f46c9b14ce473',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: 'f490a51b609534f6b46f46c9b14ce473',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T16:49:56.270Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f0e6049e63ea5df6741fcd0c757b0b8a',
        affiliate: 'ABC',
        isci: 'GE31W1'
      },
      sessionCount: 4,
      pvCount: 7,
      lift: 1.5277777777777777,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'ABC',
      origEventId: 'f0e6049e63ea5df6741fcd0c757b0b8a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T17:00:04.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6baeafd7d9583f62cfbf008f926ad4c8',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 7,
      pvCount: 8,
      lift: 0.33511904761904754,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '6baeafd7d9583f62cfbf008f926ad4c8',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T14:14:21.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '47ae366ecdd7f3a928e4d8ecc55df350',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: -0.2585696971777714,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '47ae366ecdd7f3a928e4d8ecc55df350',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:19:20.323Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '886f52e082769bfcf64cc9bc65fb94c0',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 4,
      pvCount: 7,
      lift: 0.28194444444444444,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: '886f52e082769bfcf64cc9bc65fb94c0',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T18:58:47.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '5160fa9e815b0c0cf0415af7d5e63d1e',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W2'
      },
      sessionCount: 7,
      pvCount: 10,
      lift: 0.7272727272727272,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'IND (KNLC)',
      origEventId: '5160fa9e815b0c0cf0415af7d5e63d1e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T18:42:03.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '526db979332df3a28286159047e4a510',
        affiliate: 'CBS',
        isci: 'GE31W1'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 0.05972222222222222,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CBS',
      origEventId: '526db979332df3a28286159047e4a510',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T15:24:11.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '98e54dc77d1791d5d30be27f7ee7b97d',
        affiliate: 'CW',
        isci: 'GE31W2'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'CW',
      origEventId: '98e54dc77d1791d5d30be27f7ee7b97d',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T12:50:16.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6d8502b1bc9b2b10b5b9cfb0c4127057',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 5,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '6d8502b1bc9b2b10b5b9cfb0c4127057',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T13:42:51.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'c7e5e993aadf3e4f67d4c6300cd616a1',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 2,
      pvCount: 4,
      lift: 1.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'c7e5e993aadf3e4f67d4c6300cd616a1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T16:11:42.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7dc0c42f0d150b1fecce9a68ffcb243e',
        affiliate: 'NBC',
        isci: 'GG35W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GG35W1',
      affiliate: 'NBC',
      origEventId: '7dc0c42f0d150b1fecce9a68ffcb243e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T14:59:33.309Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '219b37d88a69f98a30d7b4982a33089b',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 6,
      pvCount: 16,
      lift: 0.3053571428571428,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: '219b37d88a69f98a30d7b4982a33089b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T16:45:52.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '98d3f8618954352c0300d6442cfde48e',
        affiliate: 'ABC',
        isci: 'GE31W1'
      },
      sessionCount: 4,
      pvCount: 7,
      lift: 0.5310185185185183,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'ABC',
      origEventId: '98d3f8618954352c0300d6442cfde48e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T15:17:24.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f2049029e98420fb95c566eef4d31fed',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 0.25,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'f2049029e98420fb95c566eef4d31fed',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T11:29:18.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '553228767d450b9b4c293d4955d26f15',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.16666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '553228767d450b9b4c293d4955d26f15',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T11:29:08.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '94f076695e7a3b7d73ad684d0df7ad72',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 5,
      pvCount: 5,
      lift: 0.6863095238095238,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: '94f076695e7a3b7d73ad684d0df7ad72',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T14:45:11.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '6537d432d23d3a1146181f40ee3a56a3',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.0037397721326292706,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '6537d432d23d3a1146181f40ee3a56a3',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-07T16:46:06.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7aa5281c05296c0b6246c7c40b57769c',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 7,
      pvCount: 15,
      lift: 0.6666666666666666,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '7aa5281c05296c0b6246c7c40b57769c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T16:27:33.029Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '04ed64356fbc6979de18051c23f30b27',
        affiliate: 'CBS',
        isci: 'GE31W1'
      },
      sessionCount: 2,
      pvCount: 5,
      lift: 0.26666666666666666,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'CBS',
      origEventId: '04ed64356fbc6979de18051c23f30b27',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T19:31:34.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8a713791238ec670cb2f222dda5f60ae',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.3333333333333333,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '8a713791238ec670cb2f222dda5f60ae',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T12:25:28.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '58033864e0904fc96932efca3046285b',
        affiliate: 'ABC',
        isci: 'GE31W1'
      },
      sessionCount: 3,
      pvCount: 6,
      lift: -0.07083333333333335,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'ABC',
      origEventId: '58033864e0904fc96932efca3046285b',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T14:33:41.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '8641791586549dc414ef5b888c2dba6e',
        affiliate: 'CW',
        isci: 'GE31W2'
      },
      sessionCount: 6,
      pvCount: 7,
      lift: 0.4381529581529582,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'CW',
      origEventId: '8641791586549dc414ef5b888c2dba6e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T14:25:30.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '37d0b8a1e0bb01d3873273125501823a',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 4,
      pvCount: 13,
      lift: 0.05041997354497354,
      baselineSessionCount: 3,
      baselineSessionsPerSecond: 0.01,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '37d0b8a1e0bb01d3873273125501823a',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T15:42:43.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '377c44db952277368c4325b76b7e9e16',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 7,
      pvCount: 10,
      lift: 0.2527777777777777,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '377c44db952277368c4325b76b7e9e16',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T14:14:44.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'd620471489ee5beb92ceab70a98dc32e',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.6666666666666664,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'd620471489ee5beb92ceab70a98dc32e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T13:47:50.992Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '442f30bc25e21f4ed08b6cef429f65d0',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 2,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: '442f30bc25e21f4ed08b6cef429f65d0',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T23:58:01.728Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '494e258e276edeb86de28cdcf2f24bfe',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 6,
      pvCount: 19,
      lift: 0.781547619047619,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '494e258e276edeb86de28cdcf2f24bfe',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T17:16:37.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7f5c59ba1f79adf87b7e85bae65eb412',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 3,
      pvCount: 6,
      lift: 1.4999999999999996,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: '7f5c59ba1f79adf87b7e85bae65eb412',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T13:17:46.718Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1d2b2ea16ff692380d3c25bc0d01d829',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 10,
      pvCount: 14,
      lift: 0.6285714285714284,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '1d2b2ea16ff692380d3c25bc0d01d829',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T14:16:34.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'f2e5721d43facb67941a44170f677430',
        affiliate: 'ABC',
        isci: 'GF35W1'
      },
      sessionCount: 3,
      pvCount: 5,
      lift: 0.23053749998410533,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'ABC',
      origEventId: 'f2e5721d43facb67941a44170f677430',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-12T16:23:38.634Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '36f9b76c22ad2b916ea29e0abc899095',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 6,
      pvCount: 19,
      lift: 0.7117063492063491,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '36f9b76c22ad2b916ea29e0abc899095',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T17:15:08.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '88c73742d8b11db49f57887c520d7490',
        affiliate: 'MNTV',
        isci: 'GF35W1'
      },
      sessionCount: 2,
      pvCount: 10,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'MNTV',
      origEventId: '88c73742d8b11db49f57887c520d7490',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T19:47:14.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3f69a1578439502396e2e5a7fe3cbc2c',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 2,
      pvCount: 10,
      lift: -0.20059523809523808,
      baselineSessionCount: 4,
      baselineSessionsPerSecond: 0.013333333333333334,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: '3f69a1578439502396e2e5a7fe3cbc2c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T18:44:36.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'ebda2633d13de13e127daeae410b5c31',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 3,
      pvCount: 3,
      lift: 1.1428571428571426,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: 'ebda2633d13de13e127daeae410b5c31',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T21:48:26.121Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '7250368989c5d2dc41cc0dc7ccf5e5c8',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 3,
      pvCount: 6,
      lift: 0.8908730158730158,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '7250368989c5d2dc41cc0dc7ccf5e5c8',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T16:44:42.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '04be38e235cb44ee448c254055dcc1a1',
        affiliate: 'MNTV',
        isci: 'GE31W1'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.2777777777777778,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'MNTV',
      origEventId: '04be38e235cb44ee448c254055dcc1a1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-14T16:29:23.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '15fc6ce8f301b0e286af0ed2c4809399',
        affiliate: 'NBC',
        isci: 'GE31W2'
      },
      sessionCount: 4,
      pvCount: 13,
      lift: 0.818181818181818,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'NBC',
      origEventId: '15fc6ce8f301b0e286af0ed2c4809399',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T13:29:15.900Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'fa67d1c6e13f01ddc84661759b9f75f1',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W2'
      },
      sessionCount: 2,
      pvCount: 2,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GE31W2',
      affiliate: 'IND (KNLC)',
      origEventId: 'fa67d1c6e13f01ddc84661759b9f75f1',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T17:49:27.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '1e9495b12dec8a7e311a7a21e71dac7c',
        affiliate: 'MNTV',
        isci: 'GF35W1'
      },
      sessionCount: 2,
      pvCount: 10,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'MNTV',
      origEventId: '1e9495b12dec8a7e311a7a21e71dac7c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T19:47:50.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '2343eb93aa42de7f34550f02992b90b5',
        affiliate: 'MNTV',
        isci: 'GG35W1'
      },
      sessionCount: 1,
      pvCount: 2,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 30,
      isci: 'GG35W1',
      affiliate: 'MNTV',
      origEventId: '2343eb93aa42de7f34550f02992b90b5',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-13T22:55:03.501Z',
      dmaName: 'Springfield MO, United States'
    },
    {
      _id: {
        origEventId: '7199e80130b10d78c5e217bf95928034',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: '7199e80130b10d78c5e217bf95928034',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-08T15:16:15.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '82623ccd30739af9001612d7a2253e14',
        affiliate: 'IND (KNLC)',
        isci: 'GF31W1'
      },
      sessionCount: 7,
      pvCount: 16,
      lift: 0.2906349206349206,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '82623ccd30739af9001612d7a2253e14',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T17:19:12.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b26854327ba0f140e841cbd30ad2b2d4',
        affiliate: 'ABC',
        isci: 'GF35W1'
      },
      sessionCount: 4,
      pvCount: 6,
      lift: 1.2685185185185182,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'ABC',
      origEventId: 'b26854327ba0f140e841cbd30ad2b2d4',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T15:54:07.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '4d10cac7980fb6fa6b25fdaeb6c779ff',
        affiliate: 'IND (KNLC)',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 1,
      lift: 0.14285714285714285,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'IND (KNLC)',
      origEventId: '4d10cac7980fb6fa6b25fdaeb6c779ff',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-10T11:27:32.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '3c538f44fa5786b4a7ba6e49b91921ae',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 1,
      pvCount: 10,
      lift: 1,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: '3c538f44fa5786b4a7ba6e49b91921ae',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T23:46:56.488Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '94d02d4cd85208f766fbe638696306cd',
        affiliate: 'ABC',
        isci: 'GE31W1'
      },
      sessionCount: 5,
      pvCount: 8,
      lift: 0.8513888888888886,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'ABC',
      origEventId: '94d02d4cd85208f766fbe638696306cd',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T15:17:47.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '21be8de9b72307759aa8c29a4c5c1f3c',
        affiliate: 'IND (KNLC)',
        isci: 'GF35W1'
      },
      sessionCount: 3,
      pvCount: 5,
      lift: 2.5,
      baselineSessionCount: 0,
      baselineSessionsPerSecond: 0,
      eventLength: 60,
      isci: 'GF35W1',
      affiliate: 'IND (KNLC)',
      origEventId: '21be8de9b72307759aa8c29a4c5c1f3c',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-11T15:48:43.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: '57ce0ffc5f64df22b8778e153d1046db',
        affiliate: 'IND (NTVI)',
        isci: 'GF31W1'
      },
      sessionCount: 3,
      pvCount: 9,
      lift: 0.4839285714285714,
      baselineSessionCount: 1,
      baselineSessionsPerSecond: 0.0033333333333333335,
      eventLength: 120,
      isci: 'GF31W1',
      affiliate: 'IND (NTVI)',
      origEventId: '57ce0ffc5f64df22b8778e153d1046db',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-06T13:45:52.000Z',
      dmaName: 'St. Louis MO, United States'
    },
    {
      _id: {
        origEventId: 'b72a1aee45edd2ec71e3759fc8bb156e',
        affiliate: 'MNTV',
        isci: 'GE31W1'
      },
      sessionCount: 1,
      pvCount: 3,
      lift: -0.07707451499118166,
      baselineSessionCount: 2,
      baselineSessionsPerSecond: 0.006666666666666667,
      eventLength: 60,
      isci: 'GE31W1',
      affiliate: 'MNTV',
      origEventId: 'b72a1aee45edd2ec71e3759fc8bb156e',
      brand: '624dfcaee48f5e0d04a49ee6',
      eventTimestamp: '2022-05-09T19:15:30.000Z',
      dmaName: 'St. Louis MO, United States'
    }
  ];

  public static mmRes = [
    {
      _id: {
        leadSource: 'sep 2022'
      },
      leadSource: 'sep 2022',
      sessionCount: 1
    },
    {
      _id: {
        leadSource: 'google-ppc'
      },
      leadSource: 'google-ppc',
      sessionCount: 106
    },
    {
      _id: {
        leadSource: 'yahoo'
      },
      leadSource: 'yahoo',
      sessionCount: 6
    },
    {
      _id: {
        leadSource: 'direct'
      },
      leadSource: 'direct',
      sessionCount: 103
    },
    {
      _id: {
        leadSource: 'facebook'
      },
      leadSource: 'facebook',
      sessionCount: 5
    },
    {
      _id: {
        leadSource: 'bing'
      },
      leadSource: 'bing',
      sessionCount: 57
    },
    {
      _id: {
        leadSource: 'other'
      },
      leadSource: 'other',
      sessionCount: 19
    },
    {
      _id: {
        leadSource: 'google-organic'
      },
      leadSource: 'google-organic',
      sessionCount: 83
    }
  ];

  public static nMMRes = [
    {
      _id: {
        leadSource: 'landing page'
      },
      leadSource: 'landing page',
      sessionCount: 3
    },
    {
      _id: {
        leadSource: 'other'
      },
      leadSource: 'other',
      sessionCount: 2524
    },
    {
      _id: {
        leadSource: 'google-organic'
      },
      leadSource: 'google-organic',
      sessionCount: 7943
    },
    {
      _id: {
        leadSource: 'yahoo'
      },
      leadSource: 'yahoo',
      sessionCount: 492
    },
    {
      _id: {
        leadSource: 'direct'
      },
      leadSource: 'direct',
      sessionCount: 8097
    },
    {
      _id: {
        leadSource: 'facebook'
      },
      leadSource: 'facebook',
      sessionCount: 269
    },
    {
      _id: {
        leadSource: 'bing'
      },
      leadSource: 'bing',
      sessionCount: 2045
    },
    {
      _id: {
        leadSource: 'youtube'
      },
      leadSource: 'youtube',
      sessionCount: 1
    },
    {
      _id: {
        leadSource: 'aep 2022'
      },
      leadSource: 'aep 2022',
      sessionCount: 2
    },
    {
      _id: {
        leadSource: 'aep eblast - post dispatch'
      },
      leadSource: 'aep eblast - post dispatch',
      sessionCount: 7
    },
    {
      _id: {
        leadSource: 'hs_email'
      },
      leadSource: 'hs_email',
      sessionCount: 1
    },
    {
      _id: {
        leadSource: 'google-ppc'
      },
      leadSource: 'google-ppc',
      sessionCount: 15487
    },
    {
      _id: {
        leadSource: 'adwords'
      },
      leadSource: 'adwords',
      sessionCount: 73
    },
    {
      _id: {
        leadSource: 'linkedin'
      },
      leadSource: 'linkedin',
      sessionCount: 7
    },
    {
      _id: {
        leadSource: 'sep 2022'
      },
      leadSource: 'sep 2022',
      sessionCount: 82
    },
    {
      _id: {
        leadSource: 'hs_automation'
      },
      leadSource: 'hs_automation',
      sessionCount: 5
    }
  ];

  public static test1mmRes = [
    {
      _id: {
        leadSource: 'direct'
      },
      leadSource: 'direct',
      sessionCount: 30
    },
    {
      _id: {
        leadSource: 'google-ppc'
      },
      leadSource: 'google-ppc',
      sessionCount: 35
    },
    {
      _id: {
        leadSource: 'google-organic'
      },
      leadSource: 'google-organic',
      sessionCount: 30
    },
    {
      _id: {
        leadSource: 'other'
      },
      leadSource: 'other',
      sessionCount: 5
    },
    {
      _id: {
        leadSource: 'bing'
      },
      leadSource: 'bing',
      sessionCount: 16
    }
  ];

  public static test2mmRes = [
    {
      _id: {
        leadSource: 'direct'
      },
      leadSource: 'direct',
      sessionCount: 40
    },
    {
      _id: {
        leadSource: 'facebook'
      },
      leadSource: 'facebook',
      sessionCount: 3
    },
    {
      _id: {
        leadSource: 'bing'
      },
      leadSource: 'bing',
      sessionCount: 17
    },
    {
      _id: {
        leadSource: 'yahoo'
      },
      leadSource: 'yahoo',
      sessionCount: 3
    },
    {
      _id: {
        leadSource: 'other'
      },
      leadSource: 'other',
      sessionCount: 5
    },
    {
      _id: {
        leadSource: 'google-organic'
      },
      leadSource: 'google-organic',
      sessionCount: 25
    },
    {
      _id: {
        leadSource: 'sep 2022'
      },
      leadSource: 'sep 2022',
      sessionCount: 1
    },
    {
      _id: {
        leadSource: 'google-ppc'
      },
      leadSource: 'google-ppc',
      sessionCount: 33
    }
  ];

  public static test3mmRes = [];

  public static test4mmRes = [];

  public static test5mmRes = [
    {
      _id: {
        leadSource: 'google-ppc'
      },
      leadSource: 'google-ppc',
      sessionCount: 7
    },
    {
      _id: {
        leadSource: 'other'
      },
      leadSource: 'other',
      sessionCount: 3
    },
    {
      _id: {
        leadSource: 'google-organic'
      },
      leadSource: 'google-organic',
      sessionCount: 7
    },
    {
      _id: {
        leadSource: 'direct'
      },
      leadSource: 'direct',
      sessionCount: 9
    },
    {
      _id: {
        leadSource: 'bing'
      },
      leadSource: 'bing',
      sessionCount: 10
    }
  ];

  public static test6mmRes = [
    {
      _id: {
        leadSource: 'google-organic'
      },
      leadSource: 'google-organic',
      sessionCount: 19
    },
    {
      _id: {
        leadSource: 'other'
      },
      leadSource: 'other',
      sessionCount: 5
    },
    {
      _id: {
        leadSource: 'bing'
      },
      leadSource: 'bing',
      sessionCount: 16
    },
    {
      _id: {
        leadSource: 'yahoo'
      },
      leadSource: 'yahoo',
      sessionCount: 3
    },
    {
      _id: {
        leadSource: 'direct'
      },
      leadSource: 'direct',
      sessionCount: 28
    },
    {
      _id: {
        leadSource: 'facebook'
      },
      leadSource: 'facebook',
      sessionCount: 2
    },
    {
      _id: {
        leadSource: 'google-ppc'
      },
      leadSource: 'google-ppc',
      sessionCount: 35
    }
  ];

    public static timeOfDay = [
        {
            "_id": {
                "origEventId": "4687eb8eb4bb8f55a3f9598fc79fb00a",
                "affiliate": "FOX",
                "isci": "GF31W1"
            },
            "sessionCount": 3,
            "pvCount": 3,
            "lift": -0.5000000000000001,
            "baselineSessionCount": 5,
            "baselineSessionsPerSecond": 0.016666666666666666,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "FOX",
            "origEventId": "4687eb8eb4bb8f55a3f9598fc79fb00a",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-06T15:24:19.148Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "b0c2ed9865346621b5a1e616ad4b4172",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 0.16666666666666666,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "b0c2ed9865346621b5a1e616ad4b4172",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-11T11:49:53.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "38b834fc49f53eb9582aec863281212a",
                "affiliate": "MNTV",
                "isci": "GE31W1"
            },
            "sessionCount": 1,
            "pvCount": 2,
            "lift": 1,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W1",
            "affiliate": "MNTV",
            "origEventId": "38b834fc49f53eb9582aec863281212a",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-13T17:29:46.000Z",
            "dmaName": "Springfield MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "2e23041cc60baf130282d638039d5a51",
                "affiliate": "CBS",
                "isci": "GF31W1"
            },
            "sessionCount": 2,
            "pvCount": 4,
            "lift": 0.05925925925925925,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CBS",
            "origEventId": "2e23041cc60baf130282d638039d5a51",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T15:24:31.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "9a08598bd84d4861e5dd75e7899618d9",
                "affiliate": "CBS",
                "isci": "GE31W2"
            },
            "sessionCount": 2,
            "pvCount": 4,
            "lift": 2,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "CBS",
            "origEventId": "9a08598bd84d4861e5dd75e7899618d9",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T00:45:47.489Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "prime_time"
        },
        {
            "_id": {
                "origEventId": "c13e4cc573ae011f86efa1a859cc3908",
                "affiliate": "ABC",
                "isci": "GF31W1"
            },
            "sessionCount": 2,
            "pvCount": 3,
            "lift": -0.003240740740740738,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "ABC",
            "origEventId": "c13e4cc573ae011f86efa1a859cc3908",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T16:14:37.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "b565fd7ec1483c654072d838593c086f",
                "affiliate": "MNTV",
                "isci": "GF35W1"
            },
            "sessionCount": 4,
            "pvCount": 5,
            "lift": 0.11111111111111097,
            "baselineSessionCount": 3,
            "baselineSessionsPerSecond": 0.01,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "MNTV",
            "origEventId": "b565fd7ec1483c654072d838593c086f",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T14:47:45.105Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "4d1dc28b6d2e1741906d022831b327d8",
                "affiliate": "CW",
                "isci": "GF35W1"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 0.5,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "CW",
            "origEventId": "4d1dc28b6d2e1741906d022831b327d8",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-11T12:32:55.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "e0750e37d3bbd2aeaa9a3d45ea2625f8",
                "affiliate": "ABC",
                "isci": "GF31W1"
            },
            "sessionCount": 3,
            "pvCount": 9,
            "lift": 0.20277777777777772,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "ABC",
            "origEventId": "e0750e37d3bbd2aeaa9a3d45ea2625f8",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T16:55:42.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "6c2c333ad00fd9335277bde401294ada",
                "affiliate": "CW",
                "isci": "GF31W1"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": -0.04490740740740741,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CW",
            "origEventId": "6c2c333ad00fd9335277bde401294ada",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-13T10:30:01.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "7930da060bbce9da91545c27f413e988",
                "affiliate": "CBS",
                "isci": "GF31W1"
            },
            "sessionCount": 4,
            "pvCount": 12,
            "lift": 0.05450617283950615,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CBS",
            "origEventId": "7930da060bbce9da91545c27f413e988",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T15:11:43.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "791f52fe23a439918526376bcd6625ac",
                "affiliate": "FOX",
                "isci": "GF31W1"
            },
            "sessionCount": 3,
            "pvCount": 3,
            "lift": 0.004417989417989399,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "FOX",
            "origEventId": "791f52fe23a439918526376bcd6625ac",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T14:26:42.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "9a7f1b231ca2eaa578700bf15aee748f",
                "affiliate": "CBS",
                "isci": "GF31W1"
            },
            "sessionCount": 1,
            "pvCount": 4,
            "lift": 0.1,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CBS",
            "origEventId": "9a7f1b231ca2eaa578700bf15aee748f",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-06T19:31:21.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "879d17f0bb2e4ef29baa1c5025ed9552",
                "affiliate": "CBS",
                "isci": "GE31W2"
            },
            "sessionCount": 2,
            "pvCount": 8,
            "lift": 0.818181818181818,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "CBS",
            "origEventId": "879d17f0bb2e4ef29baa1c5025ed9552",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-06T14:23:15.105Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "e5213b32a3fd01ebb3970a0810761662",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 2,
            "pvCount": 3,
            "lift": -0.5454545454545455,
            "baselineSessionCount": 4,
            "baselineSessionsPerSecond": 0.013333333333333334,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "e5213b32a3fd01ebb3970a0810761662",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-13T15:15:33.150Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "529a162f081fa3af136051686ac88b05",
                "affiliate": "FOX",
                "isci": "GF35W1"
            },
            "sessionCount": 2,
            "pvCount": 2,
            "lift": 2,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "FOX",
            "origEventId": "529a162f081fa3af136051686ac88b05",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-13T17:58:48.915Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "965c72d42c9a51d91317e797af683f43",
                "affiliate": "CW",
                "isci": "GF31W1"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": -0.034490740740740745,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CW",
            "origEventId": "965c72d42c9a51d91317e797af683f43",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-13T10:29:39.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "2da6bc57636d7d9288f1828fce1b6901",
                "affiliate": "CW",
                "isci": "GE31W2"
            },
            "sessionCount": 2,
            "pvCount": 7,
            "lift": 0.818181818181818,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "CW",
            "origEventId": "2da6bc57636d7d9288f1828fce1b6901",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T17:50:17.677Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "658673bb0f5ee8c8f81452d9aee62d56",
                "affiliate": "MNTV",
                "isci": "GE31W1"
            },
            "sessionCount": 1,
            "pvCount": 2,
            "lift": 1,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W1",
            "affiliate": "MNTV",
            "origEventId": "658673bb0f5ee8c8f81452d9aee62d56",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-13T17:28:48.061Z",
            "dmaName": "Springfield MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "f6e5305c13d8d7463d57dfed5acfe9ce",
                "affiliate": "MNTV",
                "isci": "GF31W1"
            },
            "sessionCount": 1,
            "pvCount": 3,
            "lift": -0.07707451499118165,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "MNTV",
            "origEventId": "f6e5305c13d8d7463d57dfed5acfe9ce",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T19:15:30.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "0a410f37359624dc2584ad969130de53",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 4,
            "pvCount": 5,
            "lift": 2.5,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "0a410f37359624dc2584ad969130de53",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T17:45:21.669Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "d1a615aaa57b3a31861ac1dbb5fd8279",
                "affiliate": "ABC",
                "isci": "GF35W1"
            },
            "sessionCount": 7,
            "pvCount": 14,
            "lift": 0.4222222222222221,
            "baselineSessionCount": 3,
            "baselineSessionsPerSecond": 0.01,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "ABC",
            "origEventId": "d1a615aaa57b3a31861ac1dbb5fd8279",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T16:37:27.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "f3742b278fce1a55a293700918bb8057",
                "affiliate": "CBS",
                "isci": "GF31W1"
            },
            "sessionCount": 1,
            "pvCount": 4,
            "lift": 0.1,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CBS",
            "origEventId": "f3742b278fce1a55a293700918bb8057",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-06T19:31:21.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "3a74edce7bdbd7e9d5da5f6d0541e4fb",
                "affiliate": "MNTV",
                "isci": "GF31W1"
            },
            "sessionCount": 2,
            "pvCount": 2,
            "lift": 0.2777777777777778,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "MNTV",
            "origEventId": "3a74edce7bdbd7e9d5da5f6d0541e4fb",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-14T16:29:46.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "8e9932924ffbfa966af321d7fef942b9",
                "affiliate": "MNTV",
                "isci": "GF31W1"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 0.1111111111111111,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "MNTV",
            "origEventId": "8e9932924ffbfa966af321d7fef942b9",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-14T16:29:07.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "fd84ec4eff81f6609b1b894dc61a6339",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 0.2,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "fd84ec4eff81f6609b1b894dc61a6339",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T12:14:00.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "826a6a70e07200737cc6574f3d00640f",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 4,
            "pvCount": 6,
            "lift": 4,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "826a6a70e07200737cc6574f3d00640f",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-11T15:59:55.529Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "4517dfd0f570b7f0967db291fd24625a",
                "affiliate": "MNTV",
                "isci": "GF35W1"
            },
            "sessionCount": 1,
            "pvCount": 2,
            "lift": 0.3333333333333333,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "MNTV",
            "origEventId": "4517dfd0f570b7f0967db291fd24625a",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-06T09:39:00.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "overnight"
        },
        {
            "_id": {
                "origEventId": "b85912581740ce3e709c78b634510e6b",
                "affiliate": "CBS",
                "isci": "GF31W1"
            },
            "sessionCount": 4,
            "pvCount": 12,
            "lift": 0.05450617283950615,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CBS",
            "origEventId": "b85912581740ce3e709c78b634510e6b",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T15:11:43.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "2728a12c8832a154ddf12796fcfc9c8e",
                "affiliate": "ABC",
                "isci": "GF35W1"
            },
            "sessionCount": 3,
            "pvCount": 4,
            "lift": 0.48379629629629617,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "ABC",
            "origEventId": "2728a12c8832a154ddf12796fcfc9c8e",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T15:54:42.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "4d68285076737df726fa017f8d6d5496",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 3,
            "pvCount": 12,
            "lift": 3,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "4d68285076737df726fa017f8d6d5496",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T21:13:36.466Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_fringe"
        },
        {
            "_id": {
                "origEventId": "2910357582e33e09c293ecdcf1e28789",
                "affiliate": "CW",
                "isci": "GF31W1"
            },
            "sessionCount": 2,
            "pvCount": 5,
            "lift": 0.10296296296296292,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CW",
            "origEventId": "2910357582e33e09c293ecdcf1e28789",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-06T14:37:42.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "3374af4c01da369a910cb71836e25655",
                "affiliate": "ABC",
                "isci": "GF35W1"
            },
            "sessionCount": 3,
            "pvCount": 3,
            "lift": 1.5,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "ABC",
            "origEventId": "3374af4c01da369a910cb71836e25655",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T16:31:56.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "b6bcc0b114aca46800b5ba90d96295b3",
                "affiliate": "CBS",
                "isci": "GF31W1"
            },
            "sessionCount": 1,
            "pvCount": 4,
            "lift": 0.1,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CBS",
            "origEventId": "b6bcc0b114aca46800b5ba90d96295b3",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-06T19:31:21.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "44b49c6277f841b21023be280a3cad2c",
                "affiliate": "ABC",
                "isci": "GF31W1"
            },
            "sessionCount": 2,
            "pvCount": 3,
            "lift": -0.003240740740740738,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "ABC",
            "origEventId": "44b49c6277f841b21023be280a3cad2c",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T16:14:37.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "6bacfbc8b03219a86cc5b5ad8a692b05",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 0.3333333333333333,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "6bacfbc8b03219a86cc5b5ad8a692b05",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T12:25:28.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "924e4ab68d083c1ce9fa3d6eb56028f4",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 2,
            "pvCount": 2,
            "lift": 0.6666666666666666,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "924e4ab68d083c1ce9fa3d6eb56028f4",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-13T12:12:41.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "b5d81b4ebaf7180716ce49752bd8b3b7",
                "affiliate": "ABC",
                "isci": "GF31W1"
            },
            "sessionCount": 3,
            "pvCount": 5,
            "lift": 0.6944444444444444,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "ABC",
            "origEventId": "b5d81b4ebaf7180716ce49752bd8b3b7",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T16:59:24.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "a11828a71f924274cca531ba5b762c16",
                "affiliate": "MNTV",
                "isci": "GF31W1"
            },
            "sessionCount": 2,
            "pvCount": 2,
            "lift": 0.2777777777777778,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "MNTV",
            "origEventId": "a11828a71f924274cca531ba5b762c16",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-14T16:29:31.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "621fe96e2c0716f8da9051a4e70d4abc",
                "affiliate": "FOX",
                "isci": "GF31W1"
            },
            "sessionCount": 5,
            "pvCount": 10,
            "lift": 0.09544027778837415,
            "baselineSessionCount": 5,
            "baselineSessionsPerSecond": 0.016666666666666666,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "FOX",
            "origEventId": "621fe96e2c0716f8da9051a4e70d4abc",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T19:26:47.006Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "e1050eca9d9de928fe6aef1ccefaac5c",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 7,
            "pvCount": 7,
            "lift": 5.363636363636363,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "e1050eca9d9de928fe6aef1ccefaac5c",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T18:28:51.499Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "b54cf0c95bcd28a0162d74437def893d",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 5,
            "pvCount": 5,
            "lift": 0.25363636363636366,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "b54cf0c95bcd28a0162d74437def893d",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T12:45:16.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "bb2d6a5baa7fe34c69ce3510477b1e95",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 4,
            "pvCount": 7,
            "lift": 1.3181818181818181,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "bb2d6a5baa7fe34c69ce3510477b1e95",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-13T13:53:01.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "d05074e16fb38b887db29163167baa93",
                "affiliate": "CBS",
                "isci": "GF31W1"
            },
            "sessionCount": 2,
            "pvCount": 4,
            "lift": 0.05972222222222222,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CBS",
            "origEventId": "d05074e16fb38b887db29163167baa93",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T15:24:11.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "e4161d7430889d851c7b05119b4949c5",
                "affiliate": "MNTV",
                "isci": "GF35W1"
            },
            "sessionCount": 1,
            "pvCount": 9,
            "lift": 1,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "MNTV",
            "origEventId": "e4161d7430889d851c7b05119b4949c5",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-13T00:18:24.452Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "prime_time"
        },
        {
            "_id": {
                "origEventId": "bd793a01c572db31b612d8df8d6715a0",
                "affiliate": "CBS",
                "isci": "GF31W1"
            },
            "sessionCount": 2,
            "pvCount": 5,
            "lift": 0.26666666666666666,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CBS",
            "origEventId": "bd793a01c572db31b612d8df8d6715a0",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-06T19:32:01.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "9cb92d56dbd0cb510abf5d3e1391af57",
                "affiliate": "MNTV",
                "isci": "GF31W1"
            },
            "sessionCount": 1,
            "pvCount": 3,
            "lift": -0.07707451499118166,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "MNTV",
            "origEventId": "9cb92d56dbd0cb510abf5d3e1391af57",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T19:15:30.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "66a1cc2d6c5d20393490ff3691392ffb",
                "affiliate": "NBC",
                "isci": "GE31W1"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 0.5,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W1",
            "affiliate": "NBC",
            "origEventId": "66a1cc2d6c5d20393490ff3691392ffb",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-11T14:23:27.000Z",
            "dmaName": "Springfield MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "3b77b35e0d67b9acc479449bada25ffc",
                "affiliate": "CW",
                "isci": "GF31W1"
            },
            "sessionCount": 2,
            "pvCount": 5,
            "lift": 0.09879629629629626,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CW",
            "origEventId": "3b77b35e0d67b9acc479449bada25ffc",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-06T14:37:48.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "1209badfadd538bea1effbcfc2aa6fe2",
                "affiliate": "ABC",
                "isci": "GF31W1"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 0.3333333333333333,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "ABC",
            "origEventId": "1209badfadd538bea1effbcfc2aa6fe2",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-11T16:53:09.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "68028d57c41ae0b33ee26e9fe5d73208",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 3,
            "pvCount": 9,
            "lift": 1.801781817999753,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "68028d57c41ae0b33ee26e9fe5d73208",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-06T15:12:04.757Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "cd801fabd110c87742b243ef9314ce8d",
                "affiliate": "CW",
                "isci": "GF31W1"
            },
            "sessionCount": 3,
            "pvCount": 7,
            "lift": 0.3407407407407407,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CW",
            "origEventId": "cd801fabd110c87742b243ef9314ce8d",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-06T14:37:13.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "b60bfd5afd89c6ffa3234d8c95c236e8",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 2,
            "pvCount": 5,
            "lift": 2,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "b60bfd5afd89c6ffa3234d8c95c236e8",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T17:14:02.374Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "5a0785b82a5913133fc26c7ac3faf19b",
                "affiliate": "CBS",
                "isci": "GF31W1"
            },
            "sessionCount": 4,
            "pvCount": 12,
            "lift": 0.06803130511463842,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CBS",
            "origEventId": "5a0785b82a5913133fc26c7ac3faf19b",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T15:11:13.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "bca30fe8aec528034b8260159d25be73",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 2,
            "pvCount": 4,
            "lift": -0.09090909090909098,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "bca30fe8aec528034b8260159d25be73",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T15:26:49.907Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "80aa7bfb012788f2cab4444e9e698ebe",
                "affiliate": "FOX",
                "isci": "GF31W1"
            },
            "sessionCount": 4,
            "pvCount": 16,
            "lift": 2.333333333333333,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "FOX",
            "origEventId": "80aa7bfb012788f2cab4444e9e698ebe",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-11T17:14:35.302Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "a4b6b7dc72a9d4f8037992ea87daeb45",
                "affiliate": "CW",
                "isci": "GF35W1"
            },
            "sessionCount": 2,
            "pvCount": 2,
            "lift": 2,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "CW",
            "origEventId": "a4b6b7dc72a9d4f8037992ea87daeb45",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-13T16:53:04.133Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "f0a3d1a6ce236b281c2cb25fe1816cf1",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 0.3333333333333333,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "f0a3d1a6ce236b281c2cb25fe1816cf1",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T12:25:28.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "f2991c8edd9bff81a0b74e6b19651701",
                "affiliate": "CBS",
                "isci": "GF31W1"
            },
            "sessionCount": 1,
            "pvCount": 4,
            "lift": 0.1,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CBS",
            "origEventId": "f2991c8edd9bff81a0b74e6b19651701",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-06T19:31:25.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "a0fb7b7d4c1fb0c9b6d7cced9aa41898",
                "affiliate": "MNTV",
                "isci": "GF35W1"
            },
            "sessionCount": 2,
            "pvCount": 5,
            "lift": -0.15848055548138096,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "MNTV",
            "origEventId": "a0fb7b7d4c1fb0c9b6d7cced9aa41898",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-06T14:38:31.348Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "626c8f7c2fe60e673f8de6e3be12cabe",
                "affiliate": "CBS",
                "isci": "GF31W1"
            },
            "sessionCount": 2,
            "pvCount": 5,
            "lift": 0.26666666666666666,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CBS",
            "origEventId": "626c8f7c2fe60e673f8de6e3be12cabe",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-06T19:31:34.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "dae2be21c27c3e3940970c6e50955d85",
                "affiliate": "ABC",
                "isci": "GF31W1"
            },
            "sessionCount": 3,
            "pvCount": 9,
            "lift": 0.20277777777777772,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "ABC",
            "origEventId": "dae2be21c27c3e3940970c6e50955d85",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T16:55:42.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "272099b1bb061cccaca7fac2df365d86",
                "affiliate": "CBS",
                "isci": "GF31W1"
            },
            "sessionCount": 4,
            "pvCount": 12,
            "lift": 0.0657164902998236,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CBS",
            "origEventId": "272099b1bb061cccaca7fac2df365d86",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T15:11:08.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "31a154e29fce361ad0cd70d6aace3436",
                "affiliate": "CBS",
                "isci": "GF31W1"
            },
            "sessionCount": 4,
            "pvCount": 12,
            "lift": 0.06571649029982361,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CBS",
            "origEventId": "31a154e29fce361ad0cd70d6aace3436",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T15:11:08.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "59ca93df3acf310dc1e970205e38d853",
                "affiliate": "FOX",
                "isci": "GF31W1"
            },
            "sessionCount": 3,
            "pvCount": 3,
            "lift": -0.0036375661375661473,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "FOX",
            "origEventId": "59ca93df3acf310dc1e970205e38d853",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T14:27:16.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "4956ced83a57b04a4068487022dde85a",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 0.2,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "4956ced83a57b04a4068487022dde85a",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T12:14:00.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "6d94431e8cb1f331c7bb50530f712902",
                "affiliate": "CBS",
                "isci": "GF35W1"
            },
            "sessionCount": 2,
            "pvCount": 15,
            "lift": 1,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "CBS",
            "origEventId": "6d94431e8cb1f331c7bb50530f712902",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T19:32:53.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "10db9a8b26aafc4efbfd404a25044719",
                "affiliate": "MNTV",
                "isci": "GF35W1"
            },
            "sessionCount": 1,
            "pvCount": 2,
            "lift": 0.3333333333333333,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "MNTV",
            "origEventId": "10db9a8b26aafc4efbfd404a25044719",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-06T09:39:00.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "overnight"
        },
        {
            "_id": {
                "origEventId": "1798b1ae66b3b791a4ca3b136f819e9d",
                "affiliate": "MNTV",
                "isci": "GF31W1"
            },
            "sessionCount": 9,
            "pvCount": 19,
            "lift": 1.0535185185185183,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "MNTV",
            "origEventId": "1798b1ae66b3b791a4ca3b136f819e9d",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T15:37:32.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "326431c3e7be548c58ac874d35bc84a4",
                "affiliate": "CW",
                "isci": "GE31W2"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 0.16666666666666666,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "CW",
            "origEventId": "326431c3e7be548c58ac874d35bc84a4",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-11T11:48:23.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "80832e7e514f7a029b2f9581400b5af6",
                "affiliate": "ABC",
                "isci": "GF31W1"
            },
            "sessionCount": 1,
            "pvCount": 2,
            "lift": 0.3333333333333333,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "ABC",
            "origEventId": "80832e7e514f7a029b2f9581400b5af6",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T16:15:14.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "2b41b67c0d3ee36359acc266450445b4",
                "affiliate": "ABC",
                "isci": "GF31W1"
            },
            "sessionCount": 2,
            "pvCount": 2,
            "lift": 0.6666666666666666,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "ABC",
            "origEventId": "2b41b67c0d3ee36359acc266450445b4",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T14:32:55.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "30f657f2340e09cd39b6f6c8fae58bd7",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 5,
            "pvCount": 8,
            "lift": 0.5495322270322269,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "30f657f2340e09cd39b6f6c8fae58bd7",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T14:00:01.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "d6e471e2c7f04d7f6c5ad4a860a46bed",
                "affiliate": "ABC",
                "isci": "GF35W1"
            },
            "sessionCount": 3,
            "pvCount": 3,
            "lift": 0.8666666666666667,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "ABC",
            "origEventId": "d6e471e2c7f04d7f6c5ad4a860a46bed",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T11:24:04.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "805727c128bd73ca8a1e2e79a28dc577",
                "affiliate": "CW",
                "isci": "GE31W2"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 0.5,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "CW",
            "origEventId": "805727c128bd73ca8a1e2e79a28dc577",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T19:25:25.723Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "7987832022c9281931523a734de496cb",
                "affiliate": "CW",
                "isci": "GE31W2"
            },
            "sessionCount": 6,
            "pvCount": 7,
            "lift": 0.4294949494949495,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "CW",
            "origEventId": "7987832022c9281931523a734de496cb",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T14:25:22.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "a3e71e91d7b6ee3d0c61edd39ecd7ca4",
                "affiliate": "MNTV",
                "isci": "GF31W1"
            },
            "sessionCount": 1,
            "pvCount": 3,
            "lift": -0.07013007054673723,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "MNTV",
            "origEventId": "a3e71e91d7b6ee3d0c61edd39ecd7ca4",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T19:15:45.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "69a98fa63421574c1c02029110f025cd",
                "affiliate": "FOX",
                "isci": "GF35W1"
            },
            "sessionCount": 5,
            "pvCount": 5,
            "lift": 0.19916666666666666,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "FOX",
            "origEventId": "69a98fa63421574c1c02029110f025cd",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T12:46:37.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "fa8480428f226a72ceb437d29d1d4eee",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 0.2,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "fa8480428f226a72ceb437d29d1d4eee",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T13:28:46.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "1d064ac8f5fe602ab1405842baa5c54c",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 4,
            "pvCount": 7,
            "lift": 1.3181818181818181,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "1d064ac8f5fe602ab1405842baa5c54c",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-13T13:53:01.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "3c10d3cd74f3734af179c787a26bfcd9",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 2,
            "pvCount": 3,
            "lift": 0.3818181818181818,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "3c10d3cd74f3734af179c787a26bfcd9",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-11T10:24:50.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "f5fe6e7bed51dfcf892f77f5578920e5",
                "affiliate": "MNTV",
                "isci": "GF35W1"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 1,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "MNTV",
            "origEventId": "f5fe6e7bed51dfcf892f77f5578920e5",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T00:47:20.864Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "prime_time"
        },
        {
            "_id": {
                "origEventId": "5119e68c1bc108d0e9b4f69cbe52b490",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 2,
            "pvCount": 3,
            "lift": 0.818181818181818,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "5119e68c1bc108d0e9b4f69cbe52b490",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-13T18:53:04.765Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "0080e1e147272345e07a144866fd167a",
                "affiliate": "CW",
                "isci": "GF31W1"
            },
            "sessionCount": 3,
            "pvCount": 3,
            "lift": 0.09014660493827159,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CW",
            "origEventId": "0080e1e147272345e07a144866fd167a",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T13:56:29.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "2b9b8696a4d5f77b50e38e70cff31d5f",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 3,
            "pvCount": 3,
            "lift": 1.727272727272727,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "2b9b8696a4d5f77b50e38e70cff31d5f",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T17:25:33.537Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "92c8f362de650fae702c4051c894a77a",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 5,
            "pvCount": 5,
            "lift": 0.25363636363636366,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "92c8f362de650fae702c4051c894a77a",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T12:45:16.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "c4389f2a22ba42425a33eadf0a0b2095",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 3,
            "pvCount": 3,
            "lift": 3,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "c4389f2a22ba42425a33eadf0a0b2095",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-13T17:12:43.287Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "998e2353dc529ad4ff56e9a3bfba88d8",
                "affiliate": "ABC",
                "isci": "GF35W1"
            },
            "sessionCount": 2,
            "pvCount": 2,
            "lift": 0.2222222222222222,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "ABC",
            "origEventId": "998e2353dc529ad4ff56e9a3bfba88d8",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-06T15:44:51.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "b83ba3288bcd3d50790fe078a66ec1f0",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 5,
            "pvCount": 13,
            "lift": 0.6363636363636362,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "b83ba3288bcd3d50790fe078a66ec1f0",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-11T16:24:58.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "17b03adb8de174e32835a0f6f933037b",
                "affiliate": "MNTV",
                "isci": "GF35W1"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": -0.21064814814814817,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "MNTV",
            "origEventId": "17b03adb8de174e32835a0f6f933037b",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-11T13:18:13.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "0e31bc5667551085199d26083c70134c",
                "affiliate": "CW",
                "isci": "GF35W1"
            },
            "sessionCount": 2,
            "pvCount": 3,
            "lift": -0.45080833335717524,
            "baselineSessionCount": 3,
            "baselineSessionsPerSecond": 0.01,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "CW",
            "origEventId": "0e31bc5667551085199d26083c70134c",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T15:47:32.825Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "51815ca5e809c5cd1c7e9b581c7cb134",
                "affiliate": "MNTV",
                "isci": "GF31W1"
            },
            "sessionCount": 9,
            "pvCount": 19,
            "lift": 1.0535185185185183,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "MNTV",
            "origEventId": "51815ca5e809c5cd1c7e9b581c7cb134",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T15:37:32.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "74cb02371c7c93ec6634e513dfc1eb09",
                "affiliate": "ABC",
                "isci": "GF31W1"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 0.25,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "ABC",
            "origEventId": "74cb02371c7c93ec6634e513dfc1eb09",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T11:12:50.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "e4b5cb26fea9a59820c4670a1fa198d6",
                "affiliate": "ABC",
                "isci": "GF31W1"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 0.25,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "ABC",
            "origEventId": "e4b5cb26fea9a59820c4670a1fa198d6",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T11:12:50.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "b018f32857dc8ee1856c0dd191055230",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": -0.04545454545454549,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "b018f32857dc8ee1856c0dd191055230",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T12:29:59.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "bea7e047c7805fa8c29e1c2dc1f84f0c",
                "affiliate": "CW",
                "isci": "GF31W1"
            },
            "sessionCount": 5,
            "pvCount": 8,
            "lift": 0.11527006172839502,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CW",
            "origEventId": "bea7e047c7805fa8c29e1c2dc1f84f0c",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-13T19:36:42.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "94d02d4cd85208f766fbe638696306cd",
                "affiliate": "ABC",
                "isci": "GF31W1"
            },
            "sessionCount": 5,
            "pvCount": 8,
            "lift": 0.8513888888888886,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "ABC",
            "origEventId": "94d02d4cd85208f766fbe638696306cd",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-06T15:17:47.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "b72a1aee45edd2ec71e3759fc8bb156e",
                "affiliate": "MNTV",
                "isci": "GF31W1"
            },
            "sessionCount": 1,
            "pvCount": 3,
            "lift": -0.07707451499118166,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "MNTV",
            "origEventId": "b72a1aee45edd2ec71e3759fc8bb156e",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T19:15:30.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "b26854327ba0f140e841cbd30ad2b2d4",
                "affiliate": "ABC",
                "isci": "GF35W1"
            },
            "sessionCount": 4,
            "pvCount": 6,
            "lift": 1.2685185185185182,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "ABC",
            "origEventId": "b26854327ba0f140e841cbd30ad2b2d4",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T15:54:07.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "04be38e235cb44ee448c254055dcc1a1",
                "affiliate": "MNTV",
                "isci": "GF31W1"
            },
            "sessionCount": 2,
            "pvCount": 2,
            "lift": 0.2777777777777778,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "MNTV",
            "origEventId": "04be38e235cb44ee448c254055dcc1a1",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-14T16:29:23.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "15fc6ce8f301b0e286af0ed2c4809399",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 4,
            "pvCount": 13,
            "lift": 0.818181818181818,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "15fc6ce8f301b0e286af0ed2c4809399",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-11T13:29:15.900Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "1e9495b12dec8a7e311a7a21e71dac7c",
                "affiliate": "MNTV",
                "isci": "GF35W1"
            },
            "sessionCount": 2,
            "pvCount": 10,
            "lift": 1,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "MNTV",
            "origEventId": "1e9495b12dec8a7e311a7a21e71dac7c",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-08T19:47:50.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "88c73742d8b11db49f57887c520d7490",
                "affiliate": "MNTV",
                "isci": "GF35W1"
            },
            "sessionCount": 2,
            "pvCount": 10,
            "lift": 1,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "MNTV",
            "origEventId": "88c73742d8b11db49f57887c520d7490",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-08T19:47:14.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "2343eb93aa42de7f34550f02992b90b5",
                "affiliate": "MNTV",
                "isci": "GE31W1"
            },
            "sessionCount": 1,
            "pvCount": 2,
            "lift": 1,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W1",
            "affiliate": "MNTV",
            "origEventId": "2343eb93aa42de7f34550f02992b90b5",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-13T22:55:03.501Z",
            "dmaName": "Springfield MO, United States",
            "timeOfDay": "early_fringe"
        },
        {
            "_id": {
                "origEventId": "f2e5721d43facb67941a44170f677430",
                "affiliate": "ABC",
                "isci": "GF35W1"
            },
            "sessionCount": 3,
            "pvCount": 5,
            "lift": 0.23053749998410533,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "ABC",
            "origEventId": "f2e5721d43facb67941a44170f677430",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T16:23:38.634Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "04ed64356fbc6979de18051c23f30b27",
                "affiliate": "CBS",
                "isci": "GF31W1"
            },
            "sessionCount": 2,
            "pvCount": 5,
            "lift": 0.26666666666666666,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CBS",
            "origEventId": "04ed64356fbc6979de18051c23f30b27",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-06T19:31:34.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "8a713791238ec670cb2f222dda5f60ae",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 0.3333333333333333,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "8a713791238ec670cb2f222dda5f60ae",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T12:25:28.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "58033864e0904fc96932efca3046285b",
                "affiliate": "ABC",
                "isci": "GF31W1"
            },
            "sessionCount": 3,
            "pvCount": 6,
            "lift": -0.07083333333333335,
            "baselineSessionCount": 3,
            "baselineSessionsPerSecond": 0.01,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "ABC",
            "origEventId": "58033864e0904fc96932efca3046285b",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T14:33:41.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "8641791586549dc414ef5b888c2dba6e",
                "affiliate": "CW",
                "isci": "GE31W2"
            },
            "sessionCount": 6,
            "pvCount": 7,
            "lift": 0.4381529581529582,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "CW",
            "origEventId": "8641791586549dc414ef5b888c2dba6e",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T14:25:30.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "98d3f8618954352c0300d6442cfde48e",
                "affiliate": "ABC",
                "isci": "GF31W1"
            },
            "sessionCount": 4,
            "pvCount": 7,
            "lift": 0.5310185185185183,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "ABC",
            "origEventId": "98d3f8618954352c0300d6442cfde48e",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-06T15:17:24.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "98e54dc77d1791d5d30be27f7ee7b97d",
                "affiliate": "CW",
                "isci": "GE31W2"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 0.5,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "CW",
            "origEventId": "98e54dc77d1791d5d30be27f7ee7b97d",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T12:50:16.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "7dc0c42f0d150b1fecce9a68ffcb243e",
                "affiliate": "NBC",
                "isci": "GE31W1"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 1,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W1",
            "affiliate": "NBC",
            "origEventId": "7dc0c42f0d150b1fecce9a68ffcb243e",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T14:59:33.309Z",
            "dmaName": "Springfield MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "526db979332df3a28286159047e4a510",
                "affiliate": "CBS",
                "isci": "GF31W1"
            },
            "sessionCount": 2,
            "pvCount": 4,
            "lift": 0.05972222222222222,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CBS",
            "origEventId": "526db979332df3a28286159047e4a510",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T15:24:11.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "4b00091cd0774b050b9721a255bfd736",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 6,
            "pvCount": 6,
            "lift": 1.727272727272727,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "4b00091cd0774b050b9721a255bfd736",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T17:30:01.524Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "726e202da5a50f3b192e17081e3b0c58",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 5,
            "pvCount": 8,
            "lift": 0.5597594997594997,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "726e202da5a50f3b192e17081e3b0c58",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T13:59:52.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "f490a51b609534f6b46f46c9b14ce473",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 1,
            "pvCount": 2,
            "lift": 0.5,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "f490a51b609534f6b46f46c9b14ce473",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-11T16:49:56.270Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "f0e6049e63ea5df6741fcd0c757b0b8a",
                "affiliate": "ABC",
                "isci": "GF31W1"
            },
            "sessionCount": 4,
            "pvCount": 7,
            "lift": 1.5277777777777777,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "ABC",
            "origEventId": "f0e6049e63ea5df6741fcd0c757b0b8a",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T17:00:04.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "47ae366ecdd7f3a928e4d8ecc55df350",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": -0.2585696971777714,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "47ae366ecdd7f3a928e4d8ecc55df350",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T15:19:20.323Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "f332a46400b221f735811ab69749c426",
                "affiliate": "CBS",
                "isci": "GF31W1"
            },
            "sessionCount": 2,
            "pvCount": 4,
            "lift": 0.04884259259259259,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CBS",
            "origEventId": "f332a46400b221f735811ab69749c426",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T15:24:41.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "912a58116469350cbf468ae5aef8b122",
                "affiliate": "CW",
                "isci": "GF31W1"
            },
            "sessionCount": 2,
            "pvCount": 5,
            "lift": 0.09879629629629626,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CW",
            "origEventId": "912a58116469350cbf468ae5aef8b122",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-06T14:37:48.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "f2be5326d1feb983bfd31664c5a76e3a",
                "affiliate": "MNTV",
                "isci": "GF31W1"
            },
            "sessionCount": 10,
            "pvCount": 20,
            "lift": 0.26157407407407407,
            "baselineSessionCount": 3,
            "baselineSessionsPerSecond": 0.01,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "MNTV",
            "origEventId": "f2be5326d1feb983bfd31664c5a76e3a",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T15:36:40.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "831e625dd1c927a627ca6d9d2f3eada3",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 2,
            "pvCount": 2,
            "lift": 0.6666666666666666,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "831e625dd1c927a627ca6d9d2f3eada3",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-13T12:12:37.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "541163bc72e18135aa1d487b8eaacd8f",
                "affiliate": "FOX",
                "isci": "GF35W1"
            },
            "sessionCount": 4,
            "pvCount": 4,
            "lift": 2,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "FOX",
            "origEventId": "541163bc72e18135aa1d487b8eaacd8f",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-11T15:44:11.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "5d6618c88438cd3757d9c6ea5739797d",
                "affiliate": "MNTV",
                "isci": "GF35W1"
            },
            "sessionCount": 1,
            "pvCount": 2,
            "lift": 0.3333333333333333,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "MNTV",
            "origEventId": "5d6618c88438cd3757d9c6ea5739797d",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-06T09:38:25.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "overnight"
        },
        {
            "_id": {
                "origEventId": "4b62b12eff5392ec1ef4dff5eea87454",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 5,
            "pvCount": 5,
            "lift": 3.545454545454545,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "4b62b12eff5392ec1ef4dff5eea87454",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-11T15:24:53.975Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "886839a23f1dbecdc0b49b9480e902cc",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 0.2,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "886839a23f1dbecdc0b49b9480e902cc",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T13:28:46.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "1f467346d4311a1c031cd6cb61c99e19",
                "affiliate": "ABC",
                "isci": "GF35W1"
            },
            "sessionCount": 3,
            "pvCount": 3,
            "lift": 0.11236388882001234,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "ABC",
            "origEventId": "1f467346d4311a1c031cd6cb61c99e19",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T14:59:31.716Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "3bd656c3f190493e8afc3a92566b4e01",
                "affiliate": "CBS",
                "isci": "GF35W1"
            },
            "sessionCount": 5,
            "pvCount": 8,
            "lift": 0.09860339506172837,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "CBS",
            "origEventId": "3bd656c3f190493e8afc3a92566b4e01",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-13T19:36:26.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "518f07ceb6139615bebb32c51cd65b88",
                "affiliate": "CW",
                "isci": "GF31W1"
            },
            "sessionCount": 5,
            "pvCount": 8,
            "lift": 0.11364969135802468,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CW",
            "origEventId": "518f07ceb6139615bebb32c51cd65b88",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-13T19:36:53.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "864d7a93646155e1b9f72ad228676d99",
                "affiliate": "MNTV",
                "isci": "GF31W1"
            },
            "sessionCount": 2,
            "pvCount": 2,
            "lift": 0.2777777777777778,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "MNTV",
            "origEventId": "864d7a93646155e1b9f72ad228676d99",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-14T16:29:46.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "701091514cc7b41f12f96176a7866612",
                "affiliate": "FOX",
                "isci": "GF35W1"
            },
            "sessionCount": 6,
            "pvCount": 6,
            "lift": 0.37833333333333324,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "FOX",
            "origEventId": "701091514cc7b41f12f96176a7866612",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T12:46:01.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "555ab3a9990010dfb892d4d92f1851c5",
                "affiliate": "ABC",
                "isci": "GF35W1"
            },
            "sessionCount": 7,
            "pvCount": 14,
            "lift": 0.4222222222222221,
            "baselineSessionCount": 3,
            "baselineSessionsPerSecond": 0.01,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "ABC",
            "origEventId": "555ab3a9990010dfb892d4d92f1851c5",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T16:38:03.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "0f0ab88efe6c6612fe6901b98798b5c1",
                "affiliate": "MNTV",
                "isci": "GF35W1"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 1,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "MNTV",
            "origEventId": "0f0ab88efe6c6612fe6901b98798b5c1",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-07T13:24:08.384Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "18d33e0c8e7e1552360b8aaf7f7cb7f6",
                "affiliate": "CBS",
                "isci": "GE31W2"
            },
            "sessionCount": 3,
            "pvCount": 3,
            "lift": 1.727272727272727,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "CBS",
            "origEventId": "18d33e0c8e7e1552360b8aaf7f7cb7f6",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T14:59:31.579Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "bd68731d5df66626cd70d284a0ab5b05",
                "affiliate": "CW",
                "isci": "GE31W2"
            },
            "sessionCount": 2,
            "pvCount": 3,
            "lift": 0.6666666666666666,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "CW",
            "origEventId": "bd68731d5df66626cd70d284a0ab5b05",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T18:24:40.521Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "c1d7bfb793612bce998b124dfe416075",
                "affiliate": "CBS",
                "isci": "GF31W1"
            },
            "sessionCount": 3,
            "pvCount": 5,
            "lift": 3,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CBS",
            "origEventId": "c1d7bfb793612bce998b124dfe416075",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-07T00:31:25.560Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "prime_time"
        },
        {
            "_id": {
                "origEventId": "ceced9b94fd87d4ad49e4c9245028f50",
                "affiliate": "MNTV",
                "isci": "GF31W1"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 0.1111111111111111,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "MNTV",
            "origEventId": "ceced9b94fd87d4ad49e4c9245028f50",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-14T16:29:07.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "304761cc8bdda82b77943fcc04de4e05",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 5,
            "pvCount": 5,
            "lift": 0.25363636363636366,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "304761cc8bdda82b77943fcc04de4e05",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T12:45:16.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "2906d51416b7ecc77f49b0566adeadd5",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 2,
            "pvCount": 4,
            "lift": 2,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "2906d51416b7ecc77f49b0566adeadd5",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T21:24:22.528Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_fringe"
        },
        {
            "_id": {
                "origEventId": "6ae511476d4512130eac0a74448f9fe1",
                "affiliate": "FOX",
                "isci": "GF31W1"
            },
            "sessionCount": 3,
            "pvCount": 3,
            "lift": 0.00441798941798941,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "FOX",
            "origEventId": "6ae511476d4512130eac0a74448f9fe1",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T14:26:42.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "28bb6d5720d1127bdf69b13ef2427886",
                "affiliate": "CBS",
                "isci": "GF31W1"
            },
            "sessionCount": 2,
            "pvCount": 5,
            "lift": 0.26666666666666666,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CBS",
            "origEventId": "28bb6d5720d1127bdf69b13ef2427886",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-06T19:31:48.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "46418efca6d8619a8d632d428f73cec2",
                "affiliate": "ABC",
                "isci": "GF31W1"
            },
            "sessionCount": 3,
            "pvCount": 6,
            "lift": -0.1,
            "baselineSessionCount": 3,
            "baselineSessionsPerSecond": 0.01,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "ABC",
            "origEventId": "46418efca6d8619a8d632d428f73cec2",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T14:33:08.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "4c0679aa4007a77f4638f870e364b17c",
                "affiliate": "ABC",
                "isci": "GF31W1"
            },
            "sessionCount": 3,
            "pvCount": 6,
            "lift": -0.07083333333333335,
            "baselineSessionCount": 3,
            "baselineSessionsPerSecond": 0.01,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "ABC",
            "origEventId": "4c0679aa4007a77f4638f870e364b17c",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T14:33:41.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "274f579f241b95ea0cbddc4a5f2d8e11",
                "affiliate": "CW",
                "isci": "GF31W1"
            },
            "sessionCount": 5,
            "pvCount": 8,
            "lift": 0.11527006172839502,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CW",
            "origEventId": "274f579f241b95ea0cbddc4a5f2d8e11",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-13T19:36:42.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "b4a3e87185d8409905618ae633d008a0",
                "affiliate": "CW",
                "isci": "GF31W1"
            },
            "sessionCount": 5,
            "pvCount": 8,
            "lift": 0.07927469135802467,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CW",
            "origEventId": "b4a3e87185d8409905618ae633d008a0",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-13T19:37:26.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "f6569da8bcddd66855c73c982e26ec9f",
                "affiliate": "MNTV",
                "isci": "GF31W1"
            },
            "sessionCount": 2,
            "pvCount": 5,
            "lift": -0.04074074074074076,
            "baselineSessionCount": 3,
            "baselineSessionsPerSecond": 0.01,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "MNTV",
            "origEventId": "f6569da8bcddd66855c73c982e26ec9f",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T19:16:08.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "2a47f1a37477fcbf1a6d8cd5c5199c43",
                "affiliate": "CW",
                "isci": "GF35W1"
            },
            "sessionCount": 3,
            "pvCount": 8,
            "lift": 1.4999999999999996,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "CW",
            "origEventId": "2a47f1a37477fcbf1a6d8cd5c5199c43",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-06T16:53:13.110Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "5c1f992165acf93d510b688893e0934b",
                "affiliate": "ABC",
                "isci": "GF31W1"
            },
            "sessionCount": 4,
            "pvCount": 6,
            "lift": 1.811111111111111,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "ABC",
            "origEventId": "5c1f992165acf93d510b688893e0934b",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T14:33:37.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "21047b79fe097da82505e1ff7fe98283",
                "affiliate": "FOX",
                "isci": "GF35W1"
            },
            "sessionCount": 2,
            "pvCount": 4,
            "lift": 0.15740740740740733,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "FOX",
            "origEventId": "21047b79fe097da82505e1ff7fe98283",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-13T12:58:42.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "e24164cf33be0bf3c0e6182d3d9b6049",
                "affiliate": "MNTV",
                "isci": "GF31W1"
            },
            "sessionCount": 2,
            "pvCount": 2,
            "lift": 0.2777777777777778,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "MNTV",
            "origEventId": "e24164cf33be0bf3c0e6182d3d9b6049",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-14T16:29:23.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "057caf83a19e4f628ec9e376e864ec6c",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": -0.04545454545454549,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "057caf83a19e4f628ec9e376e864ec6c",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T12:29:59.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "a822d4ee037d5e84a600a181b5d7f30a",
                "affiliate": "CW",
                "isci": "GF31W1"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": -0.034490740740740745,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CW",
            "origEventId": "a822d4ee037d5e84a600a181b5d7f30a",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-13T10:29:39.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "5b4a5e639b25624a433295722a6affc2",
                "affiliate": "CW",
                "isci": "GF31W1"
            },
            "sessionCount": 5,
            "pvCount": 8,
            "lift": 0.07927469135802467,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CW",
            "origEventId": "5b4a5e639b25624a433295722a6affc2",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-13T19:37:26.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "8fff9155b961005a05d17a772e992661",
                "affiliate": "FOX",
                "isci": "GF35W1"
            },
            "sessionCount": 4,
            "pvCount": 4,
            "lift": 2.5,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "FOX",
            "origEventId": "8fff9155b961005a05d17a772e992661",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-11T15:43:36.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "88f7d728f439a9433b3953c7bd394cee",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 2,
            "pvCount": 4,
            "lift": 0.6912136363260674,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "88f7d728f439a9433b3953c7bd394cee",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T13:57:39.099Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "7bdc7d26a60d6e4ca03af0f319faa901",
                "affiliate": "CBS",
                "isci": "GF31W1"
            },
            "sessionCount": 2,
            "pvCount": 4,
            "lift": 0.05972222222222222,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CBS",
            "origEventId": "7bdc7d26a60d6e4ca03af0f319faa901",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T15:24:11.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "6558d1be7cb735cc1f3797aab4dc05ca",
                "affiliate": "ABC",
                "isci": "GF35W1"
            },
            "sessionCount": 4,
            "pvCount": 6,
            "lift": 0.6666666666666664,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "ABC",
            "origEventId": "6558d1be7cb735cc1f3797aab4dc05ca",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T20:54:07.759Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "6453d8df58dd393968dff83c799f6a85",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 5,
            "pvCount": 8,
            "lift": 0.5597594997594997,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "6453d8df58dd393968dff83c799f6a85",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T13:59:52.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "0d51b2ea25d96eea2570bfcfd39c2ccc",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 5,
            "pvCount": 13,
            "lift": 0.6363636363636362,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "0d51b2ea25d96eea2570bfcfd39c2ccc",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-11T16:24:58.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "f8cfc2af0e623880d38a879b4511b0e0",
                "affiliate": "CBS",
                "isci": "GF35W1"
            },
            "sessionCount": 1,
            "pvCount": 5,
            "lift": 1,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "CBS",
            "origEventId": "f8cfc2af0e623880d38a879b4511b0e0",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-11T00:32:54.525Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "prime_time"
        },
        {
            "_id": {
                "origEventId": "b0e5deaa1b2c4cd9fcc12cfd27f9dae5",
                "affiliate": "MNTV",
                "isci": "GF31W1"
            },
            "sessionCount": 10,
            "pvCount": 20,
            "lift": 0.31046296296296294,
            "baselineSessionCount": 3,
            "baselineSessionsPerSecond": 0.01,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "MNTV",
            "origEventId": "b0e5deaa1b2c4cd9fcc12cfd27f9dae5",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T15:37:02.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "8d93f942583a9698a1f02ce2c716f28d",
                "affiliate": "MNTV",
                "isci": "GF35W1"
            },
            "sessionCount": 7,
            "pvCount": 11,
            "lift": 1.1166666666666665,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "MNTV",
            "origEventId": "8d93f942583a9698a1f02ce2c716f28d",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T19:18:54.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "687cd9767300be7e799caea2181a3ac4",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 2,
            "pvCount": 8,
            "lift": 2,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "687cd9767300be7e799caea2181a3ac4",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T16:13:35.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "49b5e244aec255e28651578dcfba9f3e",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 0.2,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "49b5e244aec255e28651578dcfba9f3e",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T13:28:46.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "0ddb07b2e4c2d945611a4d4874ef6439",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 1,
            "pvCount": 2,
            "lift": 0.3333333333333333,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "0ddb07b2e4c2d945611a4d4874ef6439",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T16:24:21.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "f1cc5b843fc60017fefe183fa7af532d",
                "affiliate": "CW",
                "isci": "GF31W1"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": -0.034490740740740745,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CW",
            "origEventId": "f1cc5b843fc60017fefe183fa7af532d",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-13T10:29:39.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "bc13097c46ac04815bc1ae763a874a0f",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 0.2,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "bc13097c46ac04815bc1ae763a874a0f",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T12:14:00.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "ba41e0e46cad5d11602542679989e4d4",
                "affiliate": "ABC",
                "isci": "GF35W1"
            },
            "sessionCount": 3,
            "pvCount": 4,
            "lift": 0.36507936507936506,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "ABC",
            "origEventId": "ba41e0e46cad5d11602542679989e4d4",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-06T15:45:22.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "989f9539e72af67407224a68fe4c66fa",
                "affiliate": "ABC",
                "isci": "GF35W1"
            },
            "sessionCount": 3,
            "pvCount": 4,
            "lift": 3,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "ABC",
            "origEventId": "989f9539e72af67407224a68fe4c66fa",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T21:31:22.223Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_fringe"
        },
        {
            "_id": {
                "origEventId": "7ce1be8b327e1f284743e9af549e9428",
                "affiliate": "CBS",
                "isci": "GF31W1"
            },
            "sessionCount": 4,
            "pvCount": 12,
            "lift": 0.06409611992945323,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CBS",
            "origEventId": "7ce1be8b327e1f284743e9af549e9428",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T15:11:31.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "025758bde6b4b830356ba8afa527eec2",
                "affiliate": "ABC",
                "isci": "GF35W1"
            },
            "sessionCount": 2,
            "pvCount": 4,
            "lift": 0.6666666666666664,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "ABC",
            "origEventId": "025758bde6b4b830356ba8afa527eec2",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T14:59:32.735Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "f596478043e99975a6de5b28e40513a3",
                "affiliate": "MNTV",
                "isci": "GF31W1"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 0.1111111111111111,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "MNTV",
            "origEventId": "f596478043e99975a6de5b28e40513a3",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-14T16:29:11.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "3b2d63146af313f8547475fd2613e9a3",
                "affiliate": "ABC",
                "isci": "GF35W1"
            },
            "sessionCount": 1,
            "pvCount": 2,
            "lift": 1,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "ABC",
            "origEventId": "3b2d63146af313f8547475fd2613e9a3",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-08T21:36:54.529Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_fringe"
        },
        {
            "_id": {
                "origEventId": "a6dc953b16a56d280ab988a14f52135e",
                "affiliate": "MNTV",
                "isci": "GF31W1"
            },
            "sessionCount": 2,
            "pvCount": 2,
            "lift": 0.2777777777777778,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "MNTV",
            "origEventId": "a6dc953b16a56d280ab988a14f52135e",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-14T16:29:31.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "3d07d864f133df9baf45bbd680da8e3c",
                "affiliate": "MNTV",
                "isci": "GF35W1"
            },
            "sessionCount": 2,
            "pvCount": 2,
            "lift": -0.1666666666666668,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "MNTV",
            "origEventId": "3d07d864f133df9baf45bbd680da8e3c",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-13T18:38:09.584Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "6e7477ca88febf5dd9484cea67b58bc0",
                "affiliate": "MNTV",
                "isci": "GF35W1"
            },
            "sessionCount": 4,
            "pvCount": 13,
            "lift": 2.333333333333333,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "MNTV",
            "origEventId": "6e7477ca88febf5dd9484cea67b58bc0",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-11T18:17:44.370Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "edce5b4337bb1515e7e68af4508d7490",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 7,
            "pvCount": 12,
            "lift": 5.363636363636363,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "edce5b4337bb1515e7e68af4508d7490",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T18:59:51.500Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "e9f142317df3e4ee60794e5ab88ad763",
                "affiliate": "CBS",
                "isci": "GF31W1"
            },
            "sessionCount": 2,
            "pvCount": 4,
            "lift": 0.05925925925925925,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CBS",
            "origEventId": "e9f142317df3e4ee60794e5ab88ad763",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T15:24:31.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "68e6076b052b15ad24d08fc1012cb180",
                "affiliate": "CW",
                "isci": "GF31W1"
            },
            "sessionCount": 3,
            "pvCount": 3,
            "lift": 0.09014660493827159,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CW",
            "origEventId": "68e6076b052b15ad24d08fc1012cb180",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T13:56:29.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "06cee7980074669d4b868aa0b9f0e82b",
                "affiliate": "MNTV",
                "isci": "GE31W1"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 1,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W1",
            "affiliate": "MNTV",
            "origEventId": "06cee7980074669d4b868aa0b9f0e82b",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-07T16:10:57.000Z",
            "dmaName": "Springfield MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "93b02e6d7e8c0149bb0d1226d83ccbf3",
                "affiliate": "CW",
                "isci": "GF31W1"
            },
            "sessionCount": 3,
            "pvCount": 7,
            "lift": 0.3807407407407407,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CW",
            "origEventId": "93b02e6d7e8c0149bb0d1226d83ccbf3",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-06T14:37:31.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "3022d6fc3d1e99df2167fcffa56c7a94",
                "affiliate": "CW",
                "isci": "GF31W1"
            },
            "sessionCount": 3,
            "pvCount": 3,
            "lift": 0.11264991181657846,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CW",
            "origEventId": "3022d6fc3d1e99df2167fcffa56c7a94",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T13:56:57.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "af8c665253f8d7118158ba70a3d42019",
                "affiliate": "CW",
                "isci": "GE31W2"
            },
            "sessionCount": 6,
            "pvCount": 7,
            "lift": 0.4294949494949495,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "CW",
            "origEventId": "af8c665253f8d7118158ba70a3d42019",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T14:25:22.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "7b76b48994f19b1dc536c21a21fcc993",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 3,
            "pvCount": 6,
            "lift": 0.36363636363636354,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "7b76b48994f19b1dc536c21a21fcc993",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T16:58:54.247Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "30fd197bc404a7b45a1b5550e72bbf58",
                "affiliate": "ABC",
                "isci": "GG35W6"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 0.5,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GG35W6",
            "affiliate": "ABC",
            "origEventId": "30fd197bc404a7b45a1b5550e72bbf58",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T11:29:44.000Z",
            "dmaName": "Springfield MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "24c4aa7da5a28428f7486c7c68910c5b",
                "affiliate": "ABC",
                "isci": "GF35W1"
            },
            "sessionCount": 1,
            "pvCount": 4,
            "lift": 0.5,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "ABC",
            "origEventId": "24c4aa7da5a28428f7486c7c68910c5b",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-11T14:25:01.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "1d54e4b8cbf4f8a8f1a9e19b3946af68",
                "affiliate": "ABC",
                "isci": "GF35W1"
            },
            "sessionCount": 3,
            "pvCount": 3,
            "lift": 1.5,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "ABC",
            "origEventId": "1d54e4b8cbf4f8a8f1a9e19b3946af68",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T16:31:22.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "425afd7e0e18de4f4dd73b4f4e78a582",
                "affiliate": "ABC",
                "isci": "GF35W1"
            },
            "sessionCount": 2,
            "pvCount": 2,
            "lift": 0.2222222222222222,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "ABC",
            "origEventId": "425afd7e0e18de4f4dd73b4f4e78a582",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-06T15:44:51.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "65ec3d625aefdb3c5614588279019253",
                "affiliate": "CW",
                "isci": "GF31W1"
            },
            "sessionCount": 5,
            "pvCount": 8,
            "lift": 0.11527006172839502,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CW",
            "origEventId": "65ec3d625aefdb3c5614588279019253",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-13T19:36:46.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "5d028712a09376876d4ed2e5fe79b9ed",
                "affiliate": "MNTV",
                "isci": "GF35W1"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": -0.21064814814814817,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "MNTV",
            "origEventId": "5d028712a09376876d4ed2e5fe79b9ed",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-11T13:18:13.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "6dccd4cae0ac0b46d10f6819fea653c6",
                "affiliate": "CBS",
                "isci": "GF31W1"
            },
            "sessionCount": 5,
            "pvCount": 6,
            "lift": 3.166666666666666,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CBS",
            "origEventId": "6dccd4cae0ac0b46d10f6819fea653c6",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T20:11:08.730Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "6a294f1a000cda4fe2837be322eddf4e",
                "affiliate": "MNTV",
                "isci": "GF31W1"
            },
            "sessionCount": 2,
            "pvCount": 5,
            "lift": -0.017228835978835986,
            "baselineSessionCount": 3,
            "baselineSessionsPerSecond": 0.01,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "MNTV",
            "origEventId": "6a294f1a000cda4fe2837be322eddf4e",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T19:15:53.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "37c7b7367daa92649d1139092536a53a",
                "affiliate": "CBS",
                "isci": "GF31W1"
            },
            "sessionCount": 4,
            "pvCount": 12,
            "lift": 0.06844797178130509,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CBS",
            "origEventId": "37c7b7367daa92649d1139092536a53a",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T15:11:16.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "39bae6c6d79827acacbddabfa8bcd656",
                "affiliate": "CBS",
                "isci": "GF31W1"
            },
            "sessionCount": 2,
            "pvCount": 4,
            "lift": 0.01180555555555556,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CBS",
            "origEventId": "39bae6c6d79827acacbddabfa8bcd656",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T15:24:56.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "5cbc984bfef674e1a883fd292caec77d",
                "affiliate": "FOX",
                "isci": "GF35W1"
            },
            "sessionCount": 4,
            "pvCount": 7,
            "lift": 0.3252500000927182,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "FOX",
            "origEventId": "5cbc984bfef674e1a883fd292caec77d",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-11T20:43:41.683Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "4ca44c5d17f2332616d9e3838642dbec",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 2,
            "pvCount": 2,
            "lift": 0.6666666666666666,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "4ca44c5d17f2332616d9e3838642dbec",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-13T12:12:37.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "97c7de84c2ed9577cfad8b58a976030c",
                "affiliate": "CBS",
                "isci": "GF31W1"
            },
            "sessionCount": 2,
            "pvCount": 5,
            "lift": 0.26666666666666666,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CBS",
            "origEventId": "97c7de84c2ed9577cfad8b58a976030c",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-06T19:31:38.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "41e68b97a69d1f0de8539d5f66830ae3",
                "affiliate": "ABC",
                "isci": "GF31W1"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 0.3333333333333333,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "ABC",
            "origEventId": "41e68b97a69d1f0de8539d5f66830ae3",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T16:56:24.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "d30978954bc76e36fe453d972f5ff407",
                "affiliate": "CBS",
                "isci": "GF31W1"
            },
            "sessionCount": 2,
            "pvCount": 4,
            "lift": 0.05972222222222222,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CBS",
            "origEventId": "d30978954bc76e36fe453d972f5ff407",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T15:24:11.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "bbede927466cbbc3d04399f16c9f86f0",
                "affiliate": "FOX",
                "isci": "GF31W1"
            },
            "sessionCount": 4,
            "pvCount": 6,
            "lift": 0.11111111111111097,
            "baselineSessionCount": 3,
            "baselineSessionsPerSecond": 0.01,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "FOX",
            "origEventId": "bbede927466cbbc3d04399f16c9f86f0",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T15:22:45.769Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "22c71959824bbbe2a2038bce68ab2a83",
                "affiliate": "CBS",
                "isci": "GE31W2"
            },
            "sessionCount": 5,
            "pvCount": 9,
            "lift": 1.2727272727272725,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "CBS",
            "origEventId": "22c71959824bbbe2a2038bce68ab2a83",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T15:59:51.330Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "3208bd3fa4bed78d9ac62b9037d06867",
                "affiliate": "MNTV",
                "isci": "GF35W1"
            },
            "sessionCount": 6,
            "pvCount": 10,
            "lift": 0.6999999999999998,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "MNTV",
            "origEventId": "3208bd3fa4bed78d9ac62b9037d06867",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T19:18:18.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "94df22ddd566ae9e702a03e7b01aeed4",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 5,
            "pvCount": 8,
            "lift": 0.5199025974025974,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "94df22ddd566ae9e702a03e7b01aeed4",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T14:00:12.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "7bc96e0a3d2fce9e39f3bb0a36d89ad6",
                "affiliate": "CW",
                "isci": "GF35W1"
            },
            "sessionCount": 4,
            "pvCount": 12,
            "lift": 4,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "CW",
            "origEventId": "7bc96e0a3d2fce9e39f3bb0a36d89ad6",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-11T17:32:21.711Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "88524468cc9bd6d8b3f2d9629d88a72c",
                "affiliate": "MNTV",
                "isci": "GE31W1"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 1,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W1",
            "affiliate": "MNTV",
            "origEventId": "88524468cc9bd6d8b3f2d9629d88a72c",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-11T22:11:35.083Z",
            "dmaName": "Springfield MO, United States",
            "timeOfDay": "early_fringe"
        },
        {
            "_id": {
                "origEventId": "a99373b887b40887efd55e0292368938",
                "affiliate": "FOX",
                "isci": "GF35W1"
            },
            "sessionCount": 5,
            "pvCount": 12,
            "lift": 1.5374999999999996,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "FOX",
            "origEventId": "a99373b887b40887efd55e0292368938",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-06T15:07:04.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "a9f345f850e97d79cdf90fc9e5eaaddb",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 0.2,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "a9f345f850e97d79cdf90fc9e5eaaddb",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T12:14:12.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "65f8ca5b8d2b7f6172a19af51a044760",
                "affiliate": "CBS",
                "isci": "GF31W1"
            },
            "sessionCount": 5,
            "pvCount": 13,
            "lift": -0.16666666666666682,
            "baselineSessionCount": 5,
            "baselineSessionsPerSecond": 0.016666666666666666,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CBS",
            "origEventId": "65f8ca5b8d2b7f6172a19af51a044760",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T20:24:12.093Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "2e1367dda9b0c40b66db5e19a0855a70",
                "affiliate": "MNTV",
                "isci": "GF35W1"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": -0.25925925925925924,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "MNTV",
            "origEventId": "2e1367dda9b0c40b66db5e19a0855a70",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-11T13:17:38.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "dc6283db9e0c432dc00ca56c0f42c296",
                "affiliate": "ABC",
                "isci": "GF35W1"
            },
            "sessionCount": 5,
            "pvCount": 6,
            "lift": 0.38888888888888873,
            "baselineSessionCount": 3,
            "baselineSessionsPerSecond": 0.01,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "ABC",
            "origEventId": "dc6283db9e0c432dc00ca56c0f42c296",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-11T13:58:43.250Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "8ecd53ea9df10e20ac685c123c23a4c7",
                "affiliate": "CW",
                "isci": "GE31W2"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 0.16666666666666666,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "CW",
            "origEventId": "8ecd53ea9df10e20ac685c123c23a4c7",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-11T11:48:23.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "d3edb611623df26a5104e4057a6ccb6a",
                "affiliate": "FOX",
                "isci": "GF31W1"
            },
            "sessionCount": 3,
            "pvCount": 3,
            "lift": -0.0036375661375661473,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "FOX",
            "origEventId": "d3edb611623df26a5104e4057a6ccb6a",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T14:27:16.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "fb084f493b7b12639c3c99e169efeee0",
                "affiliate": "CW",
                "isci": "GF35W1"
            },
            "sessionCount": 2,
            "pvCount": 3,
            "lift": 0.6666666666666664,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "CW",
            "origEventId": "fb084f493b7b12639c3c99e169efeee0",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T15:55:19.966Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "eaa36f8600afe098a8b7ff1068ecf8d1",
                "affiliate": "ABC",
                "isci": "GF35W1"
            },
            "sessionCount": 3,
            "pvCount": 3,
            "lift": 0.8666666666666667,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "ABC",
            "origEventId": "eaa36f8600afe098a8b7ff1068ecf8d1",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T11:23:32.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "d4336c5932d024eae42363056231bab0",
                "affiliate": "ABC",
                "isci": "GF35W1"
            },
            "sessionCount": 3,
            "pvCount": 4,
            "lift": 1.4999999999999996,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "ABC",
            "origEventId": "d4336c5932d024eae42363056231bab0",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T20:17:44.133Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "6ae87bb67730109ebde9c035e72d9504",
                "affiliate": "ABC",
                "isci": "GF35W1"
            },
            "sessionCount": 4,
            "pvCount": 7,
            "lift": 4,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "ABC",
            "origEventId": "6ae87bb67730109ebde9c035e72d9504",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T13:59:02.275Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "dd88c5d8fcc1b2b0576d64be9fb041fd",
                "affiliate": "FOX",
                "isci": "GF35W1"
            },
            "sessionCount": 2,
            "pvCount": 4,
            "lift": 0.20601851851851843,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "FOX",
            "origEventId": "dd88c5d8fcc1b2b0576d64be9fb041fd",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-13T12:59:17.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "a82a420c6be683ae2abcb25279bbe5a1",
                "affiliate": "CW",
                "isci": "GF31W1"
            },
            "sessionCount": 5,
            "pvCount": 8,
            "lift": 0.11364969135802468,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CW",
            "origEventId": "a82a420c6be683ae2abcb25279bbe5a1",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-13T19:36:53.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "f5ecfd6a9cd05695f65ab0b8dd5551f7",
                "affiliate": "CW",
                "isci": "GE31W2"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 0.16666666666666666,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "CW",
            "origEventId": "f5ecfd6a9cd05695f65ab0b8dd5551f7",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-11T11:48:29.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "3717a6236187208eb1ff3b5b4581bf81",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 0.2,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "3717a6236187208eb1ff3b5b4581bf81",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T12:14:00.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "f113fc681da491a97af1b62701b29e0e",
                "affiliate": "ABC",
                "isci": "GF35W1"
            },
            "sessionCount": 1,
            "pvCount": 4,
            "lift": 0.5,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "ABC",
            "origEventId": "f113fc681da491a97af1b62701b29e0e",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-11T14:25:37.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "43f9eae7a048a44d0bad0baf2c3d538e",
                "affiliate": "CW",
                "isci": "GF31W1"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": -0.034490740740740745,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CW",
            "origEventId": "43f9eae7a048a44d0bad0baf2c3d538e",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-13T10:29:46.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "d8904f6b3ccf4cffa645cd86ddefcefd",
                "affiliate": "CW",
                "isci": "GE31W2"
            },
            "sessionCount": 1,
            "pvCount": 2,
            "lift": 0.5,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "CW",
            "origEventId": "d8904f6b3ccf4cffa645cd86ddefcefd",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-11T16:48:24.850Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "3ab4a1613877a4c7501d31068bce2a33",
                "affiliate": "CBS",
                "isci": "GF31W1"
            },
            "sessionCount": 2,
            "pvCount": 4,
            "lift": 0.06180555555555554,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CBS",
            "origEventId": "3ab4a1613877a4c7501d31068bce2a33",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T15:24:20.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "a790c77d15f8f99025b6e9a26a7c9770",
                "affiliate": "CBS",
                "isci": "GF35W1"
            },
            "sessionCount": 2,
            "pvCount": 3,
            "lift": -0.13164351851851852,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "CBS",
            "origEventId": "a790c77d15f8f99025b6e9a26a7c9770",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-13T19:35:49.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "82a685c49d1e0cb2aa49dba56ff7663b",
                "affiliate": "CW",
                "isci": "GF31W1"
            },
            "sessionCount": 3,
            "pvCount": 3,
            "lift": 0.11264991181657846,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CW",
            "origEventId": "82a685c49d1e0cb2aa49dba56ff7663b",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T13:57:12.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "6ba80b6eec7bac6068e36d2cf3fd0a41",
                "affiliate": "CW",
                "isci": "GE31W2"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 0.5,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "CW",
            "origEventId": "6ba80b6eec7bac6068e36d2cf3fd0a41",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T12:50:16.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "260e5620e43e04345e03735c60e00292",
                "affiliate": "CW",
                "isci": "GF31W1"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": -0.04490740740740741,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CW",
            "origEventId": "260e5620e43e04345e03735c60e00292",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-13T10:30:01.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "8684dec1637b93e7aa75db05c1cfd146",
                "affiliate": "FOX",
                "isci": "GF31W1"
            },
            "sessionCount": 5,
            "pvCount": 12,
            "lift": 3.166666666666666,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "FOX",
            "origEventId": "8684dec1637b93e7aa75db05c1cfd146",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-13T20:44:05.099Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "32e0af1575ada9bd8402acdab7ad5348",
                "affiliate": "CBS",
                "isci": "GF31W1"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 1,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CBS",
            "origEventId": "32e0af1575ada9bd8402acdab7ad5348",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-15T00:48:38.384Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "prime_time"
        },
        {
            "_id": {
                "origEventId": "6087681dc99d473cd651328e4ef5a5cc",
                "affiliate": "ABC",
                "isci": "GF35W1"
            },
            "sessionCount": 3,
            "pvCount": 4,
            "lift": 0.48379629629629617,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "ABC",
            "origEventId": "6087681dc99d473cd651328e4ef5a5cc",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T15:54:42.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "69d3dd9a7b104398d857f091f4a2b809",
                "affiliate": "ABC",
                "isci": "GF35W1"
            },
            "sessionCount": 3,
            "pvCount": 3,
            "lift": 0.2499999999999998,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "ABC",
            "origEventId": "69d3dd9a7b104398d857f091f4a2b809",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T21:37:29.770Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_fringe"
        },
        {
            "_id": {
                "origEventId": "d2ed6a3ba399aaebe9ac965edd527850",
                "affiliate": "CW",
                "isci": "GF35W1"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 0.5,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "CW",
            "origEventId": "d2ed6a3ba399aaebe9ac965edd527850",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-11T12:32:21.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "05afac9a6804917b93ac2aa4e31d2048",
                "affiliate": "FOX",
                "isci": "GF35W1"
            },
            "sessionCount": 5,
            "pvCount": 12,
            "lift": 1.5374999999999996,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "FOX",
            "origEventId": "05afac9a6804917b93ac2aa4e31d2048",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-06T15:06:31.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "a08f4e688358699e189d2eed8df49055",
                "affiliate": "CW",
                "isci": "GF31W1"
            },
            "sessionCount": 3,
            "pvCount": 7,
            "lift": 0.3807407407407407,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CW",
            "origEventId": "a08f4e688358699e189d2eed8df49055",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-06T14:37:31.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "f0b55df3d5c7d4ec032526782715e4e0",
                "affiliate": "MNTV",
                "isci": "GF31W1"
            },
            "sessionCount": 1,
            "pvCount": 3,
            "lift": -0.07013007054673723,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "MNTV",
            "origEventId": "f0b55df3d5c7d4ec032526782715e4e0",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T19:15:45.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "190b9f1bdf8caf83677a854bf31f647a",
                "affiliate": "CBS",
                "isci": "GF31W1"
            },
            "sessionCount": 2,
            "pvCount": 4,
            "lift": 0.06180555555555554,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CBS",
            "origEventId": "190b9f1bdf8caf83677a854bf31f647a",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T15:24:20.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "0a416face5316087e299fe98756b2026",
                "affiliate": "CW",
                "isci": "GF31W1"
            },
            "sessionCount": 5,
            "pvCount": 8,
            "lift": 0.11527006172839502,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CW",
            "origEventId": "0a416face5316087e299fe98756b2026",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-13T19:36:42.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "94d9f4354b0706f6d9c45707431a7ad2",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 1,
            "pvCount": 2,
            "lift": 0.3333333333333333,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "94d9f4354b0706f6d9c45707431a7ad2",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T16:24:21.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "3055e9e37f039a75f723f1bab571cd3b",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 0.16666666666666666,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "3055e9e37f039a75f723f1bab571cd3b",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-11T11:49:53.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "c9e305b3dba3d452d282fd189f321f86",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 2,
            "pvCount": 3,
            "lift": 0.3818181818181818,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "c9e305b3dba3d452d282fd189f321f86",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-11T10:25:08.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "673d7bc1dfbe0e8c133bd2e8adff6e26",
                "affiliate": "ABC",
                "isci": "GF31W1"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 0.25,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "ABC",
            "origEventId": "673d7bc1dfbe0e8c133bd2e8adff6e26",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T11:13:13.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "95d2de2831745d3196764f620f84805f",
                "affiliate": "MNTV",
                "isci": "GE31W1"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": -0.09090909090909098,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 30,
            "isci": "GE31W1",
            "affiliate": "MNTV",
            "origEventId": "95d2de2831745d3196764f620f84805f",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-11T19:58:55.255Z",
            "dmaName": "Springfield MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "2630c6d61478bd663388175af4e8c431",
                "affiliate": "ABC",
                "isci": "GF35W1"
            },
            "sessionCount": 3,
            "pvCount": 9,
            "lift": -0.375,
            "baselineSessionCount": 4,
            "baselineSessionsPerSecond": 0.013333333333333334,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "ABC",
            "origEventId": "2630c6d61478bd663388175af4e8c431",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-06T20:44:55.235Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "9601c93450e1a0d3187f604b78bd97ec",
                "affiliate": "ABC",
                "isci": "GF31W1"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 0.3333333333333333,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "ABC",
            "origEventId": "9601c93450e1a0d3187f604b78bd97ec",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-11T16:52:38.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "873bb5fe14e0ed66c7096b647524268c",
                "affiliate": "CW",
                "isci": "GF31W1"
            },
            "sessionCount": 3,
            "pvCount": 3,
            "lift": 0.1057716049382716,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CW",
            "origEventId": "873bb5fe14e0ed66c7096b647524268c",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T13:56:44.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "735cbaefbfeaa9dc9dc186c2fa0e13f2",
                "affiliate": "ABC",
                "isci": "GF31W1"
            },
            "sessionCount": 5,
            "pvCount": 8,
            "lift": 0.8513888888888886,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "ABC",
            "origEventId": "735cbaefbfeaa9dc9dc186c2fa0e13f2",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-06T15:17:47.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "49ced2241deac108ab83dda039dd3267",
                "affiliate": "CW",
                "isci": "GE31W2"
            },
            "sessionCount": 2,
            "pvCount": 2,
            "lift": 2,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "CW",
            "origEventId": "49ced2241deac108ab83dda039dd3267",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-06T15:38:24.233Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "a195d2dab9a129204e696fee613eb0ce",
                "affiliate": "CBS",
                "isci": "GF35W1"
            },
            "sessionCount": 2,
            "pvCount": 2,
            "lift": 2,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "CBS",
            "origEventId": "a195d2dab9a129204e696fee613eb0ce",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-08T00:32:32.600Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "prime_time"
        },
        {
            "_id": {
                "origEventId": "3fdb008c002c7979c7ddaec25e884331",
                "affiliate": "ABC",
                "isci": "GF31W1"
            },
            "sessionCount": 2,
            "pvCount": 2,
            "lift": 0.6666666666666666,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "ABC",
            "origEventId": "3fdb008c002c7979c7ddaec25e884331",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T14:32:55.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "552e2fd88d3b31f5282ebd8fba717298",
                "affiliate": "CBS",
                "isci": "GF31W1"
            },
            "sessionCount": 4,
            "pvCount": 12,
            "lift": 0.06733686067019397,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CBS",
            "origEventId": "552e2fd88d3b31f5282ebd8fba717298",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T15:11:24.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "2dbe31a936f53f896445068af50cb43f",
                "affiliate": "ABC",
                "isci": "GF35W1"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": -0.2830541667011049,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "ABC",
            "origEventId": "2dbe31a936f53f896445068af50cb43f",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T13:59:32.898Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "2e3ee1d42fee355627177a72c051706c",
                "affiliate": "CBS",
                "isci": "GF31W1"
            },
            "sessionCount": 4,
            "pvCount": 12,
            "lift": 0.06571649029982361,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CBS",
            "origEventId": "2e3ee1d42fee355627177a72c051706c",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T15:11:08.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "ce153e648273b231b2b0e4bb8216ac87",
                "affiliate": "FOX",
                "isci": "GF31W1"
            },
            "sessionCount": 3,
            "pvCount": 3,
            "lift": 0.0019179894179894086,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "FOX",
            "origEventId": "ce153e648273b231b2b0e4bb8216ac87",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T14:27:00.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "bca5a48c0f901218ed4c99086a2fa34d",
                "affiliate": "ABC",
                "isci": "GG35W6"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 0.5,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GG35W6",
            "affiliate": "ABC",
            "origEventId": "bca5a48c0f901218ed4c99086a2fa34d",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T11:28:49.000Z",
            "dmaName": "Springfield MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "a58727a3ceba19fec699d4ec7184c457",
                "affiliate": "FOX",
                "isci": "GF31W1"
            },
            "sessionCount": 3,
            "pvCount": 3,
            "lift": -0.0036375661375661473,
            "baselineSessionCount": 2,
            "baselineSessionsPerSecond": 0.006666666666666667,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "FOX",
            "origEventId": "a58727a3ceba19fec699d4ec7184c457",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T14:27:16.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "7dff891c736e0df72248dfe3465ee2d4",
                "affiliate": "MNTV",
                "isci": "GF31W1"
            },
            "sessionCount": 10,
            "pvCount": 20,
            "lift": 0.31046296296296294,
            "baselineSessionCount": 3,
            "baselineSessionsPerSecond": 0.01,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "MNTV",
            "origEventId": "7dff891c736e0df72248dfe3465ee2d4",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T15:37:02.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "7aea473084dda87a850d5133fee61856",
                "affiliate": "ABC",
                "isci": "GF31W1"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 0.25,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "ABC",
            "origEventId": "7aea473084dda87a850d5133fee61856",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T11:13:32.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "c1b528b5bdae00979c646452e20e42b7",
                "affiliate": "CW",
                "isci": "GF31W1"
            },
            "sessionCount": 3,
            "pvCount": 3,
            "lift": 0.11264991181657846,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CW",
            "origEventId": "c1b528b5bdae00979c646452e20e42b7",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T13:56:57.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "8af890c588d520236bc63057b344805f",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 2,
            "pvCount": 3,
            "lift": 0.6666666666666666,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "8af890c588d520236bc63057b344805f",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T18:24:14.810Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "e3823a59c0e3f5e02aa4affd8cee453c",
                "affiliate": "MNTV",
                "isci": "GF31W1"
            },
            "sessionCount": 2,
            "pvCount": 5,
            "lift": -0.017228835978835986,
            "baselineSessionCount": 3,
            "baselineSessionsPerSecond": 0.01,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "MNTV",
            "origEventId": "e3823a59c0e3f5e02aa4affd8cee453c",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T19:15:53.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "350a0f95a897e33c1583ab392d391341",
                "affiliate": "ABC",
                "isci": "GF31W1"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 0.3333333333333333,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "ABC",
            "origEventId": "350a0f95a897e33c1583ab392d391341",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-11T16:53:09.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "813ca4b5994ab6263d5507298979ba0a",
                "affiliate": "ABC",
                "isci": "GF31W1"
            },
            "sessionCount": 6,
            "pvCount": 10,
            "lift": 1.6495370370370368,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "ABC",
            "origEventId": "813ca4b5994ab6263d5507298979ba0a",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-06T15:18:06.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "da4abaae0c9775d46f46f7b695ad4e41",
                "affiliate": "MNTV",
                "isci": "GF31W1"
            },
            "sessionCount": 10,
            "pvCount": 20,
            "lift": 0.31046296296296294,
            "baselineSessionCount": 3,
            "baselineSessionsPerSecond": 0.01,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "MNTV",
            "origEventId": "da4abaae0c9775d46f46f7b695ad4e41",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T15:37:02.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "98dfd5efbdeba04f1c69d7066b5d45eb",
                "affiliate": "MNTV",
                "isci": "GE31W1"
            },
            "sessionCount": 1,
            "pvCount": 3,
            "lift": 1,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W1",
            "affiliate": "MNTV",
            "origEventId": "98dfd5efbdeba04f1c69d7066b5d45eb",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T17:44:29.000Z",
            "dmaName": "Springfield MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "fc06be3c3a3181878660f03d5b48fa64",
                "affiliate": "MNTV",
                "isci": "GF31W1"
            },
            "sessionCount": 2,
            "pvCount": 5,
            "lift": -0.02615740740740742,
            "baselineSessionCount": 3,
            "baselineSessionsPerSecond": 0.01,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "MNTV",
            "origEventId": "fc06be3c3a3181878660f03d5b48fa64",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-09T19:16:02.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "1861d95c223b6e954493ae38750e8bfc",
                "affiliate": "CBS",
                "isci": "GF31W1"
            },
            "sessionCount": 2,
            "pvCount": 5,
            "lift": 0.26666666666666666,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF31W1",
            "affiliate": "CBS",
            "origEventId": "1861d95c223b6e954493ae38750e8bfc",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-06T19:32:01.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "3226f656c989eaaff5392d330d558696",
                "affiliate": "ABC",
                "isci": "GF35W1"
            },
            "sessionCount": 1,
            "pvCount": 2,
            "lift": 1,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "ABC",
            "origEventId": "3226f656c989eaaff5392d330d558696",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-11T19:25:08.967Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "563064f6d17593cbe8d508db8c41eba5",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 2,
            "pvCount": 4,
            "lift": 2,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "563064f6d17593cbe8d508db8c41eba5",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-11T21:25:00.780Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_fringe"
        },
        {
            "_id": {
                "origEventId": "7c6f12340eb1c5dd3490a2ec90cad3df",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 3,
            "pvCount": 5,
            "lift": 3,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "7c6f12340eb1c5dd3490a2ec90cad3df",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T17:58:59.517Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "2dc61a66c2b4d699836e37f5a139bd27",
                "affiliate": "FOX",
                "isci": "GF35W1"
            },
            "sessionCount": 4,
            "pvCount": 5,
            "lift": 2.5,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "FOX",
            "origEventId": "2dc61a66c2b4d699836e37f5a139bd27",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T17:46:07.496Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "0781ba4f272090ca299f68ac112ac580",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 0.16666666666666666,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "0781ba4f272090ca299f68ac112ac580",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-11T11:49:53.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "44fadcb6e2e106a0331a3461ec401104",
                "affiliate": "CBS",
                "isci": "GF35W1"
            },
            "sessionCount": 1,
            "pvCount": 2,
            "lift": 1,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "CBS",
            "origEventId": "44fadcb6e2e106a0331a3461ec401104",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-14T00:35:56.343Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "prime_time"
        },
        {
            "_id": {
                "origEventId": "9de686774b5aa5ec6e90036e756cdb82",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 1,
            "pvCount": 2,
            "lift": 0.3333333333333333,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "9de686774b5aa5ec6e90036e756cdb82",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T16:24:21.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "5222b944042a8c0830859900d153421c",
                "affiliate": "CBS",
                "isci": "GF35W1"
            },
            "sessionCount": 2,
            "pvCount": 15,
            "lift": 1,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "CBS",
            "origEventId": "5222b944042a8c0830859900d153421c",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-10T19:33:29.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "cffa28c7043cad529d2bf2a56583a5e2",
                "affiliate": "ABC",
                "isci": "GF35W1"
            },
            "sessionCount": 3,
            "pvCount": 9,
            "lift": 1.509259259259259,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "ABC",
            "origEventId": "cffa28c7043cad529d2bf2a56583a5e2",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-12T15:17:38.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "277781800022ec49e1e74d7dd82b9113",
                "affiliate": "NBC",
                "isci": "GE31W2"
            },
            "sessionCount": 4,
            "pvCount": 7,
            "lift": 4,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W2",
            "affiliate": "NBC",
            "origEventId": "277781800022ec49e1e74d7dd82b9113",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-06T17:29:21.455Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "daytime"
        },
        {
            "_id": {
                "origEventId": "8bc1ea7ba4c1d67eb46b5106023339d1",
                "affiliate": "FOX",
                "isci": "GF35W1"
            },
            "sessionCount": 2,
            "pvCount": 4,
            "lift": 0.20601851851851843,
            "baselineSessionCount": 1,
            "baselineSessionsPerSecond": 0.0033333333333333335,
            "eventLength": 60,
            "isci": "GF35W1",
            "affiliate": "FOX",
            "origEventId": "8bc1ea7ba4c1d67eb46b5106023339d1",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-13T12:59:17.000Z",
            "dmaName": "St. Louis MO, United States",
            "timeOfDay": "early_morning"
        },
        {
            "_id": {
                "origEventId": "8526de4a35804ee8adb073df2cf75a5b",
                "affiliate": "NBC",
                "isci": "GE31W1"
            },
            "sessionCount": 1,
            "pvCount": 1,
            "lift": 0.5,
            "baselineSessionCount": 0,
            "baselineSessionsPerSecond": 0,
            "eventLength": 30,
            "isci": "GE31W1",
            "affiliate": "NBC",
            "origEventId": "8526de4a35804ee8adb073df2cf75a5b",
            "brand": "624dfcaee48f5e0d04a49ee6",
            "eventTimestamp": "2022-05-11T14:23:27.000Z",
            "dmaName": "Springfield MO, United States",
            "timeOfDay": "daytime"
        }

    ];

  public static trafficMicroMomentAll = [
    {
      affiliate: 'CW',
      airingCount: 21,
      avgPctLift: 1.1632012145300792,
      avgPv: 2.4857142857142858,
      avgSessions: 2.9047619047619047,
      _id: { affiliate: 'CW' }
    },
    {
      affiliate: 'IND (KNLC)',
      airingCount: 95,
      avgPctLift: 1.3479331248526947,
      avgPv: 1.8698621553884711,
      avgSessions: 3.094736842105263,
      _id: { affiliate: 'IND (KNLC)' }
    },
    {
      affiliate: 'MNTV',
      airingCount: 15,
      avgPctLift: 0.7722629124628574,
      avgPv: 2.3333333333333335,
      avgSessions: 1.6666666666666667,
      _id: { affiliate: 'MNTV' }
    },
    {
      affiliate: 'FOX',
      airingCount: 17,
      avgPctLift: 1.7149990196321523,
      avgPv: 2.1205882352941177,
      avgSessions: 4,
      _id: { affiliate: 'FOX' }
    },
    {
      affiliate: 'IND (ERBK)',
      airingCount: 10,
      avgPctLift: 0.8909090909090909,
      avgPv: 2.3,
      avgSessions: 1,
      _id: { affiliate: 'IND (ERBK)' }
    },
    {
      affiliate: 'IND (NTVI)',
      airingCount: 27,
      avgPctLift: 1.1226569664961865,
      avgPv: 1.9087301587301586,
      avgSessions: 3.037037037037037,
      _id: { affiliate: 'IND (NTVI)' }
    },
    {
      affiliate: 'ABC',
      airingCount: 16,
      avgPctLift: 0.717563033242902,
      avgPv: 1.7520833333333332,
      avgSessions: 2.6875,
      _id: { affiliate: 'ABC' }
    },

    {
      affiliate: 'NBC',
      airingCount: 46,
      avgPctLift: 1.5173748682374537,
      avgPv: 1.8270186335403726,
      avgSessions: 3.347826086956522,
      _id: { affiliate: 'NBC' }
    },

    {
      affiliate: 'CBS',
      airingCount: 25,
      avgPctLift: 1.9740579595854786,
      avgPv: 1.967111111111111,
      avgSessions: 3.64,
      _id: { affiliate: 'CBS' }
    }
  ];

  public static test1Traffic = [
    {
      _id: {
        affiliate: 'IND (NTVI)'
      },
      avgSessions: 3.736842105263158,
      avgPv: 2.1005430242272345,
      avgPctLift: 0.5369857348397448,
      affiliate: 'IND (NTVI)',
      airingCount: 57
    },
    {
      _id: {
        affiliate: 'IND (KNLC)'
      },
      avgSessions: 3.549019607843137,
      avgPv: 1.7854108309990662,
      avgPctLift: 0.7969926708995207,
      affiliate: 'IND (KNLC)',
      airingCount: 102
    }
  ];

  public static test2Traffic = [
    {
      _id: {
        affiliate: 'FOX'
      },
      avgSessions: 3.75,
      avgPv: 1.5666666666666667,
      avgPctLift: 1.1289328703780968,
      affiliate: 'FOX',
      airingCount: 12
    },
    {
      _id: {
        affiliate: 'IND (KNLC)'
      },
      avgSessions: 2.5833333333333335,
      avgPv: 1.8264880952380953,
      avgPctLift: 0.609579918981978,
      affiliate: 'IND (KNLC)',
      airingCount: 48
    },
    {
      _id: {
        affiliate: 'CW'
      },
      avgSessions: 2.142857142857143,
      avgPv: 1.6666666666666665,
      avgPctLift: 1.245122619044213,
      affiliate: 'CW',
      airingCount: 7
    },
    {
      _id: {
        affiliate: 'MNTV'
      },
      avgSessions: 2.235294117647059,
      avgPv: 2.4257703081232496,
      avgPctLift: 0.5444357843180887,
      affiliate: 'MNTV',
      airingCount: 17
    },
    {
      _id: {
        affiliate: 'CBS'
      },
      avgSessions: 2.142857142857143,
      avgPv: 3.7285714285714286,
      avgPctLift: 0.8524228395061728,
      affiliate: 'CBS',
      airingCount: 7
    },
    {
      _id: {
        affiliate: 'ABC'
      },
      avgSessions: 3,
      avgPv: 1.6886904761904762,
      avgPctLift: 0.8317764786427568,
      affiliate: 'ABC',
      airingCount: 28
    }
  ];
  public static test3Traffic = [
    {
      _id: {
        affiliate: 'IND (ERBK)'
      },
      avgSessions: 1,
      avgPv: 2.5,
      avgPctLift: 0.3333333333333333,
      affiliate: 'IND (ERBK)',
      airingCount: 6
    }
  ];

  public static test4Traffic = [
    {
      _id: {
        affiliate: 'ABC'
      },
      avgSessions: 1,
      avgPv: 1,
      avgPctLift: 0.5,
      affiliate: 'ABC',
      airingCount: 2
    }
  ];

  public static test5Traffic = [
    {
      _id: {
        affiliate: 'FOX'
      },
      avgSessions: 3.5454545454545454,
      avgPv: 1.5363636363636362,
      avgPctLift: 0.4733084235218867,
      affiliate: 'FOX',
      airingCount: 11
    },
    {
      _id: {
        affiliate: 'IND (KNLC)'
      },
      avgSessions: 2.2962962962962963,
      avgPv: 2.0941358024691357,
      avgPctLift: 0.2990108963681494,
      affiliate: 'IND (KNLC)',
      airingCount: 54
    },
    {
      _id: {
        affiliate: 'CW'
      },
      avgSessions: 3.0384615384615383,
      avgPv: 1.5115384615384617,
      avgPctLift: 0.10176706010039341,
      affiliate: 'CW',
      airingCount: 26
    },
    {
      _id: {
        affiliate: 'MNTV'
      },
      avgSessions: 3.5833333333333335,
      avgPv: 1.9259259259259258,
      avgPctLift: 0.2011316872427983,
      affiliate: 'MNTV',
      airingCount: 24
    },
    {
      _id: {
        affiliate: 'CBS'
      },
      avgSessions: 2.606060606060606,
      avgPv: 2.55959595959596,
      avgPctLift: 0.30653759820426485,
      affiliate: 'CBS',
      airingCount: 33
    },
    {
      _id: {
        affiliate: 'ABC'
      },
      avgSessions: 2.52,
      avgPv: 1.5413333333333332,
      avgPctLift: 0.4829629629629629,
      affiliate: 'ABC',
      airingCount: 25
    }
  ];

  public static test6Traffic = [
    {
      _id: {
        affiliate: 'CW'
      },
      avgSessions: 2.3846153846153846,
      avgPv: 1.3461538461538463,
      avgPctLift: 0.5601531801531802,
      affiliate: 'CW',
      airingCount: 13
    },
    {
      _id: {
        affiliate: 'IND (KNLC)'
      },
      avgSessions: 2.4827586206896552,
      avgPv: 1.4753694581280787,
      avgPctLift: 0.6287356321839079,
      affiliate: 'IND (KNLC)',
      airingCount: 29
    },
    {
      _id: {
        affiliate: 'NBC'
      },
      avgSessions: 2.683333333333333,
      avgPv: 1.5538492063492064,
      avgPctLift: 1.0603947101900817,
      affiliate: 'NBC',
      airingCount: 60
    },
    {
      _id: {
        affiliate: 'CBS'
      },
      avgSessions: 3,
      avgPv: 2.2,
      avgPctLift: 1.4545454545454544,
      affiliate: 'CBS',
      airingCount: 4
    }
  ];

  public static liftBySpotFull = [
    {
      affiliates: ['IND (KNLC)', 'IND (NTVI)'],
      airingCount: 79,
      avgBaseline: 0,
      avgPctLift: 1.5383054421725062,
      avgSessions: 3.3376623376623376,
      isci: 'GE31W2',
      _id: { isci: 'GE31W2' }
    },
    {
      affiliates: ['IND (ERBK)', 'MNTV', 'NBC'],
      airingCount: 13,
      avgBaseline: 0,
      avgPctLift: 0.8545454545454546,
      avgSessions: 1,
      isci: 'GE31W1',
      _id: { isci: 'GE31W1' }
    },
    {
      affiliates: ['CW', 'CBS', 'NBC', 'IND (KNLC)'],
      airingCount: 89,
      avgBaseline: 0,
      avgPctLift: 1.5676901425949816,
      avgSessions: 3.1294117647058823,
      isci: 'GF31W1',
      _id: { isci: 'GF31W1' }
    },
    {
      affiliates: ['ABC', 'FOX', 'MNTV', 'CW', 'IND (KNLC)', 'CBS'],
      airingCount: 64,
      avgBaseline: 0,
      avgPctLift: 0.9435867664775576,
      avgSessions: 2.742424242424242,
      isci: 'GF35W1',
      _id: { isci: 'GF35W1' }
    },

    {
      affiliates: ['FOX', 'MNTV', 'CW', 'IND (KNLC)', 'CBS'],
      airingCount: 25,
      avgBaseline: 0,
      avgPctLift: 1.2597942956501527,
      avgSessions: 3.857142857142857,
      isci: 'GG35W1',
      _id: { isci: 'GG35W1' }
    },
    {
      affiliates: ['IND (ERBK)'],
      airingCount: 2,
      avgBaseline: 0,
      avgPctLift: 1,
      avgSessions: 1,
      isci: 'GG35W6',
      _id: { isci: 'GG35W6' }
    }
  ];
}
